const langTW = {
  add: "添加",
  after: "後",
  app: "應用",
  activated: "已啟用",
  stoped: "已停止",
  all: "全部",
  allMember: "全部成員",
  avg: "平均",
  array: "陣列",
  allow: "允許",
  abuseReport: "我要舉報",
  ascending: "昇冪",
  average: "平均值",
  back: "返回",
  backTo: "返回",
  batchEdit: "批量編輯",
  batchAdd: "大量新增",
  before: "前",
  bind: "綁定",
  between: "在{{begin}}到{{end}}之間",
  bold: "粗體",
  batchOperation: "批量操作",
  briefing: "簡報",
  cancel: "取消",
  checked: "勾選",
  china: "中國",
  city: "市",
  close: "關閉",
  clear: "清空",
  clearConfig: "清空配置",
  clearLink: "取消聯動",
  collect: "收起",
  color: "顏色",
  comment: "評論",
  config: "配置",
  contact: "連絡人",
  contacts: "通訊錄",
  copy: "複製",
  generate: '生成',
  copies: "{{- name}}_拷貝",
  count: "計數",
  county: "縣",
  current: "當前",
  custom: "自訂",
  chart: "流轉圖",
  data: "數據",
  dataSource: "資料來源",
  date: "日期",
  change: "更改",
  datetime: "日期時間",
  detail: "詳情",
  displayName: "顯示名",
  create: "新建",
  createDate: "提交日期",
  dash: "報表",
  dashboard: "工作臺",
  "go.dashboard": "返回工作臺",
  day: "日",
  days: "天",
  deal: "處理",
  defaults: "預設值",
  default: "預設",
  delete: "刪除",
  deleted: "已刪除",
  description: "描述資訊",
  dingtalk: "釘釘",
  done: "完成",
  doned: "已完成",
  disabled: "不可用",
  disable: "禁用",
  district: "區",
  download: "下載",
  dynamic: "動態",
  dynamicEmpty: "暫無動態",
  dynamicParameter: "動態參數",
  dynamicNotifier: "動態提醒人",
  department: "部門",
  descending: "降冪",
  error: "错误",
  line: "行",
  lineHeight: "行高",
  height1: "高",
  middle: "中",
  low: "低",
  adaptive: '自适应',
  auto: "自動",
  Left: "还剩 ",
  "subform.mobile.mode": "移動端顯示樣式",
  "chinese.descending": "中文降序",
  "ascii.descending": "Ascii降序",
  "chinese.ascending": "中文升序",
  "ascii.ascending": "Ascii升序",
  earliest: "最早",
  excel: "工作表",
  etl: "資料流程",
  edit: "編輯",
  qickedit: '快捷編輯',
  'qickedit.open': '打開快捷編輯',
  'qickedit.close': '關閉快捷編輯',
  'data.manager.qickedit': '打開快捷編輯，在資料管理介面，編輯數據不觸發公式聯動擴展效驗',
  editable: "可編輯",
  equal: "等於",
  empty: "「空」",
  emptyValue: "空值",
  enabled: "可用",
  enable: "啟用",
  export: "匯出",
  explain: "說明",
  expr: "運算式",
  every: "每",
  exemption: "限免",
  fail: "失敗",
  field: "欄位",
  filter: "篩選",
  fixedChars: "固定字元",
  fontFamily: "字體",
  fontSize: "字型大小",
  format: "格式",
  formerName: "原名：{{- name}}",
  formula: "公式",
  functionIntro: "功能介紹",
  future: "未來",
  free: "免費",
  email: "郵箱",
  already: "已",
  fullScreen: "全屏",
  exitfullScreen: "退出全屏",
  fx: "平台",
  form: "表單",
  gather: "匯總",
  goHome: "返回首頁",
  goImport: "繼續導入",
  group: "分組",
  halfLine: "1/2",
  help: "幫助",
  helpCenter: "幫助中心",
  hide: "隱藏",
  home: "首頁",
  hongkong: "中國香港",
  hour: "時",
  IDNum: "身份證號碼",
  iSee: "我知道了",
  import: "導入",
  invite: "邀請",
  incNumber: "自動計數",
  italic: "斜體",
  language: "語言",
  label: "標題",
  latLng: "緯度：{{latitude}}，經度：{{longitude}}",
  learnMore: "瞭解更多",
  leaveNotSaveTip: "離開當前頁後，您所做的修改不會被保存",
  latest: "最新",
  layout: "相片順序",
  legend: "圖例",
  loading: "載入中...",
  loadMore: "載入更多",
  log: "日誌",
  source: "源碼",
  more: "更多",
  move: "移動",
  macao: "中國澳門",
  max: "最大值",
  min: "最小值",
  mingdao: "明道",
  minute: "分",
  meaning: "含義",
  member: "成員",
  outsider: "外部聯系人",
  outsiderGroup: "外部聯系人分組",
  meter: "米",
  meters: "{{meters}}米",
  mobileNum: "手機號碼",
  modify: "修改",
  modifyConfig: "修改配置",
  manager: "管理員",
  money: "金額",
  month: "月",
  months: "個月",
  must: "必須",
  name: "姓名",
  nextStep: "下一步",
  new: "創建",
  navigator: "導航器",
  nickname: "昵稱",
  nothing: "無",
  notSupport: "不支持",
  support: "支持",
  off: "關",
  official: "官方",
  ok: "確定",
  on: "開",
  openBrowser: "在瀏覽器中打開",
  openDashboard: "打開工作臺",
  operationSuccess: "操作成功",
  operationFailed: "操作失敗",
  open: "打開",
  openLink: "打開連結",
  operator: "操作人",
  option: "選項",
  optional: "選填",
  or: "或",
  organization: "組織架構",
  other: "其他",
  'other.ext': "<其他>",
  print: "列印",
  pause: "暫停",
  paused: "已暫停",
  qrCode: "二維碼",
  query: "查詢",
  querying: "正在查詢...",
  past: "過去",
  colorful: "彩色",
  params: "參數",
  password: "密碼",
  passForget: "忘記密碼",
  passReset: "重置密碼",
  emailPassReset: "郵箱找回密碼",
  phonePassReset: "手機找回密碼",
  preview: "預覽",
  previewFail: "預覽失敗",
  province: "省",
  phone: "手機",
  'phone.email': "手機/郵箱",
  "phone.code.qr.tip": "手機掃碼上傳",
  prevStep: "上一步",
  quarter: "季",
  read: "已讀",
  recover: "恢復",
  remove: "刪除",
  redo: "重做",
  refresh: "刷新",
  release: "發佈",
  rename: "重命名",
  "rename.group": "重命名分組",
  "delete.group": "删除分組",
  renew: "續費",
  resigned: "已刪除",
  robot: "系統機器人",
  role: "角色",
  required: "必填",
  report: "報表",
  reselect: "重新選擇",
  reimport: "重新導入",
  save: "保存",
  "save.as": "另存",
  scanCode: "掃碼",
  search: "搜索",
  second: "秒",
  share: "分享",
  searching: "搜索中...",
  select: "--請選擇--",
  selectAll: "全選",
  selectAllSearchResult: "搜索結果全選",
  send: "發送",
  setting: "設置",
  settingDone: "已設置",
  server: "伺服器",
  show: "顯示",
  signin: "登錄",
  signout: "退出賬號",
  signup: "註冊",
  sinaWeibo: "新浪微博",
  skip: "跳過",
  state: "狀態",
  submit: "提交",
  sum: "求和",
  success: "成功",
  sort: "排序",
  'sort.value.same': "按相同值排序",
  tax: "稅率",
  taiwan: "中國臺灣",
  talkLater: "以後再說",
  telNum: "電話號碼",
  text: "文本",
  tencentQQ: "騰訊QQ",
  time: "時間",
  times: "次",
  timeBegin: "開始時間",
  timeEnd: "結束時間",
  timeout: "已超時",
  timestamp: "時間戳記",
  title: "標題",
  today: "今天",
  total: "共計",
  transparent: "透明",
  translate: "轉換",
  type: "類型",
  unbind: "解綁",
  unbindqywx: "解綁企業微信",
  unchecked: "不勾選",
  underline: "底線",
  undo: "撤銷",
  unbindSuccess: "解綁成功",
  unbindFail: "解綁失敗",
  unfilled: "未填寫",
  unknown: "未知",
  unlimited: "不限",
  unnamed: "未命名",
  unnamedData: "未命名數據",
  unread: "未讀",
  update: "更新",
  updated: "已修改",
  updater: "修改人",
  upgrade: "升級",
  username: "用戶名",
  use: "使用",
  validate: "校驗",
  validCode: "驗證碼",
  variable: "變數",
  verify: "驗證",
  view: "查看",
  visible: "可見",
  wework: "企業微信",
  wechat: "微信",
  "wechat.enhance.title": "微信增強",
  "wechat.enhance.desc": "開啟後，僅支持在微信中填寫，可獲取填寫者微信信息。只適應於表單外鏈和表單內鏈直接訪問鏈接的場景",
  "wechat.enhance.getEditorInfo": "獲取填寫者信息",
  "wechat.enhance.notice": "注：通過微信公眾號獲取信息",
  "wechat.enhance.get.automatic": "靜默獲取",
  "wechat.enhance.get.automatic.tooltip": "直接填寫表單，後台自動獲取，僅獲取微信OpenID",
  "wechat.enhance.get.fromDialog": "彈窗獲取",
  "wechat.enhance.get.fromDialog.tooltip": "填表前會彈窗請求授權，填寫者確認後，可獲取微信個人信息",
  "wechat.enhance.scan.fill": "請使用微信掃碼填寫",
  wechatQRCode: "請使用微信掃描二維碼登錄",
  week: "周",
  when: "當",
  wholeLine: "全部",
  widget: "控件",
  widgetName: "控件名稱",
  year: "年",
  years: "年",
  yes: "是",
  zipCode: "郵遞區號",
  zoomIn: "放大",
  zoomOut: "縮小",
  top: "上",
  bottom: "下",
  left: "左",
  right: "右",
  "account.setting": "賬號設置",
  "account.bind": "賬號綁定",
  "account.fx.bind": "綁定已有平台賬號",
  "account.mode": "賬號模式",
  "account.mode.weChat": "企業微信集成模式",
  "account.mode.dingTalk": "釘釘集成模式",
  "account.mode.public": "公共模式",
  "account.info.update.fail": "賬號資訊修改失敗",
  "account.unbind": "賬號解綁",
  "account.unbind.confirm": "確定解綁該{{type}}賬號?",
  "account.cancel": "註銷企業賬號",
  "account.cancel.apply": "企業賬號註銷申請",
  "account.cancel.apply.publicLetter": "申請公函",
  "account.cancel.apply.publicLetter.name": "《平台平臺登出企業申請公函範本》",
  "account.cancel.apply.publicLetter.download": "請先下載{{- link}}，填寫完成並加蓋公章後拍照上傳。",
  "account.cancel.warning": "登出企業賬號會清空所有通訊錄資料以及已經產生的所有業務資料和應用，且無法恢復，請謹慎操作！",
  "account.cancel.tip": "如確定要註銷賬號，請認真填寫以下資訊，我司將在3個工作日內聯繫您並完成賬號註銷的後續工作，請保持電話暢通。",
  "account.cancel.success.tip": "您已經提交註銷申請，我司將在3個工作日內聯繫您並完成賬號註銷的後續工作，請保持電話暢通。",
  "account.cancel.reason": "賬號註銷原因",
  "account.passForget.login": "返回登錄",
  "account.passForget.loginName.placeholder": "您註冊時使用手機號或郵箱",
  "account.passForget.loginName.errTip": "手機號/郵箱錯誤",
  "account.passReset.success": "密碼重置成功",
  "account.passReset.fail": "密碼重置失敗!",
  "account.passReset.login": "立即登錄",
  "account.passReset.newPass.placeholder": "新密碼，至少6位",
  "account.register.account": "註冊賬號",
  "account.register.captcha.placeholder": "圖片驗證碼",
  "account.register.phone.errTip": "手機號錯誤",
  "account.register.email.errTip": "郵箱不正確",
  "account.register.email.placeholder": "請輸入您的郵箱",
  "account.register.hasAccount": "已有賬號？",
  "account.register.incomplete": "註冊資訊填寫不完整!",
  "account.register.invite.guide": "您的團隊中還沒有成員，現在邀請成員協同辦公吧～",
  "account.register.password.placeholder": "密碼，至少6位元",
  "account.register.phone.placeholder": "您的手機號",
  "account.register.readAccept": "點擊註冊表明您已閱讀並同意",
  "account.register.signin": "直接登錄",
  "account.register.success": "註冊成功",
  "account.register.switch.email": "手機號無法註冊？點擊此處",
  "account.register.switch.phone": "郵箱無法註冊？點擊此處",
  "account.register.term": "《服務條款》",
  "account.register.userName.errTip": "使用者名支援字母、數位和底線，需以字母開頭，至少需要3位",
  "account.register.phone.exist": "手機號已存在，請直接登錄",
  "account.register.validCode.placeholder": "收到的驗證碼",
  "account.signin.account": "賬號登錄",
  "account.signin.dingtalk": "釘釘登錄",
  "account.signin.wechat": "企業微信登錄",
  "account.signin.wechat1": "微信登錄",
  "account.signin.sso": "單點登錄",
  "account.signin.sso.tip": "請配置完單點登錄後再來勾選",
  "account.signin.autoSignin": "記住密碼",
  "account.signin.forgetPass": "忘記密碼了?",
  "account.signin.hasNoAccount": "還沒有帳號？",
  "account.signin.register": "立即註冊",
  "account.signin.otherAccount": "其他登錄",
  "account.signin.wechatOpenTip": "還未開通企業微信？",
  "account.signin.dingtalkOpenTip": "還未開通釘釘？",
  "account.signin.corpOpen": "立即開通",
  "account.signin.qrcode": "點擊掃碼登錄",
  "account.signin.signinWithFX": "平台賬號登錄",
  "account.signin.user.placeholder": "手機號/郵箱/使用者名",
  "account.signin.user.emptyTip": "請輸入手機號/郵箱/使用者名",
  "account.signin.phone.email": "請輸入手機號/郵箱號",
  "account.signin.failTip": "賬號或密碼錯誤",
  "account.signin.wework.member": "企業微信成員登錄",
  "account.signin.wework.admin": "企業微信管理員登錄",
  "account.signin.banner.text": "點擊獲取「裝置管理2.0」方案",
  "account.signinCorp.dingtalkTitle": "使用釘釘用戶端掃描二維碼即可登錄企業應用系統",
  "account.signinCorp.wechatTitle": "使用企業微信掃描二維碼即可登錄企業應用系統",
  "account.success.teamJoin": "您已加入團隊",
  "account.success.enter": "進入系統",
  "account.info": "我的賬號資訊",
  "align.top": "頂部對齊",
  "align.center": "居中對齊",
  "align.bottom": "底部對齊",
  "align.left": "左對齊",
  "align.right": "右對齊",
  "repeat.tip": '此項內容已存在，不允許重複提交',
  "validate.tip": '請正確填寫【{{name}}】',
  "api.aliasOrId": "欄位別名/欄位ID",
  "api.alias.format.tip": "存在格式不正確的值",
  "api.alias.notSaveTip": "離開當前頁後，您的設置不會被保存",
  "api.alias.reserve.tip": "使用了保留字",
  "api.alias.repeat.tip": "存在重複值",
  "api.alias.set": "設置欄位別名",
  "api.alias.set.tip": "資料推送、發送API請求和返回回應資料時，使用欄位別名來替換欄位ID",
  "api.alias.rule.lowercase": "「小寫字母」",
  "api.alias.rule.number": "「數位」",
  "api.alias.rule.underline": "「底線」",
  "api.alias.set.info": "注：欄位別名僅允許使用{{- lowercase}}{{- number}}和{{- underline}}組合，且必須以{{- begin}}開頭",
  "api.auth": "認證方式",
  "api.auth.token": "平台使用基於簡單權杖的身份驗證{{- where}}，APIKey預設未生成，需要點擊{{- button}}生成。 生成方式：{{- step1}} >> {{- step2}} >> {{- step3}}，點擊右側的{{- document}}可以查看對應的API文檔。",
  "api.auth.genTokenInAccount": "（在「賬戶中心」生成或管理您的APIKey）",
  "api.auth.key": "API Key",
  "api.auth.key.reset": "對於生成的APIKey還可以進行重置和刪除。",
  "api.auth.setHttpHeaders": "通過 HTTP Headers 設置{{- auth}}的值為{{- yourKey}}來進行安全性認證",
  "api.auth.example": "示例如下：",
  "api.auth.warning": "請注意：APIKey與您的賬戶擁有相同的許可權，請務必保密！",
  "api.create": "新建單條資料介面",
  "api.createData": "新增數據",
  "api.create.desc": "在指定表單中添加一條數據。",
  "api.CeateKey": "創建API Key",
  "api.CeateKey.success": "創建成功",
  "api.doc": "API文檔",
  "api.doc.alias.idNotChange": "表單控制項一旦添加，會以_widget_為首碼的固定控制項ID來表示控制項，無論修改控制項的任何資訊都不會變更控制項ID。",
  "api.doc.alias.set": "每個控制項都對應著一個欄位。 使用者可以自己設置{{- alias}}。 {{- setTip}}",
  "api.doc.alias.set.tip": "如果設置了別名，則在之後所有的API中，控制項所對應的欄位名都將以{{- widgetAlias}}作為實際欄位名；如果沒有設置別名，則控制項將採用{{- widgetId }}作為實際欄位名。",
  "api.desc": "您可以通過我們提供的API介面來整合平台資料及其他外部資料。",
  "api.delete": "刪除單條資料介面",
  "api.delete.desc": "按照指定資料ID刪除表單中的資料，刪除的數據進入回收站。",
  "api.deleteData": "刪除資料",
  "api.selectApp": "請選擇應用來查看API文檔",
  "api.error.example": "當狀態返回碼為400時，伺服器會返回具體的錯誤碼 code 和錯誤資訊 message，對照表如下：",
  "api.error.table": "錯誤對照表",
  "api.error.table.tip": "所有API使用{{- code}}的回應方式來表示錯誤原因。介面正確統一返回HTTP狀態碼為{{- successCode}}的正確回應。介面錯誤統一返回HTTP狀態碼為{{- errorCode400}}的錯誤回應，同時回應內容會返回{{- errorCode}}和{{- errorMessage}}。",
  "api.error.table.example": "狀態返回碼對照表如下：",
  "api.error.statusCode": "狀態返回碼（status code）",
  "api.error.res": "介面錯誤統一返回",
  "api.error.code": "錯誤碼（code）",
  "api.error.2009": "沒有應用操作許可權",
  "api.error.3005": "介面參數不正確",
  "api.error.4000": "資料提交失敗",
  "api.error.4001": "資料不存在",
  "api.error.8301": "簽名校驗失敗",
  "api.error.8302": "沒有介面請求許可權",
  "api.error.8303": "超出請求頻率限制",
  "api.error.statusAndErrorCode": "狀態碼+錯誤碼",
  "api.error.message": "錯誤資訊（message）",
  "api.key.view.click": "點擊查看API Key",
  "api.getMultiData": "讀取多條數據",
  "api.getOneData": "讀取單條數據",
  "api.intro": "介紹",
  "api.key.reset": "重置API Key",
  "api.key.reset.confirm": "您確定要重置API Key嗎？",
  "api.key.reset.tip": "重置API Key後，現有的API集成將停止工作。",
  "api.key.reset.success": "重置成功",
  "api.key.delete": "刪除API Key",
  "api.key.delete.confirm": "您確定要刪除API Key嗎？",
  "api.key.delete.tip": "刪除API Key後，現有的API集成將停止工作。",
  "api.key.warning": "API Key與您的管理員賬戶具有相同的許可權，請務必保密",
  "api.key.auth": "安全認證",
  "api.key.auth.tip": "為確保資訊安全，請輸入您的登錄密碼",
  "api.limit": "頻率限制",
  "api.limit.num": "5次/秒",
  "api.notSupport": "另外，系統欄位 和 以下所列舉的控制項{{- notSupport}}添加和修改資料：",
  "api.notSupport.file": "圖片、附件、手寫簽名",
  "api.notSupport.link": "關聯資料、關聯查詢",
  "api.overview": "下面的API文檔是專門為您根據當前表單的配置生成的，提供了完整的樣例資料結構和請求路徑。如果您刪除/添加控制項或者修改控制項標題，則該文檔裡所對應的控制項欄位的其他資訊也會相應更改。",
  "api.params.data": "資料內容",
  "api.params.desc.dataId": "上一次查詢資料結果的最後一條資料的ID，沒有則留空",
  "api.params.desc.fields": "需要查詢的資料欄位",
  "api.params.desc.data": "資料內容，同資料提交",
  "api.params.desc.filter": "數據篩選器",
  "api.params.desc.items": "僅子表單控制項有；陣列裡包含了每個子控制項的資訊",
  "api.params.desc.isTriggerFlow": "用來控制是否觸發流程，預設不觸發流程",
  "api.params.desc.isStartTrigger": "用來控制是否觸發智慧助手，預設不觸發智慧助手",
  "api.params.desc.limit": "查詢的資料條數，1~100，默認100",
  "api.params.desc.name": "欄位名、欄位ID（可設置欄位別名）",
  "api.params.desc.title": "控制項標題",
  "api.params.desc.type": "控制項類型；每種控制項類型都有對應的資料類型",
  "api.query": "查詢多條資料介面",
  "api.query.desc": "該介面的返回資料，始終{{- order}}。",
  "api.query.order": "按照提交時間正序排列",
  "api.query.single": "查詢單條資料介面",
  "api.query.single.desc": "按照指定資料ID獲取表單中的資料。",
  "api.req.example": "請求示例：",
  "api.req.params": "請求參數：",
  "api.req.noParams": "請求參數：無",
  "api.res": "回應內容：",
  "api.res.example": "回應資料樣例：",
  "api.res.getFields": "每一個表單控制項都表示一個欄位，只要控制項不刪除，欄位ID就不會變化。",
  "api.res.order": "按照資料ID正序排列",
  "api.res.success": "回應成功",
  "api.rule": "規則",
  "api.rule.host": "API的統一訪問地址為",
  "api.rule.https": "所有API請求都必須通過HTTPS進行身份驗證和發起",
  "api.rule.post": "統一採用POST請求的形式",
  "api.rule.utf8": "資料傳輸編碼為UTF-8",
  "api.rule.json": "所有資料均為JSON格式",
  "api.supply.phoneAndPass": "請補充手機號和密碼",
  "api.supply.phoneAndPass.tip": "API Key與您的管理員賬戶具有相同的許可權，為了您的賬號安全，請先綁定手機號並設置密碼。",
  "api.update": "修改單條資料介面",
  "api.updateData": "編輯資料",
  "api.update.desc": "按照指定資料ID修改表單中的資料。",
  "api.warning": "請注意：表單控制項一旦添加，則以_widget_為首碼的控制項ID將不再會發生變更。",
  "api.widget.info": "控制項資訊",
  "api.widget.alias": "控制項別名",
  "api.widget.linkquery": "關聯查詢控制項",
  "api.widget.separator": "分割線控制項",
  "api.widget.valueTable": "控制項與資料類型對照表",
  "api.widgets": "表單字段查詢介面",
  "api.widgets.desc": "獲取指定表單的控制項/欄位資訊，除{{- separator}}和{{- linkquery}}以外。具體可以查閱{{- widgetsTable}}。",
  "app.category.quickStart": "快速上手",
  "app.category.rank": "精選推薦",
  "app.category.application": "用途",
  "app.category.common": "行業",
  "app.category.feature": "功能",
  "app.category.it": "IT互聯網",
  "app.category.manufacturing": "製造業",
  "app.category.trade": "貿易零售",
  "app.category.service": "服務業",
  "app.category.education": "教育培訓",
  "app.category.housing": "建築房產",
  "app.category.financial": "金融",
  "app.category.medicine": "醫療醫藥",
  "app.category.government": "政府單位",
  "app.category.logistics": "物流運輸",
  "app.category.businessService": "商業服務",
  "app.category.hr": "人力行政",
  "app.category.audit": "財務報銷",
  "app.category.office": "辦公協作",
  "app.category.inventory": "進銷存",
  "app.category.store": "門店管理",
  "app.category.crm": "客戶關係",
  "app.category.sales": "銷售",
  "app.category.project": "項目任務",
  "app.category.production": "生產管理",
  "app.category.assetEquipment": "資產設備",
  "app.category.formula": "公式函數",
  "app.category.flow": "流程",
  "app.category.aggregate": "聚合表",
  "app.category.print": "自訂列印",
  "app.category.dataRely": "數據聯動",
  "app.category.dataAuth": "數據許可權",
  "app.category.dataAuth1": "數據許可權",
  "app.category.notify": "推送提醒",
  "app.category.association": "選項關聯",
  "app.category.dataSubmit": "提交扩展",
  "app.category.signature": "手寫簽名",
  "app.category.dashboard": "報表",
  "app.list": "應用列表",
  "app.set.share": "表單/報表發佈",
  "app.set.auth": "報表資料許可權",
  "app.set.bridge.emptyTip": "請選擇需要跨應用使用的表單",
  "app.set.url": "應用URL",
  "app.set.url.tip": "自訂應用URL, 可使用URL直接打開該應用",
  "app.set.url.placeholder": "請輸入url",
  "app.set.entry": "1.選擇表單/報表",
  "app.set.auth.fail1": "許可權獲取失敗！",
  "app.set.auth.fail2": "請先選擇需要授權的頁面！",
  "app.set.filter.tip": "添加表單過濾條件設定報表的資料查看範圍",
  "app.set.save.fail1": "應用名稱不能為空！",
  "app.set.save.fail2": "應用URL包含非法字元！",
  "app.set.auth.tip": "成員不在列表中？請點擊同步成員",
  "app.set.range": "2.選擇發佈範圍",
  "app.set.data.auth.member": "1.選擇部門/成員",
  "app.set.data.auth.filter": "2.設置過濾條件",
  "app.mine": "我的應用",
  "my.app": "我的應用",
  "dash.mine": "我的圖表",
  "dash.mine.empty": "暫無圖表",
  "dash.favorites.empty": "暫無收藏",
  "app.carousel.map": "輪播圖",
  "app.recent.use": "最近使用",
  "app.rich.text": "富文本",
  "app.notice.board": "公告欄",
  "app.favorites": "我的收藏",
  "app.favorites.tip": "收藏",
  "app.favorites.cancel": "取消收藏",
  "app.favorites.fail": "收藏已失效",
  "app.favorites.max.tip": "最多只能收藏{{count}}个",
  "image.upload.rules": '支持jpg、jpeg、png、gif格式,單張5M以內',
  "image.upload.rules.one": '支持jpg、jpeg、png、gif格式,单张{{count}}M以内',
  "image.upload.length.rules": '不能超過10張圖片',
  "image.upload.size.rules": '超過5M',
  "image.upload.size.rules.one": '超過{{count}}M',
  "form.theme.imageMore.center": "原圖居中",
  "form.theme.imageMore.centerCover": "居中填滿",
  "form.theme.imageMore.stretchCover": "拉伸填滿",
  "dash.image.position": "填充方式",
  "dash.image.automatic.seeding": "自動輪播",
  "image.between.rotations": "輪播間隔",
  "app.template.owned": "我的應用範本",
  "app.notFound": "應用不存在或沒有訪問權限，請聯繫團隊管理員",
  "app.dotGuide.appList": "創建的應用展示在這裡。點擊此處進入應用管理",
  "app.create": "創建應用",
  "app.create.new": "創建新應用",
  "app.empty": "當前沒有可訪問應用",
  "app.empty.tip": "您當前沒有應用，請到工作臺創建應用",
  "app.empty.tip.creatOwnCorp": "您當前沒有任何團隊，請創建",
  "app.create.tip": "請聯繫貴司管理員將表單/報表共用給您",
  "app.create.empty": "創建空白應用",
  "app.create.empty.tip": "從零開始創建全新應用",
  "app.create.fromTemplate": "範本中心創建",
  "app.create.fromTemplate.tip": "安裝範本，快速開展您的業務",
  "app.custom": "定制應用",
  "app.custom.tip": "官方團隊為您個人化定制",
  "app.manage": "管理應用",
  "app.install.report.convert": "應用安裝成功，安裝時已將報表升級為報表",
  "app.install.guide": "點擊此處安裝應用",
  "app.installing": "正在安裝應用...",
  "app.name": "應用名稱",
  "app.name.update.fail": "修改名稱失敗!",
  "app.copy": "複製應用",
  "app.copy.confirm": "您是否要複製“{{- name}}”?",
  "app.copy.tip": "複製應用會複製該應用的表單、報表等，但不會複製應用內資料",
  "app.copy.success": "應用已複製",
  "app.copy.fail": "應用複製失敗",
  "app.delete": "刪除應用",
  "app.delete.success": "應用已刪除",
  "app.delete.warning": "刪除應用則表單、報表以及資料也都將一併刪除，且無法還原。",
  "app.delete.warning.extraFunc": "此應用內有表單被{{- func}}功能調用！刪除應用則表單、報表以及資料也都一併刪除，同時將刪除表單的資料使用權限，無法還原。",
  "app.delete.typeName": "如確定刪除，請輸入應用名稱：",
  "app.desc": "應用描述",
  "app.desc.placeholder": "請輸入對應的描述，幫助其他用戶瞭解應用功能",
  "app.style.edit": "修改樣式",
  "app.state.review": "正在審核",
  "app.publish.template": "發佈到範本中心",
  "app.publish.enable.tip": "未啟用的報表不會發佈到範本中心，如需發佈請先啟用",
  "app.publish.continue": "繼續發佈",
  "app.cannot.publish": "該應用無法發佈到範本中心",
  "app.publish.template.confirm": "確定要發佈此應用到範本中心嗎？",
  "app.publish.template.fail": "應用發佈失敗!",
  "app.publish.template.tip": "此應用本身及其部分資料會被提交到範本中心，如果不希望公開當前應用資料，請複製此應用並準備示例資料後發佈。",
  "app.publish.noLongerDisplay": "以後不再顯示",
  "app.review.tip": "已提交審核，請等待…",
  "app.noAuth.operate": "您沒有應用操作許可權",
  "app.noAuth.visit": "您沒有應用存取權限",
  "app.noAuth.visit.tip": "在當前團隊「{{corp}}」內沒有許可權，請聯繫管理員分配許可權或切換至其他團隊",
  "app.deleted.tip": "應用已被刪除，去工作臺轉轉吧～",
  "app.visit.enter": "進入應用訪問",
  "app.edit.enter": "進入應用管理",
  "app.trial": "還可以試用{{day}}天{{hour}}小時{{minute}}分",
  "app.trial.tip": "試用結束後應用內高級功能將納入用量統計",
  "auth.group": "許可權組",
  "auth.group.empty": "暫無相關許可權組",
  "auth.group.submit.name": "直接提交資料",
  "auth.group.submit.description": "在此分組內的成員只可以填報資料，設置了頁面共用的成員自動加入此分組",
  "auth.group.manage.name": "管理全部資料",
  "auth.group.manage.description": "在此分組內的成員可以管理全部資料",
  "auth.group.manage.description.dash": "在此分組內的成員可以管理全部數據，並擁有所有菜單權限",
  "auth.group.manage.description.dash.chart": "在此分組內的成員可以查看全部數據，並擁有所有菜單權限",
  "auth.group.review.name": "查看全部資料",
  "auth.group.review.description": "在此分組內的成員可以查看所有資料",
  "auth.group.manageOwn.name": "管理本人資料",
  "auth.group.manageOwn.description": "在此分組內的成員可以管理自己填報的資料",
  "auth.group.manageOwn.description.dash": "在此分組內的成員可以管理自己數據，並擁有所有菜單權限",
  "auth.group.manageOwn.description.dash.chart": "在此分組內的成員可以查看自己數據，並擁有所有菜單權限",
  "auth.group.deleteTip1": "該許可權組中有多名成員，",
  "auth.group.deleteTip2": "刪除後該許可權組將失效，且無法還原",
  "app.set": "應用設置",
  "app.group": "應用分組",
  "app.log": "應用日誌",
  "app.defaultName": "未命名應用",
  "app.edit.group.create": "新建分組",
  "app.edit.group.placeholder": "請輸入分組名稱",
  "app.edit.group.fail1": "分組新建失敗",
  "app.edit.group.fail2": "分組信息不能為空",
  "app.edit.group.fail3": "獲取分組信息失敗",
  "app.edit.group.empty": "--無分組--",
  "app.edit.group.deleteTip": "非空分組不能刪除!",
  "app.edit.group.moveTo": "移動到「{{- groupName}}」",
  "app.edit.sequenceChange": "調整順序",
  "app.edit.sequenceDone": "完成排序",
  "app.edit.move.success": "移動成功",
  "app.edit.exist": "已創建的",
  "app.edit.folder.select": "請選擇目的檔案夾",
  "app.edit.menu.guideTip": "支援拖拽排序啦",
  "app.edit.coopForm.create": "新建表單",
  "app.edit.coopForm.createTip": "表單可用來搜集資料，並帶有資料協作功能，適合進行資料上報",
  "app.edit.flowForm.create": "新建流程表單",
  "app.edit.flowForm.createTip": "流程表單適合報銷、請假申請或其他工作流",
  "app.edit.dash.create": "新建報表",
  "app.edit.dash.createTip": "報表是資料視覺化工具，適合進行資料展現和分析",
  "app.edit.report.create": "新建報表",
  "app.edit.report.createTip": "報表適合用來進行資料匯總、結果展示，趨勢分析等",
  "app.edit.formCreate.empty": "創建空白表單",
  "app.edit.formCreate.excel": "從Excel創建表單",
  "app.edit.toCoopForm": "切換為普通表單",
  "app.edit.toCoopForm.msg": "切換為普通表單，流程相關功能將不可用，是否確認切換？",
  "app.edit.toFlowForm": "切換為流程表單",
  "app.edit.toFlowForm.msg": "切換為流程表單，資料管理許可權設置將不可用，是否確認切換？",
  "app.edit.change.success": "切換成功",
  "app.edit.copyToCurrent": "複製到當前應用",
  "app.edit.copyToOther": "複製到其他應用",
  "app.edit.target.select": "請選擇目標應用",
  "app.edit.copy.success": "複製成功",
  "app.edit.copy.fail": "複製失敗",
  "app.edit.delete.confirm": "如確定刪除，請輸入表單名稱：",
  "app.edit.appBridge": "『跨應用』",
  "app.edit.delete.hasAppBridge": "此表單中有{{count}}條資料，且已被{{ref}}功能調用！刪除表單將清空資料，同時將刪除表單的資料使用權限，無法還原。",
  "app.edit.delete": "此表單中有{{count}}條數據！刪除表單將清空資料，且無法還原。",
  "app.edit.dashDelete.msg": "刪除報表會同時刪除報表的存取權限，且無法還原。",
  "app.edit.entryDelete.msg": "刪除報表會同時刪除報表的存取權限，且無法還原。",
  "app.load.empty.title": "該應用已被刪除",
  "app.load.empty.msg": "該應用已被管理員刪除，請打開工作臺選擇其他應用",
  alliance: "服務商聯盟",
  "alliance.guide.title": "加入平台推廣聯盟",
  "alliance.guide.subTitle": "獲得高額推廣獎勵",
  "alliance.guide.join": "立刻加入",
  "alliance.guide.step.title": "只需三步，輕鬆獲取推廣收益",
  "alliance.guide.step1": "第一步：填寫個人資料，申請加入平台推廣聯盟",
  "alliance.guide.step2": "第二步：獲得推廣連結，推廣產品",
  "alliance.guide.step3": "第三步：如果您推薦的用戶購買了平台高級版本，至少400元的現金分成",
  "alliance.guide.bannerText": "搶先推廣，享受前期紅利",
  "alliance.guide.company": "公司簡介",
  "alliance.guide.phone": "諮詢熱線",
  "alliance.guide.social": "用戶交流群",
  "alliance.guide.marketing": "市場合作",
  "alliance.guide.copyRight": "©2016-2020 長沙異次元網絡科技有限公司版權所有",
  "alliance.apply.state.noApply": "申請理由未達到要求。",
  "alliance.apply.state.empty": "該頁面不存在!",
  "alliance.apply.state.noPass": "很抱歉，您的申請未通過審核",
  "alliance.apply.broadcast": "推廣平台將帶來經濟收入，為避免可能的經濟糾紛，請確保您對平台賬號的完全所有權。如果您不確定自己對賬號的所有權，我們推薦您註冊新賬號",
  "alliance.apply.reason": "原因：",
  "alliance.apply.forbidden": "很抱歉，您的賬號已被禁用",
  "alliance.apply.inquiry": "如有疑議，請諮詢",
  "alliance.apply.check.fail": "此項有誤",
  "alliance.apply.submit": "提交申請",
  "alliance.apply.reSubmit": "重新申請",
  "alliance.apply.success": "您的申請已提交，請等待審核",
  "alliance.apply.successTip": "推廣聯盟正在小範圍測試階段，部分使用者的申請可能受到影響，別擔心，我們會儘快審核您的申請。",
  "alliance.apply.faq": "常見問題",
  "alliance.apply.faq.q1": "什麼是平台推廣聯盟？",
  "alliance.apply.faq.a1": "平台推廣聯盟是平台合作夥伴的一種類型，參與平台聯盟可獲得推廣獎勵、應用遷移、參與扶持計畫助力事業發展等特殊待遇。",
  "alliance.apply.faq.q2": "我是否應該加入平台推廣聯盟？",
  "alliance.apply.faq.a2": "首先要認可平台，相信平台的發展空間。擁有合法的流量資源或者客戶資源，或者需要遷移應用，希望借助平台助力事業發展等，歡迎加入推廣聯盟獲得更多回報。",
  "alliance.apply.faq.q3": "向朋友推薦了平台，會獲得什麼？",
  "alliance.apply.faq.a3": "豐厚的傭金回報，能力強者可獲得平台官方資源支持幫你更好的推廣。",
  "alliance.manage.alliance": "推廣平台",
  "alliance.manage.own": "我的推廣",
  "alliance.manage.account": "我的賬戶",
  "alliance.manage.datum": "個人資料",
  "alliance.account.income": "累計賺取傭金",
  "alliance.account.cashed": "累計提現金額",
  "alliance.account.cashable": "可提現傭金",
  "alliance.account.apply": "申請提現",
  "alliance.account.record": "交易記錄",
  "alliance.account.category": "類別",
  "alliance.account.order": "推薦傭金",
  "alliance.account.cash": "提現",
  "alliance.account.tax": "扣稅",
  "alliance.account.tax.tooltip": "我司按國家法定政策代扣代繳相關稅費，繳納比例以實際結算金額為準",
  "alliance.account.ordered": "已到賬",
  "alliance.account.state.waiting": "審核中",
  "alliance.account.state.denied": "提現失敗",
  "alliance.account.state.paid": "提現成功",
  "alliance.account.money": "元",
  "alliance.profile.authenticated": "已認證",
  "alliance.profile.fullName.errMsg": "請輸入姓名",
  "alliance.profile.alipay": "支付寶",
  "alliance.profile.alipay.errMsg": "請輸入支付寶賬號",
  "alliance.profile.pass": "提現密碼",
  "alliance.profile.placeholder": "提現密碼8-20位元，包含字母和數位",
  "alliance.profile.noPassTip": "您有正在進行的提現，無法修改支付寶。",
  "alliance.profile.phone": "手機號",
  "alliance.profile.apply.tip1": "1.建議綁定實名認證的支付寶；",
  "alliance.profile.apply.tip2": "2.填寫支付寶昵稱和支付寶認證姓名，方便我們核對支付寶賬號正確性。",
  "alliance.profile.alipay.nickname": "支付寶昵稱",
  "alliance.profile.alipay.nickname.errMsg": "請填寫支付寶昵稱",
  "alliance.profile.alipay.name": "支付寶認證姓名",
  "alliance.profile.alipay.name.errMsg": "請填寫支付寶認證姓名",
  "alliance.share.onLine": "線上推廣",
  "alliance.share.link": "推廣連結",
  "alliance.share.link.tip": "好友點擊會進入含有您推薦碼的註冊頁",
  "alliance.share.link.copy": "複製推廣連結",
  "alliance.share.link.result": "如何提高推廣效果",
  "alliance.share.rule": "平台聯盟規則詳解",
  "alliance.share.income": "我的推廣收益",
  "alliance.share.income.get": "如何獲得推廣收益",
  "alliance.share.income.text": "推薦一個高級版客戶：客戶首次購買平台的訂單金額10%作為推廣獎勵；推薦兩個及以上高級版客戶：客戶首次購買平台的訂單金額20%作為推廣獎勵。",
  "alliance.share.allIncome": "累計獲得傭金",
  "alliance.share.allCash": "累計提現",
  "alliance.share.accurateLink": "精准推廣",
  "alliance.share.accurateLink.title": "什麼是精准推廣",
  "alliance.share.accurateLink.description": "精准推廣是指將你製作的應用，通過應用安裝連結的形式，分享給可能需要這個應用的人，他註冊平台後即可安裝使用此應用。",
  "alliance.share.accurateLink.tip1": "為方便您對應用的管理，應用安裝連結預設情況下是關閉的。如果需要分享應用安裝連結，請先啟用。",
  "alliance.share.accurateLink.tip2": "如果您發佈的連結不符合{{-linkDescription}}，平台有權隨時封禁您的應用外鏈。",
  "alliance.share.state.forbidden": "被禁用",
  "alliance.share.state.using": "使用中",
  "alliance.share.state.noUsing": "未使用",
  "alliance.share.app.link.on": "啟用應用安裝連結",
  "alliance.share.app.link.off": "停用應用安裝連結",
  "alliance.share.app.open.title": "您確定要啟用應用安裝連結嗎？",
  "alliance.share.app.open.msg": "啟用後其他用戶可以通過您分享的應用安裝連結安裝此應用。",
  "alliance.share.app.open.success": "啟用成功",
  "alliance.share.app.open.fail": "該應用無法開啟應用安裝外鏈",
  "alliance.share.app.enter": "進入應用",
  "alliance.share.app.forbidden.title": "您確定要停用應用安裝連結嗎？",
  "alliance.share.app.forbidden.msg": "停用後其他用戶將不可通過應用安裝連結安裝此應用。已安裝此應用的用戶不受影響",
  "alliance.share.app.forbidden.success": "停用成功",
  "alliance.share.app.copy": "複製應用安裝連結",
  "alliance.share.title": "{{- name}}分享給您一個應用：{{- appName}}。點選連結進行安裝:",
  "alliance.user.register": "已註冊",
  "alliance.user.registerTime": "註冊日期",
  "alliance.user.orderPrice": "實際支付金額",
  "alliance.user.payTime": "支付日期",
  "alliance.cash.alipay": "支付寶：",
  "alliance.cash.amount": "提現金額：",
  "alliance.cash.taxTip": "提現金額為稅前金額，我司按國家法定政策代扣代繳相關稅費，繳納 比例以實際結算金額為准。",
  "alliance.cash.applyTip": "您提交的申請我們會在每個月中旬進行統一處理，請耐心等待。",
  "alliance.cash.apply.infoTitle": "個人資料資訊不完整，是否現在去補全資訊？",
  "alliance.cash.apply.info": "您需要進行實名認證，並設置支付寶和提現密碼後才能提現",
  "alliance.cash.apply.text4Ok": "去補全",
  "alliance.cash.apply.minCount": "（超過 {{ count }} 元方可提現）",
  "alliance.cash.pass": "提現密碼：",
  "alliance.cash.pass.errMsg": "請輸入提現密碼",
  "alliance.cash.fullName": "真實姓名",
  "alliance.cash.fullName.emptyTip": "請填寫姓名",
  "alliance.cash.IDNum.emptyTip": "請填寫身份證號碼",
  "alliance.cash.certification.tip": "（請保證照片清晰，大小在 5M 以內）",
  "alliance.cash.idCard.front": "身份證正面照片",
  "alliance.cash.idCard.back": "身份證反面照片",
  "alliance.cash.idCard.emptyTip": "請上傳身份證照片",
  "alliance.cash.apply.fail": "你的提現申請未能通過",
  "alliance.cash.apply.success": "提現申請已提交",
  "alliance.cash.apply.success.tip1": "平台會在兩個工作日內處理您的提現申請。",
  "alliance.cash.apply.success.tip2": "預計到賬時間：",
  "alliance.cash.certification.success": "實名認證已提交",
  "alliance.cash.certification.success.tip1": "平台會在兩個工作日內處理您的實名認證申請。",
  "alliance.cash.certification.success.tip2": "預計處理時間：",
  "alliance.cash.certification.title": "實名認證",
  "aggregate.defaultName": "未命名聚合表",
  "aggregate.delete.msg": "刪除聚合表會同時刪除該聚合表的資料使用權限，且無法還原",
  "aggregate.create": "新建聚合表",
  "aggregate.design": "聚合表設計",
  "aggregate.fieldAdd.tip": "請從右側面板添加欄位",
  "aggregate.tip": "聚合表可以對表單資料進行預處理，並在表單中再次調用，常用於進-銷-存等場景。",
  "bind.click": "點擊綁定",
  "bind.fail": "綁定失敗",
  "bindTip.back": "點擊返回登錄頁",
  "bindTip.login": "秒後自動跳轉登錄頁",
  "bindTip.social": "QQ/微博登錄",
  "bindTip.tip": "由於業務調整，平台不再支持使用新的QQ/微博賬號登錄，請使用其他方式登錄註冊！給您帶來不便，十分抱歉！",
  "content.empty": "暫無內容",
  "content.type": "請輸入內容",
  "coupon.renew": "續費專享優惠券",
  "coupon.validity": "有效期：{{dateRange}}",
  "coupon.count": "我的優惠券：{{count}}張",
  "copy.translate.dash": "複製並轉換為報表",
  "corp.create": "創建我的團隊",
  "corp.current": "當前團隊",
  "corp.enter": "進入團隊",
  "corp.name": "{{- user}}的團隊",
  "corp.name.label": "我的團隊",
  "corp.name.update": "修改團隊名",
  "corp.name.update.success": "團隊名修改成功",
  "corp.name.placeholder": "請輸入團隊名稱",
  "corp.name.notEmpty": "團隊名不能為空",
  "corp.name.tooLong": "團隊名最多為{{length}}個字",
  "corp.joined": "我加入的團隊",
  "corp.owned": "我創建的團隊",
  "corp.owner": "企業創建者",
  "corp.url": "企業帳號URL",
  "corp.dd.url": "釘釘專屬掃碼URL",
  "corp.url.tip": "當前企業專屬的登錄入口",
  "corp.url.placeholder": "支援字母、數位、底線，需以字母開頭，最少{{length}}位",
  "corp.url.validate.fail": "不符合格式要求",
  "corp.url.update.success": "企業賬號URL修改成功",
  "corp.authInfo": "授權資訊",
  "corp.email": "企業郵箱",
  "corp.email.invalid.tip": "請輸入正確的企業郵箱",
  "corp.join.success": "加入團隊成功！",
  "corp.unbind.confirm": "確定解綁企業套件",
  "corp.unbind.msg": "解綁企業套件後，企業通訊錄將丟失，已提交的資料中成員昵稱將無法顯示，請在解綁前做好資料備份。",
  "corp.dingtalk.unbind": "解綁釘釘",
  "corp.dingtalk.authorization": "釘釘應用授權",
  "corp.dingtalk.authorization.explain": "釘釘應用綁定說明",
  "corp.dingtalk.href": "需要聯系【團隊管理員】登錄釘釘開放平臺 <a href='{{url}}' target='_blank' style='color: #00FFD2;'>{{url}}</a> 進行綁定配置 ",
  "corp.dingtalk.text1": "釘釘應用綁定采用了釘釘【企業內部開發】的模式對接",
  "corp.dingtalk.text2": "為什麽采用【企業內部開發】的模式",
  "corp.dingtalk.text3": "采用【企業內部開發】的模式可以獲取更多的能力：比如，通訊錄自動同步等，節約大量時間",
  "corp.dingtalk.help": "請根據 <a style='color: #FFB200;'><i class='icon-bsy-guide'></i>參數配置操作引導</a> 完成操作 ",
  "corp.dingtalk.start.btn": "開始操作",
  "corp.dingtalk.Step.help": "<i class='icon-bsy-guide'></i>參數配置操作引導",
  "corp.dingtalk.Step.unbind": "是否解除釘釘授權？",
  "corp.dingtalk.Step.unbind.tip": "解除釘釘綁定以後，賬號將還原到本賬號原來的通訊錄信息，應用和數據信息將保留，重新綁定原釘釘應用可以恢復。",
  "corp.dingtalk.Step.unbin.btn": "解除釘釘授權",
  "corp.qywework.Step.unbin.btn": "解除企業微信授權",
  "corp.dingtalk.Step1.title": "Step1：基本信息填寫",
  "corp.dingtalk.Step2.title": "Step2：創建應用並填寫應用憑證和配置訪問地址",
  "corp.feishu.Step2.title": "Step2：配置事件訂閱請求網址",
  "corp.dingtalk.Step3.title": "Step3：開通通訊錄權限和待辦權限",
  "corp.feishu.Step3.title": "Step3：配置訪問地址和應用權限並發布應用",
  "corp.dingtalk.Step4.title": "Step4：發布應用並配置掃碼登錄參數",
  "corp.dingtalk.Step1.title.tip": "（請先打開鏈接<a href='https://open-dev.dingtalk.com/v2/fe/app#/corp/app' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/corp/app</a>創建應用）",
  "corp.feishu.Step1.title.tip": "（請先打開鏈接<a href='https://open.feishu.cn/' style='color:var(--bsy-base-color);' target='_blank'>https://open.feishu.cn/</a>創建應用）",
  "corp.dingtalk.team.Step1.title.tip": "（自定義）",
  "corp.dingtalk.Step2.title.tip": "（請先打開鏈接<a href='https://open-dev.dingtalk.com/v2/fe/app#/corp/app' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/corp/app</a>創建應用）",
  "corp.dingtalk.Step3.title.tip": "（繼續在鏈接<a href='https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/4' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/4</a>中完成以下操作）",
  "corp.dingtalk.Step4.title.tip": "（繼續在鏈接<a href='https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/12' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}}/12</a>中完成以下操作）",
  "corp.dingtalk.Step1.corpId.title": "企業信息參數<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step1.name.title": "團隊名稱<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step1.corpId.title.tip": "（在釘釘開放平臺【首頁】中獲取）",
  "corp.feishu.Step1.corpId.title.tip": "（在飛書應用中獲取下列參數，詳見參數配置操作引導）",
  "corp.dingtalk.Step1.corpId.waterMark": "請輸入團隊ID",
  "corp.dingtalk.Step1.SSOsecret.title": "開發信息<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step1.SSOsecret.title.tip": "（在釘釘開放平臺首【基本信息】中獲取）",
  "corp.dingtalk.Step1.SSOsecret.waterMark": "請輸入免登密鑰",
  "corp.dingtalk.Step2.app.title": "1.應用憑證<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step2.app.title.tip": "（在上面鏈接創建應用後獲取）",
  "corp.dingtalk.Step2.agent.waterMark": "請輸入AgentId",
  "corp.dingtalk.Step2.AppKey.waterMark": "請輸入AppKey",
  "corp.dingtalk.Step2.AppSecret.waterMark": "請輸入AppSecret",
  "corp.dingtalk.Step3.corpId.title": "2.配置訪問地址<span style='color:#F5222D;'>*</span>",
  "corp.feishu.Step3.corpId.title": "1.配置訪問地址<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step3.corpId.title.tip": "（請將以下地址信息復製粘貼到上面鏈接的【開發管理】，詳見參數配置操作引導）",
  "corp.dingtalk.Step3.SSOsecret.title": "1.開通通訊錄權限<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step3.SSOsecret.title2": "2.開通待辦權限<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step3.SSOsecret.title.tip": "（請前往釘釘開放平臺進行操作，詳見參數配置操作引導）",
  "corp.dingtalk.Step3.Tip": "註意：必須開通以上權限才能進入下一步",
  "corp.dingtalk.Step3.ip": "服務器出口IP",
  "corp.dingtalk.Step3.index": "應用首頁地址",
  "corp.dingtalk.Step3.pc": "PC端首頁地址",
  "corp.dingtalk.Step3.address": "後臺管理地址",
  "corp.dingtalk.Step4.corpId.title": "1.掃碼登錄應用授權信息<span style='color:#F5222D;'>*</span>",
  "corp.feishu.Step4.corpId.title": "訂閱事件請求網址<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step4.corpId.title.tip": "（請將以下授權信息復製粘貼到上面鏈接相關位置，詳見參數配置操作引導）",
  "corp.feishu.Step4.corpId.title.tip": "（請將以下參數復製粘貼到相關位置，詳見參數配置操作引導）",
  "corp.feishu.corpId.title.tip": "（詳見參數配置操作引導）",
  "corp.feishu.Step42.corpId.title.tip": "（請將以下網址信息復製粘貼到相關位置，詳見參數配置操作引導）",
  "corp.dingtalk.Step4.SSOsecret.title": "2.登錄信息參數<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step4.SSOsecret.title.tip": "（在釘釘開放平臺【應用開發-移動應用接入-登錄】中獲取）",
  "corp.dingtalk.Step4.name": "名稱",
  "corp.dingtalk.Step4.desc": "描述",
  "corp.dingtalk.Step4.logo": "授權LOGO地址",
  "corp.dingtalk.Step4.url": "回調域名",
  "corp.dingtalk.Step4.appId.waterMark": "請輸入appId",
  "corp.dingtalk.Step4.appSecret.waterMark": "請輸入appSecret",
  "corp.dingtalk.SSO.tip": "用於釘釘後臺進入應用操作",
  "corp.dingtalk.add.SSOsecret.waterMark": "請輸入SSOsecret",
  "corp.dingtalk.add.SSOsecret.errorEmpty": "SSOsecret不能為空",
  "corp.authorization": "應用授權",
  "corp.dingtalk.authorization.ok": "確認授權",
  "corp.dingtalk.authorization.tip": "注：綁定SSOSecret可實現釘釘應用後臺免登跳轉平台後臺",
  "corp.dingtalk.authorization.success": "授權成功",
  "corp.dingtalk.print.fail": "用戶端中不支援系統列印，請在瀏覽器中打開進行操作",
  "corp.dingtalk.print.ok": "立即前往",
  "corp.dingtalk.print.cancel": "暫不列印",
  "corp.wechat.bindFail1": "微信綁定失敗",
  "corp.wechat.bindFail2": "微信綁定失敗，此微信賬號已綁定平台賬號",
  "corp.wechat.title": "平台·快速創建企業管理應用",
  "corp.wechat.enter": "進入應用中心",
  "corp.wework.bind.tip": "如需綁定企業微信，{{- info}}",
  "corp.wework.bind.info": "點此諮詢",
  "corp.bind.confirm": "綁定已有賬號",
  "corp.bind.confirm.msg": "綁定已有平台賬號，會將該賬號中的應用合併到當前賬號，該賬號中的使用者和許可權資料也會被清除，此操作不可逆。是否確認綁定已有賬號？",
  "corp.bind.ok": "確認綁定",
  "corp.integrate.wechat.account": "集成自己的微信公眾號",
  "corp.request": "申請",
  "corp.switch": "團隊切換",
  "code.reget": "重新獲取({{num}})",
  "city.withMark": "(市)",
  "day.short": "日",
  "day.week.Monday": "星期一",
  "day.week.Tuesday": "星期二",
  "day.week.Wednesday": "星期三",
  "day.week.Thursday": "星期四",
  "day.week.Friday": "星期五",
  "day.week.Saturday": "星期六",
  "day.week.Sunday": "星期日",
  "dash.data.component": "數據控件",
  "dash.add.tip": "從左上角添加控件，進行資料展示和分析。",
  "dash.add.tip.learnMore": "瞭解這些控件",
  "dash.auth.errorTip": "僅登錄使用者可查看資料",
  "dash.auth.noAuth": "您沒有查看資料的許可權",
  "dash.areaChart": "面積圖",
  "dash.aggregateFunc": "彙總函式",
  "dash.auto.calc": "自動計算",
  "dash.axis.x": "座標X軸",
  "dash.axis.y": "座標Y軸",
  "dash.barChart": "橫條圖",
  "dash.config.error": "控件配置異常",
  "dash.chart": "統計表",
  "dash.chart.add": "添加圖表",
  "dash.chart.design": "圖表設計",
  "dash.chart.relySet": "圖表聯動",
  "dash.chart.customizeRelySet": "圖表自定義聯動",
  "dash.chart.relyEmpty": "沒有可以聯動的圖表",
  "dash.chart.tip": "1個維度，1個或多個指標\n2個維度，1個指標",
  "dash.chart.type": "圖表類型",
  "dash.chart.unnamed": "未命名圖表",
  "dash.chart.sort.empty": "沒有支援排序的欄位",
  "dash.calendar.empty": "當日無資料",
  "dash.copy.success": "複製成功！",
  "dash.copy.title": "{{- title }}_拷貝",
  "dash.copy.maxCountExceed": "複製失敗！ 最多存在{{ limit }}個圖表",
  "dash.data.manage": "資料管理控件",
  "dash.data.manageTable": "資料管理表格",
  "dash.data.manage.select": "選擇控件類型",
  "dash.data.manage.selectPlaceholder": "請選擇",
  "dash.data.manage.formSelect": "請選擇資料來源",
  "dash.data.manage.dateSelect": "請選擇時間維度",
  "dash.data.manage.date": "時間維度",
  "dash.data.manage.filterAdd": "添加資料來源過濾條件",
  "dash.data.manage.getAuth": "資料獲取許可權",
  "dash.data.manage.allData": "全部資料",
  "dash.data.manage.userAuth": "使用成員對資料來源表單的許可權",
  "dash.data.manage.formTip": "使用者訪問控件時，根據他在資料來源表單中所在的許可權組，僅可查看有許可權的資料。",
  "dash.data.manage.allTip": "使用者訪問控件時可以查看控件中的全部資料",
  "dash.data.manage.authTip": "資料來源表單尚未配置資料許可權，使用者訪問控件時無法查看資料。 你可以現在去配置資料來源許可權，或完成控件設置後配置",
  "dash.dataSource.empty": "沒有可選擇的資料來源",
  "dash.thresholds.tip": "成員使用者必須綁定郵箱或關注微信服務號，才能收到提醒。",
  "dash.thresholds.set": "如何設置",
  "dash.thresholds.name": "預警名稱",
  "dash.thresholds.filter": "預警條件",
  "dash.thresholds.field.placeholder": "請選擇指標欄位",
  "dash.thresholds.num.placeholder": "請輸入數值",
  "dash.thresholds.mem.tip": "請確保已將報表發佈給以下部門或成員",
  "dash.thresholds.msg.wx": "微信提醒",
  "dash.thresholds.msg.wechat": "企業微信提醒",
  "dash.thresholds.msg.dd": "釘釘提醒",
  "dash.thresholds.nameTip": "請輸入預警名稱",
  "dash.thresholds.nameTip2": "預警名稱不能超過{{ count }}字",
  "dash.thresholds.filterTip": "預警條件未設置完整",
  "dash.thresholds.timeTip": "預警時間未設置完整",
  "dash.thresholds.msgTip": "預警提醒方式未設置完整",
  "dash.thresholds": "資料預警",
  "dash.thresholds.add": "添加預警",
  "dash.thresholds.setTip": "如何設置資料預警？",
  "dash.thresholds.deleteConfirm": "確定刪除該預警嗎？",
  "dash.guideline": "輔助線",
  "dash.guideline.add": "添加輔助線",
  "dash.guideline.label": "輔助線名稱",
  "dash.guideline.label.placeholder": "請輸入輔助線名稱，最多{{ count }}個字元",
  "dash.guideline.label.required": "請輸入輔助線名稱",
  "dash.guideline.label.length": "輔助線名稱不能超過{{ count }}個字元",
  "dash.guideline.dynamic": "動態值",
  "dash.guideline.nameAndValue": "名稱和值",
  "dash.chart.thresholds.maxCountTip": "單個圖表最多開啟{{ count }}個數據預警",
  "dash.countdown": "試用期倒計時：",
  "dash.color": "顏色設置",
  "dash.color.bg": "指標圖背景色",
  "dash.color.custom00": "熾熱",
  "dash.color.custom01": "希望",
  "dash.color.custom02": "低調",
  "dash.color.custom03": "馬卡龍",
  "dash.color.custom04": "質感",
  "dash.color.custom05": "風情海灘",
  "dash.color.custom06": "叢林深處",
  "dash.color.custom07": "憂鬱藍調",
  "dash.color.custom08": "輕快現代",
  "dash.color.custom09": "春日花園",
  "dash.color.customMap01": "星空",
  "dash.color.customMap02": "極光",
  "dash.color.customMap03": "月色",
  "dash.color.customMap04": "朝霞",
  "dash.color.customMap05": "杜鵑",
  "dash.color.customMap06": "清晨",
  "dash.color.customMap07": "日光",
  "dash.color.set": "色彩配置",
  "dash.color.item": "支援設置顏色的項",
  "dash.color.empty": "請先添加維度/指標",
  "dash.color.preset": "預設顏色",
  "dash.color.valueSize.s": "寬鬆",
  "dash.color.valueSize.m": "標準",
  "dash.color.valueSize.l": "緊湊",
  "dash.display": "顯示模式",
  "dash.chartLabel": "資料標籤",
  "dash.chartLabel.display": "顯示資料標籤",
  "dash.xFields.display": "顯示維度值",
  "dash.chartLabel.value.display": "顯示指標值",
  "dash.percent.display": "顯示百分比",
  "dash.legend.display": "顯示圖例",
  "dash.legend.position": "圖例顯示在圖表",
  "dash.legend.type": "類型",
  "dash.legend.type.plain": "普通圖例",
  "dash.legend.type.scroll": "帶分頁的圖例",
  "dash.position.bottom": "底部",
  "dash.position.top": "頂部",
  "dash.position.left": "左側",
  "dash.position.right": "右側",
  "dash.xAxis.display": "顯示刻度標籤",
  "dash.cond": "過濾條件",
  "dash.cond.add.fail": "添加失敗，同一欄位不能重複添加篩選條件",
  "dash.cond.delete": "刪除篩選條件",
  "dash.cond.drag.tip": "拖動左側欄位到此處來添加過濾條件",
  "dash.cond.edit": "修改篩選條件",
  "dash.cond.set": "設置過濾條件",
  "dash.cond.set.fail": "過濾條件設置不正確",
  "dash.columnChart": "直條圖",
  "dash.columnChart.stack": "堆積直條圖",
  "dash.data.canExport": "可匯出數據",
  "dash.defaultName": "未命名報表",
  "dash.design": "報表設計",
  "dash.dimension": "維度",
  "dash.dimension.single": "單項",
  "dash.dimension.sticky": "維度凍結",
  "dash.dimension.add.fail": "添加失敗，同一欄位不能重複添加維度",
  "dash.dimension.drag.tip": "拖動左側欄位到此處來添加維度",
  "dash.dimension.map.drag.tip": "拖動左側地址或定位字段到此處來添加維度",
  "dash.dimension.provinceCity": "省-市",
  "dash.dimension.provinceCityDistrict": "省-市-區",
  "dash.dimension.x": "維度（行）",
  "dash.dimension.y": "維度（列）",
  "dash.dimension.x.sticky": "凍結行維度",
  "dash.dimension.y.sticky": "凍結列維度",
  "dash.dimension.yearQuarter": "年-季",
  "dash.dimension.yearMonth": "年-月",
  "dash.dimension.yearWeek": "年-周",
  "dash.dimension.yearMonthDay": "年-月-日",
  "dash.dotGuide.func": "統計表的基本功能是對資料做分類統計，「維度」是對資料做分類的依據。",
  "dash.dotGuide.metric": "「指標」是要統計的資料，會根據「維度」中設置的分組方式進行匯總計算。",
  "dash.dotGuide.drag": "拖動欄位到「維度」和「指標」上，即可完成添加。",
  "dash.dotGuide.type": "設置圖表的「維度」和「指標」後，可以選擇合適的圖表類型。",
  "dash.error.chartNumExceed": "添加失敗！ 最多存在{{ limit }}個圖表",
  "dash.error.canNotDeleteMetric": "此指標正在被使用，無法刪除",
  "dash.externalLink": "報表查看連結",
  "dash.enable": "啟用報表",
  "dash.enable.done": "報表已啟用",
  "dash.enable.title": "已將您的報表轉換為報表，但尚未啟用",
  "dash.enable.tip1": "未啟用的報表不支援發佈，您可以在未啟用狀態下調整報表的設計。",
  "dash.enable.tip2": "注意，一旦您啟用報表，那麼可訪問原報表的成員也將立即獲取報表的存取權限，我們建議您在啟用前，確保報表已正確設置，可以覆蓋報表的功能。",
  "dash.field.add.fail": "添加失敗，同一欄位不能重複添加",
  "dash.field.add.guide": "拖入欄位來添加資料",
  "dash.field.changeName": "修改顯示名",
  "dash.field.changeName.tip": "請輸入顯示名稱",
  "dash.field.drag.tip": "拖動左側欄位到此處來添加顯示欄位",
  "dash.field.delete": "刪除欄位",
  "dash.field.groupResultShow": "高級計算",
  "dash.field.group.showReal": "無",
  "dash.field.group.showPercent": "佔比",
  "dash.field.group.showGrowth": "同比/環比",
  "dash.field.group.showConversion": "轉化率",
  "dash.field.growthRate.yoy": "環比增長率",
  "dash.field.growthRate.yoy2": "上年同比增長率",
  "dash.field.growthRate.qoq": "環比增長率",
  "dash.field.growthRate.mom": "環比增長率",
  "dash.field.growthRate.mom2": "上月同比增長率",
  "dash.field.growthRate.wow": "環比增長率",
  "dash.field.growthRate.wow2": "上周同比增長率",
  "dash.field.growthRate.dod": "環比增長率",
  "dash.field.growthValue.yoy": "環比增長值",
  "dash.field.growthValue.yoy2": "上年同比增長值",
  "dash.field.growthValue.qoq": "環比增長值",
  "dash.field.growthValue.mom": "環比增長值",
  "dash.field.growthValue.mom2": "上月同比增長值",
  "dash.field.growthValue.wow": "環比增長值",
  "dash.field.growthValue.wow2": "上周同比增長值",
  "dash.field.growthValue.dod": "環比增長值",
  "dash.field.subformSet": "子表單字段設置",
  "dash.growth.disabled.tip": "維度中有且僅有1個日期時間字段時，才能設置同比/環比。",
  "dash.filter": "篩選控件",
  "dash.clear.filter": "清空篩選",
  "dash.descriptionBtn": "文本控件",
  "dash.image": "图片控件",
  "dash.real.time": "實時時間",
  "dash.filter.quick": "快捷篩選",
  "dash.embedded.iframe": "嵌入頁面",
  "dash.embedded.layout.container": "容器組件",
  "dash.description.empty": "暫無文本內容",
  "dash.filter.add": "添加篩選器",
  "dash.filter.btn": "篩選按鈕",
  "dash.filter.sizer": "篩選器",
  "dash.filter.btn.info": "按鈕用於解決資料量過大導致的篩選緩慢問題。添加篩選按鈕前，請先添加篩選控件",
  "dash.filter.name": "篩選器名稱",
  "dash.filter.selectChart": "1.選擇需要篩選的圖表",
  "dash.filter.selectField": "2.選擇篩選欄位",
  "dash.filter.setDefault": "3.設置篩選器",
  "dash.filter.chart.empty": "當前無可用圖表，請添加圖表或修改已有圖表配置",
  "dash.filter.method": "篩選方式",
  "dash.filter.select.text": "選擇選項",
  "dash.filter.select.custom": "輸入文本",
  "dash.filter.select.input": "精確查詢",
  "dash.filter.field.emptyTip": "無可選欄位，請調整篩選欄位或圖表",
  "dash.filter.chart.emptyMsg": "請選擇篩選圖表",
  "dash.filter.fields.emptyMsg": "請選擇篩選欄位",
  "dash.filter.title.emptyMsg": "請輸入篩選器名稱",
  "dash.format.input.tip": "請輸入自訂格式",
  "dash.format.preview": "效果預覽",
  "dash.lineChart": "折線圖",
  "dash.link.canceled": "聯動已取消",
  "dash.link.empty": "當前沒有圖表與本圖表聯動",
  "dash.max.exceed.title": "匯總計算後數據量過大，僅顯示前2000條",
  "dash.max.exceed.msg": "您可以添加或修改過濾條件來縮小數據范圍",
  "dash.metric": "指標",
  "dash.metric.left": "指標（左）",
  "dash.metric.right": "指標（右）",
  "dash.metric.add": "添加指標",
  "dash.metric.add.tip": "請先添加指標",
  "dash.metric.drag.tip": "拖動左側欄位到此處來添加指標",
  "dash.metric.delete.tip": "刪除此指標？",
  "dash.metric.edit": "編輯指標",
  "dash.metric.exist": "現有指標",
  "dash.metric.add.success": "計算欄位添加成功",
  "dash.metric.inputExpr.tip": "請輸入公式",
  "dash.metricTable": "指標圖",
  "dash.metricTable.tip": "0個維度，1個指標\n1個維度，1個指標",
  "dash.multiAxesChart": "雙軸圖",
  "dash.multiAxesChart.tip": "1個維度，1個或多個指標",
  "dash.multiAxesChart.type": "雙軸圖類型",
  "dash.multiAxesChart.left": "左軸",
  "dash.multiAxesChart.right": "右軸",
  "dash.pivotTable": "透視表",
  "dash.pivotTable.tip": "1個維度，1個或多個指標\n多個維度，1個或多個指標",
  "dash.pieChart": "圓形圖",
  "dash.pieChart.tip": "1個維度，1個指標",
  "dash.radarChart": "雷達圖",
  "dash.mapChart.tip": "1個地理維度，1個指標",
  "dash.mapChart.display": "地圖顯示範圍",
  "dash.drilling": "鑽取",
  "dash.mapChart.drilling": "地圖鑽取",
  "dash.mapChart.drilling.p": "可鑽取到省",
  "dash.mapChart.drilling.pc": "可鑽取到省、市",
  "dash.mapChart.drilling.c": "可鑽取到市",
  "dash.mapChart.drilling.none": "不啟用",
  "dash.mapChart.type": "地圖類型",
  "dash.funnelChart.type": "漏鬥圖類型",
  "dash.pieChart.type": "餅圖類型",
  "dash.columnChart.type": "柱形圖類型",
  "dash.barChart.type": "條形圖類型",
  "dash.mapChart.displayEffect": "顯示效果",
  "dash.mapChart.bubble": "氣泡地圖",
  "dash.mapChart.area": "區域地圖",
  "dash.funnel.common": "基礎漏鬥圖",
  "dash.funnel.customized": "對比漏鬥圖",
  "dash.mapChart.unknownCountry": "有{{- count }}個未知地名",
  "dash.mapChart.unknownProvince": "該省有{{- count }}個未知地名",
  "dash.mapChart.unknownCity": "該市有{{- count }}個未知地名",
  "dash.release": "發佈報表",
  "dash.release.mem": "將報表發佈給團隊成員，成員登錄系統後即可查看報表",
  "dash.release.link": "將報表發佈為公開連結，無需登錄即可查看報表",
  "dash.release.team": "報表訪問內鏈",
  "dash.source": "資料來源",
  "dash.source.description1": "即以當前已存在的表單已經錄入的數據作為數據源，可與其他表單或本表單已經錄入的數據進行各種數據處理操作",
  "dash.source.description2": "如：",
  "dash.source.description3": "頁面錄入數據後，和其他輸入源的數據可以進行橫向連接、追加合併、分組匯總等操作",
  "dash.source.description4": "下圖以追加合併為例",
  "dash.source.etl": "資料視圖輸出表",
  "dash.source.stale": "資料來源已失效",
  "dash.source.stale.tip": "資料來源已失效，請更改資料來源後重新配置圖表",
  "dash.source.select": "請選擇圖表資料來源",
  "dash.source.update": "更改資料來源",
  "dash.source.update.tip": "更改資料來源將清空當前圖表配置，是否確認修改？",
  "dash.subform.fields.set": "請設置需顯示的欄位",
  "dash.subform.fields.select": "選擇顯示欄位",
  "dash.sort.maxCount.tip": "最多能添加{{- count}}個排序規則",
  "dash.sort.add": "添加排序規則",
  "dash.sort.empty": "無排序規則，請添加",
  "dash.sort.setting": "排序規則設置",
  "dash.sort.field.empty": "沒有支援排序的欄位",
  "dash.sort.rule": "排序規則優先順序由高到低",
  "dash.table": "明細表",
  "dash.table.editCustomField": "編輯自訂欄位",
  "dash.table.addCustomField.tip": "使用數學運算子編輯公式",
  "dash.table.inputName.tip": "請輸入欄位名稱",
  "dash.top.limit": "僅支援1～1000的正整數",
  "dash.permission": "資料獲取許可權",
  "dash.permission.all": "資料來源表單中的全部資料",
  "dash.permission.form": "使用成員對資料來源表單的許可權",
  "dash.permission.all.desc": "使用者訪問控件時可以查看控件中的全部資料。",
  "dash.permission.form.desc": "使用者訪問控件時，根據他在資料來源表單所在的許可權組，僅可查看有許可權的資料。",
  "dash.notify": "定時提醒",
  "dash.notify.sub": "提醒成員定時查看報表",
  "dash.notify.help": "如何設置定時提醒？",
  "dash.xAxis.showTag": "強制顯示所有標籤",
  "dash.xAxis.showTag.warning": "勾選此項會導致標籤重疊，影響展示效果，請謹慎",
  "dash.xAxis.tag.direction": "標籤文字顯示方向",
  "dash.xAxis.tag.horizontal": "橫向",
  "dash.xAxis.tag.vertical": "豎向",
  "dash.xAxis.tag.leftBank": "左傾斜",
  "dash.xAxis.tag.rightBank": "右傾斜",
  "dash.yAxis.title.tip": "請輸入標題",
  "dash.statistical.table.tip": "提供多種圖表樣式，對數據進行匯總統計",
  "dash.list.tip": "提炼部分或全部数据到表格中进行查看",
  "dash.calendar.tip": "根據成員權限，以日歷的形式呈現和管理數據",
  "dash.manage.table.tip": "根據成員權限，以表格的形式呈現和管理數據",
  "dash.filter.tip": "用於解決數據量過大導致的篩選緩慢問題，添加篩選按鈕前，請先添加篩選器",
  "dash.filter.btn.tip": "用於篩選儀表盤數據",
  "dash.showSubtotal.tip": "小计",
  "dash.description.tip": "對數據分析結果進行描述性說明",
  "dash.mobileLayout": "移動端佈局",
  "dash.mobileLayout.tip": "開啟移動端佈局，即可自定義控件大小、位置等",
  "dash.mobileLayout.open": "開啟",
  "dash.mobileLayout.close": "關閉移動端佈局",
  "dash.mobileLayout.hide": "隱藏的控件",
  "dash.mobileLayout.hideEmpty": "沒有隱藏的控件\n（隱藏的控件在移動端不顯示）",
  "dash.mobileLayout.closeTip": "離開當前頁後，已有設置不會保存，此操作無法還原。",
  "dash.mobileLayout.closeConfirm": "您確定要關閉移動端樣式嗎？",
  "dash.mobileLayout.closeMsg": "關閉後，已有設置不會保存，此操作無法還原。",
  "dashboard.desc": "工作臺可以創建和切換應用，管理通訊錄，處理待辦任務",
  "dashboard.dingtalk.trial.tip": "當前為試用版本，剩餘{{- days}}天，{{- click}}。",
  "dashboard.dingtalk.trial.click": "請點擊這裡升級",
  "dashboard.dingtalk.trial.marketQr": "打開手機釘釘，掃一掃升級版本",
  "dashboard.broadcast.vipTrial": "想要體驗平台全部強大功能？現在贈送你高級功能30天試用期",
  "dashboard.broadcast.overLimit": "您的使用量已超出系統限制，為保障試用版到期後的正常使用，請升級版本。",
  "dashboard.dotGuide.app1": "應用由表單、流程表單和報表等組成。創建的表單和報表展示在左側清單中",
  "dashboard.dotGuide.app2": "做好的應用可快速訪問和使用。點擊此處進入應用訪問",
  "dashboard.dotGuide.formAndReport": "訪問表單可以提交資料，訪問報表可以查看資料",
  "dashboard.dotGuide.enter": "點擊此處進入工作臺",
  "dashboard.enter": "進入後臺",
  "dashboard.guide.title": "新手引導",
  "dashboard.guide.invite.title": "邀請成員加入",
  "dashboard.guide.invite.desc": "在新手引導中快速邀請成員（您也可以在左上角切換至通訊錄後邀請成員）",
  "dashboard.guide.invite.corp": "通過釘釘/企業微信安裝平台的使用者可跳過此步驟",
  "dashboard.guide.invite.action": "邀請成員",
  "dashboard.guide.create.title": "創建流程/表單/報表",
  "dashboard.guide.create.desc": "創建一個應用，並在應用中添加流程/表單/報表",
  "dashboard.guide.create.action": "瞭解如何創建",
  "dashboard.guide.publish.title": "發佈給成員填報和查看",
  "dashboard.guide.publish.desc": "把創建好的流程/表單/仪表盘發佈給成員，即可開始使用",
  "dashboard.guide.publish.action": "瞭解成員使用方式",
  "data.access.tip": "成員登錄系統訪問資料",
  "data.batch.export.file": "批量匯出附件",
  "data.batch.edit": "批量修改",
  "data.batch.edit.peview.btn": "修改並預覽",
  "data.batch.edit.peview": "批量修改數據預覽",
  "data.batch.edit.peview.subtitle": "<i class='icon-bsy-warning'></i>請先仔細對比【修改後的值】是否是自己需要的結果後，確認修改後結果不可撤回",
  "data.batch.edit.subtitle": "本次操作将修改 <span style='color:red;'>{{len}}</span> 条数据",
  "data.batch.edit.tip": "資料批量修改後將無法撤銷，請謹慎操作；",
  "data.batch.edit.tip.distinct": "設置不允許重複值的欄位不支援修改；",
  "data.batch.edit.tip.field": "圖片、檔、分割線、關聯查詢、關聯資料、定位、手寫簽名欄位不支援批量修改。",
  "data.batch.edit.tip.empty": "如需清空欄位，保留此項為空即可",
  "data.batch.edit.field.select": "請選擇需要修改的欄位",
  "data.batch.edit.warning.distinct": "該欄位不允許重複，不支援批量修改",
  "data.batch.edit.record.view": "查看修改記錄",
  "data.batch.edit.warning.field": "該欄位不支援批量修改",
  "data.batch.edit.busy": "正在修改資料，無法批量修改",
  "data.batch.print.qrCode": "批量列印二維碼",
  "data.batch.transfer": "批量調整負責人",
  "data.batch.transfer.busy": "正在調整負責人，無法批量調整負責人",
  "batch.export.app.packge.title": "應用包導出",
  "batch.export.app.packge": "批量導出應用",
  "move.sort": "移動排序",
  "app.group.empty": "拖拽應用到此處來添加或點擊",
  "data.doCount": "統計資料量",
  "data.counting": "正在統計...",
  "data.doCount.timeout": "統計超時，資料量超出統計範圍",
  "data.comment.empty": "暫無評論",
  "data.comment.noSupport.tip": "回收站中的資料不支援新增評論",
  "data.comment.publish": "發表評論",
  "data.delete.all": "清空全部",
  "data.delete.noAuth.tip": "沒有刪除此資料的許可權",
  "data.display": "資料顯示",
  "data.display.order": "顯示序號",
  "data.display.top.before": "顯示前",
  "data.display.top.after": "條資料",
  "data.transfer.all": "調整全部",
  "data.transfer.selected": "調整選中",
  "data.edit.all": "修改全部",
  "data.edit.selected": "修改選中",
  "data.clear": "清空數據",
  "data.current": "當前資料",
  "data.empty": "暫無數據",
  "data.dock.empty": "該企業沒有給你分享應用/表單權限，請聯繫對方負責人處理",
  "data.content.empty": "暫無內容",
  "data.empty.publish.tip": "暫無數據，你可以將表單發佈給團隊成員或公開發佈來搜集資料",
  "data.first": "已經是本頁第一條資料",
  "data.last": "已經是本頁最後一條資料",
  "data.link.tip": "訪問資料鏈接需要登錄系統並授權",
  "data.noFlow.inProgress": "沒有進行中的流程",
  "data.noFlow.inProgress.selected": "沒有選中進行中的流程，請重新選擇",
  "data.next": "下一條",
  "data.edit.next": "編輯下一條",
  "data.view.next": "查看下一條",
  "data.next.tip": "查看下一條數據，快速鍵「→」",
  "data.openLink": "公開連結",
  "data.openLink.tip": "通過公開連結訪問資料",
  "data.openLink.desc": "通過公開連結，無需登錄即可訪問資料",
  "data.openLink.subtitle": "通過公開連結，無需登錄即可訪問表單和資料",
  "data.pdf": "PDF預覽",
  "data.prev": "上一條",
  "data.none": "沒有資料",
  "data.permission.get": "資料獲取許可權",
  "data.edit.prev": "編輯上一條",
  "data.view.prev": "查看上一條",
  "data.prev.tip": "查看上一條數據，快速鍵「←」",
  "data.print": "正在生成列印檔案，請等待",
  "data.qr.private": "數據內鏈二維碼",
  "data.qr.public": "數據外鏈二維碼",
  "data.rely": "數據聯動",
  "data.cancelOperation": "取消操作",
  "data.operation.select": "請選擇需要操作的資料",
  "data.select": "當前選中了{{- count}}條資料",
  "data.select.all": "您當前選中了全部資料",
  "data.print.selected": "列印選中",
  "data.print.all": "列印全部",
  "data.file.export.selected": "匯出選中資料的附件",
  "data.file.export.all": "匯出全部資料的附件",
  "data.file.export.waitingTip": "正在打包附件，請等待",
  "data.file.export.packingTip": "您可以關閉頁面，系統將會繼續打包附件",
  "data.recover.select": "恢復選中",
  "data.recover.all": "恢復全部",
  "data.recover.confirm": "您確定要恢復所選資料嗎？",
  "data.recover.tip": "{{- selectText}}，資料恢復後可在資料管理中查看",
  "data.hardDelete.confirm": "您確定要徹底刪除所選資料嗎？",
  "data.hardDelete.tip": "{{- selectText}}，徹底刪除後資料無法恢復",
  "data.selected": '选中的数据',
  "data.any": "任意數據",
  "data.id": "數據ID",
  "data.id.only": "數據的唯一ID",
  "data.label": "數據標題",
  "data.label.add.field": "添加欄位",
  "data.label.subTitle": "資料標題用於快速辨識一條資料，適用於資料表格首列標題、關聯資料、資料詳情頁等功能場景中",
  "data.label.firstField": "第一個欄位的值",
  "data.label.custom": "自訂標題",
  "data.label.tip": "輸入文字或添加欄位，至少需要添加一個欄位",
  "data.label.required": "自訂標題不能為空",
  "data.label.fail1": "自訂標題至少需要添加一個欄位",
  "data.label.fail2": "資料標題最多支援20個欄位",
  "data.auth": "數據許可權",
  "data.auth.short": "數據許可權",
  "data.auth.title": "可以查看到哪些資料",
  "data.auth.subTitle": "設置對應的「資料許可權」，可以讓團隊成員管理表單搜集到的資料",
  "data.auth.add": "添加許可權組",
  "data.auth.create": "新建許可權組",
  "data.auth.edit": "編輯許可權組",
  "data.auth.select": "選擇許可權組",
  "data.auth.required": "許可權組名稱不能為空",
  "data.auth.name": "名稱資訊",
  "data.auth.name.title": "可設置許可權組名稱和描述資訊",
  "data.auth.name.placeholder": "填寫許可權組名稱",
  "data.auth.description.placeholder": "填寫描述資訊",
  "data.auth.options": "操作許可權",
  "data.auth.options.short": "操作許可權",
  "data.auth.options.coopTitle": "可對資料進行哪些操作",
  "data.auth.options.flowTitle": "可對流程進行哪些操作",
  "data.auth.field.title": "可以查看和編輯資料的哪些欄位",
  "data.notify": "推送提醒",
  "data.notify.subTitle": "通過設置推送提醒可以到期查看提醒內容",
  "data.notify.create": "新建推送提醒",
  "data.notify.delete.confirm": "您確定要刪除這條推送提醒嗎？",
  "data.notify.delete.msg": "刪除推送提醒後被提醒人將無法收到消息提醒，此操作無法還原",
  "data.notify.time": "提醒時間",
  "data.notify.overTime": "結束提醒時間",
  "data.notify.dataCreate": "新資料提交時提醒",
  "data.notify.dataUpdate": "資料修改後提醒",
  "data.notify.custom": "自訂時間提醒",
  "data.notify.custom.tip": "提示：設置自訂時間提醒前，請先將本表單共用給成員或將成員加入相關協作許可權組。",
  "data.notify.update.tip": "提示：被提醒人若不在相關許可權組中，收到提醒時無法查看資料。",
  "data.notify.update.any": "任意欄位修改後提醒",
  "data.notify.update.detail.single": "{{- field}}欄位修改後提醒",
  "data.notify.update.detail.multi": "{{- fields}}中的任意欄位修改後提醒",
  "data.notify.field.set": "提醒欄位設置",
  "data.notify.field.set.tip": "請至少選擇一個提醒欄位",
  "data.notify.field.set.desc": "請選擇修改資料會觸發提醒的欄位",
  "data.notify.update.fields": "指定欄位修改後提醒",
  "data.notify.update.fields.tip": "提示：如果設置了多個提醒欄位，任意一個欄位被修改就會觸發提醒",
  "data.notify.update.set": "指定欄位修改後提醒",
  "data.notify.byWidget": "根據表單內日期時間欄位提醒",
  "data.notify.byWidget.tip": "提示：被提醒人若不在相關許可權組中，收到提醒時無法查看資料。",
  "data.notify.byWidget.placeholder": "請選擇表單內的日期時間欄位",
  "data.notify.startTime.set": "請設置開始提醒時間",
  "data.notify.customRange": "在{{time}}提醒",
  "data.notify.customRange.repeat": "（{{repeat}}提醒一次，於{{time}}結束）",
  "data.at.repeat": "（{{repeat}}重復，於{{time}}結束）",
  "data.notify.widgetLabel": "在{{- label}}",
  "data.notify.today": "當天，",
  "data.notify.current": "當時提醒",
  "data.notify.widgetResult": "於{{time}}提醒",
  "data.notify.offsetTime": "{{time}}提醒",
  "data.notify.condition": "提醒條件",
  "data.notifier": "被提醒人：",
  "data.notify.type": "提醒方式",
  "data.notify.everyday": "每天",
  "data.notify.everyWeek": "每週",
  "data.notify.everyTwiceWeek": "每兩周",
  "data.notify.everyMonth": "每月",
  "data.notify.everyYear": "每年",
  "data.notify.leave.msg": "離開當前頁後，您的推送提醒設置不會被保存",
  "data.notify.defaultMsg": "請及時處理",
  "data.notify.title": "如何設置推送提醒？",
  "data.notify.over": "請設置結束提醒時間",
  "data.notify.target": "被提醒人",
  "data.notify.target.set": "點擊設置被提醒人",
  "data.notify.onlyOnce": "只提醒一次",
  "data.notify.once": "{{time}}提醒一次",
  "data.notify.customRepeat": "自訂重複",
  "data.notify.repeatText": "的{{repeat}}",
  "data.notify.repeatType": "重複類型",
  "data.notify.mode": "提醒類型",
  "data.notify.lastDay": "最後一個自然日",
  "data.notify.assign": "指定日期",
  "data.notify.relative": "相對日期",
  "data.notify.repeat.week": "按周重複",
  "data.notify.repeat.month": "按月重複",
  "data.notify.currentTime": "當時",
  "data.notify.before": "之前",
  "data.notify.after": "之後",
  "data.notify.accordWithCondition": "滿足條件的資料",
  "data.notify.condition.add": "添加條件",
  "data.notify.condition.addTip": "（請添加表單內欄位，當提交的資料滿足您設置的表單字段條件時收到提醒）",
  "data.notify.msg": "提醒文字",
  "data.notify.corp": "{{corp}}提醒",
  "data.notify.typeTip": "（可多選，至少選擇一種提醒方式）",
  "data.notify.corpTip": "成員用戶必須綁定郵箱或關注微信服務號，才能收到提醒。",
  "data.notify.corpText": "如何設置？",
  "data.notify.createMsg": "有新資料提交，請及時處理",
  "data.notify.customMsg": "已到提醒時間，請及時處理",
  "data.notify.widgetMsg": "有資料到期，請及時處理",
  "data.notify.updateMsg": "有資料被修改，請及時處理",
  "data.notify.fail1": "未設置被提醒人",
  "data.notify.fail2": "未設置提醒時間",
  "data.notify.fail3": "未設置結束時間",
  "data.notify.fail4": "未選擇表單內的時間日期欄位",
  "data.notify.fail5": "重複類型未設置完整",
  "data.submitPrompt": "提交跳转",
  "data.submitPrompt.subTitle": "自訂表單提交成功後的提示內容，以及可以跳转指定链接",
  "data.submitPrompt.label": "表單提交後顯示",
  "data.submitPrompt.system": "系統預設提示",
  "data.submitPrompt.custom": "自訂提示頁面",
  "data.submitPrompt.insert": "插入表單字段",
  "data.submitPrompt.maxWordCount": "富文本的字數上限為200個字，提交頁面的實際顯示內容也為前200個字",
  "data.submitPrompt.wordsCount": "還可以輸入{{words}}個字",
  "data.submitPrompt.nextTip": "顯示“繼續添加”按鈕",
  "data.submitPrompt.tip": "可以添加文字、表單字段和系統欄位，可對文字和欄位進行富文本編輯",
  "data.submitPrompt.tip1": "彈出表單提交後自動關閉",
  "data.submitPrompt.href": "表單提交後跳轉指定鏈接",
  "data.submitPrompt.href.tip1": "新頁面打開",
  "data.submitPrompt.href.externalUrl": "外部鏈接",
  "data.submitPrompt.href.internalFrom": "內部表單",
  "data.submit.check": "資料提交校驗",
  "data.submit.c.base": "資料提交，正在計算",
  "data.submit.c.zhong": "中",
  "data.submit.c.ing": "正在計算",
  "data.submit.c.timeout.tip": "提交時間過長？ 請聯系管理員調整表單設計",
  "data.printTemplate": "列印範本",
  "data.printTemplate.select": "選擇列印範本",
  "data.printTemplate.system": "系統列印範本",
  "data.printTemplate.custom": "自訂列印範本",
  "data.printTemplate.learnMore": "瞭解列印範本",
  "data.printTemplate.failForFree": "免費版使用者無法使用自訂列印範本功能",
  "data.printTemplate.empty": "您還沒有為此表單創建過列印範本",
  "data.printTemplate.createCustom": "創建自訂列印範本",
  "data.printTemplate.customEmpty": "暫無相關列印範本",
  "data.printTemplate.set": "列印範本設置",
  "data.printTemplate.subTitle": "列印表單時將按照使用中的範本格式列印",
  "data.printTemplate.emptyTip": "此範本未被任何位置使用",
  "data.printTemplate.create": "新建列印範本",
  "data.printTemplate.deleteMsg": "刪除此範本後，原先使用此範本的位置將會使用預設列印範本來列印表單。",
  "data.printTemplate.rangeTip": "此範本在以下位置使用",
  "data.printTemplate.rangeView": "查看使用範圍",
  "data.printTemplate.emptyInfo": "此範本未被該流程版本中的節點使用",
  "data.printTemplate.word.edit": "編輯word模板信息",
  "data.printTemplate.word.name": "打印模板名稱",
  "data.printTemplate.word.push": "上傳模板",
  "data.operation.record": "操作记录",
  "data.api": "數據推送",
  "data.api.subTitle": "資料推送可將表單數據推送至您指定的伺服器",
  "data.api.create": "新建數據推送",
  "data.api.custom": "推送到自訂伺服器",
  "data.api.fr": "推送到FineReport伺服器",
  "data.api.log": "推送日誌",
  "data.api.deleteTitle": "您確定要刪除這條資料推送嗎？",
  "data.api.deleteMsg": "刪除資料推送後目標伺服器將無法收到推送資料，此操作無法還原",
  "data.api.fail.tip1": "{{count}} 條資料推送失敗，請調整配置後重新推送",
  "data.api.fail.tip2": "超過 100 條資料推送失敗，推送已暫停。 系統為您保留了前 100 條失敗資料，請調整配置後重新推送",
  "data.api.trigger.create": "有新資料提交時推送",
  "data.api.trigger.update": "有資料被修改時推送",
  "data.api.trigger.remove": "有資料被刪除時推送",
  "data.api.trigger.recover": "有資料被恢復時推送",
  "data.api.trigger.formUpdate": "表單結構有變化時推送",
  "data.api.trigger.comment": "有新增評論時推送",
  "data.api.trigger.comment.edit": "有評論被修改時推送",
  "data.api.flow.status": "當新增，修改數據，或流程狀態更改時，推送數據和流程狀態信息",
  "data.api.serverUrl": "伺服器位址：{{- url}}",
  "data.api.serverUrl.config": "伺服器位址",
  "data.api.push.now": "正在推送，請稍後",
  "data.api.push.finish": "推送完成",
  "data.api.push.finish.detail": "{{- success}}條資料推送成功，{{- fail}}條資料推送失敗",
  "data.api.push.again": "重新推送",
  "data.api.push.again.tip": "確定要重新推送這些資料嗎？",
  "data.api.push.again.detail": "重新推送前，請確保您的資料推送已正確配置。",
  "data.api.push.discard": "放棄推送",
  "data.api.push.discard.tip": "確定要放棄推送這些資料嗎？",
  "data.api.push.discard.detail": "放棄推送會刪除失敗記錄，此操作不可撤銷。",
  "data.api.pushTime": "推送時間：{{time}}",
  "data.api.doc.title": "欄位對照表及JSON樣例",
  "data.api.form.structure": "表單資料結構",
  "data.api.flowState.explain": "2表示流程手動結束；1表示流程已完成；0表示流程進行中",
  "data.api.leaveMsg": "離開當前頁後，您的資料推送設置不會被保存",
  "data.api.log.fail": "推送失敗日誌",
  "data.api.log.success": "推送成功日誌",
  "data.api.allLog": "全部日誌",
  "data.api.logTip": "僅保留6個月的推送日誌",
  "data.api.logTime": "推送時間",
  "data.api.logUrl": "推送位址",
  "data.api.logResult": "推送結果",
  "data.api.logDetail": "推送詳情",
  "data.api.logEmpty": "暫無推送日誌",
  "data.api.fail": "推送失敗",
  "data.api.code": "狀態碼",
  "data.api.server": "目標伺服器",
  "data.api.server.custom": "自訂伺服器",
  "data.api.server.fr": "FineReport伺服器",
  "data.api.server.test": "伺服器連接測試",
  "data.api.secret.create": "生成Secret",
  "data.api.server.target": "請填寫目標伺服器位址",
  "data.api.server.connecting": "正在連接伺服器...",
  "data.api.server.connectSuccess": "伺服器連接成功！",
  "data.externalLink": "數據外鏈",
  "data.externalLink.subTitle": "將表單中的資料發佈為獨立的公開連結，無需登錄即可訪問資料",
  "data.externalLink.allEnabled": "可查看全部欄位，可編輯全部欄位",
  "data.externalLink.enabledCount": "可查看全部欄位，可編輯{{count}}個欄位",
  "data.externalLink.enabled": "可查看全部欄位",
  "data.externalLink.visibleEnabledCount": "可查看{{visibleCount}}個欄位，可編輯{{enableCount}}個欄位",
  "data.externalLink.visibleCount": "可查看{{count}}個欄位",
  "data.externalLink.auth": "外鏈許可權配置",
  "data.externalLink.info": "可以查看和編輯資料外鏈的哪些欄位",
  "data.view": "查看數據",
  "date.ago.minute": "{{value}}分鐘前",
  "date.day": "{{day}}日",
  "date.days": "{{day}}天",
  "date.number": "{{number}}號",
  "date.hours": "{{hour}}小時",
  "date.minutes": "{{minute}}分鐘",
  "date.end": "結束日期",
  "date.just": "剛剛",
  "date.lastMonth": "上月",
  "date.lastWeek": "上周",
  "date.lastSevenDays": "過去7天",
  "date.month": "{{month}}月",
  "date.quarter": "第{{quarter}}季度",
  "date.static": "固定值",
  "date.formula": "公式計算值",
  "date.start": "起始日期",
  "date.thisMonth": "本月",
  "date.thisWeek": "本周",
  "date.today": "當天",
  "date.today.after": "今天之後",
  "date.today.before": "今天之前",
  "date.today.time": "今天{{hour}}:{{minute}}",
  "date.week": "{{week}}周",
  "date.year": "{{year}}年",
  "date.thisYear": "今年",
  "date.lastYear": "去年",
  "date.year_quarter": "{{year}}年第{{quarter}}季度",
  "date.year_month": "{{year}}年{{month}}月",
  "date.year_week": "{{year}}年{{week}}周",
  "date.year_month_day": "{{year}}年{{month}}月{{day}}日",
  "date.month_day": "{{month}}月{{day}}日",
  "date.yesterday": "昨天",
  "date.sunday": "星期日",
  "date.monday": "星期一",
  "date.tuesday": "星期二",
  "date.wednesday": "星期三",
  "date.thursday": "星期四",
  "date.friday": "星期五",
  "date.saturday": "星期六",
  "date.sunday.short": "日",
  "date.monday.short": "一",
  "date.tuesday.short": "二",
  "date.wednesday.short": "三",
  "date.thursday.short": "四",
  "date.friday.short": "五",
  "date.saturday.short": "六",
  "date.sunday.custom": "周日",
  "date.monday.custom": "周一",
  "date.tuesday.custom": "周二",
  "date.wednesday.custom": "周三",
  "date.thursday.custom": "周四",
  "date.friday.custom": "周五",
  "date.saturday.custom": "周六",
  "date.january": "一月",
  "date.january.short": "1月",
  "date.january.short.chain": "一",
  "date.february": "二月",
  "date.february.short": "2月",
  "date.february.short.chain": "二",
  "date.march": "三月",
  "date.march.short": "3月",
  "date.march.short.chain": "三",
  "date.april": "四月",
  "date.april.short": "4月",
  "date.april.short.chain": "四",
  "date.may": "五月",
  "date.may.short": "5月",
  "date.may.short.chain": "五",
  "date.june": "六月",
  "date.june.short": "6月",
  "date.june.short.chain": "六",
  "date.july": "七月",
  "date.july.short": "7月",
  "date.july.short.chain": "七",
  "date.august": "八月",
  "date.august.short": "8月",
  "date.august.short.chain": "八",
  "date.september": "九月",
  "date.september.short": "9月",
  "date.september.short.chain": "九",
  "date.october": "十月",
  "date.october.short": "10月",
  "date.october.short.chain": "十",
  "date.november": "十一月",
  "date.november.short": "11月",
  "date.november.short.chain": "十一",
  "date.december": "十二月",
  "date.december.short": "12月",
  "date.december.short.chain": "十二",
  "date.format": "yyyy年MM月dd日 HH:mm",
  "dataTable.deleteAllTip": "您當前選中了全部資料，資料刪除後可在回收站中恢復",
  "dataTable.deleteAllTip.mergeAuth": "根據資料許可權的設置，你可能無法刪除全部可見資料。",
  "dataTable.deleteAllSelectDataTip": "您確定要刪除所選資料嗎？",
  "dataTable.dataRecover": "恢復刪除資料？瞭解高級版本",
  "dataTable.deleteTip": "您當前選中了{{- length}}條資料，資料刪除後可在回收站中恢復",
  "dataTable.deleteTipForFree": "您當前選中了{{- length}}條資料，免費版刪除的資料無法恢復",
  "dataTable.deleteAllTipForFree": "您當前選中了全部資料，免費版刪除的資料無法恢復",
  "dataTable.deleteAllDataTip": "您確定要清空所有資料嗎？",
  "dataTable.editor.exit": "退出編輯",
  "dataLimitTip.link": "該賬號的本月資料流程量已用完，無法提交新資料，請聯繫連結發佈者升級版本",
  "dataLimitTip.account": "該賬號的本月資料流程量已用完，無法提交新資料，請聯繫賬號創建者升級版本",
  "dataLimitTip.account.admin": "您的本月資料流量已用完，無法提交新資料，請升級版本",
  "dingtalkCorp.corpSelect": " 企業選擇",
  "dingtalkCorp.empty.title": "您還不在平台成員列表中",
  "dingtalkCorp.empty.subTitle": "請聯繫貴司管理員同步成員",
  "dingtalkCorp.bind": "綁定您的平台賬號",
  "delete.hard": "徹底刪除",
  "delete.multi": "批量刪除",
  "delete.selected": "刪除選中",
  "delete.all": "刪除全部",
  "delete.success": "刪除成功!",
  "delete.fail": "刪除失敗!",
  "delete.confirm": "您確定要刪除“{{- name}}”嗎？",
  "dept.add": "添加部門",
  "dept.add.level.fail": "部門層級超過{{- level}}層，無法添加",
  "dept.current": "當前用戶所處部門",
  "dept.delete.tip": "刪除部門會將部門所關聯的許可權一併刪除，此操作不可逆",
  "dept.empty": "暫無相關部門",
  "dept.manager": "部門主管",
  "dept.manager.grade.suffix": "的主管級別：",
  "dept.manager.set": "設置部門主管",
  "dept.set": "設置部門",
  "dept.sub.add": "添加子部門",
  "dept.name.placeholder": "請輸入名稱",
  "dept.name.required": "請輸入部門名稱",
  "dept.name.notEmpty": "部門名稱不能為空",
  "dept.name.tooLong": "部門名稱不能超過{{length}}個字",
  "dept.select.tip": "請至少選擇一個部門",
  "dept.manager.grade.one": "直接部門主管",
  "dept.manager.grade.two": "上級部門主管",
  "dept.manager.grade.three": "三級部門主管",
  "dept.manager.grade.four": "四級部門主管",
  "dept.manager.grade.five": "五級部門主管",
  "combine.date": "日期匯總",
  "combine.yearAndMonth": "年、月",
  "combine.yearAndMonthAndDay": "年、月、日",
  "combine.address": "地址匯總",
  "combine.provinceAndCity": "省、市",
  "combine.detail": "關聯釋義",
  "combine.rule": "匯總方式",
  "combine.percent": "匯總占比",
  "contact.all": "全部連絡人",
  "contact.edit": "編輯連絡人",
  "contact.search": "搜索連絡人",
  "contact.search.emptyTip": "當前分組無搜尋結果，請檢查搜索值或在「全部連絡人」中搜索",
  "contact.all.search.emptyTip": "無搜尋結果，請檢查搜索值",
  "contact.group": "連絡人分組",
  "contact.group.default": "未分組",
  "contact.group.add": "添加分組",
  "contact.group.delete.confirm": "您是否要刪除“{{- name}}”？",
  "contact.group.delete.tip": "刪除分組後該分組內連絡人仍然保留在「全部連絡人」內。",
  "contact.group.placeholder": "請輸入連絡人分組名稱",
  "contact.group.name.notEmpty": "連絡人分組名稱不能為空",
  "contact.group.name.tooLong": "連絡人分組名稱不能超過32個字",
  "contact.add": "添加連絡人",
  "contact.add.success": "添加連絡人成功",
  "contact.delete": "刪除連絡人",
  "contact.delete.confirm": "您確定要刪除所選連絡人嗎？",
  "contact.delete.tip": "刪除連絡人會同時刪除該連絡人的許可權，且無法還原",
  "contact.delete.select.tip": "請選擇要刪除的連絡人",
  "contact.notSave.warning": "您的連絡人未保存,確認離開當前頁面?",
  "contact.notSave.tip": "離開當前頁您的連絡人資訊將不會被保存",
  "contact.phone.valid.tip": "手機格式不正確",
  "contact.note": "備註",
  "contact.name.placeholder": "請輸入名稱",
  "contact.name.tooLong": "分組名稱不能超過{{length}}個字",
  "contact.position": "連絡人職位",
  "contact.phone": "連絡人手機號",
  "contact.template": "通訊錄範本",
  "contact.template.import.tip": "每次最多導入200名成員，已經在通訊錄內或資訊有誤的成員不導入",
  "custom.color": "自訂顏色",
  "custom.login": "自訂登錄頁",
  "custom.login.style": "自訂登錄樣式",
  "custom.login.mode": "登錄方式",
  "custom.login.range.tip": "應用於企業帳號URL和發佈給成員的內連結中",
  "custom.login.config.close.title": "您確定要關閉配置頁面嗎？ ",
  "custom.login.config.close.msg": "關閉後已更改的配置項不會保存，此操作無法還原",
  "custom.login.auto.close.option": "自動登入選項",
  "custom.login.language.option": "語言選項",
  "custom.login.register.entrance": "註冊入口",
  "custom.login.showFigure": "展示圖",
  "custom.login.corpLogo": "企業 logo",
  "custom.login.save.title": "您尚未開啟單點登錄功能，確認保存？",
  "custom.login.save.mag": "您在「登錄方式」中勾選了「單點登錄」，保存配置後，使用單點登錄時將登錄失敗",
  "design.withMark": "（設計）",
  "dataSource.update.confirm": "您確定要修改資料來源嗎？",
  "dataSource.update.tip": "修改資料來源設置會清空已有的欄位配置和條件過濾等選項，且無法還原",
  "dataSource.update.msg": "修改資料來源設置會清空已有的欄位配置，是否確認修改？",
  "dataSource.singleForm": "單表數據",
  "dataSource.multiForm": "多表關聯",
  "dataSource.joinField.required": "請選擇表單字段建立關聯",
  "dataSource.joinField.invalid.warning": "所選關聯欄位資料類型不一致或關聯欄位不存在!",
  "dataSource.joinTable.required": "請先選擇關聯表",
  "effective.client.tip": "該功能僅對微信服務號/企業微信和釘釘移動用戶端有效",
  "email.invalid.warning": "請輸入正確的郵箱",
  "email.bind": "綁定郵箱",
  "email.new": "新郵箱",
  "email.current": "當前郵箱",
  "email.set.success": "郵箱設置成功",
  "email.verify": "驗證郵箱",
  "email.update": "修改郵箱",
  "email.update.success": "郵箱修改成功",
  "email.unbind": "解綁郵箱",
  "email.unbind.success": "郵箱解綁成功",
  "email.unbind.confirm": "您確定要解綁郵箱嗎？",
  "email.unbind.tip": "解綁郵箱需驗證當前綁定郵箱的真實性，且解綁後將無法通過原郵箱登錄平台，如需繼續使用郵箱登錄，可以在解綁後重新綁定新郵箱",
  "equidistance.horizontal": "水準等距",
  "equidistance.vertical": "垂直等距",
  "error.1": "錯誤的請求",
  "error.201": "操作失敗，請刷新頁面後重試",
  "error.1000": "該賬號不存在",
  "error.1001": "密碼不正確",
  "error.1002": "該賬號尚未啟動",
  "error.1003": "微信綁定失敗",
  "error.1004": "URL已被使用",
  "error.1005": "郵箱已存在",
  "error.1006": "資訊不符合規範",
  "error.1007": "註冊失敗",
  "error.1008": "使用者名已被佔用，請更換使用者名",
  "error.1009": "該郵箱已被佔用",
  "error.1010": "用戶不存在",
  "error.1011": "密碼格式不符合規則",
  "error.1012": "您未設置密碼",
  "error.1013": "密碼錯誤超過5次，賬號已被鎖定，請1小時後重試或重置密碼",
  "error.1014": "用戶創建失敗",
  "error.1015": "使用者資訊緩存失敗",
  "error.1016": "用戶啟動碼已過期",
  "error.1017": "用戶名不符合格式要求",
  "error.1018": "用戶郵箱不符合格式要求",
  "error.1019": "用戶昵稱不符合格式要求",
  "error.1020": "用戶校驗參數不存在",
  "error.1021": "用戶校驗參數與當前用戶不匹配",
  "error.1022": "用戶團隊不存在",
  "error.1023": "用戶名與郵箱不能同時為空",
  "error.1024": "手機號錯誤",
  "error.1025": "圖片驗證碼錯誤",
  "error.1026": "驗證碼錯誤",
  "error.1027": "手機號碼已存在",
  "error.1028": "操作過於頻繁，獲取驗證碼失敗。 請在1分鐘後再獲取驗證碼",
  "error.1029": "該功能僅供共創用戶使用",
  "error.1030": "用戶未登錄",
  "error.1031": "郵箱驗證碼不正確",
  "error.1032": "郵箱位址不正確",
  "error.1033": "用戶已被禁止訪問",
  "error.1034": "oauth認證access_token獲取失敗",
  "error.1035": "oauth認證使用者資訊獲取失敗",
  "error.1036": "用戶團隊創建失敗",
  "error.1037": "用戶團隊已經創建或當前用戶已綁定企業",
  "error.1038": "用戶未進行該類型綁定或已解綁",
  "error.1039": "使用者需保留至少一種登錄方式",
  "error.1040": "由於業務調整，平台不再支持使用新的QQ/微博賬號登錄，請使用其他方式登錄或註冊！給您帶來不便，十分抱歉",
  "error.1041": "該協力廠商賬號已被其他平台用戶綁定",
  "error.1042": "當前用戶無法試用高級版功能",
  "error.1043": "用戶不屬於當前團隊",
  "error.1044": "您的賬號不滿足申請條件",
  "error.1045": "當前賬號未綁定手機號",
  "error.1046": "當前賬號不屬於推廣者",
  "error.1047": "當前賬號未加入推廣聯盟",
  "error.1048": "當前賬號推廣碼已被禁用",
  "error.1049": "當前用戶已提交認證申請，請勿重複提交",
  "error.1050": "實名制認證創建失敗",
  "error.1051": "實名制認證資訊不存在",
  "error.1052": "當前不可修改實名制認證資訊",
  "error.1053": "當前用戶提現或實名制認證中，禁止修改支付寶相關資訊",
  "error.1054": "當前用戶沒有收到邀請或已加入團隊",
  "error.1055": "釘釘推廣申請不存在",
  "error.1056": "當前不可修改釘釘推廣資訊",
  "error.1057": "邀請連結已過期",
  "error.1058": "用戶操作許可權不足",
  "error.1059": "未做任何修改",
  "error.1061": "連絡人數量已達到上限，無法創建",
  "error.1062": "已存在同名連絡人分組",
  "error.1063": "當前用戶不允許修改團隊名稱",
  "error.1064": "團隊名稱不符合規範",
  "error.1065": "當前用戶已加入團隊",
  "error.1066": "已存在 API KEY，不能重複創建",
  "error.1067": "提交了規範外的資訊",
  "error.1068": "當前企業不匹配",
  "error.1069": "當前使用者需要補充使用者畫像資訊後才能開啟高級版功能試用",
  "error.1070": "只有一種賬號登錄方式時無法解綁",
  "error.1071": "當前手機號不正確",
  "error.1072": "當前郵箱不正確",
  "error.1073": "非企業微信集成模式不能登出企業賬號",
  "error.1074": "您已提交過註銷申請，請等候處理",
  "error.1075": "微信綁定失敗，此微信賬號已綁定平台賬號",
  "error.1076": "連續多次密碼錯誤",
  "error.1079": "當前賬號不是企業微信管理員",
  "error.1082": "手機號同郵箱不能同時為空",
  "error.1085": "成員姓名不能超過12个字符",
  "error.1087": "企業用戶id已存在",
  "error.1090": "同步成員不能加入其他企業",
  "error.1092": "成員編號最長12个字符",
  "error.1101": "管理組不存在",
  "error.1102": "當前部門不在管理組可管理範圍內",
  "error.1103": "請先切換到對應企業",
  "error.1104": "沒有管理組操作許可權",
  "error.1105": "不合法的管理組ID",
  "error.1106": "不能將自己移除管理組",
  "error.1107": "存在其它管理組成員",
  "error.1108": "企業創建者不能加入任何管理組",
  "error.1200": "不合法的角色ID",
  "error.1201": "企業角色資訊不存在",
  "error.2000": "應用名稱不能為空",
  "error.2001": "應用URL已存在",
  "error.2002": "應用URL存在非法字元",
  "error.2003": "應用管理員不存在",
  "error.2004": "該應用已被刪除，請打開工作臺選擇其他應用",
  "error.2005": "應用無法複製",
  "error.2006": "該應用無法發佈",
  "error.2007": "應用發佈失敗",
  "error.2008": "應用發佈拷貝失敗",
  "error.2009": "沒有應用操作許可權",
  "error.2010": "沒有跨應用操作許可權",
  "error.2011": "該應用使用了『跨應用』功能，暫不支援發佈到範本中心",
  "error.2012": "由於應用內存在違規資訊，已被禁止訪問",
  "error.2013": "應用未開啟推廣連結，無法訪問",
  "error.2014": "您不是系統管理員或企業建立者，請登錄相關賬戶安裝或將連結發送給相關人員進行安裝。",
  "error.2015": "該應用使用了『跨應用』功能，暫不支援開啟推廣連結",
  "error.2016": "已存在推廣中的同源應用，該應用無法開啟推廣連結",
  "error.2017": "該應用已開啟推廣連結，暫不支援使用『跨應用』功能",
  "error.2018": "沒有應用刪除許可權",
  "error.2019": "沒有應用編輯許可權",
  "error.2020": "僅系統管理員能複製發佈應用",
  "error.2021": "沒有應用創建許可權",
  "error.2022": "沒有應用安裝許可權",
  "error.2023": "默認應用不能重複安裝",
  "error.2027": "僅系統管理員能調整應用順序",
  "error.2029": "移動失敗，拖拽檔已被其他管理員刪除，請刷新頁面",
  "error.2030": "移動失敗，檔案清單已被其他管理員改動，請刷新頁面",
  "error.2031": "試用中的應用不支援複製",
  "error.2032": "試用中的應用不支援開啟安裝連結",
  "error.2033": "試用中的應用不支援發佈至範本中心",
  "error.3000": "表單不存在",
  "error.3001": "名稱不能為空",
  "error.3002": "非指定類型",
  "error.3003": "父節點不存在",
  "error.3004": "表單成員控制項不存在",
  "error.3005": "參數不正確",
  "error.3006": "聚合表不存在",
  "error.3007": "該表單已被聚合表引用，無法刪除",
  "error.3008": "不支援資料編輯操作",
  "error.3009": "操作許可權不足",
  "error.3010": "表單流程版本不正確",
  "error.3011": "外鏈擴展參數不正確",
  "error.3012": "密碼不正確",
  "error.3013": "由於網頁存在違規資訊，已被禁止訪問。",
  "error.3014": "當前應用內聚合表數量已達到上限",
  "error.3015": "發佈對外連結,請先完成手機綁定",
  "error.3016": "您的表單連結暫時不可用，我們會在24小時內審核您的表單，審核通過之後連結方可使用。",
  "error.3017": "表單列印範本不存在",
  "error.3018": "表單列印範本創建失敗",
  "error.3019": "當前表單列印範本數量已達到上限",
  "error.3020": "表單提醒配置不存在",
  "error.3021": "表單提醒配置發生變更，無法執行",
  "error.3022": "表單提醒週期已超出結束時間",
  "error.3023": "當前任務正在執行中，無法修改",
  "error.3024": "表單許可權組不存在",
  "error.3025": "表單提醒資料發生變更，無法執行",
  "error.3026": "應用未安裝，請先安裝應用再提交資料。",
  "error.3027": "表單自增 Id 獲取失敗",
  "error.3028": "伺服器 URL 格式不正確",
  "error.3029": "當前登錄團隊為：{{corpName}}\n如果確認團隊無誤，請聯繫管理員分配頁面許可權",
  "error.3031": "資料推送組已達上限，請刪除多餘推送組後再新建",
  "error.3032": "表單數據推送創建失敗",
  "error.3033": "表單數據推送配置不存在",
  "error.3034": "報表控制項不存在",
  "error.3035": "連接失敗, 請檢查您的伺服器配置",
  "error.3036": "添加的圖片數量已達上限",
  "error.3037": "無效的手寫簽名二維碼連結",
  "error.3038": "表單控制項不存在",
  "error.3039": "表單控制項類型不匹配",
  "error.3040": "表單控制項配置校驗失敗",
  "error.3041": "單個表單流水號控制項數量超出上限",
  "error.3042": "欄位別名校驗失敗",
  "error.3043": "報表控制項不存在",
  "error.3044": "表單流程節點配置不正確",
  "error.3045": "報表緩存獲取超時",
  "error.3046": "外鏈表單推送失敗",
  "error.3047": "沒有需要重新推送的資料",
  "error.3048": "已有重新推送任務",
  "error.3049": "重新推送失敗",
  "error.3050": "非空分組不能刪除",
  "error.3057": "報表功能已下線，使用報表實現相關功能",
  "error.4000": "資料提交失敗",
  "error.4001": "資料不存在",
  "error.4002": "提交值重複",
  "error.4003": "未選擇有效的欄位",
  "error.4004": "操作失敗,不允許關閉",
  "error.4005": "操作失敗,不允許撤回",
  "error.4006": "操作失敗,不允許回退",
  "error.4007": "操作失敗,沒有流程處理人",
  "error.4008": "操作失敗,流程已經關閉",
  "error.4009": "操作失敗,無許可權",
  "error.4010": "資料操作許可權不足",
  "error.4011": "資料流程轉時無流程狀態變變更",
  "error.4012": "操作失敗，當前表單正在執行其他批量編輯任務，請稍後重試",
  "error.4013": "批量編輯含有失敗的操作",
  "error.4014": "操作失敗，沒有可回退的節點",
  "error.4015": "操作失敗，當前節點不存在該候選人",
  "error.4016": "操作失敗，流程不能轉交給自己",
  "error.4017": "您沒有資料存取權限",
  "error.4018": "資料計數統計已修正",
  "error.4019": "評論功能僅適用于協作表單",
  "error.4020": "評論失敗",
  "error.4021": "單個流程節點超時流轉不能超過 10 次",
  "error.4101": "取數超出使用量限制",
  "error.4201": "匯總指標欄位配置不正確",
  "error.4202": "匯總條件欄位配置不正確",
  "error.4203": "匯總表單配置不正確",
  "error.4204": "存在重複的匯總指標欄位",
  "error.4205": "存在重複的匯總條件欄位",
  "error.4206": "沒有可以編輯的欄位，無法導入資料",
  "error.4207": "存在重複的資料表字段",
  "error.4208": "資料表單配置不正確",
  "error.4209": "匯總公式配置不正確",
  "error.4210": "無法生成匯總結果，無法匯出 Excel",
  "error.4211": "公式中存在迴圈引用",
  "error.4212": "維度含子表單欄位時，指標僅支援子表單欄位，請調整",
  "error.4213": "來自不同子表單的欄位無法匯總，請調整",
  "error.4214": "請求超時",
  "error.4215": "多個多選類欄位不能同時作為維度，請調整",
  "error.4216": "多選類欄位和子表單欄位無法匯總，請調整",
  "error.4301": "未上傳有效的 Excel 文件",
  "error.4302": "未提供 Excel 文檔標識碼",
  "error.4303": "指定的 Excel 表不存在",
  "error.4304": "不被支持的 Excel 檔案格式",
  "error.4305": "加密的 Excel 檔",
  "error.4306": "導入的表單中無可用欄位",
  "error.4307": "導入數據失敗！每條資料記錄的子表單數據不能超過200條，您的Excel資料已經超出限制，請調整您的Excel檔！",
  "error.4308": "將資料導入為部門成員欄位時不能超過10000行*200列，您的Excel資料已超上限，請調整後重新導入",
  "error.4309": "Excel 檔中資料不能超過 50000 行、200 列",
  "error.4401": "聚合資料計算失敗",
  "error.4402": "聚合計算校驗失敗",
  "error.4403": "聚合校驗公式配置不正確",
  "error.4501": "無打包文件",
  "error.4502": "未選擇檔欄位",
  "error.4503": "檔打包任務已過期",
  "error.4504": "文件不存在",
  "error.4505": "檔打包任務失敗",
  "error.4506": "檔打包任務尚未完成",
  "error.4507": "檔創建失敗",
  "error.4508": "七牛回檔鑒權參數不正確",
  "error.4509": "OSS回檔鑒權參數不正確",
  "error.4510": "檔過期時間設定失敗",
  "error.4511": "檔任務獲取失敗",
  "error.4512": "不允許刪除未完成或過期的檔任務",
  "error.4513": "該表單中有正在執行的檔打包任務",
  "error.4514": "重命名中包含不符合類型規定的控制項",
  "error.4515": "檔資訊獲取失敗",
  "error.4516": "沒有可匯出的附件",
  "error.4517": "獲取檔失敗",
  "error.4518": "無效的手寫簽名 Token",
  "error.4519": "手寫簽名上傳 Token 已過期",
  "error.4520": "WebSocket Token 已過期",
  "error.4601": "列印服務尚未初始化完成，無法列印",
  "error.4602": "無效的列印範本配置，保存失敗",
  "error.4603": "列印範本圖片載入失敗",
  "error.4604": "未選擇有效列印資料",
  "error.4605": "無效的二維碼列印配置，無法列印",
  "error.4606": "僅自訂列印範本支援批量列印",
  "error.4607": "您有檔正在生成，請稍候",
  "error.4608": "批量列印任務創建失敗",
  "error.4700": "資料流程執行失敗",
  "error.4701": "當前資料流程正在執行中",
  "error.4702": "無效ETL任務Id",
  "error.4703": "資料流程不存在",
  "error.4704": "資料流程連線存在迴圈",
  "error.4705": "無輸出節點，資料流程無法執行",
  "error.4706": "資料流程配置不正確",
  "error.4707": "橫向連接存在笛卡爾積",
  "error.4708": "輸出資料量超出限制",
  "error.4750": "資料流程中應該至少存在一個輸入節點",
  "error.4751": "同一來源的資料無法進行橫向連接",
  "error.4752": "輸入節點不能直接連接到輸出節點",
  "error.4753": "節點的輸入連線不正確",
  "error.4754": "橫向連接至少有一組連接欄位",
  "error.4755": "橫向連接配置不正確",
  "error.4756": "分組統計階段至少有一組分組和匯總欄位",
  "error.4757": "請至少添加一個欄位",
  "error.4758": "當前資料流程存在孤立節點",
  "error.4759": "當前資料流程存在多個流程",
  "error.4800": "觸發器不存在",
  "error.4801": "觸發器數量已達上限",
  "error.4802": "執行動作數量超過限制",
  "error.4803": "請選擇觸發表單",
  "error.4804": "無效的觸發動作",
  "error.4805": "請添加執行動作",
  "error.4806": "請選擇目標表單",
  "error.4807": "請指定要修改的資料",
  "error.4808": "請指定要修改的欄位",
  "error.4809": "迴圈計算錯誤",
  "error.4810": "觸發表單是其他智慧助手的目標表單，且嵌套超過3層",
  "error.4811": "目標表單是其他智慧助手的觸發表單，且嵌套超過3層",
  "error.4812": "觸發器修改資料量超過限制",
  "error.4813": "觸發器超過最大嵌套層級",
  "error.4814": "觸發器已停用",
  "error.4815": "過濾條件設置有誤",
  "error.4817": "主欄位或單個子表單不能使用不同子表單賦值",
  "error.4818": "子表單欄位不能使用主欄位賦值",
  "error.4819": "目標表單主欄位和子欄位不能同時使用子欄位賦值",
  "error.4820": "主欄位或單個子表單不能使用不同子表單欄位賦值",
  "error.4821": "最多新建200條資料",
  "error.4822": "修改欄位設置有誤",
  "error.4826": "請指定要刪除的資料",
  "error.4827": "過濾條件目標表單子表單不支援使用觸發表單子表單賦值",
  "error.4828": "過濾條件不支援配置子表單",
  "error.4829": "過濾條件未配置目標表單子表單欄位使用觸發表單主欄位賦值",
  "error.4830": "過濾條件未配置目標表單主欄位使用觸發表單子表單欄位賦值",
  "error.4831": "過濾條件子欄位不支援使用觸發表單主欄位賦值",
  "error.4832": "過濾條件目標表單主欄位僅可使用觸發表單相同子表單欄位賦值",
  "error.4833": "不支援對目標表單子欄位修改",
  "error.4834": "過濾條件僅支援對目標表單同一個子表單的子欄位進行過濾",
  "error.4835": "僅支援對目標表單同一個子表單的子欄位進行賦值",
  "error.4836": "目標表單子表單不支援使用觸發表單子表單賦值",
  "error.4837": "目標表單主欄位僅可使用觸發表單相同子表單欄位賦值",
  "error.4838": "欄位賦值和過濾條件中目標表單子表單欄位不一致",
  "error.4839": "欄位賦值和過濾條件中觸發表單子表單欄位不一致",
  "error.5000": "流程節點刪除失敗",
  "error.5001": "無法刪除帶有子節點的流程",
  "error.5002": "該版本的流程正在使用中,無法刪除",
  "error.5003": "流程節點不存在",
  "error.5004": "未提交流程審批意見",
  "error.5005": "版本內有資料,無法刪除",
  "error.5006": "無法將資料流程轉到抄送節點",
  "error.5007": "無法對已關閉的流程執行轉交",
  "error.5008": "找不到對應的負責人",
  "error.5009": "找不到回退後的負責人",
  "error.5010": "無效的流程資料",
  "error.5011": "找不到流轉節點",
  "error.5012": "未提交流程手寫簽名",
  "error.5013": "請添加節點自動處理",
  "error.5014": "最多添加5個自動處理",
  "error.5015": "最多添加1個自動提交或自動回退",
  "error.5016": "無法同時設置自動提交和自動回退",
  "error.5017": "未設置被提醒人",
  "error.5018": "提醒文字不能為空",
  "error.5019": "自動提醒的時間需早于自動提交的時間",
  "error.5020": "自動提醒的時間需早于自動回退的時間",
  "error.5023": "該節點不允許批量提交",
  "error.5024": "當前用戶對該節點無提交權限",
  "error.5025": "當前節點已經流轉完成",
  "error.5026": "流程節點批量審批失敗",
  "error.5028": "數據已過期，已為您自動清理",
  "error.6000": "已存在同名部門",
  "error.6001": "父部門不存在",
  "error.6002": "部門不存在",
  "error.6003": "存在子部門,不能刪除",
  "error.6004": "部門修改失敗",
  "error.6005": "部門創建失敗",
  "error.6006": "部門內存在成員,不能刪除",
  "error.6007": "沒有成員管理許可權",
  "error.6008": "部門主管只能是部門的直屬成員",
  "error.6009": "根部門無法設置部門主管",
  "error.6010": "企業微信模式無法刪除成員",
  "error.6011": '外部聯系人分組名稱只能中文,英文,數字,下劃線,(,),-,空格;空格不能在頭尾',
  "error.7000": "訂單創建失敗",
  "error.7001": "訂單不存在",
  "error.7002": "訂單已過期",
  "error.7003": "訂單已取消",
  "error.7004": "訂單已支付",
  "error.7005": "訂單無法刪除",
  "error.7006": "訂單無法開票",
  "error.7007": "存在未完成的訂單",
  "error.7008": "訂單開票失敗",
  "error.7009": "按用戶數計費版本無法切換版本類型",
  "error.7010": "已購買版本無法降級",
  "error.7011": "當前版本級別無法購買指定服務",
  "error.7012": "版本續費無法變更版本級別",
  "error.7013": "版本資訊有誤，請聯繫平台客服協助處理，電話 400-011-1850",
  "error.7014": "免費使用者無法購買任何服務",
  "error.7015": "可開票訂單總金額不足 1000 元，無法開票",
  "error.7016": "優惠券無效",
  "error.7017": "當前用戶無法開啟試用功能",
  "error.7018": "未上傳支付憑證",
  "error.7019": "當前用戶已領取優惠券",
  "error.7021": "您尚未設置支付寶賬號和提現密碼，無法提現",
  "error.7022": "您尚未設置支付寶賬號，無法提現",
  "error.7023": "您尚未設置提現密碼，無法提現",
  "error.7024": "提現密碼錯誤",
  "error.7925": "提現金額不得少於 1000 元",
  "error.7026": "提現金額不能超過可提現傭金",
  "error.7027": "優惠券活動已過期",
  "error.7028": "優惠券獲取失敗",
  "error.7029": "訂單已失效",
  "error.7030": "此使用者存在未支付的訂單，請聯繫使用者取消後重新創建",
  "error.7031": "支付參數簽名校驗失敗",
  "error.7038": "使用者數不能少於版本最低限制",
  "error.7102": "您的系統用量已超出當前版本限制，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7103": "系統用量超出限制，系統已暫停使用，您可以至會員中心查看版本使用詳情和升級版本以恢復系統。",
  "error.7104": "聚合表數量已達上限，您可以至會員中心查看版本使用情況和升級版本。或刪除無用聚合表後再進行新建。",
  "error.7105": "您所安裝的應用內聚合表數量超出當前版本限制。您可以至會員中心查看版本使用情況和升級版本之後再來安裝應用。",
  "error.7106": "您的聚合表數量已超出當前版本限制，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7107": "您的附件上傳量已超出當前版本限制，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7108": "您系統內的總數據量已超出當前版本限制，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7109": "您系統內的單表資料量已超出當前版本限制，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7110": "成員數量已超出上限，為了不影響您的正常使用，請儘快升級系統，否則系統將被禁用。",
  "error.7111": "成員數量超出限制。您可以至會員中心查看版本使用詳情和升級版本，以同步/邀請更多成員。",
  "error.7112": "您當前使用的版本不包含自訂列印功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7113": "自訂列印範本數量已達上限，您可以至會員中心查看版本使用情況和升級版本。或刪除無用自訂列印範本後再進行新建。",
  "error.7114": "您所安裝的應用內自訂列印範本數量超出當前版本限制。您可以至會員中心查看版本使用情況和升級版本之後再來安裝應用。",
  "error.7115": "子管理員數量已達上限，您可以至賬戶中心查看版本使用情況和升級版本或減少管理員數量。",
  "error.7116": "子管理員數量已達上限，請聯繫企業創建者升級版本或減少管理員數量。",
  "error.7117": "您當前的版本只能設置一個系統管理員，如需更多子管理員請升級版本。",
  "error.7118": "子管理員數量已超出當前版本限制，該功能已被禁用。請聯繫您企業的賬號創建者，升級版本或減少管理員數量。",
  "error.7119": "您當前的版本只能設置一個系統管理員，請聯繫您企業的賬號創建者升級版本。",
  "error.7120": "您當前使用的版本不包含資料推送功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7121": "您當前使用的版本不包含資料回收站功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7122": "您當前使用的版本不包含匯出附件功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7123": "您當前使用的版本不包含跨應用功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7124": "您當前使用的版本不包含自動同步功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7125": "您當前使用的版本不包含自訂提交成功頁面功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7126": "此範本中包含的功能已超出您當前使用的版本，是否領取高級功能30天試用期",
  "error.7127": "此範本中包含的功能已超出您當前使用的版本，是否領取高級功能7天試用期",
  "error.7128": "您所安裝的應用內聚合表數量與列印範本數量均超出當前版本限制。您可以至會員中心查看版本使用情況和升級版本之後再來安裝應用。",
  "error.7129": "您複製的資料量已經超出免費版限制，請升級版本後再使用該功能",
  "error.7130": "您所安裝的應用內包含手寫簽名控制項。您可以至會員中心查看版本使用情況和升級版本之後再來安裝應用。",
  "error.7132": "當前賬號最多可以創建5個資料流程，您可以點擊查看詳情查看資料流程使用情況，刪除無用資料流程後再新建。",
  "error.7133": "資料流程數量已超出當前版本限制，為避免系統受限影響您的正常使用，您可以點擊查看詳情刪除無用資料流程。",
  "error.7135": "每個賬號僅可創建5個智慧助手，請刪除無用的智慧助手後再新建",
  "error.7136": "智慧助手數量已超出當前版本限制，為避免系統受限影響您的正常使用，請點擊查看詳情刪除無用智慧助手。",
  "error.7137": "您所安裝的應用內資料流程數量超出當前版本限制。您可以至會員中心查看版本使用情況和升級版本之後再來安裝應用。",
  "error.7138": "您所安裝的應用內智慧助手數量超出當前版本限制。您可以至會員中心查看版本使用情況和升級版本之後再來安裝應用。",
  "error.7139": "您當前使用的版本不包含自訂樣式功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "error.7201": "資料量已達上限，請儘快聯繫貴司平台管理者升級版本或調整系統用量。",
  "error.7202": "資料量已達上限，請儘快聯繫連結發佈者升級版本或調整系統用量。",
  "error.7203": "資料量已超出限制，不可提交資料，請儘快聯繫連結發佈者升級版本以恢復使用。",
  "error.7204": "您的系統用量已超出限制，請儘快聯繫貴司平台管理者升級版本或調整系統用量。",
  "error.7205": "系統用量超出限制，請儘快聯繫連結發佈者升級版本或調整系統用量。",
  "error.7206": "系統用量超出限制，系統已暫停使用，請儘快聯繫貴司平台管理者升級版本以恢復系統。",
  "error.7207": "系統用量超出限制，系統已暫停使用，請儘快聯繫連結發佈者升級版本以恢復使用。",
  "error.7208": "檔過大，上傳失敗；請聯繫貴司平台管理者升級版本以獲得更大上傳大小。",
  "error.7209": "單表資料量已達上限，請儘快聯繫貴司平台管理者升級版本或調整系統用量。",
  "error.7210": "聚合表數量已達上限，請儘快聯繫貴司平台管理者升級版本或調整系統用量。",
  "error.7211": "自訂列印範本數量已達上限，請儘快聯繫貴司平台管理者升級版本或調整系統用量。",
  "error.7212": "該賬號的本月資料流程量已用完，無法提交新資料，請聯繫賬號創建者升級版本。",
  "error.7213": "手寫簽名功能已禁用，請聯繫企業創建者升級版本",
  "error.7214": "資料流程數量已超上限，請聯繫企業創建者升級版本或調整系統用量。",
  "error.7215": "智慧助手數量超出限制，請聯繫企業創建者升級版本或調整系統用量",
  "error.7216": "附件量超出當前版本限制，請儘快聯繫貴司平台管理者升級版本。",
  "error.7217": "附件量超出當前版本限制，請儘快聯繫連結發佈者升級版本以恢復使用。",
  "error.8000": "企業授權資訊不存在",
  "error.8001": "當前用戶已經是企業用戶",
  "error.8002": "企業用戶未同步",
  "error.8003": "企業根部門不存在",
  "error.8004": "企業組織結構初次同步失敗",
  "error.8005": "企業應用安裝失敗",
  "error.8006": "企業永久授權碼獲取失敗",
  "error.8007": "企業授權資訊獲取失敗",
  "error.8008": "企業套件啟動失敗",
  "error.8009": "企業授權權杖獲取失敗",
  "error.8010": "服務商套件憑據獲取失敗",
  "error.8011": "企業預授權碼獲取失敗",
  "error.8012": "企業用戶列表獲取失敗",
  "error.8013": "企業登錄授權憑據不存在",
  "error.8014": "不合法的企業後臺路徑",
  "error.8015": "授權狀態碼校驗失敗",
  "error.8016": "當前用戶與待綁定用戶均已購買版本，無法綁定",
  "error.8017": "企業不存在或者已經被解散",
  "error.8018": "需要先在釘釘/微信後臺解綁後操作",
  "error.8019": "用戶開啟自動同步功能",
  "error.8020": "用戶未關注該企業號或公眾號",
  "error.8022": "服務暫時不可用，請稍後重試",
  "error.8023": "corpId 或 corpSecret 錯誤",
  "error.8024": "corpId 或 ssoSecret 錯誤",
  "error.8025": "該 corpId 已被其他賬號綁定",
  "error.8026": "corpSecret 需要有根部門許可權",
  "error.8027": "使用者資訊獲取失敗",
  "error.8101": "無效的企業管理員",
  "error.8102": "未提供有效企業 Id",
  "error.8103": "綁定的企業不符合K12認證標準",
  "error.8104": "該企業已被其他平台賬號用於認證",
  "error.8105": "認證申請已提交，請不要重複認證",
  "error.8106": "申請資訊格式不正確",
  "error.8107": "申請資訊提交失敗，請重新嘗試",
  "error.8108": "釘釘URL域錯誤",
  "error.8109": "已加入推廣者聯盟的釘釘賬戶不支持綁定到其他平台賬戶",
  "error.8110": "已設置手機或郵箱的釘釘賬戶不支持綁定到其他平台賬戶",
  "error.8111": "已創建應用的釘釘賬戶不支援綁定到其他平台賬戶",
  "error.8200": "企業套件錯誤，等待轉換",
  "error.8201": "代理節點通訊失敗",
  "error.8202": "所有代理節點通訊失敗",
  "error.8301": "API 簽名校驗失敗",
  "error.8302": "沒有介面請求許可權",
  "error.8303": "API 請求次數達到頻率上限",
  "error.9001": "未配置有效的佇列任務處理方法",
  "error.9002": "佇列任務處理失敗",
  "error.9003": "佇列任務失敗重試",
  "error.9004": "佇列任務創建失敗",
  "error.9005": "佇列等待任務過多",
  "error.9006": "佇列無效任務清理失敗",
  "error.9007": "鎖獲取失敗",
  "error.9008": "鎖解除失敗",
  "error.9900": "郵件發送失敗",
  "error.9901": "消息不存在",
  "error.9902": "部分使用者未能成功發送消息",
  "error.9903": "消息範本不存在",
  "error.9904": "短信余量不足，獲取驗證碼失敗。 請聯繫企業建立者調整表單設計或購買短信容量包",
  "error.9905": "操作過於頻繁，獲取驗證碼失敗。 請在1個小時後再獲取驗證碼",
  "error.9906": "短信發送失敗",
  "error.9907": "手機號未驗證或短信驗證碼已失效",
  "error.9908": "短信驗證碼獲取失敗，請安裝應用後再使用此功能",
  "error.9909": "請輸入正確格式的手機號或郵箱",
  "error.9914": "消息額外通知人不存在, 已被修改或已被刪除",
  "error.9915": "消息額外通知人必須至少設置姓名和任意一種連絡方式",
  "error.9916": "請在60秒後重試",
  "error.9917": "同一郵箱/手機號每天最多發送兩次驗證",
  "error.10001": "登錄失敗",
  "error.10003": "成員不存在",
  "error.10007": "配置错误",
  "error.10009": "單點登錄不允許切換企業",
  "error.10010": "單點登錄不允許創建企業",
  "error.10011": "已啟用單點登錄，無法進行換綁操作",
  "error.10012": "請聯繫管理員將你加入當前團隊通訊錄",
  "error.10013": "請聯繫管理員檢查單點登錄配置",
  "error.10014": "賬號不可用",
  "error.4319": "data_id未匹配字段",
  "error.info.403": "伺服器拒絕了您的流覽請求，請確認您所擁有的存取權限。",
  "error.info.404": "您可能輸錯了位址，或該網頁已刪除或移動。",
  "error.status.400": "錯誤的請求",
  "error.status.401": "用戶未登錄",
  "error.status.402": "當前會話已過期，請刷新頁面後重試",
  "error.status.403": "沒有資料請求許可權",
  "error.status.404": "找不到資料資源",
  "error.status.429": "當前訪問人數過多，請稍後重試",
  "error.status.fail": "與伺服器通信失敗",
  "error.status.corpSwitch": "您已離開當前團隊，無法操作",
  "error.status.corpSwitch.tip": "同一瀏覽器，賬號只能處於一個團隊。如果要繼續操作，請在其他標籤頁內切換到當前團隊。",
  "error.title.403": "請求被拒",
  "error.title.404": "該頁面不知飄去何處了",
  "error.title.409": "操作許可權不足",
  "error.tip.corpName": "當前登錄團隊為「{{corp}}」",
  "error.tip.switchCorp": "如果要繼續操作，請切換團隊或聯繫管理員處理",
  "error.tip.switchCorp.mobile": "您沒有加入任何團隊，請到PC端創建團隊或聯繫管理員處理",
  "error.qiniu.violation": "上傳的附件「{{file}}」存在違規內容",
  "etl.clear": "清空輸入源",
  "etl.clear.confirm": "您確定要清空該輸入源嗎？",
  "etl.clear.info": "清空輸入源會同步清空後續節點包含當前輸入源的配置，您確定要清空該輸入源嗎？",
  "etl.create": "新建資料流程",
  "etl.clickToViewIntro": "點擊查看功能介紹",
  "etl.dataProcess": "資料處理",
  "etl.dataSource": "資料來源：",
  "etl.dataFlow.empty": "資料流程可對一個或多個資料來源進行關聯、聚合、追加合併等操作，形成輸出表。 \n 您可在報表中將輸出表作為資料來源使用。",
  "etl.dataFlow.fail": "資料流程更新失敗，請檢查資料流程設置",
  "etl.delete.msg": "刪除資料流程後，該資料流程的輸出資料也會一併被刪除，刪除的資料無法還原",
  "etl.design": "資料流程設計",
  "etl.doIt": "執行",
  "etl.empty": "您當前沒有資料輸出集<br/>請先創建資料流程再查看資料",
  "etl.empty.linkText": "什麼是資料流程？",
  "etl.emptyTip": "請先添加資料來源，並將資料來源連接到本節點",
  "etl.error.addInput": "請添加輸入源",
  "etl.error.circle": "節點連線不能形成環",
  "etl.error.directToOutput": "輸入節點不能直接連接輸出節點",
  "etl.error.exceed": "節點輸入連線超出限制",
  "etl.error.expr": "請輸入運算式",
  "etl.error.fieldName": "請輸入欄位名稱",
  "etl.error.formulaName": "請輸入計算欄位名稱",
  "etl.error.isolateNode": "當前資料流程存在孤立節點或孤立流程",
  "etl.error.noInputOrOutput": "當前資料流程沒有輸入/輸出節點",
  "etl.error.finishRely": "請先完成依賴節點的配置",
  "etl.error.line": "請將連接線連接至本節點",
  "etl.error.line.two": "請將2條連接線連接至本節點",
  "etl.error.line.more": "請將2-4條連接線連接至本節點",
  "etl.existFields": "現有欄位",
  "etl.fail": "資料流程執行失敗，輸出結果不再更新",
  "etl.dataUpdate": "更新資料",
  "etl.filter": "數據篩選",
  "etl.group": "分組匯總",
  "etl.group.addFields": "添加分組欄位",
  "etl.groups.addMetrics": "添加匯總欄位",
  "etl.group.metrics": "匯總欄位",
  "etl.group.fields": "分組欄位",
  "etl.group.rule": "分組方式",
  "etl.group.atLeastOneField": "請至少添加一組分組匯總欄位",
  "etl.hasStage": "當前資料流程已有{{title}}節點",
  "etl.inputAndOutput": "輸入輸出",
  "etl.input": "輸入",
  "etl.input.data": "輸入數據",
  "etl.input.subform.data": "子表單當前行",
  "etl.input.subform.data.tip": " (普通字段+子表單當前正在編輯行的數據)",
  "etl.input.subform.data.tip1": "指當前子表單選擇的這一行。",
  "etl.input.subform.data.tip2": "當前表子表單某行選擇輸入數據，和其他輸入",
  "etl.input.subform.data.tip3": "下圖以追加合併為例",
  "etl.input.subform.data.tip4": "以短信方式發送多條數據到指定號碼",
  "etl.input.news.tip": "將與之連接的輸出結果集以",
  "etl.input.news.tip1": "短信/郵件/語音通知/微信提醒",
  "etl.input.news.tip2": "的方式發給指定人",
  "etl.input.news.tip3": "將輸出表內的一條或多條數據進行",
  "etl.input.news.tip4": "將輸出表內的所有數據進行以",
  "etl.input.news.tip5": "的方式發送給指定的成員或部門或手機號。",
  "etl.input.news.tip6": "短信通知",
  "etl.input.news.tip7": "如果有多個接收人，則符合條件的接收人都會收到所有符合條件的短信內容。",
  "etl.input.news.tip8": "1、如果接收人為單個成員或手機號碼，則發送單條短信內容。",
  "etl.input.news.tip9": "2、如果接收人為多個成員或手機號碼，則每個符合條件的接收人都會收到第一條數據的短信內容。",
  "etl.input.subformrely.tip": "將輸出的結果聯動到當前子表單，按照類型可分為：聯動子表單當前行、聯動子表單指定行、子表單添加數據、子表單刪除數據。",
  "etl.input.subformrely.tip1": "根據設定的條件，取出輸出表內符合條件的第一條數據，聯動到當前所選擇的子表單所在行。",
  "etl.input.subformrely.tip2": "根據設定的條件，取出輸出表內符合條件的第一條數據，聯動到符合的子表單數據所在行。",
  "etl.input.subformrely.tip3": "根據設定的條件，將符合的數據添加到子表單內。",
  "etl.input.subformrely.tip4": "根據設定的條件，將目標子表單內符合條件的數據刪除。",
  "etl.input.data.description1": "即以表單當前所錄入的數據作為數據源，可與其他表單或本表單已經錄入的數據進行各種數據處理操作",
  "etl.input.data.description2": "輸入數據僅在",
  "etl.input.data.description3": "初始化、新增數據、編輯、刪除",
  "etl.input.data.description4": "時進行觸發，僅指當前所操作的",
  "etl.input.data.description5": "一條數據",
  "etl.input.data.description6": "如：",
  "etl.input.data.description7": "頁面錄入數據後，和其他數據源的數據可以進行橫向連接、追加合併、分組匯總等操作",
  "etl.input.data.description8": "下圖以追加合併為例",
  "etl.inputSource": "輸入源",
  "etl.inputSource.select.empty": "沒有可選擇的輸入源",
  "etl.inputSource.add": "添加輸入源",
  "etl.inputSource.update": "更改輸入源",
  "etl.inputSource.update.tip": "確定要更改輸入源？",
  "etl.inputSource.update.confirm": "此操作會同步更改後續節點的配置，無法還原？",
  "etl.inputSource.select": "1.選擇輸入源",
  "etl.field.select": "2.選擇欄位",
  "etl.field.select.cur": "選擇欄位",
  "etl.formula.empty.tip": "請在輸入源添加數位欄位",
  "etl.input.emptyTip": "請選擇表單數據進行查看",
  "etl.input.subform": "子表單",
  "etl.input.form": "主表",
  "etl.input.selected.field": "已選欄位",
  "etl.input.atLeastOneField": "至少選擇1個欄位",
  "etl.input.atLeastOneSubformField": "至少選擇1個子表單字段",
  "etl.input.multisubform.tip": "所選輸入源中含有多個子表單，請選擇要使用的子表單",
  "etl.input.subformfield.empty": "沒有子表單欄位",
  "etl.intro.join": "主要是將2張資料表根據連接欄位左右相連接，根據連接的方式不同又分為：內連接、左連接以及右連接。",
  "etl.intro.join.inner": "：根據連接欄位，返回左右兩側表單連接欄位相等的資料，即返回左右兩個表單的資料交集。",
  "etl.intro.join.left": "：返回左側表單的全部資料，根據連接欄位，逐行匹配並連接右側表單的資料，匹配不到則留空。",
  "etl.intro.join.right": "：返回右側表單的全部資料，根據連接欄位，逐行匹配並連接左側表單的資料，匹配不到則留空。",
  "etl.intro.union": "支援將2-4張資料表，按照欄位對應關係縱向連接，合併為1張資料表，可用於整合分散的同質資料。",
  "etl.intro.filter": "支援給單張資料表添加篩選準則，可用於過濾掉無用的資料，只保留需要的資料。",
  "etl.intro.group": "其實就是先分組再匯總。",
  "etl.intro.group.detail": "{{- group}}就是把分組欄位值相同的資料分為一組，而{{- aggregate}}則是將分好組的資料各自按照指定的匯總方式計算匯總欄位的值。",
  "etl.intro.map": "可以對資料表中的欄位進行排序、隱藏；也可以增加計算欄位，對當前表單資料進行簡單計算。",
  "etl.intro.tip": "點擊這裡可以查看各個資料處理節點的功能介紹哦~",
  "etl.intro.view": "立即查看",
  "etl.io": "輸入／輸出",
  "etl.join": "橫向連接",
  "etl.join.inner": "內連接",
  "etl.join.inner.info": "返回左右兩側表單中連接欄位相等的資料",
  "etl.join.left": "左連接",
  "etl.join.left.info": "返回左側表單的全部資料和右側表單中匹配到的資料",
  "etl.join.right": "右連接",
  "etl.join.right.info": "返回右側表單的全部資料和左側表單中匹配的資料",
  "etl.join.rule.select": "選擇連接方式",
  "etl.join.field.add": "添加連接欄位",
  "etl.join.form.left": "左側表單：",
  "etl.join.form.right": "右側表單：",
  "etl.join.tip.atLeastOne": "橫向連接至少要有一組連接欄位",
  "etl.join.tip.sameSource": "同一來源的資料無法進行橫向連接",
  "etl.join.tip.differentType": "連接欄位的類型不一致",
  "etl.join.fuzzy": "設置模糊關聯",
  "etl.join.fuzzy.precision": "模糊關聯精度",
  "etl.join.fuzzy.time": "設置模糊關聯匹配的時間單位",
  "etl.join.cartesian product": "預覽出現笛卡爾結果集，建議更改橫向連接配置，或修改資料",
  "etl.lastUpdate": "最後更新：{{time}}",
  "etl.log.just": "少於1分鐘",
  "etl.log.minute": "{{minute}}分鐘",
  "etl.log.execute": "更新日誌",
  "etl.log.startTime": "開始時間：{{time}}",
  "etl.log.time": "更新時長：{{time}}",
  "etl.log.endTime": "結束時間：{{time}}",
  "etl.log.result": "更新結果：",
  "etl.log.resultWithoutMark": "執行結果",
  "etl.log.fail.reason": "失敗原因：{{reason}}",
  "etl.log.fail.detail": "查看錯誤詳情",
  "etl.map": "欄位設置",
  "etl.map.addCalcField": "添加計算欄位",
  "etl.map.showOriginField": "顯示原始欄位",
  "etl.map.editField": "編輯欄位",
  "etl.map.hideField": "隱藏欄位",
  "etl.map.editCalcField": "編輯計算欄位",
  "etl.map.tip.atLeastOneField": "請至少添加一個欄位",
  "etl.needSourceTable": "請先添加需要連接的表格，並將相關表格連接到本節點",
  "etl.output": "輸出",
  "etl.output.emptyTip": "請先添加資料來源連接至本節點，在點擊預覽後可查看資料",
  "etl.output.table": "輸出表：",
  "etl.output.tableInfo": "（輸出表請到報表中使用）",
  "etl.preview.maxCount": "最多可預覽前{{count}}條資料",
  "etl.running": "正在更新",
  "etl.stage.config": "節點配置",
  "etl.stage.preview": "資料預覽",
  "etl.stage.preview.error": "預覽資料前，請先完成節點配置",
  "etl.stage.preview.loading": "載入中",
  "etl.stage.title": "節點名稱：",
  "etl.status.running": "執行中",
  "etl.save.success": "保存成功，可以去「報表」使用輸出的資料啦！",
  "etl.union": "追加合併",
  "etl.union.add.field.type.tip": "僅可添加同類型欄位",
  "etl.union.add.field.empty": "沒有可添加的欄位",
  "etl.union.result": "合併結果",
  "etl.union.tip.atLeastOneField": "每張表請至少添加一個欄位",
  "etl.unnamed": "未命名資料流程",
  "enable.withMark": "（啟用）",
  "export.failTip": "匯出失敗",
  "export.fail.timeout": "匯出超時",
  "export.excel.notice": "準備中",
  "export.dataId": "同時導出data_id",
  "export.userAcount": "匯出時成員帶帳戶資訊、部門帶id，方便導入",
  "export.excel.notice.title": "導出文件準備中...",
  "export.excel.notice.content": "您可以進行其他操作，準備工作會在後台進行。\n準備完成後，您會在消息裡收到含有下載鏈接的提醒。",
  "export.excel.fileSuccess": "導出文件準備完成",
  "export.excel.fileSuccess.content": "「{{name}}」的導出文件已準備完成。檔下載連結將于{{time}}小時後失效，請儘快下載。",
  "export.excel": "匯出Excel",
  "export.data.all": "匯出所有資料",
  "export.data.filtered": "匯出過濾後的數據",
  "export.field.select": "請選擇匯出欄位",
  "export.field.mode": "請選擇圖片/附件匯出的管道",
  "export.field.mode.0": "圖片保存在excel檔案中(圖片計算上傳流量)",
  "export.field.mode.1": "圖片/附件保存在excel同級目錄以zip格式匯出(圖片/附件計算上傳流量)",
  "export.field.mode.2": "圖片/附件使用超連結管道保存在excel(不計算上傳流量)",
  "export.file.all": "匯出所有資料中附件",
  "export.file.filtered": "匯出過濾後的資料中的附件",
  "export.file.widgetAndName": "匯出附件與命名方式",
  "export.file.name": "匯出時附件命名方式",
  "export.file.name.origin": "保持檔原始名稱",
  "export.file.name.field": "按照表單中欄位命名",
  "export.file.empty": "表單中沒有附件可以匯出",
  "export.file.selectAll": "附件（已全選）",
  "export.generate.downloadLink": "生成下載連結",
  "export.record": "匯出記錄",
  "export.record.delete.confirm": "您確定要刪除匯出記錄嗎？",
  "export.record.delete.tip": "刪除匯出記錄後將不可下載這次匯出的附件，且無法還原",
  "export.record.none": "無匯出記錄",
  "export.record.view": "查看匯出記錄",
  "export.link.expired.tip": "下載連結已失效，如需下載請重新匯出附件",
  "export.link.tip": "下載連結將於{{expireDate}}失效，請儘快下載",
  "export.file.fail.tip": "附件匯出失敗，請稍後重試",
  "export.file.select.tip": "請選擇需要批量匯出的附件",
  "export.name.select.tip": "請選擇用來命名的欄位",
  "external.link.password.form": "填寫該表單需輸入密碼，請輸入密碼：",
  "external.link.password.report": "查看該報表需輸入密碼，請輸入密碼：",
  "external.link.password.dash": "查看該報表需輸入密碼，請輸入密碼：",
  "external.link.scan": '微信"掃一掃"，分享給好友',
  "external.link.tip": "本內容由平台使用者製作發佈，不代表「平台」官方立場。",
  "fail.detail": "錯誤詳情",
  "field.add": "請添加欄位",
  "field.address": "地址欄位",
  "field.alias": "欄位別名",
  "field.asyncData": "關聯其他表單數據",
  "field.auth": "欄位許可權",
  "field.auth.short": "欄位許可權",
  "field.no_view_auth": "無查看許可權",
  "field.auth.add": "前往添加",
  "field.auth.emptyTip": "請先為表單添加欄位",
  "field.auth.flowTip.warning": "已啟用流程，欄位許可權以流程節點的設置為准",
  "field.auth.flowTip.info": "啟用流程後，欄位許可權以流程節點的設置為准",
  "field.auth.set": "設置操作許可權",
  "field.auth.systemTip": "系統欄位不可修改",
  "field.auth.visibleTip": "請至少選擇一個可見欄位",
  "field.chargers": "當前節點/負責人",
  "field.createTime": "提交時間",
  "field.creator": "提交人",
  "field.date": "日期欄位",
  "field.datetime": "日期時間欄位",
  "field.defaults.set": "設置預設值",
  "field.defaults.today": "填寫當天",
  "field.deleted.tip": "該欄位已刪除",
  "field.deleted.tip1": "配寘已經失效，請重新配寘",
  "field.deleter": "刪除人",
  "field.deleted": "已刪除欄位",
  "field.deleteTime": "刪除時間",
  "field.dept": "部門欄位",
  "field.dept.empty": "表單中沒有部門欄位",
  "field.ext": "擴展欄位",
  "field.edit.tip": "請選擇一個欄位來設置屬性",
  "field.file.single": "僅允許上傳單個檔",
  "field.flowState": "流程狀態",
  "field.flow.chart": "流程圖",
  "field.form": "關聯表",
  "field.formula.edit": "編輯公式",
  "field.formula.edit.done": "已設置公式",
  "field.formula.empty.tip": "無可用變數，請添加或保存表單後重試",
  "field.formula.deleted.tip": "存在已刪除欄位，點擊重新設置",
  "field.img.camera": "僅允許拍照上傳",
  "field.img.compress": "自動壓縮圖片",
  "field.img.watermark": "拍照時添加浮水印",
  "field.img.watermarkTip": "浮水印中包括提交人、提交時間、定位，僅對釘釘移動用戶端有效",
  "field.img.single": "僅允許上傳一張圖片",
  "field.id": "欄位ID",
  "field.idOrAlias": "欄位ID/欄位別名",
  "field.scan.input": "掃碼輸入",
  "field.scan.barCode": "掃描條碼",
  "field.scan.editable": "可修改掃碼結果",
  "field.scan.qrCode": "掃描二維碼",
  "field.invalid": "無效欄位",
  "field.key": "主鍵欄位",
  "field.label": "欄位標題",
  "field.layout": "佈局",
  "field.layout.tip": "打開表單屬性 > 雙列佈局才可使用",
  "field.layout.width": "顯示寬度佔用整行的",
  "field.lineType": "線型",
  "field.lineType.none": "無線框",
  "field.link": "關聯欄位",
  "field.link.tip": "僅可關聯此欄位之後的欄位，請調整表單欄位順序後設置",
  "field.linkFilter": "資料過濾",
  "field.linkFilter.add": "添加過濾條件",
  "field.linkFilter.add.done": "已添加過濾條件",
  "field.linkFilter.form": "關聯表字段",
  "field.linkFilter.invalid": "關聯條件設置失效，點擊重新設置",
  "field.linkFilter.line": "顯示資料條數",
  "field.linkFilter.line.single": "一條",
  "field.linkFilter.line.multi": "多條",
  "field.linkFilter.msg.invalid": "關聯條件設置失效，請重新設置",
  "field.linkFilter.operation": "關聯表操作",
  "field.linkFilter.operation.add": "允許新增關聯表資料",
  "field.linkFilter.scan": "開啟後掃描資料二維碼即可錄入資料",
  "field.linkFilter.tip": "添加過濾條件來限定關聯資料範圍",
  "field.location.adjustable": "允許微調",
  "field.location.center.add": "新增定位中心",
  "field.location.center.select": "請選擇定位中心",
  "field.location.empty": "當前無搜索結果",
  "field.location.lngLat.show": "顯示經緯度座標",
  "field.location.lngLat.tip": "勾選後可以獲取當前位置的經緯度座標，支援6位小數。",
  "field.location.radius": "以定位中心為圓心設置定位半徑，建議範圍500-1000",
  "field.location.range": "定位範圍",
  "field.location.range.set": "設置定位範圍",
  "field.location.range.tip": "可添加多個定位關鍵字，當定位位置滿足其中一條關鍵字時通過校驗",
  "field.noRepeat": "不允許重複值",
  "field.number": "數字欄位",
  "field.number.integer": "僅允許填寫整數",
  "field.number.integer.input": "請輸入整數",
  "field.number.range": "限定數值範圍",
  "field.number.range.btw": "請輸入{{min}}~{{max}}之間的數",
  "field.number.range.gte": "請輸入大於等於{{min}}的數",
  "field.number.range.lte": "請輸入小於等於{{max}}的數",
  "field.name": "欄位名稱",
  "field.name.type": "輸入欄位名",
  "field.option.add": "添加選項",
  "field.option.add.other": "添加其他選項",
  "field.option.contact": "選項關聯設置",
  "field.option.contact.done": "已設置選項關聯",
  "field.option.line": "每行對應一個選項",
  "field.options": "選項{{num}}",
  "field.optionalRange": "可選範圍",
  "field.phone": "手機欄位",
  "field.file": "檔欄位",
  "field.rely.set": "數據聯動設置",
  "field.rely.set.done": "已設置資料聯動",
  "field.rely.network.error": "『{{name}}』配置已失效，请联系管理员重新调整表单设计",
  "field.rely.request.error": "接口请求出现错误<br>字段名：{{name}}<br>错误信息：{{msg}}({{time}}，{{api}})",
  "field.rely.error": "数据联动异常",
  "field.rely.disable.default": "以子表單聯動為准,不支援設置預設值",
  "field.rely.disable.option": "以子表單聯動為准，不支援設置選項聯動",
  "field.rely.disable.limit": "以子表單聯動為准，不支援設置範圍聯動",
  "field.rely.doc": "什麼是數據聯動？",
  "field.rely.msg.inComplete": "請設置完整的資料聯動條件",
  "field.rely.msg.invalid": "資料聯動條件失效，請重新設置",
  "field.rely.invalid": "聯動條件失效，點擊重新設置",
  "field.rely.form": "聯動表單",
  "field.rely.form.placeholder": "請選擇聯動表單",
  "field.rely.currentForm": "當前表單字段",
  "field.rely.relyForm": "聯動表單字段",
  "field.rely.subField": "被聯動子表單子欄位",
  "field.rely.equal": "值等於",
  "field.rely.when": "的值時",
  "field.rely.show": "聯動顯示",
  "field.rely.result": "的值",
  "field.rely.sub": "子欄位資料聯動",
  "field.rely.sub.add": "添加子欄位",
  "field.rely.sub.show": "顯示為",
  "field.show": "顯示欄位",
  "field.subform.auth.tip": "勾選後可配置子表單的具體操作許可權，包括新增記錄，編輯已有記錄，刪除已有記錄。",
  "field.subform.auth.add": "可新增記錄",
  "field.subform.auth.edit": "可編輯已有記錄",
  "field.subform.auth.sort": "可對已有記錄排序",
  "field.subform.auth.delete": "可刪除已有記錄",
  "field.subform.copy.end": "複製到最後一行",
  "field.subform.copy.next": "複製到下一行",
  "field.subform.insert.up": "向上插入行",
  "field.subform.insert.next": "向下插入行",
  "field.text": "文本欄位",
  "field.typeChange.rely": "該欄位包含資料聯動/公式編輯，無法轉換",
  "field.typeChange.formula": "該欄位包含公式編輯，無法轉換",
  "field.typeChange.contact": "該欄位包含選項關聯，無法轉換",
  "field.typeChange.async": "欄位中選項來源於其他表單數據/包含資料聯動，無法轉換",
  "field.type": "欄位類型",
  "field.updateTime": "更新時間",
  "field.user": "成員欄位",
  "field.user.deptLimit": "由部門欄位確定",
  "field.width": "欄位寬度",
  "field.width.half": "1/2寬度",
  "field.width.normal": "標準寬度",
  "field.width.double": "2倍寬度",
  "field.update": "修改為",
  "field.userDept.add": "添加部門或成員",
  "field.detailOnly": "僅詳情顯示",
  "file.preview.noSupport": "當前檔案類型不支持線上預覽",
  "file.preview.support": "支援預覽的檔？",
  "filter.addCondition": "添加篩選條件",
  "filter.check.placeholder": "請輸入選項內容，多個值用‘enter’分開輸入",
  "filter.flowNode.formEmptyTip": "請先選擇表單",
  "filter.flowNode.list": "流程節點歷史版本名稱",
  "filter.method.eq": "等於",
  "filter.method.ne": "不等於",
  "filter.method.all": "同時包含",
  "filter.method.all.address": "屬於",
  "filter.method.in.one": "等於任意一個",
  "filter.method.in.many": "包含任意一個",
  "filter.method.in.flowNode": "包含",
  "filter.method.nin": "不等於任意一個",
  "filter.method.nin.address": "不屬於",
  "filter.method.lk": "包含",
  "filter.method.ulk": "不包含",
  "filter.method.ep": "為空",
  "filter.method.nep": "不為空",
  "filter.method.gt": "大於",
  "filter.method.gte": "大於等於",
  "filter.method.lt": "小於",
  "filter.method.lte": "小於等於",
  "filter.method.rg": "選擇範圍",
  "filter.method.vf": "已驗證",
  "filter.method.nvf": "未驗證",
  "filter.method.fm": "動態篩選",
  "filter.rel.tip": "篩選出符合以下",
  "filter.rel.tip1": "符合以下",
  "filter.rel.and": "所有",
  "filter.rel.or": "任一",
  "filter.rel.cond": "條件的資料",
  "filter.text.placeholder": "請輸入文本內容",
  "filter.condition": "篩選條件",
  "filter.condition.add": "添加過濾條件",
  "filter.condition.stick": "固定顯示",
  "filter.condition.cancelStick": "取消固定",
  "flow.activate": "啟動流程",
  "datahelper.curform": "當前數據源 - {{name}}",
  "datahelper.output.field.tip": "設置當前基線為 {{name}} 字段",
  "flow.attr": "流程屬性",
  "flow.attr.base": "基礎屬性",
  "flow.attr.more": "更多屬性",
  "flow.action.disable": "未開啟",
  "flow.action.enable": "已開啟",
  "flow.action.forward": "提交",
  "flow.action.forward.tip": "使用者在處理流程時點擊此按鈕，將保存使用者在此節點中對資料的更改，流程資料流程轉至後續節點。",
  "flow.action.save": "暫存",
  "flow.action.save.success": "暫存成功",
  "flow.action.save.tip1": "使用者在處理流程時點擊此按鈕，將保存使用者在此節點中對資料的更改，流程不發生流轉。",
  "flow.action.save.tip2": "暫存會將資料保存至資料庫，觸發欄位「不允許重複值」校驗。",
  "flow.action.print": "提交並列印",
  "flow.action.print.tip": "開啟後，使用者在處理流程時點擊此按鈕，將保存使用者在此節點中對資料的更改，流程流轉至後續節點，同時進入列印介面進行資料列印。",
  "flow.action.back": "回退",
  "flow.action.back.tip": "開啟後，使用者在處理流程時點擊此按鈕，將保存使用者在此節點中對資料的更改，同時流程退回到指定的節點中。",
  "flow.action.transfer": "轉交",
  "flow.action.transfer.candidates": "轉交候選人",
  "flow.action.transfer.tip": "開啟後，使用者在處理流程時點擊此按鈕，將保存使用者在此節點中對資料的更改，流程轉交至指定的負責人處理。",
  "flow.action.close": "結束流程",
  "flow.action.close.tip": "開啟後，使用者在處理流程時點擊此按鈕，將保存使用者在此節點中對資料的更改，並且終止流程，不再進行流轉。",
  "flow.action.revoke": "撤回",
  "flow.action.validate.empty": "請設置按鈕文字",
  "flow.action.validate.exceed": "超出按鈕文字上限",
  "flow.action.failTip": "流轉失敗提示",
  "flow.action.time": "處理時間",
  "flow.action.activate": "啟動",
  "flow.action.sign": "加簽",
  "flow.action.sign.tip": "開啟后，用戶在處理流程時點擊此按鈕，可以添加臨時審批人。 臨時審批人的欄位許可權、審批意見和節點操作許可權與本節點屬性一致。",
  "flow.action.sign_before": "前加簽",
  "flow.action.sign_after": "后加簽",
  "flow.action.sign_parallel": "添加審批人",
  "flow.sign.pane": "加簽",
  "flow.sign.pane.black1.title": "加簽方式",
  "flow.sign.pane.black1.tip": "请選擇加簽方式",
  "flow.sign.pane.black1.type1": "前加簽",
  "flow.sign.pane.black1.type1.desc": "被加簽人先處理，之後我處理",
  "flow.sign.pane.black1.type2": "后加簽",
  "flow.sign.pane.black1.type2.desc": "我已同意提交，之後讓被加簽人處理",
  "flow.sign.pane.black1.type3": "添加審批人",
  "flow.sign.pane.black1.type3.desc": "為當前節點新增一位審批",
  "flow.sign.pane.black2.title": "選擇審批人",
  "flow.sign.pane.black2.tip": "请選擇審批人",
  "flow.auth.group.submit.description": "在此分組內的成員可以發起流程，設置了表單共用的成員自動加入此分組",
  "flow.auth.group.review.name": "查看全部流程",
  "flow.auth.group.review.description": "在此分組內的成員可以查看全部流程",
  "flow.auth.group.manage.name": "管理全部流程",
  "flow.auth.group.manage.description": "在此分組內的成員可以管理全部流程",
  "flow.back.allow": "可回退到的節點",
  "flow.back.parent": "上一節點",
  "flow.back.placeholder": "請選擇可回退節點",
  "flow.back.range": "指定範圍內節點",
  "flow.back.tip": "沒有可回退節點",
  "flow.back.to": "回退到",
  "flow.batch.close": "批量結束流程",
  "flow.batch.forward": "批量提交",
  "flow.batch.close.tip": "此操作會終止進行中的流程，不影響已結束的流程",
  "flow.briefing.tip": "選中的欄位顯示在訪問應用的流程處理清單中，最多顯示三個",
  "flow.briefing.exceed": "最多選擇3個流程簡報選項",
  "flow.btnText": "按鈕文字",
  "flow.btnText.limit": "按鈕文字最多為{{limit}}個字",
  "flow.btnText.tip": "修改後的按鈕文字將替換節點操作的預設按鈕文字，該功能對PC端和移動用戶端均有效",
  "flow.btnText.required": "該項為必填項",
  "flow.btnText.restore": "恢復預設按鈕文字",
  "flow.candidate.tip": "無可用負責人",
  "flow.cc": "抄送人",
  "flow.cc.dynamic": "動態抄送人",
  "flow.cc.enable": "啟用抄送",
  "flow.cc.set": "點擊設置抄送人",
  "flow.charger": "負責人",
  "flow.charger.current": "當前負責人",
  "flow.charger.deptManager": "節點負責人部門主管",
  "flow.charger.dynamic": "動態負責人",
  "flow.charger.name": "負責人名稱",
  "flow.charger.select": "請選擇負責人",
  "flow.charger.set": "點擊設置負責人",
  "flow.charger.change": "調整流程負責人",
  "flow.charge.fail.noNextCharger": "找不到下個節點負責人，可聯繫管理員",
  "flow.charge.fail.noCondition": "不符合流轉條件，可聯繫管理員",
  "flow.charge.fail.noBackCharger": "找不到回退後的負責人，請聯繫管理員",
  "flow.create": "發起流程",
  "flow.creator": "發起人",
  "flow.createTime": "發起時間",
  "flow.creator.depManager": "發起人部門主管",
  "flow.close": "結束流程",
  "flow.batch.active": "批量激活流程",
  "flow.batch.active.subtitle": '<span style="color:#4D609F" >*选择每个流程版本需要激活的流程节点可以批量激活<span>',
  "flow.batch.active.flow.hint": "请选择需要激活的流程节点",
  "flow.close.confirm": "您確定要結束流程嗎？",
  "flow.close.desc": "保存在此節點中的操作，並且將流程直接結束掉，不再往下流轉",
  "flow.close.tip": "結束流程後資料將停止流轉，是否確認結束此流程？",
  "flow.close.all": "結束全部流程",
  "flow.close.all.confirm": "您確定要結束全部流程嗎？",
  "flow.close.all.done": "已結束全部流程",
  "flow.close.selected": "結束選中的流程",
  "flow.close.selected.confirm": "您確定要結束選中的流程嗎？",
  "flow.close.selected.done": "已結束選中的流程",
  "flow.chart.empty": "暫無流轉圖",
  "flow.cond": "資料流程轉條件",
  "flow.cond.add": "添加流轉條件",
  "flow.cond.custom": "使用自訂流轉條件",
  "flow.cond.custom.tip": "當資料滿足流轉條件時，進入這條連接線下的節點；不添加流轉條件時，所有資料都會進入這條連接線下的節點。",
  "flow.cond.else": "使用Else條件",
  "flow.cond.else.tip": "當資料不滿足同級的其他流轉條件時，進入這條連接線下的節點。",
  "flow.comment.empty": "暫無審批意見",
  "flow.done": "該流程已被處理",
  "flow.done.tip": "該流程已被處理，無法再次操作，請選擇其他流程。",
  "flow.done.viewReason": "查看詳細原因",
  "flow.done.clickToViewReason": "如需查看詳細原因，請點擊此處",
  "flow.drag.node.guide": "拖拽添加節點",
  "flow.enable": "開始使用",
  "flow.enable.tip": "繪製上圖所示流程圖，設定資料流程轉方式，即可搭建線上工作流",
  "flow.enable.qa": "如有問題，請參考",
  "flow.fail.hint.forward": "提交失敗",
  "flow.fail.hint.autoBack": "自動回退失敗",
  "flow.fail.hint.autoForward": "自動提交失敗",
  "flow.fail.hint.back": "回退失敗",
  "flow.fail.hint.charger": "找不到下個節點負責人。",
  "flow.fail.hint.cond": "不符合流轉條件。",
  "flow.fail.hint.reason": "出錯原因：",
  "flow.fail.hint.title": "流程出錯了，可聯繫連結發佈者尋求説明",
  "flow.fail.hint.detail": "您的資料已保存，請勿重複提交!",
  "flow.flowCreator": "流程發起人",
  "flow.launch": "發起流程",
  "flow.launch.empty": "當前沒有可發起的流程",
  "flow.list.empty": "沒有篩選出符合條件的流程",
  "flow.list.todo.empty": "沒有新的待辦任務",
  "flow.list.part.empty": "您還沒有參與流程",
  "flow.list.create.empty": "您沒有發起過流程",
  "flow.list.multiNode": "多個節點",
  "flow.list.current": "當前:",
  "flow.list.date.just": "小於1分鐘",
  "flow.list.date.longAgo": "大於30天",
  "flow.list.date.remaining": "剩餘處理時間",
  "flow.list.loaded": "已載入全部資料",
  "flow.logAndState": "流程日誌/流轉圖",
  "flow.log.enable": "允許查看流程日誌和流轉圖",
  "flow.log.tip": "開啟此功能後，處理流程時可以查看流程日誌和流轉圖。",
  "flow.log.startTime": "開始時間：{{time}}",
  "flow.log.dealTime": "處理時間：{{time}}",
  "flow.log": "流程日誌",
  "flow.log.empty": "暫無流程日誌",
  "flow.manage": "流程管理",
  "flow.msg": "流程提醒",
  "flow.msg.dingtalk": "使用釘釘提醒節點負責人、抄送人",
  "flow.msg.wework": "使用企業微信提醒節點負責人、抄送人",
  "flow.msg.wechat": "使用微信提醒節點負責人、抄送人",
  "flow.msg.email": "使用郵件提醒節點負責人、抄送人",
  "flow.node": "流程節點",
  "flow.node.action": "節點操作",
  "flow.node.action.tip": "定義流程負責人在處理流程時可以進行的操作",
  "flow.node.attr": "節點屬性",
  "flow.node.auth.empty": "節點欄位許可權未配置",
  "flow.node.cc": "抄送節點",
  "flow.node.cc.empty": "抄送人未設置",
  "flow.node.charger": "節點負責人",
  "flow.node.charger.empty": "節點負責人未設置",
  "flow.node.copy": "複製節點",
  "flow.node.current": "當前節點",
  "flow.node.del": "刪除節點",
  "flow.node.empty": "存在節點未設置負責人或全部欄位不可見",
  "flow.node.end": "流程結束",
  "flow.node.end.del": "流程結束不能刪除",
  "flow.node.end.unconnect": "流程結束節點未連接，流程無法啟用",
  "flow.node.end.desc": "沒有下級節點的節點會自動連接至流程結束；如果您需要在中途結束流程，請將需要結束流程的節點，連接到流程結束，並設置相應的流轉條件。",
  "flow.node.isolated": "存在無資料流程轉的節點，請刪除後啟用",
  "flow.node.name": "節點名稱",
  "flow.node.path": "節點連接線",
  "flow.node.pt": "節點列印範本",
  "flow.node.pt.set": "範本設置",
  "flow.node.select": "請選擇節點",
  "flow.back.node.select": "請選擇回退節點",
  "flow.node.signature.disable": "手寫簽名不可用",
  "flow.node.start": "流程發起節點",
  "flow.node.start.del": "流程發起節點不能刪除",
  "flow.node.validate": "節點校驗條件",
  "flow.node.validate.any": "所有資料均可提交",
  "flow.node.validate.meet": "滿足條件的資料才可提交",
  "flow.node.cancelReminder": "提交不觸發提醒",
  "flow.node.doing": "處理中節點",
  "flow.node.done": "已流轉節點",
  "flow.node.undone": "未流轉節點",
  "flow.node.prostatus": "處理狀態",
  "flow.node.protime": "流程處理時長",
  "flow.node.outtime": "流程超時時長",
  "flow.node.pro.text": "流程時效統計",
  // "flow.node.flow_sub": "子流程",
  "flow.node.flow_sub": "子流程贊助者",
  "flow.node.flow_sub.name": "子流程表單",
  "flow.node.flow_sub.set": "點擊設置贊助者",
  "flow.node.flow_sub.tooltip": "流轉至此節點時,將自動為所選的流程表單創建流程",
  "flow.node.flow_sub.transfer": "資料傳遞",
  "flow.node.flow_sub.transfer.set": "設置數據傳遞規則",
  "flow.node.flow_sub.transfer.done": "已設置數據傳遞規則",
  "flow.node.flow_sub.transfer.rule": "流轉規則",
  "flow.node.flow_sub.transfer.end": "子流程結束後進入下一節點",
  "flow.node.flow_sub.transfer.start": "子流程發起後進入下一節點",
  "flow.node.flow_sub.transfer.warning": "最多添加{{ count}}個子流程節點",
  "flow.node.flow_sub.rule.warning": "請先選擇子流程表單",
  "flow.node.flow_sub.rule.same": "確定要使用該子表單字段賦值嗎？",
  "flow.node.flow_sub.rule.same.desc": "單個子表單不能使用不同子表單字段賦值，此操作會清除部分已設置的規則",
  "flow.node.flow_sub.auto.submit": "子流程發起後自動提交",
  "flow.node.flow_sub.transfer.tooltip": "開啟後,流轉至子流程節點時,將自動為發起人創建流程並提交,直接進入後續節點;",
  "flow.node.flow_sub.transfer.tooltip.desc": "關閉時,僅為贊助者創建待辦,停留在發起節點",
  "flow.node.flow_sub.transfer.tip.in": "當父流程流轉到子流程節點時,以下父流程欄位值將賦給對應子流程字段",
  "flow.node.flow_sub.transfer.tip.out": "當子流程流轉完成時,以下子流程欄位值將賦給對應父流程欄位",
  "flow.node.flow_sub.complete.tip": "請設置完整的傳遞規則",
  "flow.node.flow_sub.form.fail": "表單已刪除/無跨應用許可權",
  "flow.node.flow_sub.to": "賦值給",
  "flow.node.flow_sub.parent": "父流程",
  "flow.node.flow_sub.child": "子流程",
  "flow.node.flow_sub.child.watermark": "請選擇子流程欄位",
  "flow.node.flow_sub.parent.watermark": "請選擇父流程欄位",
  "flow.node.flow_sub.add.rule": "添加規則",
  "flow.node.flow_sub.parent.child": "父流程 -> 子流程",
  "flow.node.flow_sub.child.parent": "子流程 -> 父流程",
  "flow.node.flow_sub.dynamic": "動態贊助者",
  "flow.node.flow_sub.creator": "子流程發起人",
  "flow.node.flow_sub.close.confirm": "確定要關閉「數據傳遞」設置界面嗎？",
  "flow.node.flow_sub.close.detail": "關閉後本次設置不會保存，此操作無法還原",
  "flow.node.flow_sub.log.inprocess": "子流程進行中（完成 {{ now}}/{{ total}}）",
  "flow.node.flow_sub.log.complete": "子流程已完成（完成 {{ total}}/{{ total}}）",
  "flow.node.flow_sub.empty": "存在子流程節點的表單或發起人配置有誤",
  "flow.node.flow_sub.maximum": "存在子流程表單設置出現循環或嵌套超過三層",
  "form.sub.data.deleted": "該條數據已被刪除",
  "form.sub.chargers.empty": "子流程發起人未設置",
  "flow.node.flow_sub.access.fail": "沒有對應數據查看權限",
  "form.chargersEmptyRule": "負責人為空處理規則",
  "form.chargersEmptyRule.items1": "不啟用",
  "form.chargersEmptyRule.items2": "跳過並到下一節點",
  "form.chargersEmptyRule.items3": "轉交給指定負責人",
  "form.chargersEmptyRule.spareChargers.empty": "負責人為空的備選負責人不能為空",
  "form.chargersEmptyRule.spareChargers.log": "系統自動轉交給備選負責人",
  "form.sub.form.empty": "子流程表單未設置",
  "form.sub.form.error": "子流程表單配置有誤",
  "form.sub.invalid.in": "可聯繫管理員激活至上一節點重新提交",
  "form.sub.invalid.msg": "觸發失敗",
  "mobile.flow.node.doing": "處理中",
  "mobile.flow.node.done": "已流轉",
  "mobile.flow.node.undone": "未流轉",
  "flow.node.selectActivate": "選擇啟動節點",
  "flow.node.activate.required": "啟動節點不能為空",
  "flow.node.activate.success": "啟動節點成功",
  "flow.node.activate.fail": "啟動節點失敗",
  "flow.node.required": "當前節點不能為空",
  "flow.part": "我參與的",
  "flow.print.allow": "允許查看時列印",
  "flow.release": "啟用流程",
  "flow.release.confirm": "確定要啟用流程嗎？",
  "flow.release.tip": "啟用後，新提交的資料將按此版本的流程流轉。",
  "flow.release.empty.tip": "您的流程尚未啟用，請至「流程設定」中啟用流程。",
  "flow.revoke.allow": "流程發起後允許撤回",
  "flow.revoke.tip": "選中後允許流程發起人在後續節點負責人尚未處理的情況下撤回流程",
  "flow.Urge": "催辦",
  "flow.Urge.one": "催",
  "flow.Urge.allow": "允許流程發起人催辦",
  "flow.Urge.tip": "開啟功能後，當某節點負責人尚未處理時，發起人可向其發送催辦通知",
  "flow.Urge.process.all": "全部處理中的節點",
  "flow.rule": "流轉規則",
  "flow.rule.any": "任意負責人提交後進入下一節點",
  "flow.rule.all": "所有負責人提交後進入下一節點",
  "flow.save.fail": "流程保存失敗",
  "flow.save.log": "暫存記錄",
  "flow.save.success": "流程保存成功",
  "flow.schedule": "節點限時處理",
  "flow.schedule.arrive": "流程到達節點",
  "flow.schedule.action.add": "添加自動處理",
  "flow.schedule.action.detail": "自動處理詳情",
  "flow.schedule.action.defaultMessage": "有待辦未完成，請及時處理",
  "flow.schedule.action.op": "處理方式",
  "flow.schedule.action.set": "自動處理設置",
  "flow.schedule.action.set.tip": "如何添加自動處理？",
  "flow.schedule.back": "自動回退",
  "flow.schedule.back.time": "自動回退時間",
  "flow.schedule.back.to": "回退到",
  "flow.schedule.brief.timeLimit": "流程到達該節點{{ time }}後",
  "flow.schedule.del.confirm": "您確定要刪除節點限時處理嗎？",
  "flow.schedule.del.tip": "刪除節點限時處理後，您設置的自動處理也將一併刪除，該操作不可逆。",
  "flow.schedule.doc": "如何設置限時處理？",
  "flow.schedule.forward": "自動提交",
  "flow.schedule.forward.time": "自動提交時間",
  "flow.schedule.forward.execDataExtend": "執行擴展功能",
  "flow.schedule.limit": "節點處理截止時間",
  "flow.schedule.limit.on": "在節點處理截止時間",
  "flow.schedule.limit.custom": "自訂時間",
  "flow.schedule.limit.widget": "表單內日期時間欄位",
  "flow.schedule.limit.widget.tip": "請選擇日期時間欄位",
  "flow.schedule.node.tooltip": "已設置節點限時處理",
  "flow.schedule.notify": "自動提醒",
  "flow.schedule.notify.msg": "提醒文字",
  "flow.schedule.notify.time": "自動提醒時間",
  "flow.schedule.op.forward": "自動提交",
  "flow.schedule.op.back": "自動回退",
  "flow.schedule.set": "設置限時處理",
  "flow.schedule.timeLimit": "在節點處理截止時間{{ time }}{{ op }}",
  "flow.schedule.tip": "為節點設置處理截止時間，並可自動提醒節點負責人處理待辦，如果長時間不處理可自動提交或回退，避免流程停滯。",
  "flow.schedule.validate.actionEmpty": "請添加節點自動處理",
  "flow.schedule.validate.actionConflict": "節點處理截止時間和自動處理時間存在衝突",
  "flow.schedule.validate.target": "未設置被提醒人",
  "flow.schedule.validate.msg": "提醒文字不能為空",
  "flow.schedule.validate.maxCount": "添加失敗，最多添加{{ count }}個自動處理",
  "flow.schedule.validate.onlyOne": "已設置{{ hasSet }}，最多添加1個{{ action }}",
  "flow.schedule.validate.cannot": "已設置{{ hasSet }}，無法添加{{ action }}",
  "flow.schedule.validate.earlier": "自動提醒的時間需要早于{{ action }}的時間",
  "flow.state.inProcess": "進行中",
  "flow.state.complete": "流轉完成",
  "flow.state.closed": "手動結束",
  "flow.setting": "流程設定",
  "flow.transfer": "更換待辦節點",
  "change.flow.node": "節點管理",
  "flow.transfer1": "調整",
  "flow.transfer.set": "點擊設置轉交候選人",
  "flow.transferTip": "僅調整本條資料當前負責人，不影響流程配置。",
  "flow.transfer.noChange": "當前負責人未改變",
  "flow.transfer.required": "當前負責人不能為空",
  "flow.transfer.success": "調整負責人成功",
  "flow.transfer.fail": "調整負責人失敗",
  "flow.currentTransfer": "此節點當前負責人",
  "flow.todo": "待辦任務",
  "flow.todo.count": "當前待處理任務 {{ count }} 條",
  "flow.my.cc": "我的抄送",
  "flow.my.transactors": "我處理的",
  "flow.todo.current": "當前待辦",
  "flow.todo.mission": "待辦任務",
  "flow.version": "流程版本",
  "flow.version.add": "添加新版本",
  "flow.version.add.fail": "添加新版本失敗",
  "flow.version.affix.current": "流程已啟用，如需增刪節點和連線，請",
  "flow.version.affix.history": "歷史版本不可增刪節點和連線，如需增刪節點和連線，請切換至設計中的版本，或",
  "flow.version.btn": "版本管理",
  "flow.version.current": "啟用中",
  "flow.version.del.confirm": "確定要刪除流程版本嗎？",
  "flow.version.del.fail": "刪除版本失敗",
  "flow.version.del.tip": "刪除後，你將無法再編輯和啟用此流程版本。",
  "flow.version.design": "設計",
  "flow.version.desc": "版本描述",
  "flow.version.desc.edit": "編輯版本描述",
  "flow.version.desc.label": "版本描述：",
  "flow.version.history": "歷史",
  "flow.version.label": "版本號：",
  "flow.version.manage": "管理流程版本",
  "flow.version.name": "流程版本(V{{name}})",
  "flow.vip.signature.admin": "流程中有超出當前版本的高級功能：手寫簽名。超版本功能已禁用。如需使用完整功能，請至會員中心升級版本。",
  "flow.vip.signature.mem": "流程中有超出當前版本的高級功能：手寫簽名。超版本功能已禁用。如需使用完整功能，請聯繫企業創建者升級版本。",
  "form.allFields": "所有表單字段",
  "form.attr": "表單屬性",
  "form.attr.field": "欄位屬性",
  "form.cache": "表單前臺緩存",
  "form.cache.tip": "進入表單時，自動載入上次填寫未提交的內容。基於流覽器緩存，無法跨設備讀取。",
  "form.comment": "審批意見",
  "form.comment.copied": "已複製審批意見",
  "form.comment.copy": "複製並繼續",
  "form.comment.disable": "未開啟",
  "form.comment.enable": "已開啟選填",
  "form.comment.flow": "開啟審批意見後，節點負責人處理流程時須按要求填寫審批意見",
  "form.comment.notNull": "審批意見為必填項",
  "form.comment.notNull.signature": "審批意見（手寫簽名）為必填項",
  "form.comment.notNull.text": "審批意見（文本意見）為必填項",
  "form.comment.required": "已開啟必填",
  "form.comment.save": "審批意見不會被保存，是否複製審批意見後繼續？",
  "form.comment.save.desc": "系統不會保存你已填寫的審批意見。點擊「複製並繼續」，我們會自動複製你已填寫的審批意見。",
  "form.comment.signature.notNull": "（手寫簽名必填）",
  "form.comment.text": "文本意見",
  "form.config.basic": "基礎設置",
  "form.config.ext": "表單設置",
  "form.config.Development": "後端腳本",
  "form.copy.empty": "沒有可選擇的目標應用",
  "form.copy.tip": "將表單複製到其他應用時，不會保留對其他表單的引用。資料聯動、公式中對其他表單字段的引用等都會丟失。",
  "form.copy.withData": "同時複製資料",
  "form.copy.withData.tip": "複製的資料會計入資料總量，請確保您的版本滿足需求。",
  "form.data": "資料管理",
  "form.data.manage": "表單資料管理",
  "form.data.auth": "數據許可權組",
  "form.data.auth1": "數據許可權組",
  "buttom.print.auth": "扩展按钮",
  "form.data.deleted": "資料已被刪除",
  "form.data.select": "您當前選中了{{length}}條資料，",
  "form.data.recover": "資料刪除後可在回收站中恢復",
  "form.data.canNotRecover": "免費版刪除的資料無法恢復",
  "form.design": "表單設計",
  "form.fields": "表單字段",
  "form.fields.add": "從左側拖拽來添加欄位",
  "form.fields.basis": "基礎欄位",
  "form.fields.delete": "若刪除該欄位，其對應的表單數據也會被清除。確定刪除？",
  "form.fields.enhance": "增強欄位",
  "form.fields.member": "部門成員欄位",
  "form.fields.system": "系統欄位",
  "form.guide.add1": "這裡是欄位清單。點擊欄位名可添加表單字段",
  "form.guide.add2": "這裡是欄位清單。選擇合適欄位點擊後可添加到設計面板中",
  "form.guide.data": "在這裡設置資料許可權，成員登錄系統後即可查看特定範圍的資料",
  "form.guide.field": "已添加的欄位顯示在此處，可以在右側的欄位屬性中修改欄位標題、設置欄位許可權",
  "form.guide.flow.design": "流程設定可以設置資料的流轉規則。啟用流程後，資料可按照設定規則流轉",
  "form.guide.flow.node": "流程節點在流程設計中使用最為廣泛，拖拽可添加流程節點到設計面板中",
  "form.guide.flow.version": "流程已經啟用，如需增加流程節點，請點擊添加新版本",
  "form.guide.flow.charger": "拖拽添加節點後可以在右側設置節點操作許可權，不要忘記設置負責人",
  "form.guide.flow.launch": "所有節點設置完成並連接後，點擊此處啟用流程，資料就可以按照設置的流程流轉",
  "form.guide.flow.rename": "點擊重命名流程表單",
  "form.guide.rename": "點擊重命名表單",
  "form.guide.release": "發佈表單分為團隊成員發佈和公開連結發佈。請根據使用場景選擇合適的發佈方式",
  "form.guide.save": "點擊此處保存表單設計，下次進入後可繼續編輯表單",
  "form.guide.share": "在這裡發佈表單，可以將表單發佈給團隊成員或外部人員填寫",
  "form.item.image.limit": "上傳失敗，單張圖片的上傳上限為20M",
  "form.item.file.limit": "上傳失敗，單個檔的上傳上限為20M",
  "form.item.error.format": "此項格式不正確",
  "form.layout": "電腦端表單佈局",
  "form.layout.mobile": "移動端表單佈局",
  "form.layout.standard": "標準",
  "form.layout.compact": "緊湊",
  "form.layout.normal": "單列",
  "form.layout.dc": "雙列",
  "form.flow": "流程表單",
  "form.release": "發佈表單",
  "form.release.mem": "將表單發佈給團隊成員，成員登錄系統後可填寫表單",
  "form.release.link": "將表單發佈為公開連結，無需登錄即可填寫表單",
  "form.release.auth": "載入表單許可權失敗",
  "form.load.fail": "載入表單失敗",
  "form.link": "表單訪問內鏈",
  "form.link.subTitle": "團隊成員訪問該連結需要登錄並授權",
  "form.externalLink": "表單外鏈",
  "form.externalLink.name": "表單填寫連結",
  "form.externalLink.label": "憑密碼填寫",
  "form.ext": "外鏈擴展",
  "form.ext.desc": "給表單外鏈添加擴展欄位，由此來標記資料來源",
  "form.ext.list": "擴展外鏈列表({{length}})",
  "form.ext.listTitle": "擴展外鏈列表",
  "form.ext.required": "擴展欄位不能為空",
  "form.ext.failTip": "擴展外鏈值已存在，請重新輸入",
  "form.ext.add.success": "添加成功",
  "form.ext.add.fail": "添加失敗",
  "form.query": "公開查詢",
  "form.query.subTitle": "通過公開查詢連結可以查看已經填報的資料內容，通常用於通訊錄查詢、執行進度查詢、成績查詢等場景。",
  "form.fields.display": "顯示內容",
  "form.public.queryLink": "公開查詢連結",
  "form.public.queryLink.needPass": "憑密碼查詢",
  "form.public.queryLink.shareTo": "分享到",
  "form.public.queryLink.shareMsg": "我在@平台 上創建了{{- entry}}，邀請大家來查看！-{{- name}}",
  "form.public.innerlinkshare": "分享內鏈",
  "form.public.publiclinkshare": "分享外鏈",
  "form.public.innerlinkshare.copy.success": "數據內鏈鏈接複製成功",
  "form.public.publiclinkshare.copy.success": "數據外鍊鍊接複製成功",
  "form.publish": "表單發佈",
  "form.pass.required": "密碼不能為空",
  "form.defaultName": "未命名表單",
  "form.name": "表單名稱",
  "form.search.empty": "無搜尋結果",
  "form.search.placeholder": "輸入名稱來搜索",
  "form.set": "表單設置",
  "form.group": "表單分組",
  "form.submit.async": "表單數據計算中，請勿離開頁面",
  "form.submit.async.desc": "請等待計算完成後提交，否則會丟失資料。如果此提示反復出現，請聯繫管理員調整表單設計",
  "form.submit.continue": "繼續添加",
  "form.submit.fail": "提交失敗",
  "form.submit.fail.back": "回退失敗，找不到回退後的負責人",
  "form.submit.fail.charger": "提交失敗，找不到下個節點負責人",
  "form.submit.fail.charger.desc": "流程已暫存至「我的待辦」中，可聯繫管理員檢查節點負責人後重新提交。",
  "form.submit.fail.cond": "提交失敗，不符合流轉條件",
  "form.submit.fail.cond.desc": "流程已暫存至「我的待辦」中，可聯繫管理員檢查流轉條件後重新提交。",
  "form.submit.fail.subflow": "提交失敗，不符合子流程節點流入條件",
  "form.submit.fail.subflow.desc": "流程已暫存至「我的待辦」中，可聯繫管理員檢查流程設計後重新提交。",
  "form.submit.fail.approval": "提交失敗",
  "form.submit.fail.approval.desc": "流程負責人總人數不滿足按比例審批設定的最低人數要求",
  "form.submit.invalid": "存在不符合規範的值",
  "form.submit.repeat": "此項為重複值",
  "form.submit.contain.repeat": "此項存在重複值",
  "form.submit.rule": "不可見欄位賦值",
  "form.submit.rule.tip": "根據業務需要，設置不可見欄位值的處理方式",
  "form.submit.rule.always": "始終重新計算",
  "form.submit.rule.alwaysTip": "不可見欄位的計算、提交邏輯，與可見時保持一致",
  "form.submit.rule.keep": "保持原值",
  "form.submit.rule.keepTip": "不可見欄位的原有值保持不變",
  "form.submit.rule.nullTip": "不可見欄位提交為空值",
  "form.submit.rule.alwaysTip.extra": "不可見字段的計算、提交邏輯，與可見時保持一致（特殊字段按照設置的對應規則賦值）",
  "form.submit.rule.keepTip.extra": "不可見字段的原有值保持不變（特殊字段按照設置的對應規則賦值）",
  "form.submit.rule.nullTip.extra": "不可見字段提交為空值（特殊字段按照設置的對應規則賦值）",
  "form.submit.rule.special": "特殊字段賦值規則",
  "form.submit.rule.special.tip": "此處設置的字段，不可見時按照下方對應規則賦值，不受默認賦值規則的影響",
  "form.submit.rule.special.set": "已設置特殊字段賦值規則",
  "form.submit.rule.warning": "確定要更換默認賦值規則嗎？",
  "form.submit.rule.warning.detail": "更換默認賦值規則後，將清空已設置的特殊字段賦值規則",
  "form.submit.rule.set": "設置特殊字段賦值規則",
  "form.submit.validate": "表單提交校驗",
  "form.submit.validate.flow": "已開啟流程，流程中的提交校驗以節點設置為准",
  "form.submit.Confirm.settings": "表單提交確認設置",
  "form.submit.Confirm.settings.tips.1": "需要提示確認的字段",
  "form.submit.Confirm.settings.tips.2": "選擇確認字段",
  "form.submit.Confirm.settings.tips.3": "填寫提示語",
  "form.submit.Confirm.settings.tips.4": "請確認以下字段內容是否正確",
  "form.submit.upload.Expired": "存在已過期的附件，請重新上傳後，再提交數據",
  "form.submit.async2": "計算失敗，請檢查網絡後重試",
  "form.submit.async2.desc": "「{{name}}」計算失敗。 如果此提示反復出現，請聯系管理員調整表單設計。",
  "form.field.visible.label": "字段顯隱規則",
  "form.field.visible.add": "添加顯隱規則",
  "form.field.visible.added": "已設置{{- number}}個顯隱規則",
  "form.field.visible.maxrule": "每張表單最多添加{{- number}}個顯隱規則",
  "form.field.visible.maxcond": "每個顯隱規則最多添加{{- number}}個條件",
  "form.field.visible.tip": "讓字段在特定條件成立時顯示，反之隱藏。",
  "form.field.visible.question": "如何設置顯隱規則？",
  "form.field.visible.delete": "確定要刪除此顯隱規則？",
  "field.visible.filter.inComplete": "請設置完整的條件",
  "field.visible.fields.inComplete": "請設置要顯示的字段",
  "field.visible.fields.hasUsed": "有顯示字段已被其他顯隱規則設置",
  "subField.visible.label": "子字段顯隱規則",
  "subField.visible.tip": "讓子表單的子字段在特定條件成立時顯示，反之隱藏。",
  "subField.visible.add": "添加顯隱規則",
  "subField.visible.added": "已設置{{- number}}個顯隱規則",
  "subField.trigger.show": "顯示以下子字段",
  "form.field.contact.tip": "選項關聯升級為「字段顯隱規則」，請到表單屬性中配置。",
  "form.field.trigger.before": "滿足以下",
  "form.field.trigger.after": "條件時",
  "form.field.trigger.show": "顯示以下字段",
  "form.theme.align": "對齊方式",
  "form.theme.background": "頁面背景",
  "dash.theme.component.background": "控件背景",
  "form.theme.banner": "表頭樣式",
  "form.theme.button": "提交按鈕",
  "form.theme.button.errtip": "「提交」與「提交並打印」按鈕必須開啟1個",
  "form.theme.color": "純色",
  "form.theme.custom": "自訂樣式",
  "form.theme.external": "表單外鏈樣式",
  "form.theme.image": "圖片",
  "form.theme.image.tip": "支援jpg、gif、png格式，不超過5M的圖片",
  "form.theme.style": "樣式",
  "form.theme.system": "主題樣式",
  "form.theme.title": "標題樣式",
  "form.validator.add": "添加校驗條件",
  "form.validator.add.error": "存在已刪除欄位，請及時修改",
  "form.vip.signature.admin": "表單中有超出當前版本的高級功能：手寫簽名。超版本功能已禁用。如需使用完整功能，請至會員中心升級版本。",
  "form.vip.signature.mem": "表單中有超出當前版本的高級功能：手寫簽名。超版本功能已禁用。如需使用完整功能，請聯繫企業創建者升級版本。",
  "formula.add": "添加公式",
  "formula.advance": "高級函數",
  "formula.subform": "子表單函數",
  "formula.date": "日期函數",
  "formula.empty": "沒有對應的函數",
  "formula.edit.example": "公式編輯舉例：",
  "formula.example": "示例：",
  "formula.example.language.grade": "語文成績",
  "formula.example.math.grade": "數學成績",
  "formula.example.baseVideo": "觀看公式入門視頻>",
  "formula.example.advanceVideo": "觀看公式進階視頻>",
  "formula.example.doc": "查看所有公式的幫助文檔",
  "formula.func": "函數",
  "formula.input.tip": "從左側面板選擇欄位名和函數，或輸入函數",
  "formula.input.placeholder": "請輸入提示文字",
  "formula.inputEnglish": "請在英文輸入法模式下編輯公式",
  "formula.current.form.tip": "無可用變數，請添加或保存表單後重試",
  "formula.set.success": "公式設置成功",
  "formula.valid.set.success": "校驗條件設置成功",
  "formula.field.empty.tip": "無可用變數，請添加",
  "formula.learnMore": "瞭解詳情",
  "formula.common": "常用函數",
  "formula.logic": "邏輯函數",
  "formula.math": "數學函數",
  "formula.omit": "略",
  "formula.search": "搜索函數",
  "formula.text": "文本函數",
  "formula.usage": "用法：",
  "formula.tooLong": "運算式長度超出限制",
  "formula.field.aggregate.already": "已聚合計算的欄位無法再次聚合計算",
  "formula.field.aggregate.conflict": "聚合計算的欄位無法和未聚合計算的欄位互相計算",
  "formula.field.subform.conflict": "主表字段和子表字段無法互相計算",
  "formula.field.subform.different": "不同子表單的欄位無法互相計算",
  "formula.field.number.conflict": "數位類型指標和非數位類型指標無法互相計算",
  "formula.valid.fail": "函數公式不正確",
  "formula.valid.fail.tip": "不滿足校驗條件時提示文字:",
  "formula.valid.field.tip": "存在無效欄位,請刪除",
  "formula.valid.map.tip": "MAP函數已過時,請改用MAPX函數",
  "formula.abs.intro": "ABS函數可以獲取一個數的絕對值",
  "formula.abs.usage": "ABS(數字)",
  "formula.abs.example": "ABS(-8)可以返回8，也就是-8的絕對值",
  "formula.and.intro": "如果所有參數都為真，AND函數返回布林值true，否則返回布林值 false",
  "formula.and.usage": "AND(邏輯運算式1,邏輯運算式2,...)",
  "formula.and.example": "AND({語文成績}>90,{數學成績}>90,{英語成績}>90)，如果三門課成績都> 90，返回true，否則返回false",
  "formula.average.intro": "AVERAGE函數可以獲取一組數值的算術平均值",
  "formula.average.usage": "AVERAGE(數位1,數位2,...)",
  "formula.average.usage.one.para": "AVERAGE(數位1)",
  "formula.average.example": "AVERAGE({語文成績},{數學成績}, {英語成績})返回三門課程的平均分",
  "formula.average.example.one.para": "AVERAGE({語文成績})，返回語文成績的平均分",
  "formula.ceiling.intro": "CEILING函數可以將數位增大到最接近原值的指定因數的倍數",
  "formula.ceiling.usage": "CEILING(數字,因數)",
  "formula.ceiling.example": "CEILING(7,6)返回12，因為12比7大的同時，也是6的倍數中最接近7的數字",
  "formula.char.intro": "CHAR函數可以將電腦字元集的數位代碼轉換為對應字元",
  "formula.char.usage": "CHAR(數字)",
  "formula.char.example": "CHAR(10)會返回換行字元",
  "formula.count.intro": "COUNT函數可以獲取參數的數量",
  "formula.count.usage": "COUNT(值,值,...)",
  "formula.count.usage.one.para": "COUNT(值)",
  "formula.count.example": "COUNT(小明,小王,小張,小李)返回4，也就是人員的數量",
  "formula.count.example.one.para": "COUNT({語文成績})，返回有效語文成績資料條數",
  "formula.concatenate.intro": "CONCATENATE函數可以將多個文本合併成一個文本",
  "formula.concatenate.usage": "CONCATENATE(文本1,文本2,...)",
  "formula.concatenate.example": 'CONCATENATE("三年二班","周傑倫")會返回"三年二班周傑倫"',
  "formula.countif.intro": "COUNTIF函數可以獲取陣列中滿足條件的參數個數",
  "formula.countif.usage": 'COUNTIF(陣列,"條件")',
  "formula.countif.example": 'COUNTIF(子表單.性別, "女")，可得到子表單中性別填的是"女"的數據條數；COUNTIF([1,2,3,4],">2")，可得到1,2,3,4中大於2的數字數量，結果為2。',
  "formula.date.intro": "DATE函數可以將時間戳記轉換為日期物件",
  "formula.date.usage": "DATE(時間戳記)",
  "formula.datedelta.intro": "DATEDELTA函數可以將指定日期加/減指定天數",
  "formula.datedelta.usage": "DATEDELTA(指定日期,需要加減的天數)",
  "formula.datediff.intro": "DATEDIFF函數可以計算兩個時間的差",
  "formula.datediff.usage": "DATEDIFF(指定日期1,指定日期2,類型)",
  "formula.day.intro": "DAY函數可以獲取某日期是當月的第幾日",
  "formula.day.usage": "DAY(時間戳記)",
  "formula.days.intro": "DAYS函數可以返回兩個日期之間相差的天數。",
  "formula.days.usage": "DAYS(結束日期,開始日期)",
  "formula.days360.intro": "DAYS360按照一年 360 天的演算法，返回兩個日期間相差的天數",
  "formula.days360.usage": "DAYS360(結束日期,開始日期)",
  "formula.exact.intro": "EXACT函數可以比較兩個文本是否完全相同，完全相同則返回true，否則返回false",
  "formula.exact.usage": "EXACT(文本1, 文本2)",
  "formula.exact.example": "EXACT({手機號},{中獎手機號})，如果兩者相同，返回true，如果不相同，返回false",
  "formula.false.intro": "FALSE函數返回布林值false",
  "formula.false.usage": "FALSE()",
  "formula.fixed.intro": "FIXED函數可將數位舍入到指定的小數位數並輸出為文本",
  "formula.fixed.usage": "FIXED(數字,小數位數)",
  "formula.fixed.example": 'FIXED(3.1415,2)返回"3.14"',
  "formula.floor.intro": "FLOOR函數可將數位減小到最接近原值的指定因數的倍數",
  "formula.floor.usage": "FLOOR(數字,因數)",
  "formula.floor.example": "FLOOR(7,6)返回6，因為6比7小的同時，也是6的倍數中最接近7的數字",
  "formula.getusername.intro": "GETUSERNAME函數可以獲取當前使用者的昵稱",
  "formula.getusername.usage": "GETUSERNAME()",
  "formula.hour.intro": "HOUR函數可以返回某日期的小時數",
  "formula.hour.usage": "HOUR(時間戳記)",
  "formula.if.intro": "IF函數判斷一個條件能否滿足；如果滿足返回一個值，如果不滿足則返回另外一個值",
  "formula.if.usage": "IF(邏輯運算式,為true時返回的值,為false時返回的值)",
  "formula.if.example": 'IF({語文成績}>60,1,2)，當語文成績>60時返回 1，否則返回 2。',
  "formula.ifs.intro": "IFS函數檢查是否滿足一個或多個條件，且返回符合第一個TRUE條件的值，IFS可以取代多個嵌套IF語句。",
  "formula.ifs.usage": "IFS(邏輯運算式1,邏輯運算式1為true返回該值,邏輯運算式2,邏輯運算式2為true返回該值,...)",
  "formula.ifs.example": 'IFS({語文成績}>90,"優秀",{語文成績}>80,"良好",{語文成績}>=60,"及格",{語文成績}<60,"不及格")，根據成績返回對應的評價。',
  "formula.int.intro": "INT函數可以獲取一個數的整數部分",
  "formula.int.usage": "INT(數字)",
  "formula.int.example": "INT(3.1415)返回3，也就是3.1415的整數部分",
  "formula.ip.intro": "IP函數可以獲取當前使用者的ip位址",
  "formula.ip.usage": "IP()",
  "formula.isempty.intro": "ISEMPTY函數可以用來判斷值是否為空文本、空物件或者空陣列",
  "formula.isempty.usage": "ISEMPTY(文本)",
  "formula.isoweeknum.intro": "ISOWEEKNUM函數可以返回指定日期在全年中的ISO周數",
  "formula.isoweeknum.usage": "ISOWEEKNUM(指定日期)",
  "formula.large.intro": "LARGE函數可以獲取資料集中第k個最大值",
  "formula.large.usage": "LARGE(陣列,k)",
  "formula.large.example": 'LARGE({學生成績.數學成績},1)返回子表單"學生成績"中排名第1的"數學成績"',
  "formula.left.intro": "LEFT函數可以從一個文本的第一個字元開始返回指定個數的字元",
  "formula.left.usage": "LEFT(文本,文本長度)",
  "formula.left.example": 'LEFT("三年二班周傑倫",2)返回"三年"，也就是"三年二班周傑倫"的從左往右的前2個字元',
  "formula.len.intro": "LEN函數可以獲取文本中的字元個數",
  "formula.len.usage": "LEN(文本)",
  "formula.len.example": 'LEN("朝辭白帝彩雲間")返回7，因為這句詩中有7個字元',
  "formula.log.intro": "LOG函數可以根據指定底數返回數位的對數",
  "formula.log.usage": "LOG(數字,底數)",
  "formula.log.example": "LOG(100,10)返回2，也就是以10為底數100的對數",
  "formula.lower.intro": "LOWER函數可以將一個文本中的所有大寫字母轉換為小寫字母",
  "formula.lower.usage": "LOWER(文本)",
  "formula.lower.example": 'LOWER("JAYZ")返回"jayz"',
  "formula.mapx.intro": "MAPX函數是一個可以用來進行跨表單取數的高級函數",
  "formula.mapx.usage": "MAPX(operation,map_value,map_field,result_field)",
  "formula.max.intro": "MAX函數可以獲取一組數值的最大值",
  "formula.max.usage": "MAX(數位1,數位2,...)",
  "formula.max.usage.one.para": "MAX(數位1)",
  "formula.max.example": "MAX({語文成績},{數學成績},{英語成績})返回三門課程中的最高分",
  "formula.max.example.one.para": "MAX({語文成績})，返回語文成績的最高分",
  "formula.mid.intro": "MID返回文本中從指定位置開始的指定數目的字元",
  "formula.mid.usage": "MID(文本,開始位置_數位,指定數目)",
  "formula.mid.example": 'MID("平台應用定制工具",4,6)返回"應用定制工具"',
  "formula.min.intro": "MIN函數可以獲取一組數值的最小值",
  "formula.min.usage": "MIN(數位1,數位2,...)",
  "formula.min.usage.one.para": "MIN(數位1)",
  "formula.min.example": "MIN({語文成績},{數學成績},{英語成績})返回三門課程中的最低分",
  "formula.min.example.one.para": "MIN({語文成績})，返回語文成績的最低分",
  "formula.minute.intro": "MINUTE函數可以返回某日期的分鐘數",
  "formula.minute.usage": "MINUTE(時間戳記)",
  "formula.mod.intro": "MOD函數可以獲取兩數相除的餘數",
  "formula.mod.usage": "MOD(被除數,除數)",
  "formula.mod.example": "MOD(4,3)返回1，也就是4/3的餘數",
  "formula.month.intro": "MONTH返回某日期的月份",
  "formula.month.usage": "MONTH(時間戳記)",
  "formula.not.intro": "NOT函數返回與指定運算式相反的布林值。",
  "formula.not.usage": "NOT(邏輯運算式)",
  "formula.not.example": "NOT({語文成績}>60)，如果語文成績大於60返回false，否則返回true",
  "formula.networkdays.intro": "NETWORKDAYS可以獲取兩個日期之間的工作日數，工作日不包括週末和任何其他指定日期。",
  "formula.networkdays.usage": "NETWORKDAYS(開始日期,結束日期,[公休日1,公休日2, ...])",
  "formula.now.intro": "NOW函數可以獲取當前時間",
  "formula.now.usage": "NOW()",
  "formula.or.intro": "如果任意參數為真，OR 函數返回布林值true；如果所有參數為假，返回布林值false。",
  "formula.or.usage": "OR(邏輯運算式1,邏輯運算式2,...)",
  "formula.or.example": "OR({語文成績}>90,{數學成績}>90,{英語成績}>90)，任何一門課成績> 90，返回true，否則返回false",
  "formula.power.intro": "POWER函數可以獲取數位乘冪的結果",
  "formula.power.usage": "POWER(數字,指數)",
  "formula.power.example": "POWER(3，2)返回9，也就是3的2次方",
  "formula.product.intro": "PRODUCT函數可以獲取一組數值的乘積",
  "formula.product.usage": "PRODUCT(數位1,數位2,...)",
  "formula.product.example": "PRODUCT({單價}, {數量})獲取總價，也就是單價和數量的乘積",
  "formula.rand.intro": "RAND函數可返回大於等於0且小於1的均勻分佈隨機實數",
  "formula.rand.usage": "RAND()",
  "formula.rand.example": "RAND()返回0.424656",
  "formula.recno.intro": "RECNO函數依據當前表單被新打開的次數進行不斷累計，起始值為1。",
  "formula.recno.usage": "RECNO()",
  "formula.replace.intro": "REPLACE函數可以根據指定的字元數，將部分文本替換為不同的文本",
  "formula.replace.usage": "REPLACE(文本,開始位置,替換長度,新文本)",
  "formula.replace.example": 'REPLACE("平台應用定制工具",4,6,"企業資料管理平臺")返回"平台企業資料管理平臺"',
  "formula.rept.intro": "REPT函數可以將文本重複一定次數",
  "formula.rept.usage": "REPT(文本,重複次數)",
  "formula.rept.example": 'REPT("平台",3)返回"平台平台平台"',
  "formula.right.intro": "RIGHT函數可以獲取由給定文本右端指定數量的字元構成的文本值",
  "formula.right.usage": "RIGHT(文本,文本長度)",
  "formula.right.example": 'RIGHT("三年二班周傑倫",3)返回"周傑倫"，也就是"三年二班周傑倫"從右往左的前3個字元',
  "formula.round.intro": "ROUND函數可以將數位四捨五入到指定的位元數",
  "formula.round.usage": "ROUND(數位,數位位元數)",
  "formula.round.example": "ROUND(3.1485,2)返回3.15",
  "formula.small.intro": "SMALL函數可以返回資料集中第k個最小值",
  "formula.small.usage": "SMALL(陣列,k)",
  "formula.small.example": 'SMALL({學生成績.數學成績}, 1)返回子表單"學生成績"中排名倒數第一的"數學成績"',
  "formula.sqrt.intro": "SQRT函數可以獲取一個數位的正平方根",
  "formula.sqrt.usage": "SQRT(數字)",
  "formula.sqrt.example": "SQRT(9)返回3，也就是9的正平方根",
  "formula.sum.intro": "SUM函數可以獲取一組數值的總和",
  "formula.sum.usage": "SUM(數位1,數位2,...)",
  "formula.sum.usage.one.para": "SUM(數位1)",
  "formula.sum.example": "SUM({語文成績},{數學成績}, {英語成績})返回三門課程的總分",
  "formula.sum.example.one.para": "SUM({語文成績})，返回語文成績的總分",
  "formula.sumproduct.intro": "SUMPRODUCT函數可以將陣列間對應的元素相乘，並返回乘積之和，適用于加權求和",
  "formula.sumproduct.usage": "SUMPRODUCT(陣列,陣列...)",
  "formula.sumproduct.example": "SUMPRODUCT([1,2,3],[0.1,0.2,0.3])返回1.4，也就是 1×0.1 + 2×0.2 + 3×0.3的值",
  "formula.search.intro": "SEARCH函數可以獲取文本1在文本2中的開始位置",
  "formula.search.usage": "SEARCH(文本1,文本2)",
  "formula.search.example": 'SEARCH("2016","平台2016")返回4',
  "formula.second.intro": "SECOND函數可以返回某日期的秒數",
  "formula.second.usage": "SECOND(時間戳記)",
  "formula.split.intro": "SPLIT函數可以將文本按指定分割符分割成陣列",
  "formula.split.usage": "SPLIT(文本,分隔符號_文本)",
  "formula.split.example": 'SPLIT("平台-應用定制工具","-")返回"平台，應用定制工具"',
  "formula.systime.intro": "SYSTIME函數可以獲取當前伺服器時間",
  "formula.systime.usage": "SYSTIME()",
  "formula.text.intro": "TEXT函數可以將數位轉化成文本",
  "formula.text.usage": "TEXT(數字)",
  "formula.text.example": 'TEXT(3.1415)返回"3.1415"',
  "formula.time.intro": "TIME函數可以返回特定時間的十進位數字字",
  "formula.time.usage": "TIME(時_數位,分_數位,秒_數位)",
  "formula.timestamp.intro": "TIMESTAMP函數可以將日期物件轉換成時間戳記。",
  "formula.timestamp.usage": "TIMESTAMP(日期)",
  "formula.today.intro": "TODAY函數可以返回今天",
  "formula.today.usage": "TODAY()",
  "formula.trim.intro": "TRIM函數可以刪除文本首尾的空格",
  "formula.trim.usage": "TRIM(文本)",
  "formula.trim.example": 'TRIM("    平台    ")返回"平台"',
  "formula.true.intro": "TRUE函數返回布林值true",
  "formula.true.usage": "TRUE()",
  "formula.union.intro": "UNION函數合併多個文本陣列，重複文本只顯示一次",
  "formula.union.usage": "UNION(文本1，文本2，文本3，文本4)或UNION([陣列])",
  "formula.union.example": 'UNION("張三","李四","王五","張三","李四")傳回值為["張三","李四","王五"]',
  "formula.upper.intro": "UPPER函數可以將一個文本中的所有小寫字母轉換為大寫字母",
  "formula.upper.usage": "UPPER(文本)",
  "formula.upper.example": 'UPPER("jayz")返回"JAYZ"',
  "formula.uuid.intro": "UUID函數隨機碼生成器。可適用於隨機流水號的使用場景等",
  "formula.uuid.usage": "UUID()",
  "formula.value.intro": "VALUE函數可以將文本轉化為數位",
  "formula.value.usage": "VALUE(文本)",
  "formula.value.example": 'VALUE("3.1415")返回3.1415',
  "formula.weeknum.intro": "WEEKNUM函數可以返回指定日期在當年是第幾周",
  "formula.weeknum.usage": "WEEKNUM(指定日期)",
  "formula.workday.intro": "WORKDAY函數可以獲取給定日期之前或者之後指定工作日數的日期，工作日不包括週末和任何其他指定日期。",
  "formula.workday.usage": "WORKDAY(日期,工作日數,[公休日1, 公休日2, ...])",
  "formula.xor.intro": "XOR函數可以返回所有參數的異或值",
  "formula.xor.usage": "XOR(邏輯運算式1, 邏輯運算式2,...)",
  "formula.xor.example": "XOR({語文成績}>90,{數學成績}>90)，如果兩門成績都>90,返回false；如果兩門成績都<90，返回false；如果其中一門>90，另外一門<90，返回true",
  "formula.year.intro": "YEAR函數可以返回某日期的年份",
  "formula.year.usage": "YEAR(時間戳記)",
  "formula.auto.toMetric": "自動添加為指標項",
  "formula.edit": "公式編輯",
  "formula.edit.subtitle": "使用加減運算子編輯公式",
  "formula.edit.inputName.tip": "請輸入指標名稱",
  "formula.edit.sample": "公式編輯樣式舉例：",
  "formula.edit.sample.field1": "進貨數量",
  "formula.edit.sample.field2": "出貨數量",
  "formula.field.tip": "請從左側面板選擇包含的欄位名",
  "formula.field.required": "欄位名必填",
  "formula.error": "公式不正確",
  "format.data": "資料格式",
  "format.preset": "預定義格式",
  "format.custom": "自訂格式",
  "format.custom.date.sample": "如：yyyy-mm-dd",
  "format.thousand": "千分符",
  "format.hundred": "百分比",
  "format.decimal": "小數位數",
  "format.subform.SUBFORMLESS.intro": "比較子表單裏的字段value1是否小於value2，小於返回 true，反之返回false。",
  "format.subform.SUBFORMLESS.usage": "SUBFORMLESS(value1, value2)",
  "format.subform.SUBFORMLESS.example": "此函數公式只能處理子表單裏的字段，不能使用子表單以外的字段。壹般應用於表單提交效驗裏，判斷子表單裏的數據是否合法。",
  "format.subform.SUBFORMGREATER.intro": "比較子表單裏的字段value1是否大於value2，大於返回 true，反之返回false。",
  "format.subform.SUBFORMGREATER.usage": "SUBFORMGREATER(value1, value2)",
  "format.subform.SUBFORMGREATER.example": "此函數公式只能處理子表單裏的字段，不能使用子表單以外的字段。壹般應用於表單提交效驗裏，判斷子表單裏的數據是否合法。",
  "format.subform.SUBFORMEQUAL.intro": "比較子表單裏的字段value1是否等於value2，等於返回 true，反之返回false。",
  "format.subform.SUBFORMEQUAL.usage": "SUBFORMEQUAL(value1, value2)",
  "format.subform.SUBFORMEQUAL.example": "此函數公式只能處理子表單裏的字段，不能使用子表單以外的字段。壹般應用於表單提交效驗裏，判斷子表單裏的數據是否合法。",
  "format.subform.SUBFORMLESSOREQUAL.intro": "比較子表單裏的字段value1是否小於等於value2，小於等於返回 true，反之返回false。",
  "format.subform.SUBFORMLESSOREQUAL.usage": "SUBFORMLESSOREQUAL(value1, value2)",
  "format.subform.SUBFORMLESSOREQUAL.example": "此函數公式只能處理子表單裏的字段，不能使用子表單以外的字段。壹般應用於表單提交效驗裏，判斷子表單裏的數據是否合法。",
  "format.subform.SUBFORMGREATEROREQUAL.intro": "比較子表單裏的字段value1是否大於等於value2，大於等於返回 true，反之返回false。",
  "format.subform.SUBFORMGREATEROREQUAL.usage": "SUBFORMGREATEROREQUAL(value1, value2)",
  "format.subform.SUBFORMGREATEROREQUAL.example": "此函數公式只能處理子表單裏的字段，不能使用子表單以外的字段。壹般應用於表單提交效驗裏，判斷子表單裏的數據是否合法。",
  "format.subform.SUBFORMNOTEQUAL.intro": "比較子表單裏的字段value1是否不等於value2，不等於返回 true，反之返回false。",
  "format.subform.SUBFORMNOTEQUAL.usage": "SUBFORMNOTEQUAL(value1, value2)",
  "format.subform.SUBFORMNOTEQUAL.example": "此函數公式只能處理子表單裏的字段，不能使用子表單以外的字段。壹般應用於表單提交效驗裏，判斷子表單裏的數據是否合法。",
  "get.immediate": "立即領取",
  "go.pcPlatform": "請前往電腦端體驗",
  "item.required": "此項為必填項",
  "info.Incomplete": "請填寫完整資訊",
  "invalid.username": "用戶名格式不正確",
  "invalid.email": "郵箱格式不正確",
  "invalid.phone": "手機號格式不正確",
  "invalid.nickname": "昵稱不能為空",
  "invalid.password": "密碼至少需要6位",
  "invalid.confirmPass": "兩次輸入的密碼不一致",
  "invalid.url": "URL格式不正確",
  "invite.manual.add.tip1": "成員加入時無法更改您輸入的內容，請輸入正確的資訊",
  "invite.manual.add.tip2": "按輸入的連絡方式發送邀請；同時輸入手機和郵箱，只發送手機邀請",
  "invite.name.placeholder": "必填，最長12個字元",
  "invite.phone.placeholder": "國際化手機請添加國家碼",
  "invite.phone.or.email.required": "手機和郵箱必填一項",
  "invite.phone.and.email.required": "手機和郵箱必填",
  "invite.importing": "正在導入",
  "invite.import.fail.detail": "導入失敗詳情",
  "invite.failList.download": "下載失敗清單",
  "invite.failList.download.expire.tip": "請在1小時內下載本清單",
  "invite.accept.switch.tip": "當前登錄賬號與被邀請賬號不同",
  "invite.accept.switch": "切換登錄賬號",
  "image.add": "添加圖片",
  "image.insert.url": "圖片 URL",
  "image.maxLimitTip": "圖片大小超出限制",
  "image.reset.title": "確定恢復為預設圖片？",
  "image.reset.tip": "此操作不可逆",
  "image.recommend.size": "（建議尺寸：{{- width}}*{{- height}}px）",
  "image.upload": "上傳圖片",
  "image.upload.tip": "圖片大小不超過1MB, 每次最多上傳10張",
  "image.upload.max.toast": "每次最多允許上傳10張",
  "image.url.invalid": "不合法的 URL",
  "image.url.tip": "輸入圖片URL即可插入圖片",
  "image.url.placeholder": "請輸入圖片URL",
  "image.maxLimitTip1": "圖片大小不能超過 {{count}} MB",
  "image.select": "請選擇圖片",
  "import.createSuccess.count": "您成功創建並導入了{{- count}}條資料到表單[{{- name}}]中",
  "import.contact.empty": "通訊錄中未匹配到：{{- name}}",
  "import.contact.multi": "通訊錄中存在多個：{{- name}}",
  "import.contact.isallowBlank": "字段不允許空值",
  "import.contact.isnoRepeat": "字段不允許重複值",
  "import.contact.emptyUser": "當前通訊錄中未匹配到以下成員，請修改成員姓名後重新導入",
  "import.contact.sameUser": "當前通訊錄中存在同名成員，請修改成員姓名後重新導入",
  "import.contact.emptyDept": "當前通訊錄中未匹配到以下部門，請修改部門名稱後重新導入",
  "import.contact.sameDept": "當前通訊錄中存在同名部門，請修改部門名稱後重新導入",
  "import.dept.fail": "有一個或多個部門匹配失敗",
  "import.doing": "正在導入資料...",
  "import.excel": "導入 Excel 數據",
  "import.excel.select": "選擇Excel",
  "import.excel.preview": "預覽數據",
  "import.excel.form.config": "配置表單",
  "import.excel.data": "導入數據",
  "import.excel.failTip1": "不能存在合併的儲存格",
  "import.excel.failTip2": "支援 {{size}}MB 以內的xls、xlsx格式檔",
  "import.excel.failTip3": "檔中資料不能超過50000行、200列（如需導入為部門成員欄位，則不能超過10000行、200列）",
  "import.excel.failTip4": "子表單明細同樣佔用行數",
  "import.excel.helpTip": "更多導入說明和示例，請查看",
  "import.excel.labelSet.tip": "點擊任意一行可將其設置為標題列，標題列之前的資料不導入。",
  "import.excel.limitTip": "最多可預覽前{{limit}}條資料",
  "import.excel.flow": "導入的數據觸發流程",
  "import.excel.flowAsync": "導入完成，開始觸發流程…",
  "import.excel.flowAsync.title": "成功導入 {{- count }} 條數據到表單「{{ name }}」",
  "import.excel.flowAsync.success": "流程提交成功 {{- success }} 條，提交失敗 {{- fail }} 條",
  "import.excel.flowAsync.fail": "流程提交成功{{- success}} 條，提交失敗{{- fail}} 條，提交失敗的數據已為您暫存至「我的待辦」中",
  "import.update.confirm": "確定導入並更新數據？",
  "import.update.confirm.tip": "導入的數據中「data_id」有重複值時，會逐條導入重複更新匹配到的數據。",
  "import.upsert.confirm": "確定導入並更新和新增數據？",
  "import.upsert.confirm.tip": "導入的數據中「data_id」有重複值時，會逐條導入重複更新匹配到的數據。\n導入的數據中「data_id」為空或無法匹配時，會新增數據。",
  "import.fail": "導入失敗",
  "import.warning.tip": "當前還有 {{count}} 個錯誤未處理，如果不處理，系統將自動將錯誤項目置為空，請確認是否繼續導入?",
  "import.failDetail.view": "查看問題詳情",
  "import.fail.view": "問題詳情",
  "import.fail.count": "表格資料存在{{- count}}個錯誤，請修改後再進行導入。如不修改，則錯誤資料導入後為空值，地址欄位保留原值",
  "import.failTip": "您的導入資料錯誤較多，請返回上一步檢查欄位類型，或在原excel中進行修改後再重新導入。如不修改，則錯誤資料導入後為空值",
  "import.failTip.second": "提示:成員/部門重名導致錯誤較多時，可下載 {{- tip1}}，並按照{{- tip2}}修改Excel後重新導入。",
  "import.failTip.second.tip1": "具體錯誤信息",
  "import.failTip.second.tip2": "錯誤信息說明",
  "import.field.empty": "導入的欄位名不能為空",
  "import.form": "表單導入",
  "import.formName.empty": "表單名不能為空",
  "import.notAllowed": "不導入",
  "import.prev.text": "請切換工作表或返回上一步重新選擇Excel表",
  "import.recommend": "推薦使用",
  "import.rowHead": "標題行",
  "import.success.count": "您成功導入了 {{- count}} 條資料到表單「{{- name}}」中",
  "import.template": "標準範本",
  "import.tip": "導入說明和示例",
  "import.user.fail": "有一個或多個成員匹配失敗",
  "layout.vertical": "縱向排列",
  "layout.horizontal": "橫向排列",
  "loadMore.click": "點擊載入更多",
  "log.execute": "執行日誌",
  "log.execute.empty": "暫無執行日誌",
  "log.update.tip": "（資料發生變動後1小時內自動更新）",
  "link.copy": "複製連結",
  "link.copySuccess": "連結已複製",
  "link.management.specification": "《平台外鏈管理規範》",
  "manager.normal": "普通管理組",
  "manager.add": "添加管理組",
  "manager.create.tip": "點擊添加管理員",
  "manager.creator": "創建者",
  "manager.placeholder": "請輸入管理組名稱",
  "manager.name.notEmpty": "管理組名稱不能為空",
  "manager.name.tooLong": "管理組名稱不能超過{{length}}個字",
  "manager.delete.warning": "刪除普通管理組則相關管理員及許可權也將一併刪除，且無法還原。如確定刪除，請輸入組名：",
  "manager.delete.success": "管理組已刪除!",
  "manager.system": "系統管理員",
  "manager.appAuth": "應用許可權",
  "manager.appAuth.tip": "具備所有應用的管理許可權",
  "manager.appAuth.edit.tip": "點擊選擇可編輯的應用",
  "manager.funcAuth": "功能許可權",
  "manager.funcAuth.tip": "具備所有功能許可權",
  "manager.funcAuth.app": "可添加／刪除應用",
  "manager.funcAuth.contacts": "通訊錄管理",
  "manager.sync": "同步通訊錄成員",
  "manager.contacts.range": "通訊錄管理範圍",
  "manager.contacts.range.tip": "具備對所有成員的管理許可權",
  "manager.contacts.range.edit.tip": "點擊選擇可管理的部門",
  "manager.contacts.range.empty.tip": "不選擇任何部門時，默認可管理所有部門",
  "role.contacts.range": "角色組管理範圍",
  "role.contacts.range.tip": "具備對所有角色組的管理權限",
  "role.contacts.range.edit.tip": "點擊選擇可管理的角色組",
  "role.contacts.range.empty.tip": "不選擇任何角色時，默認可管理所有角色",
  "outsider.contacts.range": "外部聯繫人管理範圍",
  "outsider.contacts.range.tip": "擁有對所有外部聯繫人的管理權限",
  "outsider.contacts.range.edit.tip": "點擊選擇可管理的外部聯繫人",
  "outsider.contacts.range.empty.tip": "不選擇任何外部聯繫人分組時，默認可管理所有外部聯繫人分組",
  "member.one": "成員1",
  "member.two": "成員2",
  "member.id": "成員編號",
  "member.id.format": "僅支援字母、數位、底線",
  "member.id.length": "成員編號最長12個字元",
  "member.id.placeholder": "成員在企業內唯一標識，建議使用工號等公司系統內統一的ID",
  "member.import.complete": "成功導入{{-successCount}}名成員",
  "member.import.not.complete": "成功導入{{-successCount}}名成員，失敗{{-failCount}}名",
  "member.async.busy": "正在同步",
  "member.async.busy.tip": "成員正在同步…",
  "member.async.start": "開始同步",
  "member.async.start.tip": "您可以進行其他操作，同步會在後臺進行。",
  "member.async.error": "成員同步失敗",
  "member.async.error.tip": "企業通訊錄同步失敗，請稍後重試。",
  "member.async.auto": "自動同步",
  "member.async.auto.set.success": "自動同步設置成功",
  "member.async.lastTime": "上次同步：{{lastTime}}",
  "member.async.manual": "手動同步成員",
  "member.async.manual.control": "手動同步",
  "member.async.weChat": "從企業微信同步成員",
  "member.async.success": "企業通訊錄同步成功",
  "member.async.time": "同步時間",
  "member.async.log": "成員同步日誌",
  "member.async.log.empty": "暫無同步日誌",
  "member.async.log.result": "同步結果",
  "member.async.log.tip": "保存最近六個月的同步日誌",
  "member.async.log.type": "同步類型",
  "member.async.log.view": "查看同步日誌",
  "member.add": "添加成員",
  "member.invite": "邀請成員",
  "member.invite.accept": "接受邀請",
  "member.invite.accept.confirm": "您要接受「{{- inviter}}」的邀請嗎？",
  "member.invite.accept.guide": "有管理員邀請您加入團隊，一起協同辦公",
  "member.invite.dept.required": "請設置成員部門",
  "member.invite.name.length": " 姓名，最長12個字元",
  "member.invite.name.required": "請輸入成員姓名",
  "member.invite.name.length.tip": "成員姓名最長12個字元",
  "member.invite.phone.required": "請輸入手機/郵箱",
  "member.invite.phoneOrMail.invalid": "手機/郵箱格式不正確",
  "member.invite.after": "受到邀請用戶加入你的團隊後，",
  "member.invite.alreadyBindWorkWx": "已綁定企業微信",
  "member.invite.batch": "你可以批量管理成員。",
  "member.invite.begin": "團隊中還沒有成員，現在開始邀請成員吧",
  "member.invite.bindWorkWxInNewTab": "請在新打開的頁面中綁定企業微信",
  "member.invite.byLink": "公開連結邀請",
  "member.invite.department": "你可以將他/她分配到不同的部門中。",
  "member.invite.form": "你可以發佈表單給他/她填寫。",
  "member.invite.manual": "手動添加成員",
  "member.invite.import": "大量匯入成員",
  "member.invite.phoneOrEmail": "手機號/郵箱",
  "member.invite.phoneOrEmail.label": "手機號/郵箱：",
  "member.invite.phoneOrEmail.notEmpty": "輸入手機號或郵箱",
  "member.invite.phoneOrEmail.invalid": "請輸入正確格式的手機號或郵箱",
  "member.invite.phone.tip": "通過手機號邀請非中國大陸成員用戶時，請在手機號前添加國際電話區號，例:+886912345689",
  "member.invite.link": "邀請連結",
  "member.invite.link.tip": "開啟邀請連結後，s只需訪問此連結，即可加入您的團隊",
  "member.invite.link.Audit": "邀請審核",
  "member.invite.link.Audit.tip": "開啟邀請審核後，需要審核通過才能加入您的團隊",
  "member.invite.link.Audit.list": "審核列表",
  "member.invite.mail.limit.tip": "每次最多發送200條短信和200封邀請郵件",
  "member.invite.mail.rate.limit.tip": "每個手機號或郵箱每天最多邀請3次",
  "member.invite.mail.invited.tip": "所有成員已加入團隊，請勿重複邀請",
  "member.invite.list": "邀請中的成員",
  "member.reinvite": "一鍵再次邀請",
  "member.joined": "已加入",
  "member.inviting": "邀請中",
  "member.invite.list.empty": "沒有正在邀請中的成員",
  "member.invite.error.tip": "已發送邀請，請勿重複操作",
  "member.invite.list.tip": "僅顯示已邀請但尚未加團隊的成員",
  "member.invite.manager": "你可以將他/她設置為管理員，協助管理平台應用。",
  "member.invite.notBind": "暫不綁定",
  "member.invite.rate.limit.tip": "已發送邀請，請勿重複操作",
  "member.invite.wait": "綁定企業微信成功後，可能需要幾分鐘時間來同步企業微信的通訊錄，請耐心等待。",
  "member.search": "搜索成員姓名",
  "member.search1": "搜索成員",
  "member.search2": "搜索成員支持姓名、手機以及郵箱",
  "member.searching": "搜索中，請稍候...",
  "member.search.emptyTip.departmentRoot": "無搜尋結果，請檢查搜索值",
  "member.search.emptyTip.public": "當前部門無搜尋結果，請檢查搜索值或在「全部成員」中搜索",
  "member.list.fail": "獲取成員列表失敗！",
  "member.dept.set": "設置成員部門",
  "member.dept.alter": "調整部門",
  "member.dept.alter.select.tip": "請選擇需要調整部門的成員",
  "member.dept.set.success": "調整成功",
  "member.remove": "刪除成員",
  "member.delete.confirm": "您確定要刪除所選成員？",
  "member.delete.tip": "刪除成員會同時刪除該成員許可權，且無法還原",
  "member.delete.success": "成員刪除成功",
  "member.delete.fail": "成員刪除失敗",
  "member.delete.owner.tip": "企業創建者無法刪除",
  "member.delete.select.tip": "請選擇需要刪除的成員",
  "member.allow.edit.name": "允許成員修改姓名",
  "member.name.valid.empty": "請輸入成員姓名",
  "member.name.valid.length": "成員姓名最長12個字元",
  "member.username.update.tip": "此編號僅可修改一次",
  "member.username.update.not": "不支援修改此編號",
  "member.not.invite.tip": "有{{-count}}名成員未加入",
  "member.not.verify.tip": "有{{-count}}個手機/郵箱未驗證",
  "member.invite.again": "再次邀請",
  "member.invite.all.again": "全部再次邀請",
  "member.verify.all.again": "全部發送驗證",
  "member.verify.success.tip": "驗證資訊發送成功！",
  "member.verify.error.tip": "已發送驗證資訊，請勿重複操作",
  "member.email.verify.tip": "未驗證郵箱無法收到消息，請及時驗證。",
  "member.phone.verify.tip": "未驗證手機無法收到消息，請及時驗證。",
  "member.number.internal.tip": "成員在企業內的唯一標識",
  "member.number.wechat.tip": "成員在企業內的唯一標識，同步自企業微信「帳號」",
  "member.number.dingtalk.tip": "成員在企業內的唯一標識，同步自釘釘「成員UserID」",
  "member.team.join": "我加入的",
  "member.team.create": "我創建的",
  "member.team.current": "當前所在企業：{{- corp}}",
  "member.team.current.tip": "管理員未開啟修改許可權的姓名不可修改，如需修改請聯繫管理員",
  "member.phone.verified": "手機已驗證，您無法修改。 如需修改請聯繫成員在賬戶中心重新綁定。",
  "member.email.verified": "郵箱已驗證，您無法修改。 如需修改請聯繫成員在賬戶中心重新綁定。",
  "member.role.list.empty": "沒有可選的角色",
  "migrate.report.tip": "此功能會複製原有報表然後轉換為報表，不影響原有報表的使用。",
  "migrate.report.member.tip": "轉換得到的報表預設不啟用，不對成員開放；啟用後即可對訪問原報表的使用者開放",
  "migrate.report.select.tip": "請選擇需要轉換的報表",
  "migrate.report.empty": "沒有可轉換的報表",
  "migrate.report.title": "報表→報表轉換",
  "migrate.waiting": "正在轉換，請等待...",
  "migrate.waiting.tip": "您可以關閉頁面，系統將繼續為您轉換",
  "migrate.done": "轉換功能運行完成",
  "migrate.success": "轉換成功",
  "migrate.done.tip": "{{-count}}個報表完整轉換為報表。",
  "migrate.not.complete.tip": "{{-count}}個報表成功轉換為報表，但有部分問題需要手動調整。",
  "migrate.fail.tip": "{{-count}}個報表轉換失敗。",
  "migrate.record.view.tip": "請在轉換記錄中查看詳情",
  "migrate.done.single.tip": "已將此報表完整轉換為報表。",
  "migrate.done.single.not.complete.tip": "已將此報表轉換為報表，但仍有部分問題需要手動調整，請在轉換記錄中查看詳情。",
  "migrate.done.fail.tip": "報表內控件數量超過50個，請減少控件數量後重試",
  "migrate.dash.enable.tip": "轉換得到的報表預設不啟用，不對成員開放。您可根據需要自行啟用，啟用後報表即對可訪問原報表的使用者開放。",
  "migrate.record.view": "查看轉換記錄",
  "migrate.record.title": "報表→報表轉換記錄",
  "migrate.record.expire.tip": "僅保留最近一周轉換記錄",
  "migrate.record.export.tip": "僅保留最近一周的轉換記錄，請儘快處理轉換問題或{{-exportBtn}}",
  "migrate.record.export": "匯出轉換記錄",
  "migrate.record.empty": "暫無轉換記錄",
  "migrate.complete": "完整轉換",
  "migrate.not.complete": "未完整轉換",
  "migrate.fail": "轉換失敗",
  "migrate.report.banner": "報表→報表轉換功能已上線，説明你把報表轉換為更美觀易用的報表。",
  "migrate.immediate": "立即轉換",
  "mobile.layout": "許可權組移動端樣式",
  "mobile.layout.card": "卡片樣式",
  "mobile.layout.card.setting": "卡片設置",
  "mobile.layout.card.image": "在卡片標題中顯示圖片欄位的內容",
  "mobile.layout.card.createInfo": "在卡片標題中顯示提交人和提交時間",
  "mobile.layout.card.label": "在卡片內容中顯示欄位標題",
  "mobile.layout.card.tip": "在移動端查看資料時，每條資料顯示為獨立的卡片，可快速瞭解資料概況。",
  "mobile.layout.example.label": "靈活易用的應用搭建平臺",
  "mobile.layout.example.createInfo": "小雲",
  "mobile.layout.fx.user": "平台使用者",
  "mobile.layout.table": "表格樣式",
  "mobile.layout.table.tip": "在移動端查看資料時，每行顯示一條資料，可以通過左右滑動查看完整資料。",
  "mobile.layout.image.select": "請選擇表單中的圖片欄位",
  "mobile.layout.preview": "樣式預覽",
  "mobile.layout.product.position": "產品定位",
  "mobile.layout.product.title": "產品名稱",
  "mobile.layout.project.member": "專案成員",
  "msg.corp_owner": "賬號建立者",
  "msg.system_admin": "系統管理員",
  "msg.dotGuide.closeGuide": "關閉引導",
  "msg.qrCode": "掃描二維碼，分享給好友",
  "msg.helpCenterGuide.info": "如需獲得更多幫助，請點擊此處，我們將竭誠為您服務",
  "msg.method": "提醒方式",
  "msg.system.notification": "系統消息",
  "msg.mail.notification": "郵件提醒",
  "msg.sms.free": "（免費）",
  "msg.sms.notification": "短信提醒",
  "msg.sms.notification.tip": "僅進行「資料推送失敗」提醒",
  "msg.sms.purchase.tip": "當前賬號的可用短信條數為0條，無法開啟短信提醒功能。 如需繼續使用該功能，您可以選擇購買短信條數後再開啟。",
  "msg.notification": "消息彈窗",
  "msg.notification.tip": "開啟後有新消息會在頁面右上角彈窗提示",
  "msg.notification.tooltip": "開啟短信提醒會耗費短信餘額",
  "msg.placeholder.mail": "請輸入郵箱",
  "msg.placeholder.phone": "請輸入手機號",
  "msg.readAll": "全部轉為已讀",
  "msg.read": "轉為已讀",
  "msg.target.add": "添加提醒物件",
  "msg.target.delete.title": "您確定要刪除該提醒物件麼嗎？",
  "msg.target.delete.content": "刪除後，該物件將不再收到任何消息提醒",
  "msg.target.email.empty": "郵箱為空，無法收到消息",
  "msg.target.email.unverified": "郵箱未驗證，不能接收消息",
  "msg.target.empty": "暫無提醒物件",
  "msg.target.empty.add": "暫無提醒物件，點擊",
  "msg.target.list": "提醒物件清單",
  "msg.target.phone.empty": "手機為空，無法收到消息",
  "msg.target.phone.unverified": "手機未驗證，不能接收消息",
  "msg.target.set": "設置提醒物件",
  "msg.target.set.selected": "已選",
  "msg.target.set.count": "個（最多5個）",
  "msg.target.update": "修改資訊",
  "msg.target.tooltip.mail": "需綁定郵箱才能收到提醒",
  "msg.target.tooltip.sms": "需綁定手機才能收到提醒",
  "msg.target.add.format": "格式不正確",
  "msg.target.add.repeat": "存在重複項",
  "msg.type": "訊息類型",
  "msg.type.manage_group": "添加/刪除管理組",
  "msg.type.manager": "添加/刪除管理員",
  "msg.type.app": "添加/刪除應用",
  "msg.type.dept_user": "添加/刪除部門或成員",
  "msg.type.app_rename": "修改應用名稱",
  "msg.type.api": "API Key 操作記錄",
  "msg.type.webhook": "資料推送提醒",
  "msg.type.etl_cron_job": "資料流程執行失敗",
  "msg.type.corp_sync": "成員同步結果",
  "msg.validate": "驗證",
  "msg.validate.send.all": "已傳送簡訊和郵箱驗證",
  "msg.validate.send.email": "已發送郵箱驗證",
  "msg.validate.send.phone": "已傳送簡訊驗證",
  "manage.group.system.name": "系統管理組",
  "message": "通知",
  "message.expire.tip": "保存最近六個月的消息記錄",
  "message.app.expire.tip": "保存最近六個月的操作記錄",
  "message.sms.expire.tip": "保存最近六個月的發送日誌",
  "message.system.log": "系統日誌",
  "message.usage.notify": "套餐提醒",
  "message.operation.notify": "運營通知",
  "message.team.invite": "協作邀請",
  "message.setting": "通知設置",
  "message.empty": "暫無消息",
  "message.notification": "您有一條新的「{{type}}」消息",
  "message.webhook": "消息推送",
  "message.webhook.desc": "使用消息推送功能可推送消息至您指定的伺服器",
  "message.webhook.leave.confirm": "離開當前頁後，您的消息推送設置不會保存。",
  "message.webhook.error": "超過100條失敗會自動關閉消息推送，請及時調整配置",
  "message.webhook.state.pushing": "推送中",
  "message.webhook.state.pause": "推送暫停",
  "message.webhook.state.fail": "推送失敗",
  "message.webhook.toMyServer": "推送至我的伺服器",
  "message.webhook.close.confirm": "您確定要關閉消息推送嗎？",
  "message.webhook.close.tip": "關閉後將無法推送消息。",
  "appLog.template": "{{- operator}} {{event}}了表單「{{- entry}}」",
  "appLog.template.rename": "{{- operator}}將表單「{{- oriEntry}}」重命名為「{{- entry}}」",
  "appLog.template.copy": "{{- operator}}複製了表單「{{- entry}}」",
  "member.select.list": "部門成員列表",
  "member.select.setting": "點擊設置",
  "member.select.dept.manager": "{{- name}} | 部門主管",
  "member.select.group.tip": "該分組沒有連絡人",
  "member.select.role.empty": "沒有角色",
  "member.select.role.empty.tip": "您可在通訊錄中新建並分配角色",
  "member.select.depart.empty": "沒有部門",
  "member.select.depart.empty.tip": "請到通訊錄中添加或同步",
  "member.select.member.empty": "沒有成員",
  "member.select.user.empty": "暫無相關連絡人",
  "member.select.role.emptyTip": "暫無相關角色",
  "metric.calc": "計算指標",
  "metric.calc.add": "添加計算指標",
  "metric.add.success": "指標添加成功",
  "more.feature": "更多自訂功能",
  "multi.tab.show": "多標籤顯示",
  "multi.tab.name": "標籤頁",
  "multi.tab.nameWithNum": "標籤頁{{num}}",
  "multi.tab.add": "添加標籤頁",
  "multi.tab.delete.tip": "刪除標籤頁後標籤頁內欄位將移動到標籤頁外部，確定要刪除嗎？",
  "nav.getTrial": "領取試用",
  "nav.guide": "新手引導",
  "nav.profile": "賬戶中心",
  "nav.appstore": "應用中心",
  "nav.pack": "套餐購買",
  "nav.update": "更新日誌",
  "nav.template": "範本中心",
  "nav.service": "技術支援",
  "nav.feedback": "意見回饋",
  "nav.service.guide": "您可以在這裡隨時聯繫技術支援。",
  "nav.doc": "幫助文檔",
  "nav.video": "視頻教程",
  "nav.message": "消息管理",
  "nav.message.tooltip": "消息",
  "nav.mobile.tooltip": "移動端",
  "nav.mobile.title": "平台沒有APP，但你可以選擇更多",
  "nav.mobile.msg": "您可以通過以下幾種方式在移動端使用平台",
  "nav.mobile.more": "需要其他的APP方案？請點擊告訴我們",
  "nav.register.dingtalk": "註冊釘釘",
  "nav.register.wework": "註冊企業微信",
  "nav.trial": "申請試用",
  "nav.sso": "將平台集成至外部的其他系統/產品",
  "nav.wechat": "微信服務號",
  "nav.wechat.or.dingtalk": "在企業微信或釘釘中使用",
  "nav.wechat.integrate": "集成您的微信公眾號",
  "nav.wechat.fx": "平台微信服務號",
  "nav.wechat.scan": "掃碼關注【平台】微信服務號，在微信中使用平台",
  "name.update": "修改名稱",
  "name.placeholder": "輸入名稱",
  "nickname.update": "修改昵稱",
  "nickname.update.success": "昵稱修改成功",
  "nickname.placeholder": "輸入昵稱",
  "nickname.tooLong": "昵稱最多為{{length}}個字",
  "nickname.user.label": "企業通訊錄姓名",
  "newValue.label": "新值：",
  "order.add": "加購",
  "order.add.aggregate": "聚合表增購包 * {{value}}個/應用",
  "order.add.api": "資料介面（API）",
  "order.add.backup": "資料回收站 * {{value}}天",
  "order.add.customLogin": "自訂登錄頁功能",
  "order.add.data": "總數據量增購包10萬條 * {{value}}",
  "order.add.data.form": "單表數據上限增購包 * {{value}}萬條",
  "order.add.etl": "資料流程 * {{value}}個",
  "order.add.manager": "子管理員 * {{value}}人",
  "order.add.trigger": "智慧助手 * {{value}}個",
  "order.add.upload": "附件上傳增購包 * {{value}}GB",
  "order.add.sms": "短信條數增購包1000條 * {{value}}",
  "order.add.sso": "單點登錄功能",
  "order.add.userMaxCount": "最多能加購{{- count}}人",
  "order.calculate.loading": "計算中",
  "order.calculate.fail": "無法計算",
  "order.confirm": "確認訂單",
  "order.confirm.tip": "您確定要提交該訂單嗎？",
  "order.confirm.noMember": "此賬號內沒有成員",
  "order.contract": "《購買協議》",
  "order.contract.accept": "我已閱讀並同意",
  "order.contract.application": "如何申請合同？",
  "order.contract.contact": "如果您需要合同，請撥打熱線：{{phone}}",
  "order.contract.hotLine": "諮詢熱線：{{hotLine}}",
  "order.copy": "份",
  "order.corp.name": "團隊名：{{- name}}",
  "order.corp.owner": "企業創建者：{{- owner}}",
  "order.coupon": "優惠券",
  "order.coupon.empty.useful": "無可用優惠券",
  "order.coupon.empty.useless": "無不可用優惠券",
  "order.coupon.limit": "折扣僅對{{value}}「版本」生效",
  "order.coupon.useful": "可用優惠券",
  "order.coupon.useless": "不可用優惠券",
  "order.category.service": "實施訂單",
  "order.data.add": "總數據量升級包",
  "order.data.add.count": "加購數據量：{{value}}份",
  "order.data.add.price": "¥500.00/份/年 1份=10萬條數據",
  "order.data.api.tip": "API為具備程式設計能力的使用者提供了一個簡單的方法來整合平台資料及其他外部資料。",
  "order.data.count": "總數據量：{{value}}萬條",
  "order.data.given": "贈送數據量：{{value}}萬條",
  "order.data.own": "已有數據量：{{value}}萬條",
  "order.data.own.pack": "版本數據量{{value}}萬條",
  "order.data.own.add": "+已加購數據量{{value}}萬條",
  "order.data.own.given": "+資料成長計畫贈送{{value}}萬條",
  "order.data.pack": "版本數據量：{{value}}萬條",
  "order.user.totalCount": "總使用者數：{{value}}人",
  "order.user.existingCount": "已有使用者數：{{value}}人",
  "order.user.pack": "使用者數增購包",
  "order.duration": "購買時長",
  "order.duration.more": "更長時間",
  "order.detail": "訂單詳情",
  "order.effectiveTime": "（確認支付後生效）",
  "order.effectiveTerm": "為了和其他付費功能有效期保持一致，已自動為您調整本次購買的有效期及價格",
  "order.given": "贈送",
  "order.my": "我的訂單",
  "order.package": "版本",
  "order.package.contrast": "查看版本詳情和對比",
  "order.price": "訂單總額：",
  "order.product.info": "產品資訊",
  "order.currency": "¥",
  "order.purchased": "已購買",
  "order.receipt": "發票與合同",
  "order.receipt.notice": "發票與合同須知",
  "order.receipt.apply": "申請發票",
  "order.receipt.application": "如何申請發票？",
  "order.receipt.how": "您可以在支付結束後申請開票，也可以在任意時間至賬號設置中的訂單管理頁面申請開票",
  "order.receipt.expire": "如果六個月內未申請發票，過期將不可再申請",
  "order.receipt.mail": "開票金額不足1000元時需自付發票費用（快遞方式為順豐到付，由順豐提供運費發票），開票金額不少於1000元時平台承擔發票郵寄費用",
  "order.receipt.contact": "如有其它疑問，請諮詢平台{{-service}}或撥打服務熱線：{{phone}}",
  "order.receipt.notAllowed": "提前開票的訂單不可合併開票",
  "order.service": "服務",
  "order.createTime": "下單時間：",
  "order.delete.confirm": "您確定要刪除訂單嗎？",
  "order.delete.confirm.tip": "刪除後無法恢復，確定要刪除該訂單嗎？",
  "order.delete.success": "刪除成功",
  "order.delete.failed": "刪除失敗",
  "order.no": "訂單號",
  "order.no.withColon": "訂單號：",
  "order.invoice.amount": "發票金額",
  "order.invoice.createTime": "創建時間",
  "order.invoice.companyName": "公司名",
  "order.invoice.sendState": "寄送狀態",
  "order.invoice.sent": "已寄送",
  "order.invoice.refuse": "已退回",
  "order.invoice.refuse.reason": "退回原因：",
  "order.invoice.toSend": "待寄送",
  "order.invoice.merge": "合併開票",
  "order.invoice.my": "我的發票",
  "order.invoice.state": "發票狀態",
  "order.invoice.state.label": "發票狀態：",
  "order.invoice.do": "確認開票",
  "order.invoice.tooLow": "金額低於{{minCash}}，無法開票！",
  "order.price.all": "總價",
  "order.price.origin": "原價：",
  "order.state": "訂單狀態",
  "order.state.label": "訂單狀態：",
  "order.state.paid": "已支付",
  "order.state.unpaid": "未支付",
  "order.state.paid.uncollected": "待回款",
  "order.state.canceled": "已取消",
  "order.state.unreceipted": "未開票",
  "order.state.receipting": "開票中",
  "order.state.receipted": "已開票",
  "order.state.expired": "已過期",
  "order.submit.success.tip": "訂單提交成功，請儘快付款",
  "order.termOfValidity": "有效期",
  "order.info": "訂單資訊",
  "order.inquiry": "如有疑問，請聯繫我們：{{phone}}",
  "order.amount": "訂單金額",
  "order.pay": "支付",
  "order.pay.done": "完成支付",
  "order.pay.fail": "支付失敗",
  "order.pay.fail.tip": "系統沒有檢測到您的支付資訊，請重新支付！",
  "order.pay.immediate": "立即支付",
  "order.pay.price": "支付金額：",
  "order.pay.success": "支付成功",
  "order.payment": "付款",
  "order.payment.confirm": "確認資訊正確",
  "order.payment.confirm.tip": "轉賬憑證提交後不可修改，請確認資訊正確",
  "order.payment.modify": "返回修改",
  "order.payment.account.name": "打款賬戶名",
  "order.payment.account.no": "打款賬戶號碼",
  "order.payment.alipay.tip": "請在新開支付寶頁面中完成支付，請勿在支付完成前關閉此窗口。",
  "order.payment.proof": "轉賬憑證",
  "order.payment.proof.tip": "我們收到轉賬和您提交的憑證後將立即為您處理訂單，感謝您的耐心等待。",
  "order.payment.tip": "如未完成支付，請點擊",
  "order.payment.transfer.submit": "提交憑證",
  "order.payment.transfer.tip1": "對公支付請按以下步驟操作",
  "order.payment.transfer.tip2": "為了您的合法權益，轉賬時請備註您的訂單編號",
  "order.payment.transfer.tip3": "匯款完成之後，請將匯款成功的憑證圖片（線下匯款的憑條或線上轉賬的截圖）提交系統",
  "order.payment.transfer.tip4": "我們收到轉賬和您提交的憑證後，將會立即為您開通服務，感謝您的耐心等待",
  "order.payment.transfer.tip5": "您也可以稍後在",
  "order.payment.transfer.tip6": "中提交憑證",
  "order.payment.unionpay": "銀聯支付",
  "order.payment.unionpay.tip": "請在新開支付頁面中完成支付，請勿在支付完成前關閉此窗口。",
  "order.payTime": "支付時間",
  "order.payProof": "支付憑證",
  "order.payProof.submit": "提交支付憑證",
  "order.payProof.refuse": "支付審核不通過",
  "order.payProof.audit": "支付憑證審核中",
  "order.operation": "操作",
  "order.operation.cancel": "取消訂單",
  "order.operation.cancel.confirm": "如果您已線下轉賬，取消訂單將導致無法驗證您的轉賬資訊，確認要取消該訂單嗎",
  "order.operation.cancel.success": "取消成功",
  "order.operation.cancel.failed": "取消失敗",
  "order.operation.invoice": "開票",
  "order.repay": "重新支付",
  "order.select.tip": "請選擇訂單！",
  "order.user": "用戶數 * {{value}}人",
  "order.userStd": "標準版 * {{value}}人",
  "order.user.add": "增購人數",
  "order.user.purchase": "購買用戶：",
  "order.user.unit": "10人起購，購買數量為5的倍數",
  "order.user.count": "X{{count}}人",
  "order.user.count.own": "當前已購買用戶數：{{count}}",
  "order.user.count.total": "增購後用戶數：",
  "order.validity": "有效期：{{time}}",
  "operation.auth.importTip": "導入時不進行表單校驗，不觸發公式，請謹慎啟用",
  "operation.auth.batchPrintTip": "僅自訂列印範本支援批量列印",
  "operation.auth.selectTip": "請至少選擇一個可以進行的操作",
  "role.add": "添加角色",
  "role.create.tip": "請聯繫貴司系統管理員新建角色",
  "role.empty": "當前沒有角色",
  "role.delete.confirm": "您是否要刪除“{{- name}}”？",
  "role.delete.tip": "刪除角色會同時刪除該角色的許可權，但不會刪除此角色中包含的通訊錄成員",
  "role.name": "角色名稱",
  "role.name.placeholder": "請輸入角色名稱",
  "role.name.notEmpty": "角色名稱不能為空",
  "role.name.tooLong": "角色名稱不能超過{{length}}個字",
  "role.desc1": "使用角色，讓協作和流程變得更加輕鬆",
  "role.desc2": "角色是什麼？在組織架構之外的更加靈活便捷的業務組，適用於無差別的跨部門協作任務和流程審批等場景",
  "role.removeMember.confirm": "您是否要移除所選成員？",
  "role.removeMember.tip": "移除成員會同時移除所選成員的當前角色身份，但不會在通訊錄中刪除所選成員",
  "role.list": "角色清單",
  "role.select": "請選擇成員角色",
  "role.select.tip": "點擊選擇角色",
  "password.update": "修改密碼",
  "password.update.success": "密碼修改成功",
  "password.set": "設置密碼",
  "password.set.warning": "請設置密碼",
  "password.signIn": "登錄密碼",
  "password.signIn.error": "登錄密碼錯誤",
  "password.new": "新密碼",
  "password.new.retype": "再輸入一次新密碼",
  "password.original": "原密碼",
  "password.minLength": "最小長度為{{length}}",
  "password.tooShort": "密碼長度小於{{length}}位",
  "password.confirm": "確認密碼",
  "persona.template.has.vip": "範本中包含高級功能",
  "persona.template.exceed.msg": "此範本中包含的功能已超出您當前的版本，請領取試用後在「範本中心」安裝",
  "persona.company.size": "{{num}}人",
  "persona.company.size.above": "{{num}}人以上",
  "persona.emptyTip.company": "團隊名稱不能為空",
  "persona.emptyTip.referrer": "瞭解管道不能為空",
  "persona.emptyTip.industry": "行業類型不能為空",
  "persona.header": "完善資訊，免費體驗30天平台高級功能",
  "persona.header.hasTrial": "完善資訊，享受大資料精准服務",
  "persona.industries.internet": "互聯網/資訊技術",
  "persona.industries.manufacturing": "製造業",
  "persona.industries.trade": "貿易/批發/零售",
  "persona.industries.service": "服務業",
  "persona.industries.education": "教育",
  "persona.industries.construction": "建築業",
  "persona.industries.finance": "金融業",
  "persona.industries.government": "政府/事業單位",
  "persona.industries.medical_medicine": "醫藥醫療",
  "persona.industries.media": "文體/娛樂/傳媒",
  "persona.industries.transportation": "運輸/物流/倉儲",
  "persona.industries.leasing": "商業服務/租賃",
  "persona.industries.estate": "房地產業",
  "persona.industries.agriculture": "農/林/牧/漁",
  "persona.industries.scientific": "科研服務",
  "persona.industries.social": "社會組織",
  "persona.industries.mining": "開採業",
  "persona.industries.resident": "居民服務",
  "persona.industries.electricity": "電熱/燃氣/水供應",
  "persona.industries.environment": "公共環境",
  "persona.job.boss": "老闆",
  "persona.job.manager": "管理人員",
  "persona.job.staff": "普通職員",
  "persona.recommend.skip": "暫不安裝",
  "persona.recommend.template": "應用範本",
  "persona.referrers.friend": "朋友推薦",
  "persona.referrers.friend.corp": "公司同事推薦",
  "persona.referrers.friend.private": "朋友私下推薦",
  "persona.referrers.friend.circle": "朋友圈",
  "persona.referrers.search": "網路搜索",
  "persona.referrers.search.form": '搜"表單"找到',
  "persona.referrers.search.flow": '搜"流程"找到',
  "persona.referrers.search.cooperate": '搜"協作軟體"找到',
  "persona.referrers.zhihu": "知乎",
  "persona.referrers.zhihu.fx": "平台官方號",
  "persona.referrers.zhihu.influencer": "知乎大V",
  "persona.referrers.weChat": "微信公眾號",
  "persona.referrers.weChat.fx": "平台公眾號",
  "persona.referrers.weChat.excel": "Excel類公眾號",
  "persona.referrers.weChat.data": "資料類公眾號",
  "persona.referrers.weChat.manage": "管理類公眾號",
  "persona.referrers.other.dingding": "阿裡釘釘",
  "persona.referrers.other.wework": "企業微信",
  "persona.referrers.other.toutiao": "今日頭條",
  "persona.referrers.other.qq": "QQ",
  "persona.referrers.other.online": "線上課程",
  "persona.referrers.other.maimai": "脈脈",
  "persona.your.company.industry": "你所在團隊/企業所屬行業：",
  "persona.your.company.name": "你的團隊/企業名稱：",
  "persona.your.company.size": "你的團隊/企業規模：",
  "persona.your.job": "你的職位：",
  "persona.your.phone": "你的手機號：",
  "persona.your.referrer": "你從何處瞭解到「平台」：",
  "persona.broadcast.title": "您的資訊尚未完善，完善賬號資訊有助於我們更好地為您服務",
  "persona.show.yes": "立即完善",
  "phone.bind": "綁定手機",
  "phone.bind.success": "手機號綁定成功",
  "phone.current": "當前手機號",
  "phone.new": "新手機號",
  "phone.invalid.warning": "請輸入正確的手機號碼",
  "phone.update": "修改手機",
  "phone.update.success": "手機號修改成功",
  "phone.unbind": "解綁手機",
  "phone.unbind.confirm": "您確定要解綁手機嗎？",
  "phone.unbind.tip": "解綁手機需驗證當前綁定手機號的真實性，且解綁後將無法通過原手機號登錄平台，如需繼續使用手機號登錄，可以在解綁後重新綁定新手機號",
  "phone.unbind.success": "手機號解綁成功",
  "phone.stop": "手機已停機？",
  "phone.verify": "驗證手機",
  "phone.conflict": "手機號碼已存在",
  "publish.immediate": "立即發佈",
  "publish.skip": "暫不發佈",
  "publish.continue": "繼續發佈",
  "publish.flow.title": "流程未啟用，是否繼續發佈？",
  "publish.flow.msg": "您可以繼續發佈表單，但提交的資料不會按照流程圖所繪過程流轉",
  "print.batch": "批量列印",
  "print.batch.expired.tip": "下載連結已失效，無法下載，如需下載請重新選擇列印資料",
  "print.batch.expired.tip1": "下载链接已失效，请重新生成PDF",
  "print.batch.fail.tip": "批量列印失敗，請稍候重試",
  "print.batch.log": "批量列印記錄",
  "print.batch.log.deleteConfirm": "您確定要刪除列印記錄嗎？",
  "print.batch.log.deleteTip": "刪除列印記錄後將不可下載這次生成的檔，且無法還原",
  "print.batch.log.none": "無批量列印記錄",
  "print.batch.packing.tip": "您可以關閉頁面，系統將會繼續生成檔",
  "print.batch.waiting.tip": "正在生成PDF文件，請等待(您可以關閉頁面，系統將會繼續生成PDF)",
  "print.batch.finished.tip": "下载链接已完成，将于{{time}}失效，请尽快下载",
  "print.batch.finished.tip1": "下载链接已完成，将于{{time}}失效，请尽快下载",
  "print.batch.failed.tip": "PDF导出失败，打印文件过大，请调整打印模板或减少打印条数后再试",
  "print.batch.failed.tip1": "下载链接已失效，请调整打印模板或减少打印条数后再试",
  "print.batch.running.tip": "PDF导出中，请稍等",
  "print.batch.running.tip1": "下载链接还未生成，请稍等",
  "print.batch.delete.tip1": "删除链接记录后不可下载本次生成的PDF文件，是否确认删除这条记录？",
  "print.begin.point": "起始列印點（以當前儲存格為基準）",
  "print.border": "邊框線",
  "print.border.none": "無邊框",
  "print.border.weight": "邊框線粗細",
  "print.bg": "背景圖",
  "print.bg.enable": "列印背景",
  "print.bg.tip": "請上傳與紙張長寬比例一致的背景圖",
  "print.cellHeight.auto": "動態儲存格高度（推薦）",
  "print.cellHeight.auto.tip": "當表單內容超出儲存格時，自動拉伸儲存格高度以列印全部內容",
  "print.cellHeight.fix": "固定儲存格高度",
  "print.cellHeight.fix.tip": "嚴格按照範本設定的儲存格尺寸列印，當內容超出儲存格時會被省略",
  "print.clear": "清除內容",
  "print.data.all": "列印全部資料",
  "print.data.filtered": "列印過濾後的資料",
  "print.delete.row": "刪除行",
  "print.delete.col": "刪除列",
  "print.hf": "頁眉頁腳",
  "print.hf.set": "頁眉頁腳設置",
  "print.hide.cancel": "取消隱藏",
  "print.hide.col": "隱藏列",
  "print.hide.row": "隱藏行",
  "print.insert.delete": "插入/刪除",
  "print.insert.number": "插入頁碼",
  "print.insert.count": "插入總頁碼",
  "print.insert.row.above": "向上插入 1 行",
  "print.insert.row.below": "向下插入 1 行",
  "print.insert.row": "插入行",
  "print.insert.col": "插入列",
  "print.insert.col.left": "向左插入 1 列",
  "print.insert.col.right": "向右插入 1 列",
  "print.insert.img": "插入圖片",
  "print.insert.img.cell": "插入儲存格圖片",
  "print.insert.img.count": "懸浮圖片不得超過{{count}}個",
  "print.insert.img.float": "插入懸浮圖片",
  "print.log.view": "查看列印記錄",
  "print.merge": "合併儲存格",
  "print.merge.confirm": "您確定要合併儲存格嗎？",
  "print.merge.confirm.tip": "選擇的區域包含多個資料，合併儲存格後將只保留編輯過的所有儲存格中最左上角的數值",
  "print.name": "未命名範本",
  "print.page.bottom": "頁腳底端距離：",
  "print.page.count": "{總頁碼}",
  "print.page.number": "{頁碼}",
  "print.page.count.text": "總頁碼",
  "print.page.number.text": "頁碼",
  "print.page.top": "頁眉頂端距離：",
  "print.paper.dir": "紙張方向",
  "print.paper.dir.p": "縱向",
  "print.paper.dir.l": "橫向",
  "print.paper.height": "高：",
  "print.paper.padding": "頁邊距",
  "print.paper.padding.top": "上：",
  "print.paper.padding.bottom": "下：",
  "print.paper.padding.left": "左：",
  "print.paper.padding.right": "右：",
  "print.paper.set": "列印紙張設置",
  "print.paper.size": "紙張大小",
  "print.paper.width": "寬：",
  "print.preview.loading.tip": "正在生成預覽，請等待",
  "print.qrcode.data": "資料二維碼",
  "print.qrcode.data.tip": "將每條資料列印為對應的二維碼，團隊成員掃碼即可查看對應資料",
  "print.qrcode.field": "欄位二維碼",
  "print.qrcode.field.tip": "將每條資料中一個欄位的內容列印為對應的二維碼，掃碼即可錄入對應內容",
  "print.qrcode.field.empty": "請選擇需要列印的欄位",
  "print.qrcode.field.placeholder": "請選擇欄位",
  "print.qrcode.layout.number": "二維碼排版",
  "print.qrcode.padding.tip": "注：紙張設置僅支持A4紙，若頁邊距設置過大會出現二維碼列印不完整的情況",
  "print.qrcode.type": "二維碼類型",
  "print.repeat": "重複列印設置（請選中單行後設置）",
  "print.repeat.cross": "跨頁時重複列印此行內容",
  "print.repeat.times": "重複列印次數：",
  "print.repeat.title": "當此分頁上列印內容超出一頁紙張時，在接下來的紙張頂部自動列印此行內容  ",
  "print.record": "列印記錄",
  "print.save.tip": "當前範本未保存",
  "print.set.bgImg": "設置背景圖",
  "print.set.cellHeight": "儲存格高度設置",
  "print.set.paper": "紙張設置",
  "print.set.repeat": "重複列印設置",
  "print.sheet.add": "增加新的列印分頁",
  "print.sheet.delete": "確定要刪除分頁？",
  "print.sheet.delete.tip": "刪除此分頁後，將不再使用此分頁的範本列印",
  "print.sheet.exceed": "分頁數量超出限制",
  "print.sheet.name": "分頁{{num}}",
  "print.system.sequence": "系統序號",
  "print.unMerge": "取消合併儲存格",
  "print.usage.empty": "暫無相關結果",
  "print.usage.flow": "僅顯示啟用中流程的節點，其他版本的節點列印範本，請到該節點屬性中設置。",
  "print.usage.flow.empty": "流程版本未啟用",
  "print.usage.flow.empty.desc": "請在流程設定中啟用流程，然後為流程節點設置列印範本",
  "print.usage.range": "範本使用範圍",
  "print.usage.set": "設置成功",
  "print.template.name": "模板名稱",
  "print.template.scenes": "場景",
  "print.template.type": "类型",
  "print.template.time": "類型",
  "print.template.op": "操作人",
  "print.template.log.type.data": "數據打印",
  "print.template.log.type.batch_qr": "批量打印二維碼",
  "print.template.log.type.batch_data": "批量打印",
  "print.template.log.scenes.flow": "流程提交並打印",
  "print.template.log.scenes.manage": "數據管理",
  "print.template.log.scenes.group": "數據權限組",
  "print.template.log.scenes.report": "報表",
  "print.template.log.scenes.button": "按鈕打印",
  "print.template.log.scenes.publicQuery": "公開查詢",
  "profile.person": "個人設置",
  "profile.corp": "企業設置",
  "profile.api": "資料介面",
  "profile.api.contact": "聯繫我們開通資料介面",
  "profile.api.empty": "您沒有開通資料介面功能",
  "profile.api.intro": "資料介面為具備程式設計能力的使用者提供了一個簡單的方法來整合平台資料及其他外部資料。",
  "profile.bind.emailOrPhone": "請綁定郵箱或手機",
  "profile.bind.emailOrPhone.pass": "請綁定郵箱或手機，並設置密碼",
  "profile.complete.warning": "請填寫全部資訊",
  "platform.empty": "這裡什麼都沒有",
  "platform.empty.tip1": "請打開「應用編輯」，添加表單和報表",
  "platform.empty.tip2": "請聯繫貴司「平台」管理員，將表單/報表共用給您",
  "platform.filter.count": "（篩選出{{filterCount}}條 / 共{{totalCount}}條）",
  "platform.filter.totalCount": "（共{{totalCount}}條）",
  "platform.flow.currentNode.select": "請先選擇當前節點",
  "platform.flow.filter.add": "添加欄位篩選條件",
  "platform.flow.todo.latest": "最新的待辦",
  "platform.flow.todo.earliest": "最早的待辦",
  "platform.flow.create.latest": "最新發起的",
  "platform.flow.create.earliest": "最早發起的",
  "platform.flow.transactors.latest": "最新处理的",
  "platform.flow.transactors.earliest": "最早处理的",
  "platform.flow.cc.latest": "最新抄送的",
  "platform.flow.cc.earliest": "最早抄送的",
  "query.condition": "查詢準則",
  "query.condition.set": "設置查詢準則",
  "query.alter": "更改查詢準則",
  "query.complete.warning": "查詢準則須填寫完整！",
  "query.pass.tip": "查詢該資料需輸入密碼，請輸入密碼：",
  "query.pass.error": "密碼錯誤",
  "query.pass.type": "請輸入密碼",
  "page.leave.confirm": "您確定要離開當前頁嗎？",
  "receipt.type": "發票類型",
  "receipt.type.special": "公司專票(紙質發票)",
  "receipt.type.plain": "公司普票(紙質發票)",
  "receipt.type.personal": "政府、事業單位、個人(紙質發票)",
  "receipt.type.plain.electric": "公司普票(電子發票)",
  "receipt.electric.tip": "電子發票與傳統紙質發票具有同等法律效力，可作報銷憑證",
  "receipt.tax.cert": "一般納稅人證明",
  "receipt.content.appPlatform": "平台應用平臺",
  "receipt.content.techService": "技術服務費",
  "receipt.tax": "稅率：{{taxRate}}",
  "receipt.info": "發票資訊",
  "receipt.downloadTemplate": "下載範本",
  "receipt.downloadWordTemplate": "下載Word範本",
  "receipt.companyName": "公司名稱",
  "receipt.taxNo": "稅號",
  "receipt.taxNo.placeholder": "請輸入18位稅號",
  "receipt.taxNo.required": "請輸入15位或18位稅號",
  "receipt.fullName": "名稱",
  "receipt.regAddress": "註冊地址",
  "receipt.regPhone": "註冊電話",
  "receipt.bank": "開戶行",
  "receipt.account": "賬號",
  "receipt.content": "發票內容",
  "receipt.sendMsg": "寄送信息",
  "receipt.receiverAddress": "郵寄地址",
  "receipt.submitSuccess.tip": "您的發票已提交，我們將在1-2個工作日寄出發票",
  "receipt.confirmInfo": "確認資訊正確",
  "receipt.returnAndEdit": "返回修改",
  "receipt.submit.tip": "發票資訊提交後不可修改，請確認資訊正確",
  "receipt.send.warning": "本次開票金額不足1000元，需自付運費。 （快遞方式為順豐到付，可向快遞員索取運費發票）",
  "pagination.limit": "{{limit}} 條/頁",
  "pagination.count": "共{{count}}條",
  "pagination.count.filtered": "篩選出{{count}}條",
  "recommend.app.all": "全部範本",
  "recommend.app.done": "開始探索平台",
  "recommend.app.title": "安裝官方範本，快速開展業務",
  "recommend.app.info": "為你精選以下官方範本，幫你快速上手平台，最多選擇3項",
  "recommend.color": "推薦顏色",
  "receiver.validate.success": "驗證成功！",
  "receiver.validate.success.tip": "您已成為「{{- name}}」團隊的消息接收人",
  "receiver.validate.fail": "連結已失效！",
  "receiver.validate.fail.tip": "請聯繫團隊的賬號建立者重新發送驗證",
  "release.team": "團隊成員",
  "release.team.link": "團隊成員訪問該連結需要登錄並授權",
  "report.release": "發佈報表",
  "report.release.mem": "將報表發佈給團隊成員，成員登錄系統後即可查看報表",
  "report.release.link": "將報表發佈為公開連結，無需登錄即可查看報表",
  "report.release.team": "報表訪問連結",
  "report.externalLink": "報表查看連結",
  "report.defaultName": "未命名報表",
  "report.chart.legend": "系列{{val}}",
  "report.chart.legend.label": "系列",
  "report.chart.category": "分類{{val}}",
  "report.chart.category.label": "分類",
  "report.load.fail": "載入報表失敗！",
  "report.form.empty.tip": "您還沒有創建表單，建議您先創建表單並錄入資料，再使用報表功能。",
  "report.design": "報表設計",
  "report.dataSource.empty.tip": "請在右側面板設置數據來源",
  "report.field.empty.tip": "請從右側面板添加欄位",
  "report.parameter.empty.tip": "請先拖入控制項並添加欄位",
  "report.dataTable": "資料表",
  "report.combinedTable": "匯總表",
  "report.barChart": "直條圖",
  "report.lineChart": "折線圖",
  "report.pieChart": "圓形圖",
  "report.areaChart": "面積圖",
  "report.radarChart": "雷達圖",
  "report.shift": "排班表",
  "report.rili": "日歷表",
  "report.map": "地圖表",
  "report.empty.tip": "拖入左側控制項繪製報表",
  "report.field.empty.toast": "請先添加欄位",
  "report.widget.filter": "條件過濾",
  "report.link": "聯動",
  "report.value": "值",
  "report.dataAuth.editable": "可修改資料",
  "report.dataAuth.removable": "可刪除資料",
  "report.dataAuth.exportable": "可匯出數據",
  "report.stickyHead": "表頭凍結",
  "report.stickyHead.row": "凍結行表頭",
  "report.stickyHead.col": "凍結列表頭",
  "report.rowHead": "行表頭",
  "report.colHead": "列表頭",
  "report.metric": "指標",
  "report.data.auth": "報表數據表權限組",
  "richtext.clear": "清除格式",
  "richtext.height": "行高",
  "richtext.strikethrough": "刪除線",
  "richtext.resizeFull": "調整至 100%",
  "richtext.resizeHalf": "調整至 50%",
  "richtext.resizeQuarter": "調整至 25%",
  "richtext.floatLeft": "左浮動",
  "richtext.floatRight": "右浮動",
  "richtext.floatNone": "不浮動",
  "richtext.dragImageHere": "將圖片拖至此處",
  "richtext.selectFromFiles": "從本地上傳",
  "richtext.image.url": "圖片位址",
  "richtext.remove": "刪除圖片",
  "richtext.original": "原始尺寸",
  "richtext.link": "連結",
  "richtext.insert.link": "插入連結",
  "richtext.unlink": "取消連結",
  "richtext.edit": "編輯連結",
  "richtext.textToDisplay": "顯示文本",
  "richtext.openInNewWindow": "在新頁面打開",
  "richtext.table": "表格",
  "richtext.insert.hr": "水平線",
  "richtext.style": "樣式",
  "richtext.normal": "普通",
  "richtext.blockquote": "引用",
  "richtext.pre": "代碼",
  "richtext.h1": "標題 1",
  "richtext.h2": "標題 2",
  "richtext.h3": "標題 3",
  "richtext.h4": "標題 4",
  "richtext.h5": "標題 5",
  "richtext.h6": "標題 6",
  "richtext.unordered": "無序列表",
  "richtext.ordered": "有序列表",
  "richtext.codeview": "原始程式碼",
  "richtext.paragraph": "段落",
  "richtext.outdent": "減少縮進",
  "richtext.indent": "增加縮進",
  "richtext.justify": "兩端對齊",
  "richtext.font.color": "字體顏色",
  "richtext.recent": "最近使用",
  "richtext.background": "背景",
  "richtext.foreground": "前景",
  "richtext.reset": "重置",
  "richtext.resetToDefault": "默認",
  "richtext.shortcuts": "快速鍵",
  "richtext.textFormatting": "文本格式",
  "richtext.action": "動作",
  "richtext.paragraphFormatting": "段落格式",
  "richtext.documentStyle": "文檔樣式",
  "richtext.specialChar": "特殊字元",
  "richtext.select": "選擇特殊字元",
  "search.max.show.tip": "僅顯示前{{- count}}個搜尋結果",
  "serial.number": "編號",
  "sms.available": "剩餘短信條數：",
  "sms.log": "短信發送日誌",
  "sms.log.empty": "暫無發送日誌",
  "sms.log.used": "消耗條數",
  "sms.log.detail.prefix": "短信驗證 - ",
  "sms.number": "短信條數：",
  "sms.order": "購買短信條數",
  "sms.pack": "短信包",
  "sms.pack.detail": "短信條數增購包",
  "sms.pack.number": "短信包數量：",
  "sms.pack.number.detail": "1000條",
  "sms.pack.order": "購買短信包",
  "sms.pack.price": "¥90.00",
  "sms.send.fail": "發送失敗，請檢查手機號是否輸入正確",
  "sms.send.success": "發送成功",
  "sms.send.status": "發送狀態",
  "sms.send.status.question1": "為什麼會發送失敗？",
  "sms.send.status.question2": "為什麼發送成功卻沒有收到短信？",
  sso: "單點登錄",
  "sso.desc": "應用於企業帳號URL和發佈給成員的內連結中",
  "sso.config.guide": "如何配置?",
  "sso.config.title": "配置單點登錄",
  "sso.config.method.tip": "請選擇單點登錄配置方式",
  "sso.config.saml.tip": "請從支援 SAML 認證協定的身份認證服務商中獲取以下資訊進行填寫",
  "sso.config.saml.title": "SAML 2.0 Endpoint (HTTP)",
  "sso.config.idp.title": "IdP 公開金鑰",
  "sso.config.algo.title": "SAML 加密演算法",
  "sso.config.cert.title": "認證金鑰",
  "sso.config.certAlgo.title": "認證加密演算法",
  "sso.config.issuer.title": "Issuer URL",
  "sso.config.secret.title": "生成金鑰",
  "sso.config.signin.title": "IdP 登錄介面",
  "sso.config.signout.title": "IdP 登出介面",
  "sso.config.signout.tip": "若填寫此項，使用者登出後，會同時登出該 IdP 下所有應用",
  "sso.config.slo.title": "SLO Endpoint (HTTP)",
  "sso.config.slo.tip": "若填寫此項，使用者從登出後，會同時登出該 IdP 下所有 SAML 應用",
  "sso.custom.api": "自訂介面",
  "sso.saml": "SAML 2.0 Endpoint",
  "sso.saml.short": "SAML 2.0",
  "sso.secret.maxLength": "金鑰長度超出限制",
  "sso.cert": "認證返回位址",
  "sso.custom": "IdP Endpoint",
  "sso.meta": "Metadata 位址",
  "sso.signout": "登出位址",
  "sso.clearConfig.title": "您確定要清空配置嗎？",
  "sso.clearConfig.msg": "清空後將無法使用單點登錄",
  "sso.item.required": "資訊不完整",
  "submit.success": "提交成功",
  "submit.fail": "提交失敗",
  "submit.verify": "提交校驗",
  "submit.select": "提交選中",
  "submit.end": "結束提交",
  "submit.finish": "提交完成",
  "submit.break": "提交中斷",
  "submit.timeout": "提交超時",
  "satisfaction.survey.title": "平台使用者滿意度調查",
  "satisfaction.survey.subtitle": "參與即有機會贏取 8 折優惠券",
  "send.verify.email": "發送驗證郵件",
  "send.verify.sms": "發送驗證短信",
  "survey.recommend.question": "您有多大可能向朋友推薦平台？",
  "survey.recommend.not": "絕對不會",
  "survey.recommend.able": "非常可能",
  "survey.research.question": "您是否願意讓貴司平台使用者也參與調研？",
  "survey.research.question.tip": "若願意，調研結束後我們將會為您回饋貴司調研結果，方便您瞭解成員對平台的滿意程度",
  "survey.recommend.unwilling": "不願意",
  "survey.recommend.willing": "願意",
  "survey.clickToParticipate": "點擊參與",
  "survey.confirm": "您確定不參加本次調研嗎？",
  "survey.confirm.manager.tip": "關閉後無法參與本次調研，您將失去贏取平台 8 折優惠券的機會。",
  "survey.confirm.member.tip": "關閉後無法參與本次調研，管理員將無法獲知您對平台的滿意度",
  "survey.confirm.info": "返回活動頁面",
  "survey.thank": "感謝您的參與",
  "survey.confirm.close": "真的要放棄折扣券和平台周邊嗎？",
  "template.case": "使用案例",
  "template.copy.other": "複製到同應用其他表單",
  "template.copy.other.tip": "將列印範本複製到當前應用內的其他表單時，僅保留範本內所有的樣式和文字，不會保留表單欄位",
  "template.copy.current": "複製到當前表單",
  "template.copy.empty": "沒有可選擇的目標表單",
  "template.copy.form.empty.tip": "請選擇目標表單",
  "template.demand.submit": "提交範本需求",
  "template.install": "安裝應用",
  "template.install.fail": "安裝失敗",
  "template.install.withData": "保留示例資料",
  "template.install.withData.tip": "保留的資料會計入資料總量，請確保您的版本滿足需求。",
  "template.install.withoutData": "不保留示例資料",
  "template.install.toGroup": "安裝應用到分組",
  "template.copy.toGroup": "複製應用到下面分組",
  "template.install.target.group": "請選擇應用安裝的分組",
  "template.not.found": "沒有搜索到相關結果",
  "template.not.suitable": "沒有找到合適的範本？",
  "template.publisher": "開發者：{{- publisher}}",
  "template.search.tip": "輸入範本名稱來搜索",
  "template.search.result": "“{{- keyword}}”的搜索結果",
  "template.share": "請複製以下連結來分享應用",
  "template.trial": "範本中包含高級功能，是否領取試用？",
  "template.trial.time": "此範本中包含的功能已超出您當前使用的版本，是否領取高級功能{{day}}天試用期？",
  "template.upgrade": "此範本包含的高級功能已超出您當前使用的版本。如需體驗請升級您的賬號。",
  "template.welcome": "歡迎加入範本中心",
  "template.desc": "範本中心是平台用戶公開發佈、交流應用的平臺。",
  "template.tip.share": "如果你只需讓團隊成員使用你的應用，那麼將應用分享給團隊成員即可",
  "template.tip.appLink": "如果你只需將應用分享給特定的用戶，那麼加入推廣聯盟後分享應用連結即可",
  "template.tip.data": "將應用發佈至範本中心時，應用中的部分資料也會一併被發佈，如果此應用中有隱私資料，請複製應用後並添加示例資料後發佈。",
  "transfer.tip": "此操作僅調整已產生流程資料中的負責人，不影響流程配置",
  "transfer.charger.original": "原負責人",
  "transfer.charger.original.label": "原負責人：",
  "transfer.charger.original.select": "請選擇原負責人",
  "transfer.charger.new": "新負責人",
  "transfer.charger.new.label": "新負責人：",
  "transfer.charger.new.select": "請選擇新負責人",
  "transfer.charger.duplicate": "原負責人和新負責人相同",
  "transfer.record": "調整記錄",
  "transfer.record.none": "無調整記錄",
  "transfer.record.view": "查看調整記錄",
  "transfer.success": "調整成功",
  "transfer.busy": "正在調整，請等待",
  "transfer.busy.tip": "您可以關閉頁面，調整會繼續進行",
  "transfer.time.label": "調整時間：",
  "transfer.count": "調整資料：{{count}}條",
  "transfer.count.success": "成功：{{count}}條",
  "transfer.count.fail": "失敗：{{count}}條",
  "trigger.create": "新建智慧助手",
  "trigger.empty": "智慧助手可以在觸發表單資料發生變動後，自動在目標表單中新增、修改、刪除資料。",
  "trigger.afterCreate": "新增數據後",
  "trigger.afterUpdate": "資料修改後",
  "trigger.afterRemove": "刪除資料後",
  "trigger.conditions": "當滿足指定條件時",
  "trigger.entry.add": "在「{{- name}}」中新增數據",
  "trigger.entry.update": "修改「{{- name}}」的資料",
  "trigger.entry.remove": "刪除「{{- name}}」的資料",
  "trigger.log.review": "查看執行日誌",
  "trigger.log.failure.detail": "失敗詳情",
  "trigger.log.failure.detail.view": "查看失敗詳情",
  "trigger.log.failure.index": "序號",
  "trigger.log.failure.reason": "失敗原因",
  "trigger.log.time": "執行時間",
  "trigger.log.user": "執行人",
  "trigger.log.count": "（{{count}}條）",
  "trigger.log.create.empty": "（0條，沒有可新增的資料）",
  "trigger.log.update.empty": "（0條，沒有可修改的資料）",
  "trigger.log.remove.empty": "（0條，沒有可刪除的資料）",
  "trigger.log.fail": "（失敗-{{msg}}）",
  "trigger.log.fail.count": "（失敗{{count}}條）",
  "trigger.log.error.1": "執行失敗",
  "trigger.log.error.4809": "迴圈計算錯誤",
  "trigger.log.error.4806": "找不到目標表單",
  "trigger.log.error.3002": "找不到目標表單",
  "trigger.log.error.4813": "超出觸發層級限制",
  "trigger.log.error.4812": "需修改資料>100條",
  "trigger.log.error.4817": "主欄位或單個子表單不能使用不同子表單賦值",
  "trigger.log.error.4821": "最多新建200條資料",
  "trigger.log.error.4012": "資料正被其他使用者編輯",
  "trigger.log.error.9007": "資料正被其他使用者編輯",
  "trigger.log.error.9008": "資料正被其他使用者編輯",
  "trigger.log.error.4000": "資料提交失敗",
  "trigger.log.error.7212": "超出每月資料提交量",
  "trigger.log.error.7206": "超出總數據量/單表資料量",
  "trigger.log.error.4403": "聚合表校驗公式錯誤",
  "trigger.log.error.4001": "資料不存在",
  "trigger.log.error.4815": "未生成有效的過濾條件",
  "trigger.log.error.4822": "修改欄位設置有誤",
  "trigger.log.error.4823": "觸發條件設置有誤",
  "trigger.log.error.4824": "刪除資料超過100條",
  "trigger.log.error.4825": "觸發資料不存在",
  "trigger.log.error.2010": "沒有跨應用操作許可權",
  "trigger.log.error.4827": "過濾條件目標表單子表單不支援使用觸發表單子表單賦值",
  "trigger.log.error.4828": "過濾條件不支援配置子表單",
  "trigger.log.error.4829": "過濾條件未配置目標表單子表單欄位使用觸發表單主欄位賦值",
  "trigger.log.error.4830": "過濾條件未配置目標表單主欄位使用觸發表單子表單欄位賦值",
  "trigger.log.error.4831": "過濾條件子欄位不支援使用觸發表單主欄位賦值",
  "trigger.log.error.4832": "過濾條件目標表單主欄位僅可使用觸發表單相同子表單欄位賦值",
  "trigger.log.error.4833": "不支援對目標表單子欄位修改",
  "trigger.log.error.4834": "過濾條件僅支援對目標表單同一個子表單的子欄位進行過濾",
  "trigger.log.error.4835": "僅支援對目標表單同一個子表單的子欄位進行賦值",
  "trigger.log.error.4836": "目標表單子表單不支援使用觸發表單子表單賦值",
  "trigger.log.error.4837": "目標表單主欄位僅可使用觸發表單相同子表單欄位賦值",
  "trigger.log.error.4838": "欄位賦值和過濾條件中目標表單子表單欄位不一致",
  "trigger.log.error.4839": "欄位賦值和過濾條件中觸發表單子表單欄位不一致",
  "trigger.log.filter.empty": "沒有符合篩選條件的執行日誌",
  "trigger.depend.subform.tip": "確定要使用子表單欄位賦值嗎？",
  "trigger.depend.subform.conflict.tip": "主欄位或單個子表單不能使用不同子表單欄位賦值。 此操作會清除部分已設置的欄位賦值方式，無法還原。",
  "trigger.depend.subform.subfield.tip": "目標表單主欄位和子欄位不能同時使用子欄位賦值。 此操作可能會清除部分已設置的欄位賦值方式，無法還原。",
  "trigger.config.subform.support": "目標表單欄位支援使用觸發表單子表單欄位。",
  "trigger.delete.title": "確定要刪除智慧助手？",
  "trigger.delete.msg": "刪除智慧助手後將不再觸發執行動作，之前的執行結果不受影響",
  "trigger.config.trigger": "設置觸發動作",
  "trigger.config.run": "設置執行動作",
  "trigger.config.name": "智慧助手名稱",
  "trigger.config.field.add": "添加欄位",
  "trigger.config.form": "觸發表單",
  "trigger.config.form.tip": "數據助手觸發執行動作修改其他表单的數據。",
  "trigger.config.action": "觸發動作",
  "trigger.config.add.tip": "新增的資料滿足以下條件，觸發執行動作",
  "trigger.config.update.tip": "修改後的資料滿足以下條件，觸發執行動作",
  "trigger.config.remove.tip": "刪除的資料滿足以下條件，觸發執行動作",
  "trigger.config.addFilter": "添加觸發條件",
  "trigger.config.fieldAdd.tip": "在目標表單中新增資料，欄位值設置如下",
  "trigger.config.helpDoc": "如何設置智慧助手？",
  "trigger.config.next": "下一步：設置執行動作",
  "trigger.config.prev": "上一步：設置觸發動作",
  "trigger.config.fail.tip1": "請輸入數據助手名稱",
  "trigger.config.fail.tip2": "數據助手名稱不能超過10字",
  "trigger.config.fail.tip3": "請選擇觸發表單",
  "trigger.config.fail.tip4": "請選擇觸發動作",
  "trigger.config.fail.tip5": "觸發表單是其他智慧助手的目標表單，且嵌套超過3層",
  "trigger.config.addData": "新增數據",
  "trigger.config.addData.tip1": "在觸發表單中填報新的資料",
  "trigger.config.addData.tip2": "在目標表單中新增資料",
  "trigger.config.updateData": "修改已有資料",
  "trigger.config.updateData2": "修改資料",
  "trigger.config.updateData.tip1": "在觸發表單中修改已有資料，如流程狀態等",
  "trigger.config.updateData.tip2": "在目標表單中查找某些資料並修改",
  "trigger.config.removeData": "刪除已有資料",
  "trigger.config.removeData2": "刪除資料",
  "trigger.config.removeData.tip1": "在觸發表單中刪除某條資料，不包含大量刪除",
  "trigger.config.removeData.tip2": "在目標表單中查找某些資料並刪除",
  "trigger.config.removeData.condition": "刪除目標表單中的哪些資料",
  "trigger.config.removeData.info": "過濾條件可以限定刪除目標表單中的哪些資料",
  "trigger.config.target": "目標表單",
  "trigger.config.target.tip": "目標表單是您想要通過智慧助手自動新增、修改、刪除資料的表單",
  "trigger.config.field.set": "設置為",
  "trigger.config.updateData.condition": "修改目標表單中的哪些資料",
  "trigger.config.updateData.info": "過濾條件可以限定修改目標表單中的哪些資料",
  "trigger.config.filter.add": "添加過濾條件",
  "trigger.config.field.updateTip": "對符合過濾條件的數據，進行以下欄位的修改",
  "trigger.config.field.updateTip1": "對符合過濾條件的數據，進行以下欄位的替換，未配寘的欄位數據替換為空",
  "trigger.config.action.add": "添加執行動作",
  "trigger.config.action.addTip": "執行動作不可超過5個",
  "trigger.config.entry.fieldValue": "字段值",
  "trigger.config.field.select": "請選擇輸出錶字段",
  "trigger.config.combo.placeholder": "請輸入內容，多個值用“enter”隔開",
  "trigger.config.leaveConfirm": "您確定要關閉設置頁面嗎？",
  "trigger.config.leaveConfirm.msg": "關閉後已設置的資料不會保存，您需要重新設置智慧助手，此操作無法還原",
  "trigger.config.tip.form": "{{- form }}{{- action}}{{- afterAction}}",
  "trigger.config.tip.afterAction": "後，觸發設置的執行動作",
  "trigger.config.tip.afterActionWithCond": "滿足指定的條件時，觸發設置的執行動作",
  "trigger.config.tip.dataAdd": "表單新增資料",
  "trigger.config.tip.dataAddWithCond": "表單新增的資料",
  "trigger.config.tip.dataUpdate": "表單修改資料",
  "trigger.config.tip.dataUpdateWithCond": "表單修改的資料",
  "trigger.config.tip.dataRemove": "表單刪除資料",
  "trigger.config.tip.dataRemoveWithCond": "表單刪除的資料",
  "trigger.config.valid.sameAction": "觸發動作與執行動作相同",
  "trigger.config.valid.circle": "當前智慧助手的目標表單執行動作，和其他智慧助手的觸發表單觸發動作相同",
  "trigger.config.subform.use.confirm": "確定要使用該子表單欄位嗎？",
  "trigger.config.subform.both.tip": "目標表單和觸發表單不支援同時使用子表單欄位，此操作會清除部分已設置的過濾條件和欄位賦值方式，無法還原。",
  "trigger.config.subform.onlyOne.tip": "過濾條件僅允許添加同一個子表單中的欄位，此操作會清除部分已設置的過濾條件和欄位賦值方式，無法還原。",
  "trigger.config.operation.confirm": "確定要進行此操作嗎？",
  "trigger.config.operation.tip": "此操作會清除部分已設置的欄位賦值方式，無法還原。",
  "trigger.config.subformrely": "子表單聯動",
  "datahelper.trigger.config.subform_to_rely": "聯動子表單當前行",
  "datahelper.trigger.config.subform_to_rely.tip": "聯動子表單觸發行的控件數據",
  "datahelper.trigger.config.subform_fix_rely": "聯動子表單指定行",
  "datahelper.trigger.config.subform_fix_rely.tip": "根據條件聯動子表單指定行的控件數據",
  "datahelper.trigger.config.subform_add": "子表單添加數據",
  "datahelper.trigger.config.subform_add.tip": "添加符合條件的數據到子表單控件尾部",
  "datahelper.trigger.config.subform_delete": "子表單刪除數據",
  "datahelper.trigger.config.subform_delete.tip": "根據條件刪除子表單控件裡的數據",
  "update.success": "修改成功",
  "update.inProcess.wait": "正在修改，請等待",
  "update.inProcess.wait.tip": "您可以關閉頁面，修改會繼續進行",
  "update.record": "修改記錄",
  "update.record.none": "無修改記錄",
  "update.field.label": "修改欄位：",
  "update.time.label": "修改時間：",
  "update.dataCount": "修改資料：{{count}}條",
  "update.dataCount.success": "成功：{{count}}條",
  "update.dataCount.fail": "失敗：{{count}}條",
  "username.valid.empty": "成員編號必填",
  "username.valid.length": "成員編號最長12個字元",
  "username.valid.regex": "成員編號僅支援字母、數位和底線",
  "validCode.fetch": "獲取驗證碼",
  "validCode.email": "郵件驗證碼",
  "validCode.shortMessage": "短信驗證碼",
  "variable.available": "可用變數",
  "variable.available.empty": "無可用變數",
  "saveInfo.saveTitle": "{{- key}}有修改，是否保存？",
  "saveInfo.saveMsg": "您修改了{{- key}}但沒有保存，是否需要保存{{- key}}並繼續？",
  "saveInfo.save": "保存並繼續",
  "saveInfo.cancel": "不保存",
  "saveInfo.fail": "保存失敗",
  "saveInfo.success": "保存成功",
  "saveInfo.update.save": "修改已保存",
  "saveInfo.setting": "保存設置",
  "signature.tip": "掃描二維碼，添加簽名",
  "signature.add": "添加簽名",
  "subform.maxCountTip": "子表單數據量已超過{{limit}}條最大限制",
  "subform.dataExistTip": "該條記錄存在資料，資料刪除後將無法恢復，確定刪除？",
  "subform.mobileLocation": "移動端獲取當前位置",
  "share.toQQ": "轉發至QQ空間",
  "share.toRenRen": "轉發至人人網",
  "share.toSina": "轉發至新浪微博",
  "share.toDouBan": "轉發至豆瓣",
  "share.toMingDao": "轉發至明道",
  "title.appSet": "應用設置-{{- name}}",
  "title.dash": "新報表設計-{{- name}}",
  "title.form": "{{- title}}-{{- name}}",
  "title.page": "{{- title}}",
  "title.profile": "{{- title}}-賬戶中心",
  "title.report": "報表設計-{{- name}}",
  "upload.browserNotSupportTip": "您使用的流覽器版本過低，無法使用檔上傳功能！",
  "upload.maxLimitTip": "檔案大小超出限制",
  "upload.maxLimitTip0": "不得上傳0KB檔案",
  "upload.maxSizeTip": "檔案大小不得超過 {{size}} MB",
  "upload.failTip": "檔上傳失敗",
  "upload.success": "上傳成功",
  "upload.fail": "上傳失敗",
  "upload.redo": "重新上传",
  "user.select": "點擊選擇成員",
  "user.searchEmpty": "暫無相關成員",
  "user.searchEmpty.resigned": "暫無相關已刪除人員",
  "user.empty": "沒有可選成員",
  "user.empty.resigned": "沒有已刪除人員",
  "upload.notSupportFileTip": "不支持選擇的檔案類型",
  "vip.systemLimitTip": "{{day}}天后系統將會受限。",
  "vip.advancedFeatures": "查看高級功能介紹",
  "vip.error.title.upgrade": "使用該功能需要升級版本，您是否要立即升級？",
  "vip.error.title.limit": "系統用量受到限制，您是否要立即升級？",
  "vip.error.7104.msg": "聚合表數量已達上限，您可以至會員中心查看版本使用情況和升級版本，或刪除無用聚合表後再進行新建。",
  "vip.error.7104.memMsg": "聚合表數量已達上限，請聯繫企業創建者升級版本後再使用該功能。",
  "vip.error.7105.msg": "你所安裝的應用中聚合表數量超出當前版本限制。請聯繫企業創建者升級版本後再安裝應用。",
  "vip.error.7110.msg": "成員數量已超出上限，為了不影響您的正常使用，請儘快升級系統，否則系統將被禁用。",
  "vip.error.7110.memMsg": "成員數量已超出上限，請聯繫企業建立者升級版本。",
  "vip.error.7111.msg": "成員數量超出限制。您可以至會員中心查看版本使用詳情和升級版本，以同步/邀請更多成員。",
  "vip.error.7111.memMsg": "成員數量超出限制。請聯繫創建者升級版本以同步/邀請更多成員。",
  "vip.error.7112.msg": "您當前使用的版本不包含自訂列印功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7112.memMsg": "您當前使用的版本不包含自訂列印功能，請聯繫企業創建者升級版本。",
  "vip.error.7113.msg": "自訂列印範本數量已達上限，您可以至會員中心查看版本使用情況和升級版本，或刪除無用自訂列印範本後再進行新建。",
  "vip.error.7113.memMsg": "自訂列印範本數量已達上限，請聯繫企業創建者升級版本後再新建。",
  "vip.error.7114.msg": "您所安裝的應用中自訂列印範本數量超出當前版本限制。請聯繫企業創建者升級版本後再安裝應用。",
  "vip.error.7120.msg": "您當前使用的版本不包含資料推送功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7120.memMsg": "您當前使用的版本不包含資料推送功能，請聯繫企業創建者升級版本。",
  "vip.error.7121.msg": "您當前使用的版本不包含資料回收站功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7122.msg": "您當前使用的版本不包含匯出附件功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7122.memMsg": "您當前使用的版本不包含匯出附件功能，請聯繫企業創建者升級版本。",
  "vip.error.7123.msg": "您當前使用的版本不包含跨應用功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7123.memMsg": "您當前使用的版本不包含跨應用功能，請聯繫企業創建者升級版本。",
  "vip.error.7124.msg": "您當前使用的版本不包含自動同步功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7125.msg": "您當前使用的版本不包含自訂提交成功頁面功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7125.memMsg": "您當前使用的版本不包含自訂提示頁面功能，請聯繫企業創建者升級版本。",
  "vip.error.7130.msg": "您使用的當前版本中不包含手寫簽名功能，您可至會員中心查看版本詳情和升級版本",
  "vip.error.7130.memMsg": "您當前使用的版本不包含手寫簽名功能，請聯繫企業創建者升級版本。",
  "vip.error.7132.msg": "資料流程數量已達上限，您可以至會員中心查看版本使用情況和升級版本，或刪除無用資料流程後再進行新建。",
  "vip.error.7132.memMsg": "資料流程數量已達上限，請聯繫企業創建者升級版本。",
  "vip.error.7133.msg": "資料流程數量已超出當前版本限制，為避免系統受限影響您的正常使用，您可以點擊查看詳情刪除無用資料流程。",
  "vip.error.7133.memMsg": "資料流程數量已超上限，請聯繫企業創建者升級版本或調整系統用量。",
  "vip.error.7134.msg": "您使用的當前版本中不包含智慧助手功能，您可至會員中心查看版本詳情和升級版本",
  "vip.error.7134.memMsg": "您所使用的版本不包含智慧助手功能，請聯繫企業創建者升級版本。",
  "vip.error.7135.msg": "智慧助手數量已達上限，您可以至會員中心查看版本使用情況和升級版本，或刪除無用的智慧助手後再進行新建。",
  "vip.error.7135.memMsg": "智慧助手數量已達上限，無法新建智慧助手。",
  "vip.error.7136.msg": "智慧助手數量已超出當前版本限制，為避免系統受限影響您的正常使用，請點擊查看詳情刪除無用智慧助手。",
  "vip.error.7136.memMsg": "智慧助手數量超出限制，請聯繫企業創建者升級版本或調整系統用量。",
  "vip.error.7139.msg": "您當前使用的版本不包含自訂樣式功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7139.memMsg": "您當前使用的版本不包含自訂樣式功能，請聯繫企業建立者升級版本。",
  "vip.error.7140.msg": "您當前使用的版本不包含自訂登錄頁功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7141.msg": "您當前使用的版本不包含單點登錄功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7142.msg": "您當前使用的版本不包含資料預警功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "vip.error.7142.memMsg": "當前版本無法使用資料預警功能，請聯繫企業建立者升級版本",
  "vip.error.7212.msg": "表格中的資料條數已超出本月資料流量限制，請升級版本。",
  "vip.error.7212.memMsg": "表格中的資料條數已超出本月資料流量限制，請聯繫帳號建立者升級版本。",
  "vip.pack.free": "免費版",
  "vip.pack.trial": "試用版",
  "vip.pack.lite": "青春版",
  "vip.pack.std": "標準版",
  "vip.pack.user": "按用戶數購買",
  "vip.pack.pro": "專業版",
  "vip.pack.ent": "企業版",
  "vip.pack.logo": "去LOGO版",
  "vip.pack.oem": "定製版",
  "vip.pack.title": "有哪些版本可以選擇",
  "vip.pack.detail": "版本明細",
  "vip.pack.oem.hotLine": "請致電：400-011-1850",
  "vip.pack.submit.request": "提交需求",
  "vip.pack.price": "{{price}}起/年",
  "vip.pack.count.title": "版本容量",
  "vip.pack.users": "使用者數",
  "vip.pack.userPrice": "使用者數增購單價",
  "vip.pack.userPriceUnit": "￥{{ price }}/人/年",
  "vip.pack.appCount": "應用數",
  "vip.pack.priceLimit": "不可增購",
  "vip.pack.manager.tip": "子管理員分為系統管理員和普通管理員，系統管理員擁有所有管理許可權，普通管理員則可以實現企業的分級管理，擁有定向管理應用和部門的許可權。如您需要在版本的基礎上額外購買子管理員數量，請與我們聯繫：400-011-1850。",
  "vip.pack.manager.count": "{{count}}個子管理員 + {{sysCount}}個系統管理員",
  "vip.pack.manager.sysCount": "{{count}}個系統管理員",
  "vip.pack.formData.tip": "單個表單內最多儲存的資料條數。",
  "vip.pack.data.freeTip": "（1000條/月）",
  "vip.pack.file.title": "每年可上傳附件總量",
  "vip.pack.file.tip": "附件上傳後即佔用附件總量，刪除已上傳的附件不會減少已使用的附件總量。",
  "vip.pack.aggregate.tip": "對資料進行聚合匯總，聚合結果可被表單、報表調用。",
  "vip.pack.aggregate.count": "每個應用{{count}}個",
  "vip.pack.dataBackup": "資料回收/恢復",
  "vip.pack.dataBackup.tip": "保留限定天數內刪除的資料，可恢復被誤刪除的資料。回收站中的資料不計入資料量且僅在回收站中可見。",
  "vip.pack.etl.tip": "資料視圖可以對資料進行預處理，完成複雜的資料建模。",
  "vip.pack.trigger.tip": "智慧助手可以在表單數據發生變動時，自動在另一張表單中增加或修改資料。",
  "vip.pack.feature.basic": "基礎功能",
  "vip.pack.log.tip": "去除表單外鏈底部平台的logo。",
  "vip.pack.userSync": "自動同步用戶",
  "vip.pack.userSync.tip": "企業號和釘釘模式下可自動進行成員同步，保持與集成賬號通訊錄一致。",
  "vip.pack.user.tip": "每個版本使用人數上限，付費版本可單獨增購使用者數",
  "vip.pack.appBridge.tip": "可從同一個賬號內的其他應用的表單中調取資料。",
  "vip.pack.signature.tip": "手寫簽名將消耗極少量附件量，1M附件量可簽名約100次。",
  "vip.pack.sso.tip": "與企業其他業務系統對接，實現一套帳號登錄多個系統（僅針對公共模式帳號）。",
  "vip.pack.service": "服務專案",
  "vip.pack.baseService.tip": "加¥2500/年可升級高級服務",
  "vip.pack.support.base": "普通技術支援",
  "vip.pack.support.gold": "高級技術支援",
  "vip.pack.service.date": "服務時間",
  "vip.pack.service.dateBasic": "工作日：09:00-17:30",
  "vip.pack.service.dateGold1": "工作日：09:00-20:00",
  "vip.pack.service.dateGold2": "雙休日：10:00-17:00",
  "vip.pack.doc": "文檔/應用範本",
  "vip.pack.feature": "可用功能",
  "vip.pack.contact.title": "沒有找到適合您的版本?",
  "vip.pack.contact.info": "請提交您的版本定制需求，我們的產品顧問會儘快與您聯繫。",
  "vip.pack.contact": "諮詢我們",
  "vip.pack.submit": "提交版本定制需求",
  "vip.pack.hotLine": "諮詢電話：400-011-1850",
  "vip.pack.bi.info": "平台同時提供私有雲產品（平台報表FineReport／平台商業智慧FineBI），幫助企業快速搭建資料獲取、處理和視覺化的一站式大資料分析平臺。",
  "vip.pack.wechatTip": "您登錄的不是企業創建者賬號，無法完成購買，請從企業微信管理後臺進入平台購買。",
  "vip.pack.dingtalkTip": "您登錄的不是企業創建者賬號，無法完成購買，請從釘釘管理後臺進入平台購買。",
  "vip.pack.error.title": "請登錄企業創建者賬號後購買",
  "vip.pack.order.title": "您是否要立即處理？",
  "vip.pack.order.msg": "存在未支付的訂單，請先支付或關閉已存在的訂單再進行購買",
  "vip.pack.order.tip": "存在未支付的訂單，您需要先支付或取消，才能創建新訂單",
  "vip.pack.order.ok": "立即處理",
  "vip.pack.order.cancel": "稍後處理",
  "vip.service.basic.name": "基本服務",
  "vip.service.advanced.name": "高級服務",
  "vip.service.silver.description": "+2500元升級高級服務",
  "vip.center": "版本信息",
  "vip.center.renewNow": "立即續費",
  "vip.center.trial": "試用高級版",
  "vip.center.purchase": "購買",
  "vip.center.upgradePack": "升級版本",
  "vip.center.service.purchase": "購買高級服務",
  "vip.center.pack.purchase": "購買版本",
  "vip.center.contact": "聯繫我們",
  "vip.center.service": "服務等級",
  "vip.center.service.basicDescription": "升級版本可享受⼀對⼀專屬客服",
  "vip.center.service.silverDescription": "最高服務等級，如需説明，請聯繫我們。",
  "vip.center.logo": "外鏈去LOGO",
  "vip.center.logo.normal": "無法使用外鏈表單去Logo功能，如有需要，請升級版本。",
  "vip.center.logo.used": "可使用外鏈去Logo功能。",
  "vip.center.manager": "子管理員",
  "vip.center.timeStart": "即日起",
  "vip.center.manager.normal": "當前版本只能使用{{managers}}個子管理員和{{sysManagers}}個系統管理員，如需更多子管理員，請聯繫我們單獨購買。",
  "vip.center.manager.free": "當前版本只能使用{{managers}}個系統管理員，如需要更多子管理員，請升級版本。",
  "vip.center.aggregate": "聚合表",
  "vip.center.aggregate.free": "每個應用中可使用{{num}}個聚合表，如需更多聚合表，請聯繫升級版本。",
  "vip.center.aggregate.normal": "每個應用中可使用{{num}}個聚合表，如需更多聚合表，請聯繫我們單獨購買。",
  "vip.center.aggregate.trial": "免費版一個應用中可新建一張聚合表，為確保試用到期後正常使用，請根據使用情況升級合適的版本。",
  "vip.center.aggregate.trialOver": "試用版一個應用中可新建{{num}}張聚合表，您的當前用量已超試用版限制，請調整系統用量或根據使用方式升級合適的版本。",
  "vip.center.aggregate.used": "每個應用中可使用{{num}}個聚合表。",
  "vip.center.aggregate.total": "當前版本每個應用可使用{{num}}個聚合表",
  "vip.center.customLogin": "自訂登錄頁",
  "vip.center.customLogin.normal": "無法使用自訂登錄頁功能，如有需要，請聯繫我們單獨購買。",
  "vip.center.customLogin.used": "可使用自訂登錄頁功能。",
  "vip.center.formData": "表單資料上限",
  "vip.center.formData.normal": "單表資料上限為{{num}}萬條，如需提高單表資料上限，請聯繫我們單獨購買。",
  "vip.center.formData.free": "單表資料上限為{{num}}萬條，如需提高單表資料上限，請升級版本。",
  "vip.center.formData.trial": "免費版單表資料上限為2萬條，為確保試用到期後正常使用，請根據使用情況升級合適的版本。",
  "vip.center.formData.trialOver": "試用版用量限制為{{num}}萬條，您的當前用量已超試用版限制，請調整系統用量或根據使用方式升級合適的版本。",
  "vip.center.formData.used": "單表資料上限為{{num}}萬條",
  "vip.center.formData.total": "當前版本表單資料上限為{{num}}萬條",
  "vip.center.dataBackup": "資料回收站",
  "vip.center.dataBackup.invalid": "無法使用資料回收站功能，如有需要，請升級版本。升級後可恢復升級前15天之內刪除的資料。",
  "vip.center.dataBackup.normal": "資料回收站可將刪除後的資料保留{{num}}天，如需保存更長時間，請聯繫我們單獨購買。",
  "vip.center.dataBackup.free": "資料回收站可將刪除後的資料保留{{num}}天，如需保存更長時間，請升級版本。",
  "vip.center.dataBackup.trial": "免費版不包含此功能，為確保試用到期後正常使用，請根據使用情況升級合適的版本。",
  "vip.center.dataBackup.used": "資料回收站可將刪除後的資料保留{{num}}天。",
  "vip.center.appBridge": "跨應用",
  "vip.center.appBridge.normal": "無法使用跨應用功能，如有需要，請升級版本。",
  "vip.center.appBridge.used": "可跨應用調取資料或執行智慧助手。",
  "vip.center.userSync": "成員自動同步",
  "vip.center.userSync.normal": "無法使用成員自動同步功能，如有需要，請升級版本。",
  "vip.center.userSync.used": "可使用成員自動同步功能。",
  "vip.center.print": "自訂列印",
  "vip.center.print.normal": "無法使用自訂列印功能，如有需要，請升級版本。",
  "vip.center.print.used": "當前版本的自訂列印範本數量無限制，可根據不同場景設置不同的列印範本。",
  "vip.center.print.limit": "當前版本可使用一個自訂列印範本，如需使用更多自訂列印範本，請升級版本。",
  "vip.center.print.total": "當前版本所有應用可使用{{num}}個列印範本",
  "vip.center.print.total.empty": "當前版本不支援自訂列印範本",
  "vip.center.print.total.unlimited": "當前版本的自訂列印範本數量無限制",
  "vip.center.print.emptyTip": "沒有自訂列印範本",
  "vip.center.fileZip.normal": "無法使用批量匯出附件功能，如有需要，請升級版本。",
  "vip.center.fileZip.used": "可使用批量匯出附件功能。",
  "vip.center.sso": "單點登錄",
  "vip.center.sso.normal": "無法使用單點登錄功能，如有需要，請聯繫我們單獨購買。",
  "vip.center.sso.used": "可使用單點登錄功能。",
  "vip.center.submitPrompt": "自訂提交成功頁面",
  "vip.center.submitPrompt.normal": "無法使用自訂提交成功頁面功能，如有需要，請升級版本。",
  "vip.center.submitPrompt.used": "可使用自訂提交成功頁面功能。",
  "vip.center.signature": "手寫簽名",
  "vip.center.signature.normal": "無法使用手寫簽名功能，如有需要，請升級版本。",
  "vip.center.signature.used": "可使用手寫簽名功能。",
  "vip.center.theme": "自訂表單外鏈樣式",
  "vip.center.theme.normal": "無法使用自訂表單外鏈樣式功能，如有需要，請升級版本。",
  "vip.center.theme.used": "可使用自訂表單外鏈樣式功能。",
  "vip.center.threshold": "報表資料預警",
  "vip.center.threshold.normal": "無法使用報表資料預警功能，如有需要，請升級版本。",
  "vip.center.threshold.used": "可使用報表資料預警功能。",
  "vip.center.dataAPI.normal": "無法使用資料介面（API）功能，如有需要，請聯繫我們單獨購買。",
  "vip.center.dataAPI.used": "可使用資料介面（API）功能。",
  "vip.center.etl": "數據視圖",
  "vip.center.etl.free": "所有應用共可使用{{num}}個資料流程，如需更多資料流程，請升級版本。",
  "vip.center.etl.normal": "所有應用共可使用{{num}}個資料流程，如需更多資料流程，請聯繫我們單獨購買。",
  "vip.center.etl.trial": "免費版所有應用共可使用{{num}}個資料流程，為確保試用到期後正常使用，請根據使用情況升級合適的版本。",
  "vip.center.etl.trialOver": "試用版所有應用共可使用{{num}}個資料流程，您的當前用量已超試用版限制，請調整系統用量或根據使用方式升級合適的版本。",
  "vip.center.etl.total": "當前版本所有應用可使用{{num}}個資料流程",
  "vip.center.etl.emptyTip": "沒有資料流程",
  "vip.center.trigger": "智慧助手",
  "vip.center.trigger.free": "所有應用共可使用{{num}}個智慧助手，如需更多智慧助手，請升級版本。",
  "vip.center.trigger.normal": "所有應用共可使用{{num}}個智慧助手，如需更多智慧助手，請聯繫我們單獨購買。",
  "vip.center.trigger.trial": "免費版所有應用共可使用{{num}}個智慧助手，為確保試用到期後可以正常使用，請根據使用情況升級合適的版本。",
  "vip.center.trigger.trialOver": "試用版所有應用共可使用{{num}}個智慧助手，您的當前用量已超試用版限制，請調整系統用量或根據使用方式升級合適的版本。",
  "vip.center.trigger.total": "當前版本所有應用可使用{{num}}個智慧助手",
  "vip.center.trigger.emptyTip": "沒有智慧助手",
  "vip.center.pack.buffer": "{{pack}}—緩衝期",
  "vip.center.pack": "會員版本",
  "vip.center.current": "（當前版本）",
  "vip.center.sysCount": "系統容量",
  "vip.center.feature": "高級功能",
  "vip.center.feature.purchase": "升級版本，享受更多高級功能",
  "vip.center.feature.desc": "高級功能介紹",
  "vip.center.serviceLevel": "當前服務",
  "vip.center.overflow": "已超量",
  "vip.center.limit": "已超限",
  "vip.center.limitTip": "您的系統用量已超出當前版本限制，部分高級功能已禁用。 為避免系統受限給您的使用造成影響，請儘快調整系統用量，或升級更高版本。",
  "vip.center.sysOutage": "系統已停用",
  "vip.center.sysOutageTip": "您的系統用量已超出當前版本限制，系統整體已停用。 為避免系統停用給您的使用造成影響，請儘快調整系統用量，或升級更高版本。",
  "vip.center.custom": "定制更高版本",
  "vip.center.vip.contact": "聯繫技術支援",
  "vip.center.service.basic": "基礎服務",
  "vip.center.service.get": "升級高級服務",
  "vip.center.service1Text": "説明中心 & 範本中心",
  "vip.center.service1Info": "提供豐富的資料供您學習",
  "vip.center.service2Text": "普通技術支援服務（線上&電話）",
  "vip.center.service2Text.advance": "高級技術支援服務（線上&電話）",
  "vip.center.service2Info": "多種高效的諮詢管道，確保您的問題得到及時處理",
  "vip.center.service2Info.advance": "多種高效的諮詢管道&資深的技術人員，確保您的問題得到及時專業的處理",
  "vip.center.service3Text": "基礎服務時間",
  "vip.center.service3Text.advance": "超長服務時間",
  "vip.center.service3Info": "工作日 9:00-17:30",
  "vip.center.service3Info.advance": "工作日 9:00-17:30, 週末10:00-17:00，除法定公休日外全年無休",
  "vip.center.service.advance.tip": "升級至高級服務後，您可獲得由資深技術支援提供的全年無休的服務（法定公休日除外）",
  "vip.center.qrcode": "掃碼關注平台公眾號",
  "vip.center.corpText1": "不錯過每一次功能更新",
  "vip.center.corpText2": "獲取最新客戶案例",
  "vip.center.corpText3": "在微信裡諮詢線上客服",
  "vip.center.hotLine": "服務熱線：400-011-1850",
  "vip.center.businessLine": "市場合作：400-011-1850",
  "vip.center.pack.start": "開通時間：{{startDate}}",
  "vip.center.pack.expireTip": "（版本到期後將變為免費版）",
  "vip.center.pack.expire": "到期時間：{{expireDate}}",
  "vip.center.user.noLimit": "不限人數",
  "vip.center.user.trialLimit": "（試用到期後限制為{{user}}人，請及時升級）",
  "vip.center.user": "{{users}}人",
  "vip.center.users": "用戶量",
  "vip.center.user.used": "已用：{{users}}人",
  "vip.center.user.all": "總量：{{users}}",
  "vip.center.user.exceeded": "已超出限制",
  "vip.center.user.purchase": "購買使用者量",
  "vip.center.exceededTip": "用量已超過當前版本限制，請儘快升級或調整用量",
  "vip.center.exceeded": "用量已超過當前版本限制，請儘快升級",
  "vip.center.version.privilege": "會員特權",
  "vip.center.file": "附件上傳量",
  "vip.center.file.used": "當年已用：{{files}}",
  "vip.center.file.all": "每年總量：{{files}}",
  "vip.center.data": "總數據量",
  "vip.center.data.used": "已用：{{data}}",
  "vip.center.data.all": "總量：{{data}}",
  "vip.center.monthData": "每月資料提交量",
  "vip.center.monthData.used": "當月已用：{{monthData}}",
  "vip.center.monthData.all": "每月總量：{{monthData}}（每月1日重置）",
  "vip.center.dataCount": "{{count}}條",
  "vip.center.dataCount.tenThousands": "{{count}}萬條",
  "vip.center.manager.count": "{{managers}}個子管理員",
  "vip.center.sms.used": "當前可用短信條數：{{-count}}條",
  "vip.center.sms.count": "短信條數",
  "vip.center.sms.count.tip": "註冊即送5條短信，如需更多短信條數可在產品內自行選購",
  "vip.center.sysManager.presented.count": "{{managers}}個贈送的系統管理員",
  "vip.center.sysManager.count": "{{managers}}個系統管理員",
  "vip.center.manager.exceededTip": "您的子管理員已達到{{managers}}個",
  "vip.center.aggregate.count": "{{aggregate}}個/應用",
  "vip.center.aggregate.exceededTip": "您的聚合表最高已達到{{aggregate}}個/應用",
  "vip.center.formData.exceededTip": "您的單表資料量已達到{{count}}萬條",
  "vip.center.dataBackup.count": "{{count}}天",
  "vip.center.print.unlimited": "無限制",
  "vip.center.print.exceededTip": "已使用{{count}}個自訂列印範本",
  "vip.center.print.count": "{{count}}個",
  "vip.center.etl.count": "{{count}}個資料流程",
  "vip.center.etl.exceededTip": "您的資料流程最高已達到{{count}}個",
  "vip.center.trigger.exceededTip": "已使用{{count}}個智慧助手",
  "vip.center.data.purchase": "購買資料總量",
  "vip.center.dingTalkTrial.tip": "您需要在釘釘應用市場中升級平台。",
  "vip.center.dingTalkTrial.detail": "請在手機上打開釘釘，進入應用市場升級平台。",
  "vip.center.wechatCorpTrial.tip": "您需要在企業微信應用市場中升級平台",
  "vip.center.wechatCorpTrial.detail": "請用電腦訪問企業微信管理後臺，升級平台",
  "vip.center.renewAddon": "高級功能續費",
  "vip.center.renewAddon.fail.info": "您的高級功能未續費，無法完成購買",
  "vip.center.renewAddon.fail.tip": "請續費高級功能後重新購買。",
  "vip.center.align.tip": "增購功能已過期",
  "vip.center.upgradeTip.dingtalk": "剩餘{{count}}天到期，為了不影響使用請至釘釘應用市場升級",
  "vip.center.upgradeTip.wechatCorp": "剩餘{{count}}天到期，為了不影響使用請至企業微信應用市場升級",
  "vip.center.renewTip.dingtalk": "已超期，為了不影響使用請至釘釘應用市場續費",
  "vip.center.renewTip.wechatCorp": "已超期，為了不影響使用請至企業微信應用市場續費",
  "vip.template.title": "恭喜您，領取成功！",
  "vip.template.description": "您已領取{{day}}天試用期，我們為您準備了高級功能使用示例範本，立刻安裝體驗吧～",
  "vip.template.install": "安裝使用",
  "vip.trial.no": "暫不試用",
  "vip.trial.success": "領取成功",
  "vip.trial.start": "開始試用",
  "vip.trial.time": "您已領取平台高級功能{{day}}天試用期。",
  "vip.trial.expire.tip": "您的試用版即將到期，到期後高級功能不可使用，請及時升級版本",
  "vip.trial.install": "成功領取{{day}}天試用期，您可以返回繼續安裝應用。",
  "vip.trial.tip": "您登錄的不是企業建立者賬號，無法領取試用，請登錄企業建立者賬號後領取。",
  "vip.trial.dingtalkTip": "您登錄的不是企業建立者賬號，無法領取試用，請從釘釘管理後臺進入平台領取試用。",
  "vip.trial.wechatTip": "您登錄的不是企業建立者賬號，無法領取試用，請從企業微信管理後臺進入平台領取試用。",
  "vip.trial.error.title": "請登錄企業建立者賬號後領取試用",
  "vip.upgrade.no": "暫不升級",
  "vip.upgrade.yes": "立即升級",
  "vip.use.start": "開始使用",
  "vip.usage.aggregate": "聚合表數量：",
  "vip.usage.aggregate.tip": "以下為聚合表超出限制的應用，請在各應用中刪除無用聚合表或升級版本。",
  "vip.usage.aggregate.empty": "當前沒有任何聚合表，請單擊此處創建聚合表",
  "vip.usage.data": "數據量：",
  "vip.usage.data.count": "{{count}}萬",
  "vip.usage.data.tip": "以下為資料量超出限制的表單，請在各表單中刪除無用資料或升級版本。",
  "vip.usage.etl": "資料流程數量：",
  "vip.usage.etl.overflow.tip": "以下為使用了資料流程的應用，請及時在各應用中刪除無用資料流程或升級版本。",
  "vip.usage.etl.tip": "以下為使用了資料流程的應用，點擊查看即可進入該應用瞭解詳情。",
  "vip.usage.print": "列印範本數量：",
  "vip.usage.print.overflow.tip": "以下為使用了列印範本的表單，請及時在各表單中刪除無用列印範本或升級版本。",
  "vip.usage.print.tip": "以下為使用了列印範本的表單，點擊查看即可進入該表單瞭解詳情。",
  "vip.usage.trigger": "智慧助手數量：",
  "vip.usage.trigger.overflow.tip": "以下為使用了智慧助手的應用，請及時在各應用中刪除無用智慧助手或升級版本。",
  "vip.usage.trigger.tip": "以下為使用了智慧助手的應用，點擊查看即可進入該應用瞭解詳情。",
  "view.click": "點擊查看",
  "view.detail": "查看詳情",
  "view.help": "查看幫助",
  "view.helpCenter": "查看幫助文檔",
  "view.detailReason": "查看詳細原因",
  "weChat.bind": "綁定微信",
  "weChat.unBind": "解綁企業微信",
  "weChat.authorization": "企業微信應用授權",
  "weChat.contacts.auth.title": "企業微信通訊錄授權",
  "weChat.contacts.auth.tip": "企業微信通訊錄授權方式變更，為保證通訊錄正常同步，請盡快處理。",
  "weChat.contacts.auth.description": "因企業微信通訊錄同步方式變更，您需要授權後同步通訊錄。請輸入以下信息完成授權。",
  "weChat.contacts.auth.description.id": "agent_id和agent_secret獲取方法，請參考",
  "weChat.contacts.auth.success": "授權成功",
  "weChat.contacts.auth.fail": "授權失敗，請重試",
  "weChat.contacts.auth.repeat": "您已成功授權，請勿重複操作",
  "weChat.contacts.auth.close.tip": "您可以稍後在「通訊錄」中完成授權",
  "weChat.contacts.agentId.notEmpty": "agent_id不能為空",
  "weChat.contacts.agentSecret.notEmpty": "agent_secret不能為空",
  "view.byPass": "憑密碼查看",
  "widget.address": "地址",
  "widget.address.district": "區/縣",
  "widget.address.district.withMark": "(縣/區)",
  "widget.address.detail": "請填寫詳細地址",
  "widget.address.detail.withMark": "(詳細地址)",
  "widget.address.province": "省/自治區/直轄市",
  "widget.address.province.withMark": "(省/自治區/直轄市)",
  "widget.address.type.detail": "省-市-區-詳細地址",
  "widget.address.type.district": "省-市-區",
  "widget.checkboxgroup": "核取方塊組",
  "widget.combo": "下拉清單",
  "widget.combocheck": "下拉核取方塊",
  "widget.datetime": "日期時間",
  "widget.datetime.calendar": "日曆",
  "widget.dept": "部門單選",
  "widget.dept.clickToSelect": "點擊選擇部門",
  "widget.dept.notSupportLink": "外鏈不支持部門欄位",
  "widget.dept.listTitle": "部門列表",
  "widget.deptgroup": "部門多選",
  "widget.file.empty": "當前沒有檔上傳",
  "widget.file.maxCount": "最多允許選擇{{num}}個檔",
  "widget.file.select": "選擇檔",
  "widget.file.size": "文件大小：",
  "widget.file.uploaded": "上傳完成",
  "widget.file.uploading": "正在上傳...",
  "widget.file.uploadTime": "上傳時間：",
  "widget.id": "控制項ID",
  "widget.image": "圖片",
  "widget.image.empty": "當前沒有圖片上傳",
  "widget.image.maxCount": "最多允許選擇{{num}}個圖片",
  "widget.image.onlyCameraTip": "啟用了「僅允許拍照上傳」功能，該功能只支援微信服務號/企業微信和釘釘移動用戶端",
  "widget.image.select": "選擇圖片",
  "widget.linkdata": "關聯資料",
  "widget.linkdata.select": "選擇資料",
  "widget.linkdata.empty": "沒有符合條件的資料",
  "widget.linkquery": "關聯查詢",
  "widget.location": "定位",
  "widget.location.get": "獲取當前位置",
  "widget.location.mobileOpen": "請在移動端打開表單獲取位置資訊",
  "widget.location.set": "定位設置",
  "widget.number": "數字",
  "widget.phone": "手機",
  "widget.phone.sms.disableInPreview": "預覽時不支援手機驗證",
  "widget.phone.sms.verify": "短信驗證",
  "widget.phone.sms.count": "當前可用短信條數：{{count}}",
  "widget.phone.sms.verify.tip": "開啟短信驗證後，手機未通過驗證的表單無法提交。 短信驗證將消耗短信條數，當短信條數為0時，表單將無法正常提交。",
  "widget.phone.sms.dingTalkTrial.tip": "當前為試用版，剩餘{{- days}}天到期，到期後功能入口將被釘釘隱藏，如需繼續使用請及時聯繫企業建立者升級版本。",
  "widget.phone.sms.wechatCorpTrial.tip": "當前為試用版，剩餘{{- days}}天到期，到期後功能入口將被企業微信隱藏，如需繼續使用請及時聯繫企業建立者升級版本。",
  "widget.phone.sms.code": "短信驗證碼",
  "widget.phone.sms.getCode": "獲取驗證碼",
  "widget.phone.sms.getCodeAgain": "重新獲取（{{second}}）",
  "widget.phone.sms.error": "短信驗證碼不正確",
  "widget.phone.not.purchase": "暫不購買",
  "widget.phone.now.purchase": "立即購買",
  "widget.phone.purchase.sms": "購買短信條數",
  "widget.phone.purchase.tip1": "短信余量過少，是否立即購買短信條數？",
  "widget.phone.purchase.tip2": "當前賬號的可用短信條數不足100條，可能影響表單提交，您可以選擇購買短信條數後再使用。",
  "widget.phone.purchase.tip3": "短信余量過少，請聯繫企業建立者購買短信條數",
  "widget.phone.purchase.tip4": "當前賬號的可用短信條數不足100條，可能影響表單提交，您可以聯繫企業建立者購買短信條數後再使用。",
  "widget.phone.purchase.tip5": "短信余量為0，是否立即購買短信條數？",
  "widget.phone.purchase.tip6": "當前賬號的可用短信條數為0條，無法開啟短信驗證功能。 如需繼續使用該功能，您可以選擇購買短信條數後再開啟。",
  "widget.phone.purchase.tip7": "短信余量為0，無法開啟短信驗證",
  "widget.phone.purchase.tip8": "當前賬號的可用短信條數為0條，無法開啟短信驗證功能。 如需使用該功能，請聯繫企業建立者購買短信條數。",
  "widget.phone.purchase.tip9": "請聯繫企業建立者購買短信條數",
  "widget.phone.validate.success": "已驗證",
  "widget.radiogroup": "選項按鈕組",
  "widget.separator": "分割線",
  "widget.signature": "手寫簽名",
  "widget.signature.rewrite": "重新手寫",
  "widget.signature.useSaved.tip": "您要使用以下簽名嗎？",
  "widget.sn": "流水號",
  "widget.sn.count.num": "計數位數",
  "widget.sn.count.numText": "{{num}}位數位",
  "widget.sn.count.duration": "重置週期",
  "widget.sn.count.start": "初始值",
  "widget.sn.count.fix": "固定位數",
  "widget.sn.createTime.format": "提交日期顯示格式",
  "widget.sn.oneTip": "表單中僅可添加一個流水號欄位",
  "widget.sn.placeholder": "自動生成無需填寫",
  "widget.sn.reset.empty": "不自動重置",
  "widget.sn.reset.emptyTip": "僅當計數達到最大值時，從0開始重新計數。",
  "widget.sn.reset.day": "每日重置",
  "widget.sn.reset.dayTip": "每日00:00:00，自動從初始值重新開始計數。 一天內如果計數達到最大值，從0開始重新計數。",
  "widget.sn.reset.week": "每週重置",
  "widget.sn.reset.weekTip": "每週一00:00:00，自動從初始值重新開始計數。 一周內如果計數達到最大值，從0開始重新計數。",
  "widget.sn.reset.month": "每月重置",
  "widget.sn.reset.monthTip": "每月首日00:00:00，自動從初始值重新開始計數。 一月內如果計數達到最大值，從0開始重新計數。",
  "widget.sn.reset.year": "每年重置",
  "widget.sn.reset.yearTip": "每年首日00:00:00，自動從初始值重新開始計數。 一年內如果計數達到最大值，從0開始重新計數。",
  "widget.sn.rule": "流水號規則",
  "widget.sn.rule.confirm": "若刪除自動計數，現有的計數記錄將無法延續。 確定刪除？",
  "widget.sn.start.tip": "請輸入初始值",
  "widget.subform": "子表單",
  "widget.subform.addTip": "從左側拖拽來添加欄位",
  "widget.subform.allowBlank": "請填寫至少一條記錄",
  "widget.text": "單行文本",
  "widget.text.error.id": "请输入正确的身份证号码",
  "widget.text.error.mobile": "请输入正确的手机号码",
  "widget.text.error.tel": "请输入正确的电话号码",
  "widget.text.error.zip": "请输入正确的邮政编码",
  "widget.text.error.email": "请输入正确的电子邮箱",
  "widget.text.error.time": "请输入正确的时间格式",
  "widget.number.error.range1": "请输入小于等于{{n}}的数字",
  "widget.number.error.range2": "请输入大于等于{{n}}的数字",
  "widget.number.error.range3": "请输入{{n}}={{n1}}之间的数字",
  "widget.textarea": "多行文本",
  "widget.upload": "附件",
  "widget.user": "成員單選",
  "widget.user.listTitle": "成員列表",
  "widget.user.notSupportLink": "外鏈不支持成員欄位",
  "widget.user.current": "當前用戶",
  "widget.user.anonymous": "匿名使用者",
  "widget.multiText.placeholder": "添加篩選值",
  "widget.multiText.placeholder.tip1": "添加自訂值",
  "widget.usergroup": "成員多選",
  "widget.timepicker.placeholder": "請設置自訂範圍",
  "widget.web.page": "外部網頁",
  "dashboard.title": "工作臺",
  "module": "功能插件",
  "team.status.owned": '我創建的',
  "team.status.joined": '我加入的',
  "allapp": '全部',
  "app.creategroup": '新建分組',
  "app.othergroup": '其他常用分組',
  "login.return": '返回賬號登錄',
  phoneValidCode: "手機驗證碼",
  emailValidCode: "郵箱驗證碼",
  "time.countdown": "倒計時",
  "time.receive": "沒收到？",
  resubmit: "重新提交",
  "verification.code": "請輸入驗證碼",
  "Under.submission": "提交中...",
  "Has.sent": "已發送",
  "System.error": "系統錯誤，稍後再試",
  "fill.Email": "請填寫Email地址",
  "fill.account": "請填寫您的賬號",
  "fill.password": "請填寫您的密碼",
  "password.long": "登錄密碼長度為6-16個字符",
  "phone.exists": "當前手機號碼已存在，是否直接綁定已有賬號？",
  "contact.technician": "系統錯誤,請聯技術人員",
  basics: "基礎",
  "vip.management": "會員管理",
  finance: "財務",
  recharge: "充值",
  "bills.consumption.details": "賬單詳情",
  "control.over.invoices": "開票記錄",
  "purchased.module": "已購插件",
  "data.statistics": "數據統計",
  security: "安全",
  "operational.log": "操作日誌",
  "security.setting": "安全設置",
  "head.portrait": "頭像",
  "change.avatar": "更換頭像",
  "replacement.failed": "用戶頭像更換失敗！",
  "replacement.successful": "用戶頭像更換成功！",
  "picture.preview": "圖片預覽：",
  "picture.reset": "復位",
  "picture.rotate": "旋轉",
  "picture.rotate.left": "向左旋轉",
  "picture.rotate.right": "向右旋轉",
  "picture.open.org": "查看原圖",
  "picture.commutation": "換向",
  "current.balance": "當前余額",
  "yun.coin": "雲幣",
  replacement: "更换",
  "team.model": "團隊模式",
  "current.package": "當前套餐",
  "membership.version": "會員版",
  "maturity.time": "到期時間",
  permanent: "永久",
  temporary: '临时',
  "buying.Members": "購買會員",
  "upper.limit.user": "成員數量上限(個)",
  ge: "個",
  tiao: "條",
  "number.invited.user": "已邀請成員數：",
  "upper.form.data": "所有表單數據量上限(條)",
  "total.upload.flow": "上傳總流量(年)",
  used: "已使用：",
  "data.view.user": "數據視圖(個)",
  "total.user": "總量：",
  "create.apiKey": "創建 API Key",
  "click.view.apiKey": "點擊查看API Key",
  "api.administrator.account": "webAPI與您的管理員賬戶具有相同的權限",
  "api.reset": "重置API Key",
  "api.delete.user": "删除API Key",
  "enter.login.password": "請輸入登錄密碼",
  "import.excel.size": "導入Excel文件大小",
  "maximum.import.execl": "單個Execl表導入的最大值 ",
  "single.upload.size": "單個上傳附件大小",
  "maximum.upload.size": "單個上傳附件大小的最大值 ",
  "recycling.bin.data": "回收站數據",
  "maximum.retention.data": "回收數據保留天數最大值",
  "allow.export": "允許導出",
  "not.allow.export": "不允許導出",
  "recharge.amount": "請輸入充值金額",
  "recharge.method": "請選擇充值方式",
  "public.payment": "對公支付",
  "immediate.recharge": "立即充值",
  "general.error": "{{ error }}",
  General: "通用",
  "delete.source.faild": "刪除源碼文件失敗，錯誤信息：{{ error }}",
  "delete.log.faild": "刪除日誌文件失敗，錯誤信息：{{ error }}",
  "rename.source.faild": "修改源碼文件名稱失敗，錯誤信息：{{ error }}",
  "rename.log.faild": "修改日誌文件名稱失敗，錯誤信息：{{ error }}",
  "rename.log.success": "修改日誌文件名稱成功",
  "rename.source.success": "修改源碼文件名稱成功",
  "copy.source.faild": "複製源碼文件失敗，錯誤信息：{{ error }}",
  "copy.log.faild": "複製日誌文件失敗，錯誤信息：{{ error }}",
  "copy.log.success": "複製日誌文件成功",
  "copy.source.success": "複製源碼文件成功",
  "create.source.faild": "新建源碼文件失敗，錯誤信息：{{ error }}",
  "create.source.success": "新建源碼文件成功",
  "old.password": "舊密碼",
  "confirm.new.password": "確認新密碼",
  confirm: "確認",
  "error.password": "重復登錄密碼輸入有誤",
  "true.value": "請輸入正確的數值",
  "installation.time": "安裝時間",
  "installation.application": "安裝應用",
  "installation.form": "安裝表單",
  author: "作者",
  "version.number": "版本號",
  "sorry.module": "對不起，您還沒有插件",
  "type.transaction": "交易類型",
  "type.operation": "操作類型",
  "ticket.issue": "出票",
  "send.out": "寄出",
  receipt: "收件",
  to: "至",
  start: "開始",
  end: "结束",
  user: "用戶",
  project: "項目",
  content: "內容",
  "sorry.log": "您還沒有操作日誌",
  "name.buyer.payee": "擡頭",
  "sorry.invoiced": "您還沒有開票記錄",
  "signed": "已簽收",
  "check.carefully": "已寄出（請註意查收）",
  "ticketing.progress": "正在出票",
  "confirmation.receipt": "確認簽收",
  "refusal.sign": "拒絕簽收",
  "enter.correct.amount": "請輸入正確的金額",
  "modify.login.password": "修改登錄密碼",
  "installed.module": "已安裝插件",
  amount: "充值金額",
  "recharge.mode": "充值方式",
  "recharge.time": "充值時間",
  "recharge.total": "合",
  "logon.timeout": "登錄超時,請重新登錄",
  "recharge.system.error": "系統錯誤",
  "RMB.recharge": "人民幣充值",
  "cancellation.invoice": "取消開票",
  "correct.order.number": "請輸入正確的訂單號",
  "transaction.time": "交易時間",
  "tickets.issued": "已出票",
  "no.need.invoice": "無需開票",
  "no.ticket.issued": "未出票",
  "activity.presentation": "活動贈送",
  "ten.thousand.data": "萬條數據",
  "G.flow": "G流量",
  expire: "到期",
  "sorry.ordered": "您還沒有訂單",
  person: "人",
  "bby.group": "用戶交流群",
  "application.customization": "申請定制",
  "online.service": "在線客服",
  "help.document": "幫助文檔",
  "flow.visit.todo": "我的待辦",
  "flow.visit.create": "我發起的",
  "flow.visit.cc": "抄送我的",
  "membership.purchase": "會員購買",
  "membership.upgrade": "會員版升級",
  "free.configuration": "自由配置",
  "user.number": "用戶數/人",
  "contacts.number": "通訊錄支持人數",
  "click.details": "點擊詳情",
  "already.have": "已擁有",
  "correct.tip": "請輸入正確的數值,0為不購買。",
  "data.volume": "數據量/萬",
  "total.number": "表單錄入的數據支持的總條數",
  "every.thousand": "萬條",
  flow: "flow",
  "uploaded.tip": "上傳的圖片和附件的大小，每年清空計算",
  "correct.tip20": "請輸入正確的數值,0為不購買。",
  "more.configuration": "更多配置",
  existing: "已有",
  "sum.order": "總和",
  "aggregate.caching": "聚合表緩存",
  "batch.export.annex": "批量導出附件",
  "use.time": "使用時長",
  "order.price.title": "訂單總額",
  "account.balance": "賬戶余額",
  "need.recharge": "還需充值",
  "operating.time": "使用時間",
  discount: "折",
  "whether.payment": "是否開啟付費功能",
  "my.module": "我的插件",
  "module.center": "插件中心",
  "verification.img.code": "請輸入圖片驗證碼",
  "verification.message.code": "請輸入6位短信驗證碼",
  "immediate.activation": "立即激活",
  "successful.activation": "激活成功",
  "your.mobile.phone": "請輸入您的手機號碼",
  "correct.validation.code": "請輸入正確的驗證碼",
  "mobile.validation.code": "請輸入手機驗證碼",
  "new.login.password": "請輸入新的登錄密碼",
  "user.login": "用户登錄",
  "user.activation": "賬戶激活",
  "wechat.registration": "微信註冊",
  "summary.title.alignment": "匯總標題對齊方式",
  "summary.title.alignment.tip": "匯總標題是指透視圖左下角的標題",
  "data.table.sticky": "表格凍結",
  "data.table.sticky.before": "固定前",
  "data.table.sticky.tip": "子表單字段整體算一列；移動端暫不支持凍結表格。",
  "data.display.column": "列數據",
  "dash.dataSource.tip.etl": "{{- etl}}可以關聯、合併、聚合多張表單的數據，得到輸出表。",
  "dash.color.defaultTip": "更改預設項顏色，會修改所有沒有自主設置顏色的項的顏色。",
  "dash.sort.custom": "自定義排序",
  "dash.sort.custom.maxTip": "當前數據項過多，僅顯示前{{- count}}項",
  "dash.sort.custom.emptyTip": "沒有可排序的數據項，請修改過濾條件或查看數據源",
  "dash.style": "報表樣式",
  "dash.style.close": "關閉報表樣式",
  "dash.style.closeConfirm": "关闭报表样式",
  "dash.style.closeConfirmMsg": "关闭报表样式",
  "dash.component.style": "控件樣式",
  "dash.all": "報表整體",
  "dash.all.style": "風格",
  "datatable.all.style": "控件樣式",
  "datatable.title.color": "標題顏色",
  "dash.component.all": "控件整體",
  "dash.component.table": "表格類控件",
  "etl.update.fail": "數據更新失敗",
  "etl.update.fail.tip": "數據更新失敗，當前不是最新數據。",
  "etl.update.check": "請檢查數據流設置",
  "etl.update.nextRun": "數據待更新，{{ minutes }}分鐘後自動更新",
  "etl.update.nextRun.tip": "數據待更新，{{ minutes }}分鐘後可查看最新數據",
  "etl.update.success": "當前已是最新數據",
  "etl.update.running": "正在更新，請稍後…",
  "etl.update.running.tip": "正在更新，稍後可查看最新數據",
  "dash.percent.disabled.tip": "匯總方式為求和或計數時，才能設置佔比。",
  "dash.conversion.disabled.tip": "只有漏斗圖，才能設置轉化率。",
  "filter.date.start": "開始時間",
  "filter.date.end": "結束時間",
  "unpaid.orders": "未支付訂單",
  "data.helper": "數據助手",
  "data.helper.allow": "開啟",
  "data.helper.allow1": "開啟中",
  "data.helper.disable1": "已禁用",
  "data.helper.allow.tip": "請確認是否{{ action }}數據助手",
  "aggregate.table.alias": "聚合表別名",
  "aggregate.table.alias.tip": "同壹應用下唯壹，如果沒有設置別名或者設置為空，則別名為默認，修改即保存",
  cache: "緩存",
  "cache.tip": "開啟後，調用聚合表數據時可加快獲取速度，如數據聯動，關聯數據等",
  "set.verification.conditions": "設置校驗條件",
  "cannot.use.system.field.alias": "不能使用系統字段別名-",
  "aggregate.table.alias.modification.failed": "聚合表別名修改失敗",
  "leave.page.tip": "當前頁面未保存，是否確定離開？",
  "page.tip": "當前頁面未保存",
  "leave": "離開",
  "setting.failed": "設置失敗",
  "click.copy": "點擊復制",
  "trigger.event": "是否觸發事件（插件事件/_form事件）",
  "operator.tip": "操作人_id，默認使用應用所有者的_id",
  "widget.upload.signature": "附件、手寫簽名",
  "system.management": "系統管理",
  "cloud.application.management": "雲應用管理",
  "incorrect.form.type": "表單類型不正確",
  "picture.upload.failed": "圖片上傳不成功",
  "aggregate.validation.failed": "聚合表校驗失敗",
  "exception.contact.administrator": "系統異常，請聯系管理員",
  "empty.recycle.irreversible": "清空回收站中所有表單以及數據，此操作不可逆",
  "empty.recycle.forms": "清空回收站所有表單",
  "empty.recycle.field": "清空回收站所有字段",
  "emptying.recycle.forms": "回收站表單正在清理中,剩余{{ count1 }} / {{ count2 }}",
  "recycle.has.cleaned": "回收站的表單已經清理完成!",
  "clean.tip": "本次清理{{ cf }}個表單，有{{ fi }}個表單出錯，請聯系管理員檢查處理",
  "application.more.tip": "當前應用表單數量超過{{ formNumberMax }}個，無法創建更多的表單，請先清空表單回收站無用表單再進行操作",
  "create.blank.flow.form": "創建空白流程表單",
  "unnamed.flow.form": "未命名流程表單",
  "unnamed.event.form": "未命名事件表單",
  "event.form": "事件表單",
  "unnamed.new.report": "未命名新報表",
  "unnamed.dash.report": "未命名分析報表",
  "unnamed.scenes.report": "未命名場景報表",
  "create.new.report": "創建報表",
  "create.old.report": "創建舊報表",
  "create.dash.report": "創建分析報表",
  "create.scenes.report": "創建場景報表",
  "scenes.report": "場景報表",
  "successfully.restored.form": "恢復表單成功",
  "failed.restored.form": "恢復表單失敗",
  "switch.event.form": "切換為事件表單",
  "switch.notEvent.form": "切換為非事件表單",
  "application.exceed": "單個應用表單數量不能超過{{ formNumberMax }}個",
  "please.enter": "請輸入",
  "confirm.delete.the": "請確認是否刪除 \"{{ name }}\" ？",
  "completely.delete.irreversible": "請確認是否徹底刪除 \"{{ name }}\" ？此操作不可逆",
  "standard.application": "標準應用",
  "scenes.used": "使用場景",
  category: "行業分類",
  "functional.classification": "功能分類",
  "tutorial.case": "教程案例",
  "search.cloud.office.applications": "搜索雲辦公應用",
  "app.preview": "應用預覽",
  "companies.use": "{{ installnum }}家公司使用",
  "installation.package.size.exceeds": "安裝包大小超出限制",
  "selected.it": "已選擇【{{ name }}】",
  "import.package.group": "導入安裝包到分組",
  "import.package.group.tip": "是否保留示例数据",
  "select.file": "選擇文件",
  "app.access": "應用訪問",
  "backend.script": "後端腳本",
  "app.management": "應用管理",
  "module.design": "插件設計",
  "module.source": "插件源碼",
  "pay.title": "充值支付 - ",
  "pay": "充值支付",
  "message.center": "消息中心",
  "no.access.contacts": "沒有通訊錄訪問權限",
  "security.strategy": "安全策略",
  "export.management": "導出管理",
  "weChat.sweep": "微信“掃壹掃”，分享給好友",
  "report.alias": "報表別名",
  "widget.alias.duplicate": "字段別名重復",
  "alias": "别名",
  "permissions.settings": "權限設置",
  "add.data.source": "新增數據源",
  "sure.add.form.data": "是否確認新增此表單數據？",
  "data.form.information": "數據表顏色信息",
  "data.table.default.sort": "數據表默認排序字段",
  "data.table.mobile.style": "數據表移動端樣式",
  "schedule.specific.information": "排班具體信息",
  "shift.time.field": "排班時間字段",
  "calendar.displayed.tip": "操作日歷以月或周顯示，默認以月日歷顯示",
  "calendar.mode": "日歷模式",
  "calendar.month": "月日歷",
  "calendar.week": "周日歷",
  "dynamic.row.field": "動態行表頭字段",
  "calendar.specific.information": "日歷具體信息",
  "calendar.color.information": "日歷表顏色信息",
  "calendar.time.field": "日歷時間字段",
  "corresponding.time.field": "對應數據表中的時間字段",
  "title.show": "展示",
  "add.search.box": "添加搜索框",
  "right.click.mark": "右鍵可標記",
  "display.data.list": "顯示數據列表",
  "map.specific.information": "地圖具體信息",
  "click.operate": "點擊操作",
  "no": "否",
  "trigger.events": "是否觸發後端事件",
  "button.events": "按鈕事件",
  "map.effective.range.field": "輻射半徑",
  "map.location.field": "地圖位置字段",
  "report.link.title": "報表鏈接",
  "report.external.link": "報表外鏈",
  "phone.binding": "手機綁定",
  "created.invited": "我創建了報表，邀請大家來查看！-",
  "created.invited.form": "我創建了表單，邀請大家來查看！-",
  "external.link.tip2": "本內容由用戶通過「{{ site_name }}」發布，並不代表{{ site_name }}的立場。 ",
  "app.group.name": "應用分組名稱",
  "app.group.deleted": "當前分組中還有應用，不能刪除!",
  "confirm.appGroup.deleted": "請確認是否刪除分組-{{ name }}",
  "NoApps.currently.visible": "當前沒有任何應用可見，",
  "share.app.permissions": "請您聯系管理員給您分享應用權限",
  "appGroup.no.has": "當前分組沒有應用",
  "clean.data": "清理數據",
  "moveTo.other.group": "移動到其他分組",
  "share.others.install": "分享給他人安裝",
  "export.installation.package": "導出安裝包",
  "export.installation.package.tip": "是否導出示例數據（每個表單最新20條數據）",
  "export.installation.package.yes": "包含示例數據下載",
  "export.installation.package.no": "不包含示例數據下載",
  "app.batch.export.options.tip1": '用户安装以后禁止再次导出',
  "app.batch.export.options.tip2": '是否导出示例',
  "installing.app": "正在安裝應用...",
  "select.app.group": "請先選擇應用分組",
  "copy.app": "應用復制",
  "delete.app.name": "如確定刪除，請輸入應用名稱",
  "want.delete.app": "您確定要刪除應用 “{{ appname }}” 嗎？",
  "delete.form.irreversible": "刪除應用則表單、報表以及數據也都將壹並刪除，此操作不可逆！",
  "delete.form.data": "如確定清空數據，請輸入表單名稱",
  "want.clear.form.data": "您確定要清空表單 “{{ name }}” 中所有的數據嗎？",
  "want.clear.form.data.filter": "您确定要清空表单 “{{ name }}” 筛选后的数据吗？",
  "want.clear.form.data.select": "您确定要清空表单 “{{ name }}” 中选择的 {{index}} 条数据吗？",
  "want.delete.form.data": "您确定要删除表单 “{{ name }}” 中所有的数据吗？",
  "clear.form.data.irreversible": "清空表單操作將徹底刪除表單中所有的數據，此操作不可逆！",
  "delete.select.form.data": "如確定刪除選擇數據，請輸入表單名稱",
  "want.clear.select.form.data": "您確定要刪除表單 “{{ name }}” 中選擇的 {{index}} 條數據嗎？",
  "clear.select.form.data.irreversible": "此操作將徹底刪除當前選擇的的數據，此操作不可逆！",
  "select.data.empty.tip": "當前沒有選擇數據，請先選擇數據",
  "clear.field": "如確定清空回收站所有字段，請輸入表單名稱",
  "want.clear.field": "您確定要清空表單 “{{ name }}” 回收站中所有的字段嗎？",
  "clear.field.irreversible": "此操作將清空回收站中的字段以及字段對應的數據，此操作不可逆！",
  "delete.field": "如確定刪除回收站字段，請輸入表單名稱",
  "want.delete.field": "您確定要刪除表單 “{{ name }}” 回收站中的字段嗎？",
  "delete.field.irreversible": "此操作將徹底刪除回收站中的字段以及字段對應的數據，此操作不可逆！",
  "select.field.empty.tip": "當前沒有選擇字段，請先選擇字段",
  "clear.app.name": "如確定清空，請輸入應用名稱",
  "clear.data.app": "您確定要清空應用 “{{ appname }}” 中的所有數據嗎？",
  "clear.data.irreversible": "執行清空操作應用中所有的數據將徹底刪除，此操作不可逆！",
  "app.data.cleared": "應用數據已清空!",
  "download.immediately": "立即下載",
  "installation.link": "安裝鏈接",
  "installation.app.link": "通過安裝鏈接可以直接安裝當前應用",
  "account.no.empty": "賬號不能為空",
  "app.installation.link": "應用安裝鏈接",
  "installation.copied.link.successfully": "安裝鏈接復制成功!",
  "generate.copied.link.successfully": "生成安裝二維碼",
  "install.password": "憑密碼安裝",
  "limit.password": "密碼不能為空且小於24位",
  "accounts.allowed.install": "允許安裝的賬號",
  "enter.app.accounts": "輸入允許安裝該應用的用戶賬號,多個賬號使用換行輸入",
  "view.installed.records": "查看被安裝記錄",
  "Share.app.install.others": "分享應用【{{ appname }}】給他人安裝",
  "install.account": "安裝人賬號",
  "install.nickname": "安裝人昵稱",
  "install.time": "安裝時間",
  "no.installation.record": "沒有安裝記錄",
  "show.latest.record": "僅顯示最新的50條記錄",
  "installation.record": "安裝記錄",
  "failed.installation.record": "獲取安裝記錄失敗!",
  "enter.new.appName": "請輸入新的應用名稱",
  "add.new.source": "新增數據來源",
  button: "按鈕",
  buttonext: "Extended",
  "data.loading": "數據加載",
  "corresponding.field": "對應字段",
  "old.perform.action": "執行動作(舊)",
  "perform.action": "執行動作",
  "form.source": "表單來源",
  "WPSTIP.7102": "系統用量超出限制，系統已暫停使用，您可以刪除部分數據來恢復系統。",
  "WPSTIP.7104": "聚合表數量已達上限，請刪除原先的聚合表後再進行新建。",
  "WPSTIP.7105": "您所安裝的應用內聚合表數量超出WPS雲表格限制，請重新選擇應用安裝。",
  "WPSTIP.7106": "您的聚合表數量已超出限制。",
  "WPSTIP.7107": "您本月的附件上傳量已超出表格限制。",
  "WPSTIP.7108": "您系統內的總數據量已超出表格限制。",
  "WPSTIP.7109": "您系統內的單表數據量已超出表格限制。",
  "WPSTIP.7110": "您系統內的成員數量已超出表格限制。",
  "WPSTIP.7111": "成員數量超出限制，您可以刪除部分成員，以邀請更多成員。",
  "to.minute": "分鐘",
  "to.hour": "小時",
  "pin.top": "頂部冻结",
  "pin.right": "右侧冻结",
  "pin.none": "取消冻结",
  "file.fetch.failed": "文件獲取失敗",
  "source.add": "新建源文件",
  "source.add.python": "創建python文件",
  "source.add.lua": "創建lua文件",
  "not.alias.jumping": "當前面板不支持應用內表單別名跳轉",
  "flow.wrong.help": "流程出錯了，可聯系鏈接發布者尋求幫助",
  "data.saved.submit": "您的數據已保存，請勿重復提交!",
  "not.current.data": "當前不是最新數據",
  "refresh.in.stop": "不刷新",
  "refresh.in.time": "及時刷新",
  "cyclic.in.refresh": "循環刷新",
  "periodic.in.refresh": "周期性刷新",
  "view.refresh.notSet": "當前沒有設置此數據視圖刷新規則",
  "update.immediately": "立即更新",
  "department.sub.department": "當前用戶所處部門以及子部門",
  "department.hasCurrentParDept": "當前用戶所處部門以及父部門",
  "top.department": "當前用戶上級部門",
  "tertiary.department": "當前用戶三級部門",
  "fourth.department": "當前用戶四級部門",
  "fifth.department": "當前用戶五級部門",
  "equal.to.filter": "等於篩選條件",
  "pivot.table": "透視圖",
  "backend.table": "後端表",
  "back.form.design": "返回表單設計",
  "has.been.saved": "有修改，是否保存？",
  "not.save.continue": "您修改了{{ key }}但沒有保存，是否需要保存{{ key }}並繼續？",
  "lat": "緯度：",
  "lon": "經度：",
  "minute.ago": "分鐘前",
  "flow.starting.point": "流程起點",
  "not.empty": "不能為空",
  "title.len": "{{ title }}長度不能大於{{ len }}個字符",
  "only.be": "只能中文,英文,數字,下劃線,(,),-,空格",
  "alias.not.empty": "別名不能為空",
  "alias.only.be": "別名只能中文,數字,字母,下劃線",
  "only.be.num": "只能字母,數字,下劃線",
  "category.num": "類別{{ num }}",
  "series.num": "系列{{ num }}",
  "continued": "持續",
  "schedule": "進度",
  "data.no.content": "數據沒有內容",
  "close.full.screen": "關閉全屏展示",
  "full.screen.show": "全屏展示",
  "shrink.toolbar": "收縮工具欄",
  "expand.toolbar": "展開工具欄",
  "latLon.not.exist": "標記經緯度不存在",
  "select.positioning.center": "選擇定位中心",
  "latLon": '經緯度',
  "add.mark": "添加標記",
  "delete.targeting": "刪除該定位",
  "latLon.marked": "該標記點的經緯度為：{{ lngNum }},{{ latNum }}",
  "address": "詳細地址：",
  "location.failed1": "定位失敗，時間未寫入",
  "current.node": "當前節點：",
  "flow.charger.current.map": "當前負責人：",
  "view.look": "查看",
  "addressing": "尋址",
  "latLon.empty.tip": "經緯度為空不能進行定位",
  "complete.driving.route": "繪制駕車路線完成",
  "failed.driving.data": "獲取駕車數據失敗：",
  "notLoaded.positioning.permission": "定位未加載完成，請檢查是否有定位權限",
  "lonLat.lon.lat": "[經緯度：經度{{ lon }},緯度{{ lat }}]",
  "select.delete.data": "選中{{ num }}條數據，刪除後將無法恢復，確定刪除？",
  "filter.delete.data": "您筛选{{ num }}条数据，删除后将无法恢复，确定删除？",
  "select.mort.data": "您當前選中{{ num }}條數據，請確定後進行操作？",
  "data.cleared": "清空數據後將無法恢復，確定清空？",
  "selected.operation": "選中操作",
  "all.operation": "全部操作",
  "more.operation": "更多操作",
  "no.data.selected": "沒有選擇任何數據",
  "not.started": "未開始",
  "over": "已結束",
  "calendar.default.mode": "日歷默認模式",
  "filter.color.settings": "數據篩選顏色設置",
  "set.data.source": "請設置數據源表",
  "set.field": "設置字段",
  "table.menu.bar": "數據表菜單欄",
  "sheet.menu.bar": "數據表菜單設置",
  "report.menu.bar": "報表菜單欄",
  "add.report.operation.menu": "添加報表操作菜單",
  "scheduled.tasks": "計劃任務",
  "module.setting.timing": "根據設置定時執行功能插件",
  "new.edited.cloudApp": "(新建或者編輯計劃任務必須要重啟雲應用才會生效)",
  "restart.app": "重啟雲應用",
  "selecting.source": "沒有選擇數據源，無法配置擴展功用",
  "extensions": "擴展功能",
  "map": "地圖",
  "data.selection": "數據多選",
  "raw.data": "原始数据",
  "view.raw.data": "查看原始数据",
  "view.raw.data.tip": "查看图表的原始数据，当数据来源为数据视图/聚合表的时候，当前属性无效",
  "data.menu.sticky": "數據菜單凍結",
  "data.menu.sticky.tip": "隻數據列寬度超過數據表寬度的時候，數據菜單凍結才會生效",
  "mobile.not.support": "移動端不支持數據多選功能",
  "report.type": "報表類型",
  "chart.linkage.settings": "圖表自定義聯動設置",
  "modifying.data.source.tip": "修改數據來源設置會清空已有的字段配置和條件過濾等選項，是否確認修改？",
  "add.data.source2": "添加數據源",
  "first.data.source": "請先添加數據源",
  "report.permissions": "報表權限",
  "source.before.permissions": "請選擇數據源表後再進行報表權限設置",
  "dimension.length": "{{ name }}只支持{{ len }}個維度，不能再添加更多維度",
  "indicator.length": "{{ name }}只支持{{ len }}個指標，不能再添加更多指標",
  "report.menu.settings": "報表菜單設置",
  "field.exists.recycle": "字段別名重復(字段存在字段回收站中)",
  "alias.empty.saving": "字段別名同壹表單下唯壹，如果沒有設置別名或者設置為空，則別名為默認，保存表單後生效",
  "function.module.settings": "功能擴展設置",
  "select.module.used.tip": "功能插件與後端事件同時只能觸發壹種，請根據實際需要選擇。按鈕觸發事件與二維碼生成功能以及掃碼功能以及三者不能同時使用。",
  "backend.event": "後端事件",
  "data.assistant": "數據助手",
  "module.interface.settings": "插件接口設置",
  "pop.report.settings": "彈出報表設置",
  "pop.form.settings": "彈出表單設置",
  "print.doc.settings": "打印文檔設置",
  "linkage.formula.converted": "字段內包含數據聯動/公式編輯，無法轉換",
  "formula.converted": "字段內包含公式編輯，無法轉換",
  "otherData.converted": "字段內選項來源於其他表單數據/包含數據聯動，無法轉換",
  "widget.option.associations.converted": "字段內包含選項關聯，無法轉換",
  "flow.started.tip": "已開啟流程，流程中的操作權限以節點設置為準",
  "excel.import.tip": "從excel導入數據",
  "focus.trigger": "焦點觸發",
  "button.trigger": "按鈕觸發",
  "set.reminder.content": "請設置提示內容",
  "message.empty.triggered": "提示消息為空的情況下，不會觸發彈出提示框",
  "subform.data.title": "子表單數據標題",
  "mobile.only.title": "子表單在移動端單行數據的標題，同壹個子表單字段同時只能設置壹個",
  "set.data.title": "設置為數據標題",
  "button.name": "按鈕名稱",
  "fill.button.name": "請填寫按鈕名稱",
  "event.button.characters": "事件按鈕名稱不能大於{{ len }}個字符",
  "reminder.box.displayed": "是否顯示提醒框",
  "reminder.title": "提醒標題",
  "fill.reminder.title": "請填寫提醒框標題內容",
  "mode": "模式",
  "list.mode": "列表模式",
  "editable.mode": "可編輯模式(僅移動端有效)",
  "process.decision": "流程決策",
  "unprocessed": "未處理",
  "pass": "通過",
  "refuse": "拒绝",
  "flow.current.node": "流程當前節點",
  "flow.current.person": "流程當前負責人",
  "data.association.table": "數據關聯表",
  "current.form": "當前表單的",
  "linkage.displayed.as": "聯動顯示為",
  "association.table": "關聯表的",
  "corresponding.value": "中對應值",
  "linkage.trigger.field": "數據聯動條件必須有壹個當前表單的字段做為觸發字段",
  "linkquery.trigger.field": "关联条件必须有一个当前表单的字段做为触发字段",
  "select.linked.sub": "請選擇子表單的聯動字段",
  "widget.width.takes": "字段寬度占整行的",
  "related.conditions": "關聯條件限定",
  "HH.mm": "時分",
  "HH.mm.ss": "時分秒",
  "scan.code.QR": "掃碼和二維碼",
  "scan.code.QR.tip": "掃描二維碼或者條形碼，掃碼功能與二維碼生成功能以及按鈕觸發事件三者不能同時使用。",
  "generate.code.QR": "是否允許生成二維碼",
  "button.text": "文本",
  "button.text.tip1": "文本修改失敗，",
  "association.form.settings": "關聯表單設置",
  "Current.Form": "[當前表單]",
  "association.form": "關聯表單",
  "decimal.allowed": "允許小數",
  "height": "高度",
  "height.according.content": "根據內容自適合高度",
  "other.at.bottom": "其他選項位於底部",
  "other.sort.field": "排序字段",
  "other.sort.mode": "排序規則",
  "other.sort.waterMark": "請選擇需要排序的字段",
  "fill.current.time": "填寫當前時間",
  "current.time": "當前時間",
  "yyyy.MM.time": "年月",
  "show.detailed.address": "顯示詳細地址",
  "automatic.trigger.positioning": "自動觸發定位",
  "uploading.multiple.pictures": "允許上傳多張圖片",
  "wechat.service.dingding": "該功能僅對微信企業號/服務號和釘釘移動客戶端有效",
  "Picture.Preview": "圖片預覽",
  "picture.hovering": "是否允許鼠標懸停在圖片上的時候，預覽大圖。預覽圖片大小範圍，最小100*100像素，最大1200*1200像素",
  "Real-time.preview.width": "實時預覽寬度",
  "Real-time.preview.pixels": "實時預覽寬度，最小值不能小於{{ minNumber }}像素，最大值不能超過{{ maxNumber }}像素",
  "Real-time.preview.height": "實時預覽高度",
  "multiple.file.uploads": "允許多文件上傳",
  "sub.empty.notLinkage": "子表單字段為空，不能設置數據聯動",
  "sub.freeze": "子表單凍結",
  "Before.freeze": "PC端凍結前",
  "Before.freeze.mobile": "移動端凍結前",
  "Subform.data.loading": "子表單數據加載",
  "data.loading.enabled": "是否開啟數據加載",
  "sumEmpty.loading.enabled": "子表單字段為空，不能開啟數據加載",
  "data.loading.settings": "數據加載設置",
  "Formula.Trigger": "公式觸發",
  "note.depend": "子表單導入數據完成後，公式將自動執行",
  "sub.data.loading.settings": "子表單數據加載設置",
  "LINE": "線條",
  "Popup.report": "彈出報表",
  "Form.report": "彈出表單",
  "Form.print": "打印文檔",
  "Form.download": "打包下載",
  "button.color": "顏色",
  "added.no.more": "{{ name }}已經添加{{ num }}個指標，不能再添加更多維度",
  "added1.no.more": "{{ name }}已經添加{{ num }}個維度，不能再添加更多指標",
  "only.add.dimensions": "最多只能添加2個維度",
  "dimensions.address.view": "編輯界面只取數據源前200條作為查詢數據預覽，完整數據請訪問頁面查看。",
  "only.preview.positioning": "維度只支持地址、定位字段",
  "basic.report": "基礎報表",
  "analysis.report": "分析報表",
  "no.source.conditions": "所有圖表都沒有添加數據源，無法添加篩選條件",
  "no.source.conditions2": "當前報表中沒的篩選條件，無法直接添加篩選按鈕",
  "mobile.style": "移動佈局",
  "set.filterButton.style": "設置篩選按鈕屬性",
  "chartData.automatically.loaded": "圖表數據自動加載",
  "chartData.automatically.loaded.tip": "當篩選按鈕字段關閉自動加載數據選擇後，所有圖表數據的加載必須通過點擊篩選按鈕才能觸發數據加載功能",
  "no.indicator.data": "暫無指標數據",
  "no.data.perspective": "透視圖暫無數據",
  "field.color.setting": "字段顯色設置",
  "field.color": "字段顏色",
  "show.name": "顯示名稱",
  "picture.realTime.preview": "圖片實時預覽設置",
  "is.picture.realTime.preview": "是否開啟圖片實時預覽",
  "Real-time.preview.pixels.height": "實時預覽高度，最小值不能小於{{ minNumber }}像素，最大值不能超過{{ maxNumber }}像素",
  "is.editable": "是否可編輯",
  "is.preview.time": "是否實時預覽",
  "Mobile.data.header": "移動端數據標題",
  "deling": "(已刪除)",
  "field.default.value": "設置當前表字段值為篩選條件的默認值",
  "current.form1": "當前表單",
  "field.only.sub-form": "顯示字段只支持壹個子表單",
  "alias.only.saving.tip": "別名同壹報表下唯壹,如果沒有設置別名或者設置為空,則別名為默認,保存報表後生效",
  "data.color.tip": "在數據表中可以根據選擇字段的內容條件不同，顯示對應的的顏色標識。顏色條件標識字段最多只能設置壹個",
  "sort.field.set.tip": "數據表默認按數據的的創建時間進行倒序排序,當設置排序字段後，將用新的字段排序創建時間的排序規則",
  "shift.time.field.tip": "排班時間字段中，第壹個字段為排班開始時間，第二個字段為排班結束時間。為確保移動端的排班表呈現效果，數據表中的日期字段格式請選擇日期時間",
  "shift.corresponding.field": "排班行表頭對應字段",
  "calendar.field.tip": "在日歷表中可以根據選擇字段的內容條件不同，顯示對應的的顏色標識。顏色條件標識字段最多只能設置壹個",
  "setting.trigger.tip": "設置將觸發_reportevent 事件,會將當前坐標,手動標記的坐標,搜索的坐標,當前的數據項,定位激活的數據項傳給後端處理",
  "number.type.circle": "數字類型,以位置字段為中心,設置的字段值為該坐標的輻射半徑",
  "map.type.latLon": "用於在地圖上面標點的字段,可選擇定位字段或文本字段,文本字段格式為(緯度,經度)",
  "login.expired.again": "登錄狀態過期，請重新登錄",
  "action.bar.style": "操作欄樣式",
  "operation.menu.tip": "普通操作菜單中，圖標與文字只能同時存在壹種樣式",
  "Text": "文字",
  "Icon": "圖標",
  "operation.icon": "操作圖標",
  "icon.color": "圖標顏色",
  "action.bar.name": "操作欄名稱",
  "action.bar.name.tip": "請輸入操作欄名稱，最多5個字符",
  "action.bar.name.tip1": "操作欄名稱不允許重復",
  "action.bar.name.msg": "操作欄名稱，最多5個字符",
  "action.bar.name.color": "操作欄名稱顏色",
  "name.color": "名稱顏色",
  "hint": "提示語",
  "enter.prompt": "請輸入提示語",
  "refresh.mode": "刷新模式",
  "not.refresh": "不刷新",
  "whole.table.refresh": "整表刷新",
  "whole.table.custom": "刷新指定表",
  "whole.table.custom.form": "選擇要刷新的圖表",
  "multi.select.operation": "多選操作",
  "multi.all.operation": "多選操作+全部操作",
  "operation.mode": "操作模式",
  "select.docking.mode": "請選擇對接模式",
  "enable.batch.selection": "是否開啟批量選擇",
  "open.all.operations": "是否開啟操作全部",
  "drop.selection.form": "請下拉選擇表單",
  "drop.selection.report": "請下拉選擇報表",
  "open.prompt.box": "是否開啟提示框",
  "Click.Settings": "(點擊設置)",
  "set.content.prompt": "請設置提示的內容",
  "set.operation.field": "設置操作表單的字段值",
  "report.source.data": "報表源數據",
  "set.filter.reports": "設置彈出報表的篩選條件",
  "exist.select.reports": "報表不存在，請重新選擇新的報表",
  "filters.available.reports": "報表沒有可用篩選條件",
  "menu.name.empty": "菜單名稱不允許為空",
  "menu.name.repeated": "菜單名稱不允許重復",
  "must.selected.report": "當前為報表彈出模式，必須選擇壹個報表",
  "must.selected.form": "當前為表單彈出模式，必須選擇壹個表單",
  "linkable.charts": "可聯動的圖表",
  "select.charts.linked": "請選擇需要聯動的圖表",
  "set.charts.linked": "設置圖表聯動的條件",
  "current.report": "當前報表",
  "add.linkage.conditions": "請添加聯動條件",
  "select.association.chart": "請選擇壹個自定義關聯圖表",
  "set.associated.chart": "請設置自定義關聯圖表的條件",
  "field.sorting": "字段排序",
  "data.before": "條件的數據前",
  "supports.positive.integers": "僅支持1-500000正整數",
  "add.sorting.field": "添加排序字段",
  "calculated.field.name": "計算字段名稱",
  "unnamed.data.view": "未命名數據視圖",
  "unnamed.data.helper": "未命名數據助手",
  "view.saved.successfully": "數據視圖保存成功",
  "data.view.design": "數據視圖設計",
  "data.helper.design": "數據助手設計",
  "nodes.view.processes": "當前數據視圖存在孤立節點或孤立流程",
  "input.view.output": "當前數據視圖沒有輸入/輸出節點",
  "calculated.field": "計算字段",
  "original.name": "原名：",
  "group.field.name": "分組節點配置字段名稱",
  "according.fields.sheet": "按單張表中的指定字段進行排序操作。",
  "enhanced.controls": "增強字段",
  "department.member.controls": "部門成員字段",
  "click.set.member": "點擊設置成員",
  "fieldAlias.modification.failed": "字段別名修改失敗，",
  "button.width.unit": "寬度(單位:px)",
  "button.width.tip": "在PC端，字段的寬帶與表單的整體布局相關，字段布局占帶寬1/2時，最大寬度為350px，其他布局最大寬度為720px",
  "button.mode": "模式",
  "department.by": "由部門字段確定",
  "restricted.field.conditions": "關聯字段條件限定",
  "add.related.conditions": "添加關聯條件",
  "modified.form.tip": "您修改了表單設計但沒有保存，是否需要保存並繼續？",
  "modified.module.tip": "您修改了插件設計但沒有保存，是否需要保存並繼續？",
  "module.development.title": "插件設計 - 功能插件開發",
  "module.development.title.source": "插件源碼 - 功能插件開發",
  "condition.setting": "條件設置",
  "qualified.data.flow": "符合條件的數據流轉到下壹節點",
  "form.link1": "表單鏈接",
  "form.link1.fill": "通過表單鏈接可以直接填寫當前表單",
  "created.form.invited": "我創建了表單，邀請大家來填寫！-",
  "external.chain.list": "擴展外鏈列表({{ extParams }})",
  "value.already.exists": "該值已存在",
  "extensionField.value.empty": "擴展字段或者值不能為空",
  "copy.external.link.tip": "外鏈復制成功",
  "normal.form": "普通表單",
  "flow.event.form": "流程事件表單",
  "form.type.switching": "表單類型切換",
  "widget.recycle.bin": "字段回收站",
  "widget.properties": "字段屬性",
  "widget.sn.only": "表單只能添加壹個流水號字段",
  "deleted.widget.tip": "若刪除該字段，其對應的表單數據也會被清除。確定刪除？",
  "deleted.widget.tip2": "當前字段配置了索引，無法直接刪除。若要刪除，請先刪除該字段的索引。",
  "update.tip": "您當前使用的版本不包含字段回收站功能，您可以至會員中心查看版本使用詳情和升級版本。",
  "form.edit.tip": "表單別名修改失敗，",
  "widget.none.tip": "字段被隱藏時，不改變該字段的原有值",
  "widget.none.tip1": "字段被隱藏時，該字段提交空值",
  "widget.none.tip2": "字段的計算、提交邏輯，與沒有隱藏時保持壹致",
  "form.alias": "表單別名",
  "form.alias.tip": "表單別名同壹應用下唯壹，如果沒有設置別名或者設置為空，則別名為默認，修改即生效",
  "form.sub.tip": "表單初始化，提交，編輯，刪除時觸發的功能插件或後端腳本設置",
  "form.sub.tip1": "表單初始化，提交，編輯，刪除時觸發的功能插件設置",
  "form.initialization": "表單初始化",
  "form.submission.data": "表單提交數據",
  "form.edit.data": "表單編輯數據",
  "form.other.properties": "表單其他屬性",
  "save.data": "保存數據",
  "allow.submission.data": "允許提交數據",
  "form.data.cache": "表單數據緩存",
  "form.data.cache.all.field": "緩存全部字段",
  "form.data.cache.field": "緩存指定字段",
  "record.user.source": "記錄用戶來源",
  "interview.method": "訪問方式",
  "interview.type": "訪問類型",
  "operating.system": "操作系統",
  "interview.IP": "訪問ip",
  "visitor.browser.type": "訪問者瀏覽器類型",
  "hidden.widget.assignment": "隱藏字段賦值",
  "hidden.widget.tip": "對表單中需要隱藏的字段根據業務需要設置被隱藏字段的值的處理方式",
  "trigger.form.event": "觸發_form事件",
  "event.form.communicate": "當前表單為事件表單，可與應用通信",
  "module.setting.layout": "插件設置界面布局",
  "show.loading.animation": "顯示加載動畫",
  "show.loading.animation.tip": "當字段觸發功能插件的時候，是否顯示加載狀態動畫（如果功能插件執行需較長時間，建議開啟，可以改善用戶體驗）。",
  "module.setting": "插件設置",
  "pre.trigger": "前置觸發",
  "post.trigger": "後置觸發",
  "pre.trigger.run": "前置執行",
  "post.trigger.run": "後置執行",
  "show.multiple.labels": "顯示多標簽",
  "close.multiple.labels": "請確認是否關閉多標籤？",
  "close.multiple.labels.tips": "多標籤關閉後，標籤頁中所有分段將按分段順序放回表單中",
  "flow.status.log": "查看許可權",
  "allow.view.status.log": "允許查看流程狀態/日誌",
  "allow.view.status.comment": "允許查看評論",
  "flow.decision.tip": "開啟流程決策之後，在移動端流程數據查看的時候，會顯示流程通過/拒絕，顯示審批的標題可以自行定義，最多支持6個字符",
  "flow.decision.switch": "流程決策開關",
  "passed.title": "通過標題",
  "approved": "審批通過",
  "fill.passed.title": "請填寫通過標題內容",
  "fill.rejected.title": "請填寫拒絕標題內容",
  "decision.passed.title": "決策通過標題",
  "decision.rejected.title": "決策拒絕標題",
  "rejected.title": "拒絕標題",
  "approval.rejected": "審批拒絕",
  "close.flow": "關閉流程",
  "close.flow.tip": "流程關閉後已經在流轉的數據將終止流轉，新提交的數據將不進入流程。",
  "save.flow.tip": "當前流程未保存，是否確定關閉？",
  "use.form.flow": "使用表單流程",
  "open.formFlow.workflow": "開啟表單流程，設置流轉條件搭建工作流",
  "flow.cond2": "流轉條件",
  "print.template": "打印模版",
  "print.template.create.online": "創建在線模式",
  "print.template.create.word": "創建Word模式",
  "print.op.log": "打印日誌",
  "field.index": "字段索引",
  "module.release": "插件发布",
  "module.icon": "插件圖標",
  "module.type": "插件類型",
  "module.image.size": "*建議圖片文件大小200KB以內，高寬100*100像素",
  "module.business.scenario": "插件業務場景",
  "module.business.scenario.tip": "*添加新的插件業務場景，請聯系在線客服處理",
  "whole.website.installation": "全站安裝",
  "this.website.installationUse": "本站安裝使用",
  "whole.website.installationUse": "全站安裝使用",
  "publishing.check.valid": "發布時勾選才有效",
  "module.description": "插件描述",
  "module.description.URL": "插件描述網址",
  "save.information": "保存信息",
  "module.save.tip": "插件描述網址格式不正確",
  "publish.module": "發布插件",
  "publish.module.set.tip": "插件發布時必須設置插件類型",
  "publish.module.set.tip2": "插件發布時必須設置業務場景",
  "publish.module.set.tip3": "插件描述網址格式不正確",
  "publish.module.set.tip4": "插件中心已經有在審核中的版本，請確認是否覆蓋正在審核中的版本？",
  "data.sub.tip": "有新數據提交時{{ tipName }}提醒",
  "set.reminders": "點擊設置提醒對象",
  "Email.submitted.tip": "有新數據提交時郵件提醒",
  "update.success1": "更新成功",
  "field.index.tip": "最多創建十個索引，組合索引最多支持三個，每個組合索引最少支持兩個最多支持三個字段",
  "printing.form.tip": "打印表單時將按照使用中的模版格式打印",
  "server.address": "服務器地址：",
  "push.time": "推送時間：",
  "delete.operation.tip": "刪除操作不可逆，是否確認刪除？",
  "reminder.time": "提醒時間：",
  "reminder.condition": "提醒條件：",
  "reminder.method": "提醒方式：",
  "Email1": "郵件",
  "expand.external.link": "擴展外鏈",
  "this.year": "今年",
  "last.seven.day": "過去七天",
  "reminder.set.tip": "您的提醒設置未保存，確定離開當前頁面？",
  "reminder.set.tip1": "您的提醒內容設置未保存，確定離開當前頁面？",
  "new.scheduled.task": "新建計劃任務",
  "up.planning.modules": "當前賬戶最多只能安裝{{ num }}個任務計劃插件",
  "schedule.task.module": "計劃任務插件：",
  "schedule.task.type": "計劃任務類型：",
  "schedule.task.type1": "計劃任務類型",
  "timed.execution": "定時執行",
  "repeat.execution": "重復執行",
  "loop.execution": "循環執行",
  "task.execution.time": "任務執行時間：",
  "task.execution.last.start": "上次執行時間：",
  "task.execution.last.end": "上次結束時間：",
  "task.execution.last.msg": "上次執行結果：",
  "single.execution": "單次執行",
  "execution.everyDay": "每天 ",
  "until.end": " 執行，直到 ",
  "end.of": " 結束 ",
  "execution.day": "日 ",
  "execution.interval": " 執行間隔 ",
  "execution.minutes": " 分鐘，",
  "execution.hour": " 小時，",
  "execution.day1": " 天，",
  "total.execution": " 總共執行 ",
  "unlimited.execution": " 不限制次數執行",
  "schedule.task.settings": "計劃任務設置",
  "schedule.task.name": "計劃任務名稱",
  "schedule.task.save.tip": "您的計劃任務設置未保存，確定離開當前頁面？",
  "new.index": "新建索引",
  "singleColumn.index": "單列索引",
  "composite.index": "組合索引",
  "index.mode": "索引模式：",
  "field.type1": "字段類型：",
  "common.field": "普通字段",
  "index.subform": "子表單-",
  "index.field": "索引字段：",
  "set.index": "設置索引",
  "new.print.template": "新建打印模版",
  "del.print.tip": "妳確定要刪除此模版嗎？刪除此模版後，原先使用此模版的位置將會使用默認打印模版來打印表單。",
  "upgrade.package.tip": "如需要使用此功能請升級您的套餐",
  "backEnd.return.value": "後端返回值",
  "copy.link.address": "復制外鏈地址",
  "create.type.tip": "請選擇您要創建的表單類型，開啟應用搭建",
  "create.form.tip": "新建表單：用於數據提交，數據收集，帶數據管理功能",
  "create.flowForm.tip": "新建流程表單：用於流程審批，申報，通知等場景",
  "create.report.tip": "新建報表：用於數據管理，匯總計算，趨勢分析等場景",
  "create.etl.tip": "數據視圖：用於對數據進行多表關聯，匯總，分組排序計算",
  "form.recycle.bin": "表單回收站",
  "form.report": "表單/報表",
  "department.id": "部門id",
  "not.configured": "未配置",
  "configur.invalid": "配置失效",
  "s.alias": "的別名",
  "backEnd.virtual.form": "後端虛擬表單",
  "field.setting.field": "字段設置節點配置字段",
  "current.view.nodes": "當前數據視圖已有{{ title }}節點",
  "view.nodes.name": "數據視圖節點名稱",
  "search.function.module": "請搜索您的功能插件",
  "search.data": "搜索数据",
  "new.function.module": "新建插件",
  "back.top.module": "回到功能插件列表頂部",
  "empty.module.tip": "沒有任何功能插件，馬上動手添加壹個吧",
  "prompt": "提示：",
  "empty.module.tip2": "您暫時沒有插件功能",
  "version": "版本：",
  'search.all': '搜索全部',
  'search.field': '搜索特定字段',
  'search.flow': '搜索流程信息',
  "del.tip": "妳確定要刪除嗎？",
  "alias.error.tip": "別名同壹報表下唯壹，如果沒有設置別名或者設置為空，則別名為默認，保存報表後生效",
  "nothing.error.tip": "還沒有任何待辦要處理",
  "nothing.error.tip1": "還沒有參與任何流程",
  "has.timed.out": "已經超時",
  "file": "文件",
  "file.wordtemplate": "word模板文件",
  "file.upload.wordtemplate.warning.tip": "請上傳word模板文件",
  "select1": "請選擇",
  "click.drag.image": "點擊或拖拽上傳圖片",
  "button2": "按　鈕",
  "click.select.data": "選擇數據",
  "my.todo.status": "我的待辦狀態",
  "processed": "已處理",
  "process.status": "流程狀態",
  "no.data.table": "數據表暫無數據",
  "not.query.data.tip": "沒有符合條件的數據",
  "del.data.tip": "數據刪除操作不可逆，是否確認刪除此數據？",
  "formula.field": "公式字段",
  "enter.field.alias": "請輸入字段別名",
  "duplicate.field.alias": "字段別名重復",
  "drag.field.tip": "拖動左側字段到此處來添加篩選條件",
  "add.filter.field": "請先添加篩選條件字段。",
  "filter.condition.setting": "篩選條件設置",
  "filter.condition.relationship": "設置篩選條件與當前表字段關系",
  "filter.condition.filled": "當選擇具體數據後，將按如下規則填充數據",
  "source.table.display": "數據源表顯示",
  "add.operation.menu": "添加操作菜單",
  "Menu.Bar": "菜單欄：",
  "go.configuration": "【去配置】",
  "operation.menus": "最多只能添加{{ num }}個操作菜單",
  "menus": "菜單",
  "add.linkage.chart": "添加自定義聯動圖表",
  "add.chart.tip": "當前圖表沒有設置數據來源，無法添加圖表自定義聯動",
  "no.chart.available": "沒有可用的圖表",
  "add.quick.query": "添加快速查詢",
  "ordinary.form.switch": "普通表單：用於數據提交,數據收集,帶數據管理功能",
  "flow.form.switch": "流程表單：用於流程審批,申報,通知等場景",
  "event.form.switch": "事件表單：普通表單+開啟後端腳本能力",
  "eventFlow.form.switch": "流程事件表單：流程表單+開啟後端腳本能力",
  "print.template.settings": "打印模版設置",
  "print.template.settings.tip1": "文檔存入附件字段",
  "print.template.settings.tip2": "選擇存入的附件字段",
  "print.template.settings.tip3": "是否展示文檔下載頁面",
  "print.template.settings.tip4": "打印校驗字段",
  "print.template.settings.tip41": "(生成打印文件前,需要效驗哪些字段的必填和格式屬性)",
  "print.template.settings.tip5": "選擇需要校驗的字段",
  "add.permission.group": "添加自定義權限組",
  "system.printing.template": "系統打印模版",
  "custom.print.template": "自定義打印模版",
  "understanding.print.templates": "了解打印模版",
  "custom.print.name": "填寫自定義權限組名稱",
  "Sure1": "確　定",
  "view.data.fields": "可查看數據那些字段",
  "page": "{{ val }} 條/頁",
  "department.heads": "-部門主管",
  "node.alias.failed": "節點別名修改失敗",
  "node": "節點",
  "node.alias": "節點別名",
  "node.alias.tip": "節點別名同壹流程表單下唯壹，如果沒有設置別名或者設置為空，則別名為默認，保存流程表單後生效",
  "node.alias.tip2": "沒有下級節點的節點會自動連接至流程結束節點；如果您需要在中途結束流程，請將需要結束流程的節點，連接到流程結束節點，並設置相應的流轉條件。",
  "node.permissions": "節點權限",
  "departments.CC": "包含抄送人下級子部門",
  "node.print.template": "節點打印模版",
  "approval.operation": "對表單操作後可填寫審批意見",
  "approval.operation.tip": "用戶在處理流程時點擊此按鈕，將保存用戶在此節點中對數據的更改，流程數據視圖轉至後續節點。",
  "allow.fallback.to": "允許回退到",
  "members.transfer.to": "轉交成員可選範圍",
  "flow.module": "流程插件",
  "cannot.triggered": "功能插件或者後端事件不能同時觸發",
  "flow.briefing": "流程簡報",
  "bulk.export": "批量導出",
  "bulk.move": "批量移動",
  "enterprise.user.id": "企業內用戶ID",
  "have": "有",
  "not.join": "名成員未加入，",
  "invite.again": "再次全部邀請",
  "move.tip": "請選擇需要移動部門的團隊成員",
  "jobtitle.set.tip": "請選擇需要設置職稱的團隊成員",
  "enterprise.tip": "組織架構中企業成員的唯壹賬號",
  "enterprise.tip1": "企業內成員的唯壹標識，企業內可修改，企業內不可重復，推薦用於工號設置",
  "security.policy": "不受安全策略限制",
  "security.policy1": "受安全策略限制",
  "bulk.removal": "批量移除",
  "add.Security.Group": "添加安全組",
  "IP.restrictions": "IP限制",
  "Accessible.IP.settings": "可訪問IP設置",
  "not.Security.Group": "您還沒有創建安全組",
  "IP.address": "IP地址：",
  "team.invitation": "團隊邀請",
  "mine": "@我的",
  "all.news": "全部消息",
  "unread.message": "未讀消息",
  "read.message": "已讀消息",
  "mark.all.read": "全部標為已讀",
  "del.all.read": "刪除全部已讀消息",
  "System.reminder": "系統提醒",
  "Email.reminder": "郵箱提醒",
  "Set.recipient": "設置接收人",
  "add.recipient": "添加接收人",
  "recipient.management": "消息接收人管理",
  "unread1": "條未讀)",
  "Auto.Start": "自動啟動",
  "application.review": "應用審核中",
  "following.set.tip": "請勾選下面內容進行設置~",
  "page.sharing": "頁面共享",
  "cross.application": "跨應用",
  "custom.menu": "自定義菜單",
  "Application.publishing": "應用發布",
  "select.app.tip": "請先在左邊選擇應用~",
  "workbench.mode": "工作臺模式",
  "traditional.list": "傳統列表",
  "Jiugongge.list": "九宮格列表",
  "menu.information": "菜單信息",
  "del.menu": "刪除菜單",
  "name.menu": "菜單名稱",
  "icon.menu": "菜單圖標",
  "mode.menu": "菜單模式",
  "name.menu.tip": "建議菜單名稱3-4個字符，以免影響美觀",
  "icon.menu.tip": "請在系統圖標庫中選擇對應圖標",
  "form.view": "表單查看",
  "flow.toDo": "流程待辦",
  "flow.toDo.tip": "流程待辦模式，可以直接處理當前應用所有需要處理的流程事務。",
  "workbench.tip": "工作臺，展示所有的表單信息，可以根據需要按列表或者九宮格模式展示。",
  "system.icon.library": "系統圖標庫",
  "view.mode.tip": "查看模式，可以直接進行數據提交或者查看報表具體數據信息。",
  "view.mode.tip1": "查看模式下，數據提交、報表數據查看，不受任何權限影響，完全公開。",
  "del.menu.tip": "刪除後{{ name }}菜單下設置的內容將被刪除",
  "app.brief": "應用簡介",
  "app.brief.isempty": "應用簡介不能為空",
  "app.baleing": "應用打包中",
  "app.version": "應用版本：",
  "Cloud.app.backend": "雲應用後端：",
  "log.content": "日誌內容",
  "log.time": "日誌時間",
  "select.operator": "請選擇操作人",
  "select.operator.type": "請選擇操作類型",
  "Fuzzy.match.search": "模糊匹配搜索",
  "Creation.time": "創建時間：",
  "shut.accidentally": "意外關閉自動重啟：",
  "Running": "運行中...",
  "NotRunning": "未運行",
  "Stop.backend.services": "停止後端服務",
  "Start.backend.services": "啟動後端服務",
  "Application.URL.tip": "自定義應用URL, 可使用URL直接打開該應用",
  "Application.URL": "應用URL",
  "update.management": "更新管理",
  "Token.management": "Token管理",
  "Token.Access": "訪問token",
  "Token.Access.tip": "妳確定要凍結此訪問token？凍結後此訪問token的請求都會失效！",
  "Token.Access.tip1": "妳確定要解凍此訪問token？",
  "Token.Generate": "生成token",
  "Token.Generate1": "生成Token",
  "quantity.Generate": "生成數量",
  "normal": "正常",
  "thaw": "解凍",
  "Freeze": "凍結",
  "Set.notes": "設置備註",
  "Visit.link": "訪問鏈接",
  "Set.Token.access": "設置Token訪問備註",
  "Remarks.32.words": "備註不能超過32個字",
  "Post.link.words": "post接口訪問鏈接：",
  "copy.Post.link.tip": "post接口訪問鏈接復制成功",
  "Form.creation": "表單創建",
  "enter.URL": "請自定義輸入url",
  "all1": "<全選>",
  "new.Management.Group": "新建管理組",
  "batch.Import": "批量導入",
  "Role.ID": "角色ID",
  "Role.New": "新建角色",
  "del.department": "刪除部門",
  "Download.tip": "樣表格式規範如下：",
  "Download.title": "批量導入角色",
  "Download.btn1": "下載表樣",
  "Download1": "1、下載表樣，按照表樣格式進行填寫。",
  "Download2": "2、表格中只需要第壹行中有帶“賬號”的列，系統會自動識別。",
  "Download3": "3、批量導入最大數據500條。",
  "del.tip1": "刪除成員會同時刪除該成員權限，此操作不可逆。是否確認刪除已選定成員？",
  "prompt1": "提示",
  "Export.tip": "導出{{ name }}所有成員嗎",
  "Export.success": "導出成功",
  "Export.failed.tip1": "沒有數據，導入失敗",
  "remove.user.tip1": "請選擇需要移除的成員",
  "Normal.mode": "普通模式",
  "enterprise.userID": "企業用戶id",
  "invite.Download1": "1.導入賬號直接生效",
  "invite.Download.title": "下載樣表「樣表文件格式」",
  "invite.Download2": "1.下載表樣，不能增加、刪除或修改本Excel表的成員信息類別，不填的留空即可。",
  "invite.Download3": "2.手機、姓名為必填，手機區號、企業內用戶ID、部門、角色、郵箱為選填。",
  "invite.Download4": "3.部門格式為：上下級部門間用‘/’隔開，且從最上級部門開始，例如“總公司/長沙分部”；多個部門之間用英文‘,’隔開。",
  "invite.Download5": "4.部門為空，格式錯誤默認頂級部門。不存在的部門自動創建，不存在角色自動創建。",
  "invite.Download6": "5.批量導入最大數據200條。信息有誤的成員不導入，如有超出，請分為多個文件導入。",
  "invite.Download7": "6.手機號作為唯一值，如果存在則修改其他字段信息。",
  "invite.Download9": "7.免激活模式的密碼規則：6位到18位，不填寫則默認為：123456  郵箱在免激活模式下有效。",
  "max.length.12": "最長12個字符",
  "max.length.16": "最長16個字符",
  "max.length.32": "最長32個字符",
  "max.length.64": "最長64個字符",
  "phone.tip1": "填寫正確的手機號，會短信通知邀請",
  "phone.email.tip1": "填寫正確的郵箱地址，會接收到郵箱通知邀請",
  "enterprise.tip2": "建議使用員工工號等與公司統壹的id",
  "del.member.tip2": "請選擇需要刪除的團隊成員",
  "ip.tip2": "請檢查IP是否填寫錯誤",
  "ip.tip3": "刪除安全組將無法還原，確定刪除？",
  "ip.name": "安全組名稱",
  "select.application": "請選擇應用",
  "select.form": "請選擇表單",
  "select.form1": "選擇表單",
  "Data.management.export": "數據管理導出",
  "Attachment.bulk.export": "附件批量導出",
  "report.table.export": "新報表-數據表導出",
  "report.perspective.export": "新報表-透視圖導出",
  "Installation.package.export": "安裝包導出",
  "type.export": "請選擇導出類型",
  "ing.export": "導出準備中",
  "download.export": "可下載",
  "status.export": "請選擇狀態",
  "time.export": "操作時間",
  "name.export": "應用/表單名稱",
  "operating.instructions": "操作說明",
  "record.export.tip": "暫無導出記錄",
  "no.data.tip": "目前還沒有任何數據",
  "Upload.installation.package": "上傳安裝包",
  "select.app.module": "選擇應用模板",
  "Import.installation.package": "導入安裝包",
  "Name.in.team": "團隊姓名",
  "to.be.verified": "待驗證",
  "setting.recipient.title": "通知設置-接收人管理",
  "Recharge.status": "充值狀態",
  "noRecharge.tip": "您還沒有未支付訂單",
  "more.module": "多插件",
  "more.module.tip": "多插件執行可支撐個數",
  "more.datahelper": "數據助手",
  "more.datahelper.tip": "數據助手執行可支撐個數",
  "form.link.style": "表單外鏈自定義樣式",
  "CrossApp.access": "跨應用取數",
  "sys.num": "系統版本號",
  "sumb.num.tip": "是否立即提交訂單",
  "sumb.type": "訂單類型：",
  "buy.type": "購買套餐",
  "r.type": "續費套餐",
  "u.type": "升級套餐",
  "tip.type": "您當前使用的版本無法使用導出附件功能，如有需要，請升級套餐。",
  "logo.del": "外鏈去除logo",
  "Expire.date": "到期時間：",
  "del.btn.date": "刪除訂單",
  "del.btn.tip": "是否刪除此訂單",
  "Total.payable": "應付總額",
  "upload.size": "上傳附件大小",
  "more.module.run": "多插件執行",
  "sumb.type1": "訂單類型",
  "sumb.time": "訂單時間",
  "remaining.time": "剩余時間",
  "select.log.type": "請選擇日誌類型",
  "select.log.type1": "出票中",
  "select.log.type2": "團隊日誌",
  "select.log.type3": "個人日誌",
  "select.log.type4": "添加/刪除普通管理組",
  "select.log.type5": "添加/刪除系統管理員",
  "select.log.type6": "添加/刪除成員",
  "select.log.type7": "子管理員組權限分配",
  "select.log.type8": "清理應用數據",
  "select.log.type9": "綁定/解綁企業微信",
  "select.log.type10": "綁定/解綁微信",
  "select.log.type11": "企業微信的成員同步",
  "select.log.type12": "修改手機號",
  "select.log.type13": "綁定/解綁釘釘",
  "change.email": "換綁郵箱",
  "bing.registered.account": "綁定註冊賬號",
  "code.not.empty": "驗證碼不能為空",
  "bind.new.email": "綁定新郵箱",
  "bind.new.phone": "綁定新手機",
  "code.sent.to": "驗證碼已發送至",
  "wrong.input.enter": "手機號或郵箱輸入有誤？重新輸入",
  "create.data.view": "新建數據視圖",
  "set.alias": "設置別名",
  "last.refresh": "最後刷新：",
  "refresh.rule": "刷新規則",
  "repetition.cycle": "重復周期",
  "column.name": "列名：",
  "column.name1": "列名",
  "alias.name1": "別名：",
  "alias.set": "別名設置",
  "column.name1.tip": "表示的是數據視圖輸出字段標題原名。",
  "alias.name1.tip": "別名同壹數據視圖下唯壹，別名命名規範",
  "alias.name1.tip2": "只能中文、數字和字母下劃線組成的32個字符以內。",
  "alias.name1.tip3": "如果沒有設置別名,則別名為默認別名。",
  "new.data.tip": "當前是最新數據",
  "refreshing.tip": "正在刷新，請稍等...",
  "new.time.tip": "循環刷新：每{{ time }}小時刷新壹次",
  "data.view.noInput": "當前視圖沒有輸出表",
  "data.view.error1": "數據視圖刷新失敗，請檢查數據視圖設置",
  "data.view.error2": "數據視圖未保存輸出節點字段信息",
  "refresh.data.view": "刷新視圖列表",
  "data.view.del1": "刪除數據視圖後，該數據視圖的輸出錶也會壹並被刪除，刪除的數據無法還原",
  "data.view.tip": "數據視圖可對壹個或多個數據源進行關聯、聚合、追加合並等操作，形成輸出表。\n 您可在報表中將輸出表作為數據源使用。",
  "refresh.rule.tip1": "當視圖的輸入源表單有變動時，會在設定的時間間隔內重繪為最新資料，報表和表單調用時會調用最近一次視圖重繪的數據",
  "refresh.rule.tip12": "適合場景：計算的及時性要求不高，分析類業務使用",
  "refresh.rule.tip13": "不適合場景：需要及時計算的場景",
  "refresh.rule.tip2": "會定時在天/周/月/年的某天某個時間刷新數據，報表和表單調用時會調用最近壹次的視圖刷新的數據。壹般用於大數據量時，周期性匯總分析時使用",
  "refresh.rule.tip22": "適合場景：定期數據更新的場景",
  "refresh.rule.tip3": "及時重繪模式會在數據視圖在訪問時計算最新的數據並返回，訪問的場景包含報表展示、數據聯動、後端腳本査詢等",
  "refresh.rule.tip32": "適合場景：常規的業務數據計算場景",
  "refresh.rule.tip33": "不適合場景：大數據計算的分析場景",
  "cycle.interval": "循環間隔",
  "data.view.alias": "數據視圖別名",
  "refresh.log": "刷新日誌",
  "refresh.log.tip": "（及時刷新不進日誌，循環刷新和重復刷新進日誌）",
  "sso.tip": "應用於企業賬號URL",
  "permission.page.tip": "無權限訪問此頁",
  "my.team.name": "我的團隊名稱",
  "how.untie.WeChat": "怎樣解綁企業微信授權？",
  "bills.details.tip": "請核對清楚開票信息，再確認",
  "bills.details.tip2": "擡頭（名稱）不能為空！",
  "bills.details.tip3": "納稅人識別號不能為空！",
  "bills.details.tip4": "收件人姓名不能為空！",
  "bills.details.tip5": "收件人聯系方式不能為空！",
  "bills.details.tip6": "收件人郵箱地址或地址不能為空！",
  "bills.details.tip7": "開票提交成功，是否查看開票記錄",
  "bills.details.tip8": "繼續開票",
  "bills.details.tip9": "請選擇需要合並開票的訂單！",
  "Total.data": "總數據：",
  "Expired": "已到期",
  "renewal.duration": "續費時長",
  "gift.time": "贈送時間",
  "discounted.price": "優惠金額",
  "vip.renewal": "會員版續費",
  "vip.buy": "會員版購買",
  "Advisory.Service": "咨詢客服",
  "Free.forever": "永久免費使用",
  "other.configure": "其他配置：",
  "vip.function": "會員功能：",
  "Import.excel.size": "導入excel大小",
  "Remove.LOGO.external": "外鏈去logo",
  "buy.webApi.tip": "（需要單獨購買,3000元/年）",
  "Advanced.Features": "高級功能：",
  "No.Advanced.Features": "沒有高級功能",
  "Independent.server.storage": "獨立服務器存儲",
  "Independent.IP": "獨立ip",
  "domain.name": "域名(自定義)",
  "domain.name.Logo": "網站名和Logo(自定義)",
  "bind.name.public": "綁定企業公眾號",
  "Service.level": "服務等級：",
  "All.apps.available": "可使用全部應用",
  "Service.time": "服務時間：",
  "Weekdays.time": "工作日 09:00-17:30",
  "Weekdays.weekends": "工作日 09:00-17:30；雙休日 10:00-17:00",
  "Alipay": "支付寶支付",
  "WeChat.payment": "微信支付",
  "Default.package": "默認套餐",
  "edit.avatar": "編輯頭像",
  "upload.avatar": "上傳本地圖片",
  "Choose.package": "選擇套餐",
  "Click.details": "（點擊詳情）",
  "Website.Terms": "《網站服務條款》",
  "Legal.Privacy": "《法律聲明及隱私權政策》",
  "Package.contents": "套餐內容",
  "Total.paid": "實付總額",
  "paid.tip1": "通過創建視圖，添加數據處理方式來對已有數據進行分析，同時還可調用數據",
  "paid.tip2": "滿足企業內多人管理平台平臺及企業內部分工明確的需求",
  "paid.tip3": "用來整合平台數據與任何外部數據",
  "Add.content": "加購內容",
  "release.title": "發布新報表",
  "Edit.Security.Group": "編輯安全組",
  "associated.control.settings": "選項關聯字段設置",
  "Set.multiple.conditions": "設置多個關聯條件限定關聯數據",
  "Watch.video.started": "觀看公式入門視頻",
  "Watch.video.Advanced": "觀看公式進階視頻",
  "Current.table.field": "當前表字段",
  "add.subform.field": "添加子表單字段",
  "Be.included": "被包含",
  "Current.field": "當前字段",
  "Linkage.table.field": "聯動表字段",
  "subordinate.department.Contains": "包含負責人下級子部門",
  "pushmsg.department.Contains": "包含被提醒人下級子部門",
  "no.flow.log": "當前沒有流程日誌",
  "Select.file.tip": "當前套餐不包含批量導入成員，",
  "Select.file.tip2": "您是否要立即升級？",
  "no.department.widget": "表單中沒有部門字段",
  "module.title1": "分類：",
  "module.title2": "安裝次數：",
  "module.title3": "暫無說明",
  "module.title4": "說明：",
  "module.title5": "已加載全部",
  "flow.create.n2": "發起流程",
  "Import.data.img": "導出數據能否帶圖片",
  "Import.user": "批量導入成員",
  "form.scheduled.num": "表單計劃任務個數",
  "replace.bound.phone": "更換綁定手機",
  "Invited": "已邀請",
  "unactivated": "未激活",
  "Editable.details": "可編輯詳情",
  "Non-editable.details": "不可編輯詳情",
  "Title": "職稱",
  "Phone": "手機：",
  "EMAIL": "郵箱：",
  "Status": "狀態：",
  "Account": "帳號：",
  "Invited.tip1": "成員沒有綁定手機號，無法進行邀請",
  "Invited.tip2": "是否再次邀請手機號為{{ mobile }}的用戶",
  "Invited.tip3": "發送邀請成功",
  "dept.tip": "子管理員權無法操作管理員權限面板",
  "add.dept.tip": "添加子部門成功",
  "dept.name": "部門名稱",
  "edit.role.name": "修改角色名稱",
  "dept.show.user": "顯示子部門成員",
  "Test.account": "測試賬號",
  "role.import.tip": "表樣格式錯誤，無法導入，請檢查或重新下載",
  "edit.Management.Group.tip": "修改普通管理組名稱",
  "edit.dept.name": "修改部門名稱",
  "department.ID": "部門ID",
  "form.data1": "表單數據",
  "phone.scan.signature": "手機掃碼添加簽名",
  "my.dept": "我的部門",
  "none.dept": "隱藏子部門成員",
  "pay.tip": "請確認是否支付此套餐？",
  "invite.Download8": "1.導入賬號需要激活",
  "select.node.tip": "請先選擇《當前節點》",
  "Set.quick.query": "設置快速查詢名稱",
  "Set.enter.query": "請輸快速查詢名稱",
  "empty.app.tip": "點擊此處創建應用，或直接從應用中心安裝現有的成熟應用",
  "Invited.all.tip": "是否再次邀請全部未加入成員",
  "unbind.wechat.tip": "解除當前賬號綁定關系嗎？",
  "sn.config.tip": "僅當計數達到最大值時，從初始值開始重新計數。",
  "sn.config.tip2": "每日00:00:00，自動從初始值重新開始計數。壹天內如果計數達到最大值，從初始值開始重新計數。",
  "sn.config.tip3": "每周壹00:00:00，自動從初始值重新開始計數。壹周內如果計數達到最大值，從初始值開始重新計數。",
  "sn.config.tip4": "每月首日00:00:00，自動從初始值重新開始計數。壹月內如果計數達到最大值，從初始值開始重新計數。",
  "sn.config.tip5": "每年首日00:00:00，自動從初始值重新開始計數。壹年內如果計數達到最大值，從初始值開始重新計數。",
  "Excel.title.tip": "上傳的 Excel 表符合以下規範：",
  "Excel.title.tip2": "請使用",
  "Excel.title.tip3": "標準模版",
  "Excel.title.tip4": "導入數據",
  "Excel.title.tip5": "數據不能超過{{ limit }}行,最多只允許導入{{ limit }}行",
  "Excel.title.tip6": "僅支持 (*.xls 和 *.xlsx) 文件",
  "Excel.title.tip7": "文件大小不超過{{ size }}MB",
  "Excel.title.tip8": "文件中數據不能超過50000行、150列(子表單明細同樣占用行數)",
  "Excel.title.tip9": "導入數據中如果包含圖片字段，則文件數據行數不能超過{{ line }}行、150列",
  "Excel.title.tip10": "從最新數據開始",
  "Excel.title.tip11": "從最早數據開始",
  "Excel.title.tip12": "導出數據中圖片總大小不能超過 {{ max }}M<br>",
  "Excel.title.tip13": "帶圖片導出的excel文件大小會記錄到上傳總流量統計中",
  "Excel.title.tip14": "帶圖片導出",
  "Excel.title.tip15": "不帶圖片導出",
  "Excel.title.tip16": "可直接導出全部數據",
  "Excel.title.tip17": "壹次只能導出{{ limit }}條數據",
  "Excel.title.tip18": "開始數據編號",
  "Excel.title.tip19": ",數據數量",
  "Excel.title.tip20": "若勾選「導入的數據觸發流程」，則最多允許導入300條數據",
  "Excel.title.tip21": "子表單不參與數據更新",
  "clean.data.tip": "可清空的數據為有權限刪除的數據，清空後將無法恢復，確定清空？",
  "index.title.tip": "索引名稱",
  "index.title.tip2": "請輸入此索引的名稱",
  "index.title.tip3": "索引模式",
  "index.title.tip4": "未設置索引名稱",
  "index.title.tip5": "索引設置名稱",
  "index.title.tip6": "索引字段",
  "index.save.tip": "您的索引設置未保存，確定離開當前頁面？",
  "switch.form.type.tip": "切換為非事件表單，雲應用交互將不可用，是否確認切換？",
  "switch.form.type.tip1": "切換為事件表單，數據提交會與雲應用交互，是否確認切換？",
  "switch.form.type.tip2": "切換為{{ text }}，是否確認切換？",
  "switch.form.type.tip3": "事件表單，數據提交會與雲應用交互",
  "switch.form.type.tip4": "普通表單，流程相關功能將不可用並且雲應用交互將不可用",
  "switch.form.type.tip5": "流程事件表單，數據管理權限設置將不可用並且數據提交會與雲應用交互",
  "switch.form.type.tip6": "流程表單，數據管理權限設置將不可用",
  "schedule.name.tip1": "(計劃任務名稱必須唯壹)",
  "schedule.Untitled.task": "未命名的計劃任務",
  "schedule.time": "未設置執行時間",
  "schedule.time1": "執行時間不能小於當前時間",
  "schedule.time2": "未設置星期幾執行",
  "schedule.time3": "未設置具體執行時間",
  "schedule.time4": "結束時間不能小於當前時間",
  "schedule.time5": "未設置循環次數",
  "schedule.time6": "未設置插件接口",
  "schedule.time7": "未設置插件接口參數",
  "schedule.time8": "未設置數據助手",
  "schedule.tip": "（日期和時間必須大於當前日期時間，才會生效）",
  "schedule.tip1": "（0表示無限循環執行，不會停止）",
  "schedule.tip2": "重復次數",
  "schedule.tip3": "重復間隔時間，不能小於30分鐘",
  "report.edit.tip": "編輯界面只取數據源前200條作為查詢數據預覽，完整數據請訪問頁面查看。",
  "filter.add.tip": "請添加篩選條件",
  "filter.Default.tip": "添加字段",
  "filter.add.report": "報表的",
  "field.add.report": "字段值",
  "report.menu": "報表操作菜單",
  "phone.email.tip": "請輸入正確的郵箱或手機",
  "money.tip": "請輸入正確的充值金額",
  "zifu.tip": "請輸入正確的字符",
  "flow.title": "待辦流程",
  "exit.login": "退出登錄",
  "switch.team": "切換團隊",
  "waiting": "等待 ",
  "processing": " 的處理",
  "arrival.time": "到達時間：",
  "flow.num": "流程編號",
  "detailed.data": "詳細數據",
  "display.show": "展開",
  "log.show": "... 展開",
  "Record.data": "添加記錄",
  "etlEmpty.tip": "當前沒有任何數據視圖，請點擊此處創建數據視圖",
  "Province": "省份",
  "City": "城市",
  "Province.City.county": "省/自治區/直轄市",
  "print.no.tip": "您還沒有為此表單創建過打印模版",
  "create.print.tip": "創建自定義打印模版",
  "add1": "新增",
  "report.menu1": "數據表操作菜單",
  "mobile.sumb": "提交並關閉",
  "mobile.dept1": "無效部門",
  "mobile.no.user": "無成員",
  "mobile.loading.more": "點擊加載更多...",
  "mobile.user.set": "角色設置",
  "mobile.user.adds": "批量添加成員",
  "mobile.user.removes": "批量刪除成員",
  "mobile.no.user.tip": "當前沒有成員，請先添加！",
  "mobile.user.phone": "共{{ num }}個聯系人",
  "mobile.user.select": "請選擇成員！",
  "mobile.ok.len": "確定({{ len }})",
  "mobile.ok.pc": "還有沒有角色，請在PC端新建，移動端只支持角色成員管理哦！",
  "mobile.ok.user.tip": "角色是什麽？在組織架構之外的更加靈活便捷的業務組，適用於無差別的跨部門協作任務和流程審批等場景\n",
  "mobile.user.dept": "當前用戶所在部門",
  "mobile.user.move": "批量移動成員",
  "mobile.user.creater.del": "創建者不能刪除",
  "mobile.manage": "管理",
  "mobile.Synchronized": "同步成功",
  "mobile.Synchronized.user": "同步成員",
  "mobile.manage.set": "管理組設置",
  "mobile.Search": "搜索：",
  "mobile.account.no.tip": "當前賬號無權限，請聯系系統管理開通權限！",
  "mobile.Search.no.user": "找不到“{{ cont }}”相關的聯系人",
  "mobile.no.user.ind": "還沒有聯系人，請邀請同事加入吧",
  "mobile.edit.user": "編輯成員信息",
  "mobile.user.cont": "成員信息",
  "mobile.no.more": "沒有更多了",
  "mobile.user.ind": "邀請同事",
  "mobile.flow.data": "流程數據",
  "mobile.num": "請輸入數字",
  "mobile.cont": "請選擇內容",
  "mobile.read.all": "全部標記為已讀",
  "not.used.template": "此模版未被任何位置使用",
  "Template.use.range": "模版使用範圍",
  "dept.or.user": "部門或成員",
  "Custom.permission.group": "自定義權限組",
  "pay.mode.title": "支付方式：",
  "System.Administrator.Group": "系統管理員組",
  "Del.agg.table": "刪除聚合表",
  "Del.agg.table.tip": "請確認是否刪除聚合表{{ name }}，此操作不可逆",
  "Public.access": "公開權限",
  "delete.recycle.bin": "是否徹底刪除回收站中選中的字段",
  "delete.recycle.filed": "請選擇需要刪除的字段",
  "delete.recycle.bin.tip": "字段徹底刪除之後，對應的數據會壹起刪除。不可恢復",
  "flow.node.tip": "僅顯示啟用中流程的節點，其他版本的節點打印模版，請到該節點屬性中設置。",
  "recover.are.tip": "確定恢復",
  "all.data.tip": "所有數據？",
  "del.are.tip": "確定徹底刪除",
  "select.data.tip": "選中{{ len }}條數據，{{ cont }}？",
  "recover.fail.tip": "恢復失敗",
  "recover.field.title": "是否恢復回收站中選中的字段",
  "recover.field.msg": "字段恢復之後，對應的數據會恢復正常訪問",
  "recover.field": "請選擇需要恢復的字段",
  "token.tip": "訪問Token鏈接",
  "Trigger.formula": "觸發公式：",
  "add.data.mode": "數據添加模式：",
  "Append.mode": "追加模式",
  "Overlay.mode": "覆蓋模式",
  "select.Excel": "選擇Excel表",
  "sub.set": "子表單設置",
  "dept.move.tip": "部門調整成功",
  "note.depend.tip": "當數據填充完成後，公式將自動執行",
  "del.widget.recycle.tip": "是否徹底刪除回收站中所有的字段",
  "background": "背景顏色",
  "dept.move.tip1": "部門調整失敗",
  "set.background.tip": "設置字段背景顏色顯示條件",
  "set.noAuthority.tip": "當前沒有可以設置的操作權限",
  "Add.extended.fields": "添加擴展字段",
  "set.extended.fields": "設置多個擴展字段",
  "title.State": "標題狀態",
  "mobile.back.app": "返回應用主頁",
  "mobile.msg.tip1": "請聯系應用管理員，設置關聯表單屬性。",
  "mobile.msg.tip2": "請聯系應用管理員，設置關聯表單的數據來源。",
  "mobile.msg.tip3": "請聯系應用管理員，設置關聯表單的顯示字段。",
  "mobile.msg.tip4": "請聯系應用管理員，設置關聯表單的字段的對應關系。",
  "mobile.msg.tip5": "請選擇要加載的數據",
  "mobile.msg.tip6": "當前選擇數據量已超過子表單最大數據限制，請重新選擇",
  "mobile.msg.tip7": "事件觸發失敗",
  "mobile.msg.tip8": "角色名不能為空",
  "mobile.msg.tip9": "是否刪除角色",
  "mobile.msg.tip10": "沒有選擇任何成員",
  "mobile.msg.tip11": "是否刪除角色？",
  "mobile.msg.tip12": "角色名不能超過32個字",
  "mobile.msg.tip13": "簽名保存成功",
  "mobile.msg.tip14": "簽名保存失敗，請及時聯系平台官方技術人員處理",
  "mobile.msg.tip15": "添加員工",
  "mobile.msg.tip16": "創建部門成功",
  "mobile.msg.tip17": "請部門昵稱不能為空",
  "mobile.msg.tip18": "刪除部門會將部門所關聯的權限壹並刪除，此操作不可逆。是否確認刪除此部門？",
  "mobile.msg.tip19": "提交失敗，找不到下個節點負責人。流程已暫存至「我的待辦」中，請聯系管理員檢查節點負責人後重新提交。",
  "mobile.msg.tip20": "提交失敗，不符合流轉條件。流程已暫存至「我的待辦」中，請聯系管理員檢查流轉條件後重新提交。",
  "mobile.msg.tip21": "回退失敗，找不到回退後的負責人。流程已暫存至「我的待辦」中，請聯系管理員檢查節點負責人後重新提交。",
  "mobile.msg.tip22": "提交失敗，不符合子流程節點流入條件。流程已暫存至「我的待辦」中，請聯系管理員檢查節點負責人後重新提交。",
  "api.error4014": "有批量操作進行中，當前操作被拒絕",
  "api.error4003": "當前套餐不包含此功能",
  "api.error4005": "套餐用量超出限制",
  "api.error4006": "插入數據失敗,後端代碼返回錯誤：",
  "api.error4007": "圖片大小超過套餐內允許的大小",
  "api.error4010": "數據插入成功,後端代碼返回錯誤：",
  "api.error4015": "當前操作只支持團隊模式為普通模式",
  "api.error4016": "企業內用戶ID格式不正確,只能字母,數字,下劃線32位內",
  "api.error4017": "企業內用戶ID已存在",
  "api.error4018": "備註格式不正確，32位以內",
  "api.error4019": "職稱格式不正確，16位以內",
  "api.error4020": "姓名格式不正確，只能中文,英文,數字,下劃線,(,),-,空格,空格不能在頭尾26位以內",
  "api.error4021": "部門參數不能為空",
  "api.error4022": "站點不允許註冊用戶",
  "api.error4023": "部門名稱格式不合法，只能中文,英文,數字,下劃線,(,),-,空格,空格不能在頭尾16位以內",
  "api.error4024": "同級部門下存在同名子部門",
  "api.error4025": "父部門不存在",
  "api.error4026": "部門編號不合法",
  "api.error4027": "部門編號重復部門編號重復",
  "api.error4028": "存在子部門的部門不能被刪除",
  "api.error4029": "存在成員的部門不能被刪除",
  "api.error4030": "單次導入部門數量超出限制",
  "api.error4031": "部門級聯層數超出限制",
  "api.error4032": "部門關系存在循環",
  "api.error4033": "至少需要壹個子部門屬於根部門",
  "api.error4034": "單次導入成員數量超出限制",
  "api.error4035": "企業內用戶ID重復",
  "api.error4046": "批量創建數據超過100條限製",
  "api.error4047": "管理員不能刪除",
  "api.error5001": "返回參數不為json格式",
  "api.error5002": "執行進程開啟失敗",
  "api.error5003": "獲取源文件失敗",
  "api.error5004": "腳本對象創建失敗",
  "api.error5005": "讀取腳本失敗",
  "api.error5006": "_webapi函數不存在",
  "api.error5007": "腳本運行出錯",
  "api.error6001": "角色組不存在",
  "api.error6002": "role_no已存在",
  "api.error6003": "角色組創建錯誤",
  "api.error6004": "角色組修改錯誤",
  "api.error6005": "角色組刪除錯誤",
  "api.error6006": "添加失敗",
  "api.error7001": "外部聯系人分組不存在",
  "api.error7002": "分組名稱不符合規則",
  "api.error7003": "和已有分組重名",
  "api.error7004": "分組重復",
  "api.error7005": "默認分組不可刪除",
  "api.error7006": "分組有成員未刪除",
  "api.error7007": "外部聯系人已存在",
  "api.error7008": "修改外部聯系人信息異常",
  "api.error7009": "用戶已在通訊錄成員，不能加入外部聯系人",
  "api.error7010": "添加外部聯系人不存在失敗",
  "api.error8001": "企業創建者不能加入任何管理組",
  "api.error8002": "管理組名稱不符合規則",
  "api.error8003": "系統管理員不能移出",
  "api.error8004": "已在其他分組",
  "api.error8005": "管理組已存在",
  "api.error10001": "應用分組創建失敗",
  "api.error10002": "應用分組重命名失敗",
  "api.error10003": "應用分組名稱不符合規則",
  "api.error10004": "應用分組不存在",
  "api.error10005": "應用分組刪除失敗",
  "api.error10006": "表單不存在",
  "api.error11001": "數據重復",
  "api.error11002": "不允許轉交",
  "api.error11003": "唯一字段對應的數據已存在",
  "api.error12001": "消息發送失敗",
  "api.error12002": "消息內容錯誤",
  "api.error12003": "未匹配到合法的消息接收者",
  "api.error13001": "密鑰不存在",
  "api.error13002": "當前套餐不包含平臺級接口權限",
  "api.error13003": "團隊信息不正確",
  "api.error13004": "贈送失敗",
  "api.error13005": "賬號不存在",
  "api.error13006": "應用安裝失敗",
  "Sharer.information": "分享人信息",
  "Installer": "安裝者信息",
  "successfully.imported": "您成功導入了1條數據到表單[Unnamed form]中",
  "Download": "立即下載",
  "batch.edit": "批量修改後無法撤銷，請謹慎操作:",
  "no.repeat": "設置不允許重復值的字段不支持修改:",
  "don't.support.batch": "文件字段、分割線、關聯查詢、關聯數據、定位字段不支持修改。",
  "edit.log": "查看修改記錄",
  "select.data.opreate": "請選擇需要打印的數據",
  "no.edit.log": "無記錄",
  "Node.dealing": "節點處理截止時間",
  "node.arrived": "流程到達節點",
  "After": "之後",
  "limit-time.action": "如何設置限時處理？",
  "Action.method": "處理方式",
  "Auto-notify.time": "自動提醒時間",
  "action.detail": "自動處理詳情",
  "post.Code": "Post接口",
  "post.Code.tip": "以下接口路徑中的app_id表示應用ID，可以前往會員中心的API文檔進行查看。",
  "post.Code.tip1": "POST /api/v2/app/{app_id}/post -post接口",
  "post.Code.tip2": "能自定義傳入json結構數據，將傳入的數據發送給後端事件 _webapi，返回自定義json結構數據",
  "post.Code.tip3": "請求數據樣例：",
  "post.Code.tip4": "_webapi事件原型",
  "post.Code.tip5": "自定義傳入的json結構數據，轉為內部可使用的數組格式",
  "post.Code.tip6": "附加信息，目前只包含ip信息",
  "post.Code.tip7": "_webapi事件接收和返回樣例：",
  "post.Code.tip8": "自定義返回值",
  "post.Code.tip9": "自定義返回消息",
  "text.mode": "文本模式",
  "text.mode.text": "文本",
  "text.mode.password": "密碼",
  "winxin.write": "請在手機微信中掃碼填寫此表單",
  "copy.form.link": "複製表單鏈接",
  'No.WeChat.public.account.configured': '當前系統未啟用微信掃碼登陸，無法開啟微信增強功能',
  "view.data": "數據查看",
  "widget.map": "地圖",
  "widget.card": "卡片",
  "widget.position": "位置",
  "switch.report.type.tip": "切換場景類型將會清空該報表所有設置，請確認是否進行此操作？",
  "switch.report.type": "切換此場景報表類型為：",
  "map.menu.bar": "地圖表菜單欄",
  "sheet.map.menu.bar": "地圖表菜單設置",
  "add.mapScope": "添加輻射半徑",
  "add.mapScope.tip": "數字類型，用於地圖上位置字段的有效範圍的半徑設置，以位置字段為中心，設置的字段值為半徑的圓圈範圍顯示",
  "Nulllable": "不回寫",
  "manualMarker": "手動標記點回寫",
  "selectMarker": "搜索框標記點回寫",
  "geolocationMarke": "當前位置標記點回寫",
  "FunctionBtn.tip": "設置將觸發_reportevent 事件，會將當前坐標，手動標記的坐標，搜索的坐標，當前的數據項，定位激活的數據項傳給後端處理",
  "mapButton.tip": "用於顯示操作按鈕，點擊觸發動作，配置回寫類型以後會把配置的標點坐標回寫到當前數據項的[地圖位置字段]中",
  "select.loc.tip": "搜索定位中心",
  "select.loc.list": "詳情列表",
  "LAL.set.title": "坐標設置",
  "map.scale.title": "默認比例尺",
  "map.set.coordinates": "設置坐標",
  "scenes.set.tip": "*只能選擇壹種類型",
  "map.biaoshi": "地圖標識",
  "map.menu1": "地圖表操作菜單",
  "map.data.num": "共{{num}}條數據",
  "map.no.num": "當前表單內沒有數字字段",
  "click.view.credentials": "點擊查看憑證",
  "userVip.up.tip": "請選擇升級或者續費",
  "app.install.tip2": "安裝成功,返回應用管理",
  "app.install.tip3": "安裝成功，3秒後返回應用管理",
  "app.install.tip4": "安裝該應用需要密碼，請輸入密碼：",
  "app.install": "安裝",
  "del.Auth.tip": "刪除權限組將無法還原，確定刪除？",
  "formula.urlencode.intro": "URLENCODE函數可以將文本內容使用進行URL進行編碼",
  "formula.urlencode.usage": "URLENCODE(text)",
  "formula.urlencode.example": "URLENCODE(文本)返回 %E6%96%87%E6%9C%AC",
  "formula.urlencode1.intro": "URLDECODE函數可以URLENCODE()函數編碼過的內容進行解碼",
  "formula.urlencode1.usage": "URLDECODE(text)",
  "formula.urlencode1.example": 'URLDECODE("%E6%96%87%E6%9C%AC")返回 文本',
  "formula.ISNAN.intro": 'ISNAN函數判斷參數是否為特殊的非數字值NaN',
  "formula.ISNAN.usage": 'ISNAN(邏輯表達式1)',
  "formula.MD5.intro": '文本字符串的MD5值',
  yearTitle: "年",
  monthTitle: "月",
  "add.data": "追加數據",
  "cover.data": "覆蓋數據",
  "import.data.tip": "您成功導入了{{len}}條數據到子表單中",
  "subform.import.data.tip": "子表單數據導入中",
  "entry.other.text": "請輸入其他文本內容",
  "setFields.max.length": "最多添加{{ len1 }}個,已選<span>{{ len2 }}</span>個",
  "edit.field": "修改字段",
  "edit.field.empty.tip": "修改字段內容為空，會清空該字段的中符合條件的值，請確認是否需要修改",
  "install.module.tip": '請確認是否安裝插件"{{name}}"嗎？',
  "del.module.tip": '請確定是否刪除插件"{{name}}"？',
  "del.datahelper.tip": '請確定是否刪除插件"{{name}}"？',
  "datahelper.output.field.only": '至少保留一個字段，做為主表字段',
  "install.module": "插件安裝",
  "update.module": "* 檢測到插件有新版本可更新 *",
  "update.module.version": "更新版本",
  "no.flow.tip": "還沒有任何流程要處理",
  "set.flow.tip": "請在流程設定中啟用流程，然後為流程節點設置打印模版",
  "open.flow.fail": "啟用流程版本失敗！",
  "open.flow.update": "流程已啟用，如需增刪節點和連線，請添加新版本",
  "open.flow.overdue": "歷史版本不可增刪節點和連線，如需增刪節點和連線，請切換至設計中的版本，或添加新版本",
  "left.form.select": "請選擇左側表",
  "left.form.field": "左側當前表字段",
  "right.form.field": "右側當前表字段",
  "right.form": "右側表單",
  "left.form": "左側表單",
  "left.relation.form": "左側關聯表",
  "right.relation.form": "右側關聯表",
  "left.form.drag": "請從左側表單列表拖選壹個表單/報表",
  "left.form.click": "點擊左側菜單進行編輯操作",
  "left.form.select.type": "左側表單可選字段類型",
  "right.form.select.type": "右側表單可選字段類型",
  "left.form.noSelect.type": "左側表單字段類型限制",
  "right.form.noSelect.type": "右側表單字段類型限制",
  "relation.form.source.mode": "關聯表來源模式",
  "left.form.source.mode": "左側表字段來源模式",
  "del.field.fictitious": "刪除此虛擬字段",
  "free.no.export": "免費版不支持帶附件/圖片導出excel",
  "image.no.upFlow": "帶附件/圖片匯出會計算上傳流量",
  "current.data": "（當前數據）",
  "map.btn.tip": "用於顯示操作按鈕,點擊觸發動作,配置回寫類型以後會把配置的標點坐標回寫到當前數據項的[地圖位置字段]中",
  "field.fictitious": "虛擬字段",
  "add.field.fictitious.form": "添加虛擬表字段",
  "output.table": "輸出表",
  "select.address": "請選擇地址",
  "select.address.sub": "選擇地址",
  "select.date": "請選擇日期",
  "select.start.date": "請選擇起始日期",
  "select.end.date": "請選擇結束日期",
  "signature.entry.tip": "請在空白區域橫向書寫簽名",
  "linkageing.tip": "數據聯動中，請稍後再試",
  "entry.flow.tip": "請填寫流程審批意見..",
  "Approval.signature": "審批簽名",
  "Approval.signature.required": "審批簽名必填",
  "Collapse.all.details": "收起所有明細數據",
  "show.all.details": "展開所有明細數據",
  "data.all.show": "數據已全部顯示",
  "mobile.leave.page.tip": "離開頁面可能會丟失已填寫的數據，確定要離開頁面嗎？",
  "no.process.toMe.tip": "沒有抄送給我的流程",
  "initiated.process.yet.tip": "還沒有發起任何流程",
  "no.data.yet.tip": "沒有任何數據",
  "msg.all.read.tip": "消息已全部標為已讀",
  "set.filter.criteria": "設置篩選條件",
  "set.Custom.filtering": "自定義篩選",
  "select.no": "當前無選項",
  "click.set.read": "點擊置為已讀",
  "type.dian": "類型：",
  "Me": "我",
  "view.all.log": "查看所有日誌",
  "del.user.tip": "是否刪除成員？",
  "del.source.file.tip": "請確認是否刪除源文件{{ name }} 嗎？",
  "edit.field.fictitious.form": "編輯虛擬表字段",
  "flow.field": "流程字段",
  "successfully.uploaded": "憑證上傳成功",
  "entry.phone": "請輸入綁定手機號",
  "edit.user": "修改人：",
  "wechat.Bind": "微信綁定",
  "wechat.unBind": "微信解綁",
  "phone.replacement": "更換手機",
  "del.app.tip": "妳確定要刪除 “{{ name }}” 應用嗎？",
  "please.del.tip": "請確認是否刪除此條記錄",
  "account.Ordinary": "普通賬號",
  "recharge.less": "充值金額不能小於或等於零",
  "upload.transfer.voucher": "請上傳轉賬憑證",
  "upload.transfer.voucher2": "聯系人不能為空",
  "upload.transfer.voucher3": "手機號不能為空",
  "upload.transfer.voucher4": "打款賬戶名不能為空",
  "upload.transfer.voucher5": "打款賬戶號碼不能為空",
  "sys.num.tip": "當前系統版本號為{{num}}",
  "vip.time.tip": "會員版本從{{ sTime }}起至{{ eTime }}到期",
  "Currently.contains.tip": "當前包含",
  "vip.center.sys_manager1": "您的{{ name }}已達總量",
  "vip.center.sys_manager2": "您的{{ name }}已超過總量",
  "vip.center.sys_manager3": "您目前版本{{ name }}已超過總量，如需更多，請升級套餐",
  "vip.center.sys_manager4": "您目前版本{{ name }}已達到總量，如需更多，請升級套餐",
  "vip.center.sys_manager5": "您當前版本不支持{{ name }}配置，如有需要，請升級套餐",
  "vip.center.sys_manager6": "{{ name }}總個數為{{ num }}，如需配置更多{{ name }}，請升級套餐",
  "vip.center.sys_manager7": "您當前版本不支持{{ name }}配置，如有需要，請聯系管理員",
  "vip.center.sys_manager8": "{{ name }}總條數為{{ num }}，如需配置更多{{ name }}，請聯系管理員",
  "vip.center.excel": "導入單個Excel文件最大值為{{ num }}，如需導入更大的Excel文件，請升級套餐",
  "vip.center.upload": "單個上傳附件大小的最大值為{{ num }}，如需上傳更大的附件，請升級套餐",
  "vip.center.hszTime": "回收站數據保留時間最長為{{ num }}天，如需保留時間更長，請升級套餐",
  "vip.center.dont": "您當前版本不支持{{ name }}，如有需要，請升級套餐",
  "vip.center.yes": "您當前版本支持{{ name }}哦~",
  "vip.center.img": "導出數據帶圖片",
  "vip.center.style": "表單外鏈自定義樣式",
  "vip.center.module": "多插件執行可最多支撐個數為{{ num }}個，如需支持更多，請升級套餐",
  "vip.center.datahelper": "數據助手执行可最多支撑个数为{{ num }}个，如需支持更多，请升级套餐",
  "vip.center.scheduled": "表單計劃任務最多支持個數為{{ num }}個，如需支持更多，請升級套餐",
  "vip.center.call": "請聯系管理員",
  "vip.center.kefu": "請聯系官方客服",
  "LALdimension.length": "{{ name }}只支持{{ len }}個位置字段，不能再添加更多了",
  "Electronic.invoice": "電子發票",
  "Electronic.invoice.tip": "請填寫正確的手機號接收電子發票信息",
  "Electronic.invoice.tip2": "請填寫正確的郵箱地址接收電子發票信息",
  "Paper.invoice": "紙質發票",
  "email.address": "郵箱地址",
  "phone.entry.tip": "請填寫正確的手機號",
  "address.entry.tip": "請填寫正確的收件地址",
  "header.name": "擡頭（名稱）",
  "Taxpayer.Number": "納稅人識別號",
  "phone.address": "電話、地址",
  "Bank.account": "開戶行及賬號",
  "Recipient.address": "收件地址",
  "Contact.information": "聯系方式",
  "module.title.source": "插件源碼",
  "module.development.title.release": "插件設計 - 功能插件設置",
  "Cache.tip": "進入表單時，自動加載上次的填寫的內容。永久緩存，上次填寫的內容會實時更新，且不會消失。提交緩存，當數據提交後，上次的填寫內容緩存就會被清空",
  "navigation": "導航",
  "Shared.with": "共享給",
  "excel.export.tip": "有選擇圖片字段，請設置 [開始數據編號]",
  "excel.export.tip1": "有選擇圖片字段，請設置 [數據數量]",
  "excel.export.tip2": "有選擇圖片字段，[數據數量] 範圍只支持1-{{ num }}",
  "excel.export.tip3": "數據編號<a style='color:#F5222D'>從大到小</a>，開始編號為<a style='color:#F5222D'>{{ start }}</a>，結束編號為<a style='color:#F5222D'>{{ end }}</a>，總共<a style='color:#F5222D'>{{ count }}</a>條",
  "excel.export.tip4": "數據編號<a style='color:#F5222D'>從小到大</a>，開始編號為<a style='color:#F5222D'>{{ start }}</a>，結束編號為<a style='color:#F5222D'>{{ end }}</a>，總共<a style='color:#F5222D'>{{ count }}</a>條",
  "excel.export.tip5": "當前圖表數據來源為數據視圖",
  "excel.export.tip6": "開始數據序號",
  "excel.export.tip7": "有選擇圖片字段，請設置 [初始數據序號]",
  "excel.export.tip8": "有選擇圖片字段，請設置 [初始數據編號]",
  "excel.export.tip9": "數據編號範圍內沒有數據，請重新設置數據編號範圍",
  "excel.export.tip10": "數據開始序號為<a style='color:#F5222D'>{{ start }}</a>，結束序號為<a style='color:#F5222D'>{{ end }}</a>，總共<a style='color:#F5222D'>{{ count }}</a>條",
  "excel.export.tip11": "導入 Excel 數據到子表單",
  "excel.export.tip12": "excel文件超過{{ limit }}行數據，無法導入到子表單。請修改後重新導入",
  "excel.export.tip13": "excel文件中的數據包含合並單元，無法導入到子表單",
  "excel.export.tip14": "工作表名稱",
  "excel.export.tip15": "导入数据错误较多，請返回上壹步檢查字段類型，或在原excel中進行修改後再重新導入。如不修改，則錯誤數據導入後為空值",
  "excel.export.tip16": "當前通訊錄中匹配到以下姓名相同的成員，請修改成員姓名或者以“姓名(賬號)”的格式編輯excel數據後重新導入",
  "excel.export.tip17": "當前通訊錄中匹配到以下姓名與賬號不對應的的成員，請修改成員姓名或者以“姓名(賬號)”的格式編輯excel數據後重新導入",
  "excel.export.tip18": "當前通訊錄中匹配到以下部門名稱相同，請修改部門名稱後重新導入",
  "excel.export.tip19": "以下字段存在重複值的，請修改正確值之後重新導入",
  "excel.export.tip20": "以下字段存在空值的，請修改正確值之後重新導入",
  "excel.export.tip21": "當前導出附件/圖片大小 <a style='color:#F5222D'>{{ size }}M</a>，已經超過 <a style='color:#F5222D'>{{ max }}M</a> 的限制",
  "excel.export.tip22": "當前導出附件/圖片大小 {{ size }}M，導出附件/圖片的最大限制為 {{ max }}M",
  "excel.export.tip23": "當前圖表數據來源於聚合錶",
  "excel.export.error": "出錯啦",
  "excel.export.tip24": "工作簿为空，请调整后重新导入",
  "excel.export.tip25": "工作簿表头为空，请调整后重新导入",
  "date.today1": "今",
  "my.address": "我的位置：",
  "address.seach.empty": "未搜索到數據",
  "address.all.show": "全部顯示",
  "only.show1": "僅顯省/市/縣區",
  "only.show2": "僅顯省/市",
  "only.show3": "僅顯示省",
  "only.show4": "顯示行政級別",
  "only.show5": "開啟經緯度定位",
  "only.select.Map.address": "請選擇地址",
  "etl.update.tip": "正在更新數據視圖數據，更新完成後，圖表會自動刷新",
  "down.refresh": "下拉刷新",
  "append": "追加",
  "cover": "覆蓋",
  "release.refresh.data": "釋放刷新數據",
  "empty.form.tip": "這是壹張空表單",
  "administrator.no.permission": "子管理員無權限",
  "Member.moved.successfully": "成員移動成功",
  "Department.added.successfully": "添加部門成功",
  "Department.set.successfully": "設置部門成功",
  "move.members": "移動成員",
  "no.data.edit": "當前沒有數據可以編輯",
  "edit.set.department": "修改/設置部門",
  "team": "團隊",
  "new.department": "新建部門",
  "department.name.empty": "部門名不能為空",
  "department.name.del": "是否刪除部門 {{ name }} ？",
  "add.administrator": "添加管理員",
  "Select.application.edited": "選擇可編輯的應用",
  "Select.manageable.departments": "選擇可管理的部門",
  "Administrative.all.applications": "對所有應用的管理權限",
  "all.access.functions": "對所有功能權限",
  "all.administrative.members": "對所有成員的管理權限",
  "Application.added.successfully": "添加應用成功",
  "Administrator.added.successfully": "添加管理員成功",
  "Management.group": "管理組",
  "New.general.management.group": "新建普通管理組",
  "General.management.name.empty": "普通管理組名不能為空",
  "del.management.tip": "是否刪除普通管理組 {{ name }} ？",
  "add.role.tip": "請添加角色",
  "del.select.user.tip": "是否刪除選中成員？",
  "no.operational.data": "沒有可操作的數據",
  "Rename.role": "重命名角色",
  "phone.email.error.tip": "手機號碼/郵箱輸入有誤",
  "phone.email.invitation": "手機/郵箱邀請",
  "invitation.success": "邀請成功",
  "invitation.phone.tip": "通過手機號邀請非中國大陸成員用戶時，請在手機號前添加國際電話區號，例:+886912345689",
  "show.invited.members": "僅顯示已經邀請的成員",
  "invitation.phone.tip2": "輸入手機號或郵箱來邀請成員，多個成員之間用英文“,”隔開，或者換行輸入",
  "invitation.phone.tip3": "通過手機號邀請成員時，請先確保手機號綁定了平台賬號，否則無法接收到成員邀請消息。暫時不支持非大陸手機號綁定註冊賬號",
  "invitation.phone.tip4": "開啟邀請鏈接後，只需訪問此鏈接，即可加入您的團隊",
  "invitation.phone.tip5": "公開鏈接復制成功",
  "empty.form.report.tip5": "這是壹個空的表單/報表",
  "empty.report.tip6": "這是壹張空報表",
  "empty.report.tip7": "查看過濾條件",
  "empty.report.tip8": "應用名稱不正確",
  "empty.report.tip9": "請選擇最小值",
  "empty.report.tip10": "請選擇最大值",
  "empty.report.tip11": "請確認是否執行操作",
  "show.all": "顯示全部",
  "empty.report.tip12": "該文件類型不支持預覽",
  "empty.report.tip13": "最多只允許選擇{{ maxFileCount }}個文件",
  "empty.report.tip14": "選擇當前節點後，可以通過節點的可見字段來篩選流程數據",
  "empty.report.tip15": "篩選字段為空，請設置篩選字段",
  "empty.report.tip16": "過濾字段為空，請設置過濾字段",
  "empty.report.tip17": "請先選擇流程表單",
  "date.ago.hours": "{{value}}小時前",
  "date.ago.day": "{{value}}天前",
  "empty.report.tip18": "空空如也，這裏什麽都沒有耶",
  "empty.report.tip19": "當前沒有審批意見..",
  "empty.report.tip20": "流程已撤回",
  "empty.report.tip21": "流程已結束",
  "empty.report.tip22": "數據已提交",
  "empty.report.tip23": "請選擇回退節點",
  "empty.report.tip24": "是否確認結束流程",
  "empty.report.tip25": "轉交負責人不能為空",
  "empty.report.tip26": "請先選擇打印模板",
  "empty.report.tip27": "打印模板列表",
  "empty.report.tip28": "未找到打印模板，請聯系管理員確認流程節點是否設置打印模板",
  "empty.report.tip29": "打印({{ text }})",
  "empty.report.tip30": "系統模板",
  "empty.report.tip31": "打印(系統模板)",
  "empty.report.tip32": "操作狀態",
  "empty.report.tip33": "超時自動提交",
  "empty.report.tip34": "超時自動回退",
  "empty.report.tip35": "自動結束",
  "empty.report.tip36": "自動結束失敗",
  "empty.report.tip37": "抄送給：",
  "empty.report.tip38": "暫無筛选結果",
  "empty.report.tip39": "匿名",
  "flow.list.multiNode1": "-多個節點",
  "flow.list.multiNode2": "未知狀態",
  "flow.list.multiNode3": "沒有查詢到符合條件的流程",
  "flow.list.multiNode4": "請選擇打印模板",
  "flow.list.multiNode5": "結束成功",
  "flow.list.multiNode6": "請選擇需要激活的流程節點",
  "flow.list.multiNode7": "不支持選擇的圖片類型",
  "flow.list.multiNode8": "圖片上傳失敗",
  "flow.list.multiNode9": "最多只允許選擇{{ maxFileCount }}張圖片",
  "flow.list.multiNode10": "正在定位中...",
  "flow.list.multiNode11": "清空地址",
  "flow.list.multiNode12": "汽車服務|汽車銷售|汽車維修|摩托車服務|餐飲服務|購物服務|生活服務|體育休閑服務|醫療保健服務|住宿服務|風景名勝|商務住宅|政府機構及社會團體|科教文化服務|交通設施服務|金融保險服務|公司企業|道路附屬設施|公共設施",
  "flow.list.multiNode13": "搜索的地點不存在或超出範圍",
  "flow.list.multiNode14": "正在定位...",
  "flow.list.multiNode15": "定位失敗請刷新重試...",
  "flow.list.multiNode16": "獲取經緯度失敗",
  "flow.list.multiNode17": "該標記點的經緯度為：",
  "flow.list.multiNode18": "該位置字段不能進行定位",
  "flow.list.multiNode19": "已讀消息已全部刪除",
  "flow.list.multiNode20": "消息內容",
  "flow.list.multiNode21": "點擊設置部門",
  "flow.list.multiNode22": "列印範本清單為空",
  "quick.go": "快捷處理",
  "quick": "快捷",
  "time1": "時間：",
  "time2": "當天空閑",
  "time3": "查詢字段",
  "time4": "請聯系貴司 管理員，將表單/報表並共享給您",
  "time5": "不會操作？請點這裏",
  "time6": "新建分組失敗",
  "time7": "您沒有團隊可切換",
  "time8": "分享人賬號",
  "time9": "筛选結果",
  "time10": "流程分組",
  "time11": "請選擇流程表單",
  "time12": "請選擇當前節點",
  "time13": "更改查詢條件",
  "time14": "抱歉，您的流程消息已過期",
  "time15": "您還不在成員列表中",
  "time16": "請聯系管理員同步成員",
  "time17": "本內容由用戶通過 {{ site_name }} 發布，並不代表{{ site_name }}的立場。 ",
  "time18": "此項超出規定範圍",
  "time19": "附件正在上傳中,請稍後進行提交操作",
  "time20": "流程出錯了，請聯系發布者處理",
  "time21": "保存中",
  "time22": "手寫簽名二維碼不存在或者已過期",
  "subform.data.load.tip": "請聯系應用管理員，設置數據加載。",
  "subform.data.load.tip2": "請聯系應用管理員，設置數據加載的來源。",
  "subform.data.load.tip3": "請聯系應用管理員，設置數據加載的顯示字段。",
  "subform.data.load.tip4": "請聯系應用管理員，設置數據加載時字段的對應關系。",
  "subform.data.load.tip5": "普通管理組不能為空",
  "subform.data.load.tip6": "請確認是否執行 {{ triggerEventButton }} 功能",
  "subform.data.load.tip7": "文本內容為空，不能生成二維碼",
  "subform.data.load.tip8": "通過掃壹掃添加",
  "subform.data.load.tip9": "設置轉交負責人",
  "subform.data.load.tip10": "當前環境不支持掃碼功能",
  "subform.data.load.tip11": "請輸入正確的值",
  "subform.data.load.tip12": "還沒有普通管理組,請先創建！",
  "subform.data.load.tip13": "當前無權限管理，請聯系系統管理員分配權限",
  "subform.data.load.tip14": "系統管理員(點擊編輯系統管理員)",
  "subform.data.load.tip15": "通訊錄權限",
  "subform.data.load.tip16": "應用權限(手機端只支持查看)",
  "subform.data.load.tip17": "通訊錄管理範圍(不選擇任何部門時，默認可管理所有部門，手機端只支持查看)",
  "subform.data.load.tip18": "普通管理員(點擊編輯普通管理員)",
  "subform.data.load.tip19": "普通管理員",
  "subform.data.load.tip20": "手機端不支持{{ title }}添加,只支持查看",
  "subform.data.load.tip21": "職位",
  "subform.data.load.tip22": "企業內ID",
  "subform.data.load.tip23": "已有賬號站內信通知，新用戶短信通知。",
  "subform.data.load.tip24": "確認並發送",
  "subform.data.load.tip25": "部門昵稱",
  "subform.data.load.tip26": "部門設置",
  "subform.data.load.tip27": "添加主管",
  "subform.data.load.tip28": "選擇主管",
  "subform.data.load.tip29": "邀請同事加入",
  "subform.data.load.tip30": "號碼查看",
  "subform.data.load.tip31": "通訊錄顯示",
  "subform.data.load.tip32": "沒有成員，請先添加成員！",
  "subform.data.load.tip33": "角色是什麽？在組織架構之外的更加靈活便捷的業務組，適用於無差別的跨部門協作任務和流程審批等場景\n",
  "subform.data.load.tip34": "部門設置成功",
  "subform.data.load.tip35": "添加成員成功",
  "subform.data.load.tip36": "-移動成員",
  "subform.data.load.tip37": "當前數據沒有設置坐標的權限",
  "subform.data.load.tip38": "請聯繫應用管理員，設置數據加載樹菜單的配置",
  "subform.data.load.tip39": "請聯繫應用管理員，設置數據加載樹菜單配置中的標題字段",
  "subform.data.load.tip40": "請聯繫應用管理員，設置數據加載樹菜單配置中的標題節點ID字段",
  "subform.data.load.tip41": "請聯繫應用管理員，設置數據加載樹菜單配置中的標題父節點ID字段",
  "subform.data.load.tip42": "請聯繫應用管理員，設置數據加載樹菜單配置中的標題根節點",
  "card.show.top.left": "在卡片標題中顯示左上字段",
  "card.show.top.right": "在卡片標題中顯示右上字段",
  "card.show.down.right": "在卡片標題中顯示右下字段",
  "card.show.down.left": "在卡片標題中顯示左下字段",
  "Lng": "，經度：",
  "new.Date": "最新數據",
  "user.detail": "成員詳情",
  "editer_browser": "浏览器",
  "editer_button_add": "添加",
  "editer_button_back_add": "返回添加",
  "editer_button_cancel": "取消",
  "editer_button_del": "删除",
  "editer_button_edit": "编辑",
  "editer_button_not_save": "不保存",
  "editer_button_ok": "确定",
  "editer_button_save": "保存",
  "editer_button_autosave": "自动保存",
  "editer_button_save_all": "保存全部",
  "editer_button_select_all": "全选/反选",
  "editer_button_set": "设置",
  "editer_button_submit": "提交",
  "editer_byte": "字节",
  "editer_can_not_repeat": "不允许重复",
  "editer_char_all_display": "显示不可见字符",
  "editer_clipboard": "查看剪贴板",
  "editer_clipboard_null": "剪贴板为空！",
  "editer_clipboard_state": "剪切板状态:",
  "editer_clone": "创建副本",
  "editer_close": "关闭",
  "editer_close_all": "关闭全部",
  "editer_close_others": "关闭其他",
  "editer_close_right": "关闭右侧标签",
  "editer_cloud": "云应用",
  "editer_code_mode": "高亮语法",
  "editer_code_theme": "代码风格",
  "editer_complete_current": "自动补全当前",
  "editer_contain": "包含",
  "editer_copy": "复制",
  "editer_copy_not_exists": "来源不存在",
  "editer_createLink": "创建快捷方式",
  "editer_createProject": "添加到编辑器工程",
  "editer_create_error": "新建失败,请检查目录权限！",
  "editer_create_success": "新建成功！",
  "editer_create_time": "创建时间",
  "editer_current_has_parent": "目标文件夹是源文件夹的子文件夹!",
  "editer_cute": "剪切",
  "editer_cute_past_success": "<b>剪切操作完成</b>(源文件被删除,剪贴板清空)",
  "editer_cute_success": "【剪切】—— 覆盖剪贴板成功!",
  "editer_data_error": "数据出错！",
  "editer_data_not_full": "数据提交不完整！",
  "editer_font_size": "字体",
  "editer_auto_complete": "自动提示(取消)",
  "editer_dialog_close_all": "关闭所有窗口",
  "editer_dialog_display_all": "显示所有窗口",
  "editer_dialog_min": "最小化",
  "editer_dialog_min_all": "最小化所有",
  "editer_edit": "编辑",
  "editer_edit_can_not": "不是文本文件",
  "editer_edit_too_big": "文件太大,不能大于2M",
  "editer_error": "操作失败",
  "editer_error_repeat": "'操作失败，请注意名称不能重复！'",
  "editer_file": "文件",
  "editer_file_type": "文件类型",
  "editer_full_screen": "全屏/退出全屏",
  "editer_function_list": "函数列表",
  "editer_get_success": "获取成功!",
  "editer_getting": "获取中...",
  "editer_go": "走着!",
  "editer_go_up": "上层",
  "editer_goto": "跳转到",
  "editer_gotoline": "跳转到行",
  "editer_search": "搜索",
  "editer_selectAll": "全选",
  "editer_if_remove": "确认删除",
  "editer_if_save_file": "文件尚未保存,是否保存？",
  "editer_info": "属性",
  "editer_menu_hidden": "隐藏",
  "editer_menu_move_del": "删除",
  "editer_menu_move_down": "下移",
  "editer_menu_move_up": "上移",
  "editer_menu_name": "菜单名",
  "editer_preview": "预览",
  "editer_redo": "反撤销",
  "editer_refresh": "刷新",
  "editer_reload": "重新载入",
  "editer_remove": "删除",
  "editer_remove_fali": "删除失败!",
  "editer_remove_info": "确认删除选中内容吗？",
  "editer_remove_item": "项内容",
  "editer_remove_success": "删除成功！",
  "editer_remove_title": "删除确认",
  "editer_rename": "重命名",
  "editer_replace": "替换",
  "editer_rname_success": "重命名成功！",
  "editer_root_path": "云系统",
  "editer_save_path": "保存路径",
  "editer_save_success": "保存成功!",
  "editer_shortcut": "快捷键",
  "editer_show_file": "新页面预览",
  "editer_size": "大小",
  "editer_sort_down": "递减",
  "editer_sort_type": "排序方式",
  "editer_sort_up": "递增",
  // "success": "操作成功",
  "editer_tips": "提示",
  "editer_tools": "工具",
  "editer_type": "撤銷",
  "editer_undo": "撤销",
  "editer_view": "視圖",
  "editer_warning": "警告",
  "editer_width": "宽",
  "editer_wordwrap": "自動換行",
  "editer_Compile": "編譯",
  "editer_Compile.error": "編譯錯誤",
  "isOk.tip": "是否確認",
  "app.stop": "停止雲應用",
  "app.start": "啟動雲應用",
  "app.restart": "重啟雲應用",
  "app.stop.tip": "是否停止雲應用",
  "app.start.tip": "是否啟動雲應用",
  "app.restart.tip": "是否重啟雲應用",
  "app.notsave.tip": "請先保存所有的源文件",
  "create.py.app.tip": "當云應用包含python文件，雲應用會自動轉換為以python語言運行",
  "create.py.module.tip": "當功能插件包含python文件，功能插件會自動轉換為以python語言運行",
  "custom.language": "當前語言類型：",
  my: "我的",
  "urge": "催一下",
  "flow.wait.time": "等待時長：",
  "flow.dealwith.time": "處理時長：",
  "flow.total.time": "當前流程累計時長：",
  "pending": "待處理",
  "flow.node.charger.more.tip": "當前節點所有負責人全部提交才允許通過",
  "flow.node.charger.single.tip": "當前節點任意負責人提交就允許通過",
  "flow.action.batchForward": "批量提交",
  "flow.todo.all": "全部流程",
  "webApi.lua1": "LUA 語法:",
  "webApi.python1": "Python 語法:",
  "webApi.sort": "排序（asc：正序；desc：倒序），不限制排序字段的數量，復選框組、下拉復選框、地址、定位、圖片、附件、手寫簽名、成員單選、成員多選、部門單選、部門多選不可作為排序字段",
  "batch.forward.tip": "開啟後，用戶在處理流程時點擊此按鈕，可以批量提交流程待辦。批量提交時不進行表單校驗，不觸發公式、聯動，請謹慎使用。",
  "batch.forward.select.all": "全選本頁",
  "batch.forward.select.tip": "已選中 {{- count}} 條（僅可選中有批量提交權限的待辦)",
  "batch.forward.empty": "沒有可操作的待辦",
  "batch.forward.select.tip1": "已選中{{- count}}條",
  "batch.forward.select.tip2": "（僅可選中有批量提交權限的待辦)",
  "batch.forward.warning.select": "請選擇需要操作的待辦",
  "batch.forward.warning.limit": "最多勾選{{count}}條待辦",
  "batch.forward.progress.title": "正在提交，請勿離開當前頁面",
  "batch.forward.progress.tip": "已提交{{count}}條/共{{total}}條",
  "batch.forward.finish.tip": "成功{{success}}條，失敗{{fail}}條",
  "batch.forward.break.tip": "已提交{{total}}條（成功{{success}}條，失敗{{fail}}條），未提交{{remain}}條",
  "webapi_forward": "webapi提交",
  "script_forward": "後端提交",
  "script_close": "後端結束流程",
  "app.common": "常用應用",
  "app.empty1": "暫無應用",
  "speedy.entry": "快捷入口",
  "chart.board": "報表看板",
  "api.getSortData": "排序查詢數據",
  "api.query.sort": "根據排序查詢多條數據接口",
  "api.skip.sort": "翻頁起始值索引",
  "appEmpty": "當前您還沒有應用，點擊上方創建新應用",
  "app.custom.add.tip": "將常用的應用添加到此處",
  "entry.speedy.add.tip": "將應用內常用的表單、流程或報表添加到此處",
  "dash.custom.add.tip": "將您最常關註的報表添加到此處",
  "dash.custom": "自定義工作臺",
  "dash.design.company": "设置企业默认工作台",
  "dash.design.custom": "设置我的工作台",
  "add.common.app": "點擊下方應用進行添加",
  "show.dash.common.app": "顯示在工作臺",
  "edit.common.app": "編輯常用應用",
  "add.common.app.title": "添加常用應用",
  "flow.todo.empty.tip": "請選擇表單處理相關流程信息",
  "flow.center": "流程中心",
  "save.data.tip": "保留示例數據（推薦）",
  "installed.app.tip": "*當前應用安裝在",
  "Current.team.name": "當前團隊名稱",
  "custom.platform.usage": "右側開關控制插件的顯示&隱藏，拖動左側按鈕可進行排序",
  "to.do.management": "待辦管理",
  "sign.out.tip": "確定要退出當前賬號？",
  "sign.out.true": "確定退出",
  "app.select.mould": "從應用中心選擇模板",
  "app.select.create.tip": "<span style='color: var(--bsy-base-color)'>{{ t1 }}</span>和<span>{{ t2 }}</span>請從PC端進行操作",
  "new.user.registration": "新用戶註冊",
  "enter.account.title": "輸入賬號",
  "enter.password.title": "輸入密碼",
  "Remember.login": "下次自動登錄",
  "forgot.login": "忘記密碼了？",
  "account.have.tip": "已有賬號,",
  "m.msg.title.phone": "輸入手機號",
  "m.msg.SMS.verification": "輸入短信驗證碼",
  "p.msg.SMS.verification": "請輸入短信驗證碼",
  "p.nickname.placeholder": "請輸入昵稱",
  "m.code.send": "發送驗證碼",
  "m.code.send.seconds": "{{time}}s後重新發送",
  "m.code.login.seconds": "註冊/驗證碼登錄",
  "m.account.password.login": "賬號密碼登錄",
  "m.reset.password.tip": "輸入您的賬號，我們幫您重設密碼",
  "m.reset.password": "重設密碼",
  "m.reset.password.account": "設置密碼的賬號：",
  "m.reset.password.two": "請再次輸入密碼",
  "m.reset.password.success": "設置密碼成功，請重新登錄",
  "m.reset.password.success.ok": "知道了",
  "reset.filter": "重置所有筛选条件",
  "reset.filter.and.tip": "符合 所有 筛选条件的数据",
  "reset.filter.or.tip": "符合 任一 筛选条件的数据",
  "m.phone.entry.error": "手機號格式不正確，請重新輸入",
  "m.tiaokuan.entry.error": "請閱讀並勾選以上條款",
  "m.setting.home.page": "點擊頭像，進入「自定義工作臺」設置首頁內容 ",
  "quick.access.edit": "編輯快捷入口",
  "add.already.count": "已添加（{{count}}/{{max}}）",
  "add.speedy.app": "點擊下方內容進行添加",
  "add.wait": "待添加",
  "add.already": "已添加",
  "add.max.count.tip": "最多添加{{count}}個",
  "no.processed": "您當前沒有已處理的流程",
  "dash.edit": "編輯報表看板",
  "dash.edit.1": "編輯報表",
  "dept.op.fail.add": "普通賬號模式才可以添加子部門",
  "dept.op.fail.rename": "普通賬號模式才可以修改部門名稱",
  "dept.op.fail.delete": "普通賬號模式才可以刪除部門名稱",
  "import.mode": "導入模式",
  "import.mode.insert": "僅新增數據",
  "import.mode.update": "僅更新數據",
  "import.mode.upsert": "更新和新增數據",
  "import.update.finish.tip": "導入完成，共更新 {{count}} 條數據",
  "import.upsert.finish.tip": "導入完成，更新 {{update}} 條數據，新增 {{add}} 條數據",
  'import_forward': '導入數據提交',
  'import_forwardfail': '導入數據提交失敗',
  "speedy.item.empty": "當前分類為空",
  "flow.count.tip": "您有{{ count }}條待辦任務",
  "image.upload.empty": "暫無圖片",
  "file.upload.empty": "暫無附件",
  "widget.signaturePad.save.tip": "保存簽名以備下次調用",
  "dash.sort.add.field": "添加排序字段",
  "module.num.no": "您當前套餐內的多插件執行個數不足",
  "tracking.num": "快遞單號：",
  "datahelper.delete.output.tip": "數據助手中的輸出節點不允許刪除",
  "datahelper.run.filter": "助手觸發條件",
  "datahelper.filter.tip": "點擊左上方添加執行字段，進行條件過濾",
  "etl.datasource.field.empty": "字段已在數據源表中刪除",
  "datahelper.perform.action.add.description1": "即將與之連接的輸出結果集，根據指定條件，對目標表單進行相應的增、刪、改、查等操作",
  "datahelper.perform.action.add.description2": "頁面錄入數據後，和其他輸入源的數據可以進行數據操作，",
  "datahelper.perform.action.add.description3": "將結果作為一條新的記錄集寫入到目標表單當中",
  "datahelper.perform.action.edit.description2": "頁面錄入數據後，",
  "datahelper.perform.action.edit.description3": "修改其他表單中的數據為當前輸入的內容",
  "datahelper.perform.action.delete.description2": "頁面錄入數據後，",
  "datahelper.perform.action.delete.description3": "刪除目標表單符合條件的數據",
  "datahelper.perform.action.dataRely.description2": "頁面錄入數據後，",
  "datahelper.perform.action.dataRely.description3": "根據當前錄入內容，查詢到需要的內容並將結果返回到前端頁面",
  "datahelper.perform.action.field.description1": "主表字段：所有字段默認為主表字段，可以將子表單字段設置為主表字段，設置為主表字段後，會將數據以主表形式展示，在調用的時候可以對應普通字段",
  "datahelper.perform.action.field.description2": "子表單字段：可以將主表字段設置為子表單字段，設置為子表單字段後，會以所有主表字段作為條件，對數據進行分組並展示在子表單當中，在調用的時候可以對應子表單字段",
  "datahelper.edit.tip": "編輯數據助手",
  "datahelper.create.undefine.name": "未命名數據助手",
  "datahelper.type.event": "控件事件",
  "datahelper.type.submit": "表單數據提交",
  "datahelper.type.deleteform": "表單刪除數據",
  "datahelper.type.updateform": "表單更新數據",
  "datahelper.type.editInitialize": "表單編輯初始化",
  "datahelper.type.floweditInitialize": "流程節點初始化",
  "datahelper.type.initialize": "表單初始化",
  "datahelper.type.flownodesave": "流程暫存",
  "datahelper.type.flownodeforward": "流程提交",
  "datahelper.type.flownodeback": "流程回退",
  "datahelper.type.flownodetransfer": "流程轉交",
  "datahelper.type.flownodeclose": "流程關閉",
  "datahelper.type.datatable_menu": "數據表菜單",
  "datahelper.type.batch_menu": "報表菜單",
  "datahelper.type.schedule": "計劃任務",
  "datahelper.type.import": "導入數據擴展操作",
  "datahelper.action.sort": "執行動作順序",
  "datahelper.add.simulationData": "添加類比數據",
  "datahelper.trigger.config.data_to_form": "常規模式",
  "datahelper.trigger.config.data_to_subform": "主錶到子表單",
  "datahelper.trigger.config.subform_to_data": "合併新增到普通欄位",
  "datahelper.trigger.config.subform_to_subform": "合併新增到子表單",
  "datahelper.trigger.config.update_data_to_form": "主錶到普通欄位",
  "datahelper.trigger.config.update_data_to_subform": "主錶到子表單",
  "datahelper.trigger.config.update_subform_to_data": "合併到普通欄位",
  "datahelper.trigger.config.update_subform_to_subform": "合併到子表單",
  "datahelper.trigger.config.rely_data_to_form": "數據聯動",
  "datahelper.trigger.config.rely_data_to_subform": " 主錶聯動到子表單",
  "datahelper.trigger.config.rely_subform_to_data": "合併聯動到普通欄位",
  "datahelper.trigger.config.rely_subform_to_subform": "合併聯動到子表單",
  "datahelper.trigger.config.data_to_form.tip": "輸出錶主錶數據對應普通欄位，子表單數據對應子表單",
  "datahelper.trigger.config.data_to_subform.tip": "輸出錶主錶數據新增到子表單",
  "datahelper.trigger.config.subform_to_data.tip": "輸出錶主錶數據和子表單數據進行合併，新增到普通欄位",
  "datahelper.trigger.config.subform_to_subform.tip": "輸出錶數據主錶數據和子表單數據進行合併，新增到子表單欄位",
  "datahelper.trigger.config.update_data_to_form.tip": "只匹配輸出錶的主錶數據，修改目標錶的普通欄位數據",
  "datahelper.trigger.config.update_data_to_subform.tip": "只匹配輸出錶的主錶數據，修改目標錶的子表單欄位數據",
  "datahelper.trigger.config.update_subform_to_data.tip": "將輸出錶主錶數據和子表單數據進行合併，修改目標表單符合條件的普通欄位數據",
  "datahelper.trigger.config.update_subform_to_subform.tip": "將輸出錶主錶數據和子表單數據進行合併，修改目標表單符合條件的子表單數據",
  "datahelper.trigger.config.rely_data_to_form.tip": "主錶數據聯動到普通欄位，子表單數據聯動到子表單",
  "datahelper.trigger.config.rely_data_to_subform.tip": "將輸出錶內符合條件的主錶數據聯動到子表單",
  "datahelper.trigger.config.rely_subform_to_data.tip": "將輸出錶主錶數據和子表單數據進行合併，聯動到普通欄位",
  "datahelper.trigger.config.rely_subform_to_subform.tip": "將輸出錶主錶數據和子表單數據進行合併，聯動到子表單欄位",
  "datahelper.trigger.config.delete_form": "删除主錶數據",
  "datahelper.trigger.config.delete_subform": "删除子表單數據",
  "datahelper.trigger.config.delete_form.tip": "删除符合條件的主錶數據",
  "datahelper.trigger.config.delete_subform.tip": "查找符合主表條件的數據，删除數據內符合子表條件的數據",
  "datahelper.trigger.config.update_replace_subform": "替換子表單",
  "datahelper.trigger.config.update_replace_subform.tip": "對符合條件的數據中的子表單進行直接覆蓋替換",
  "datahelper.trigger.config.data_rely_form": "聯動數據到主錶欄位",
  "datahelper.trigger.config.data_rely_subform": "聯動數據到子表單欄位",
  "datahelper.trigger.config.data_rely_form.tip": "聯動數據到主錶欄位",
  "datahelper.trigger.config.data_rely_subform.tip": "聯動數據到子表單欄位",
  "datahelper.trigger.config.upsertData.add": "若找不到符合過濾條件的數據，則根據以下配寘在目標表單中新增數據",
  "datahelper.trigger.config.rely.default": "若沒有聯動到任何數據，則根據預設值填寫表單欄位",
  "datahelper.trigger.config.run1": "設定欄位對應關係",
  "datahelper.trigger.config.run1.Valid.tip": "請設定欄位對應關係",
  "datahelper.trigger.config.run2": "設定其他選項",
  "datahelper.trigger.config.run3": "設定新增數據欄位對應關係",
  "datahelper.trigger.config.run4": "設定數據聯動失敗的時候的預設值",
  "datahelper.trigger.config.next": "下一步：設定欄位對應關係",
  "datahelper.trigger.config.next1": "其他設定",
  "datahelper.trigger.config.next2": "下一步：設定新增數據",
  "datahelper.trigger.config.next3": "下一步：設定聯動數據",
  "datahelper.trigger.config.next4": "下一步：消息推送设置",
  "datahelper.trigger.config.prev": "上一步：設定觸發動作",
  "datahelper.trigger.config.prev1": "上一步：設定欄位對應關係",
  "datahelper.trigger.config.prev2": "上一步：设置消息推送模式",
  "datahelper.trigger.config.prev3": "上一步：消息推送设置",
  "datahelper.trigger.config.data_to_news": "单条数据推送",
  "datahelper.trigger.config.datas_to_news": "多条数据推送",
  "datahelper.trigger.config.data_to_news.tip": "单条数据推送",
  "datahelper.trigger.config.datas_to_news.tip": "多条数据推送",
  "datahelper.trigger.config.datas_to_news.tip1": "推送每条消息间隔",
  "datahelper.output.field.move.sn.fail": '子表單內不支持流水號欄位',
  "datahelper.trigger.filter.add.tip1": '輸出錶數據滿足以下',
  "datahelper.trigger.filter.update.tip1": '輸出錶數據滿足以下',
  "datahelper.trigger.filter.delete.tip1": '輸出錶數據滿足以下',
  "datahelper.trigger.filter.rely.tip1": '輸出錶數據滿足以下',
  "datahelper.trigger.filter.datanews.tip1": '輸出錶數據滿足以下',
  "datahelper.trigger.filter.tip2": '條件觸發執行動作，不滿足以下',
  "datahelper.trigger.filter.add.link.tip1": '篩選出符合以下',
  "datahelper.trigger.filter.add.link.tip2": '條件的數據',
  "datahelper.trigger.filter.delete.filter.tip1": '删除符合以下',
  "datahelper.trigger.filter.delete.filter.tip2": '删除子表單',
  "datahelper.trigger.filter.delete.filter.tip3": '中符合以下',
  "datahelper.trigger.config.entry.field": "輸出錶欄位",
  "datahelper.trigger.config.target.field": "目標表單",
  "datahelper.trigger.config.target.fieldsubform": "目標子表單",
  "datahelper.trigger.add.filter": "請添過濾選條件",
  "datahelper.trigger.delete.filter": "請添過濾選條件",
  "datahelper.trigger.delete.filter.subform": "請添加子表單篩選條件",
  "datahelper.trigger.filter.update.filter.tip1": '修改符合以下',
  "datahelper.trigger.filter.update.filter.tip2": '修改子表單',
  "datahelper.trigger.filter.update.filter.tip3": '中符合以下',
  "datahelper.trigger.filter.update.filter.tip4": '联动符合以下',
  "datahelper.trigger.filter.update.filter.tip5": '添加联动符合以下',
  "datahelper.trigger.datarely.tip1": "按以下的欄位設定，對目標錶進行數據填充 ",
  "datahelper.trigger.datarely.tip2": "，並按以下的欄位設定，對目標錶進行數據填充",
  "datahelper.trigger.datarely.tip3": "請先選擇子表單",
  "datahelper.trigger.datarely.tip4": "，并按以下的字段设置，进行数据新增",
  "datahelper.trigger.datarely.tip5": "限定範圍為導入數據(後置觸發)",
  "datahelper.trigger.output.tip1": "數據有效判斷",
  "datahelper.trigger.success.tip": "開啟執行動作完成後的提示資訊",
  "datahelper.trigger.success.tip1": "有符合數據操作時候的設定",
  "datahelper.trigger.success.tip2": "沒有符合數據操作時候的設定",
  "datahelper.trigger.success.tip3": "清空指定欄位",
  "datahelper.trigger.success.tip4": "中斷執行",
  "datahelper.trigger.success.tip5": "提示資訊",
  "datahelper.trigger.success.tip6": "觸發指定公式",
  "datahelper.trigger.success.tip7": "日誌資訊",
  "datahelper.trigger.success.tip8": "字段為空時忽略字段",
  "datahelper.trigger.success.tip9": "輸出表某個字段內容為空時，不對目標表單字段進行修改",
  "datahelper.trigger.success.tip10": "當被替換的子表單整體為空時，不進行修改",
  "datahelper.trigger.success.tip11": "返回執行的條數提示",
  "datahelper.trigger.actionsMaxCount.error": "執行動作不能超過 {{count}} 個",
  "datahelper.trigger.actionsModuleMaxCount.error": "最多只能添加 {{count}} 個功能模組執行動作",
  "datahelper.trigger.output.filter.rel.and": "所有數據",
  "datahelper.trigger.output.filter.rel.or": "任意一條數據",
  "datahelper.trigger.output.filter.error.tip": "請填寫錯誤資訊",
  "datahelper.trigger.action.success.tip": "請填寫提示資訊",
  "datahelper.trigger.action.success.tip1": "請填寫日誌資訊",
  "datahelper.trigger.output.filter.ok.tip": "保存成功",
  "datahelper.trigger.destform": "請先添加目標錶",
  "datahelper.trigger.op.mode.tip": "點擊查看，操作模式詳細說明",
  "datahelper.trigger.dataoutput.name": "輸出錶[數據助手]",
  "datahelper.trigger.start.flow": "是否發起新的流程",
  "datahelper.trigger.dest.form.notsubform": "目標錶沒有子表單，不支持當前操作模式，請重新選擇",
  "datahelper.trigger.action.filter.text": "執行條件",
  "datahelper.trigger.title1": "字段对应关系",
  "datahelper.output.error.tip1": "開啟數據有效性判斷，當出現錯誤後將直接返回，不繼續往下執行",
  "datahelper.output.error.tip2": "當結果集為空的時候，提示下麵錯誤資訊並直接返回，不繼續往下執行",
  "datahelper.output.error.tip3": "當結果集為空的時候，直接返回，不執行後續動作",
  "datahelper.output.error.tip4": "請填寫具體的錯誤資訊",
  "datahelper.output.error.tip5": "所有數據：整個結果集中全部數據不符合下麵的條件<br>任意一條數據：結果集中的一條數據不符合下麵的條件",
  "datahelper.output.error.tip6": "當結果集中",
  "datahelper.output.error.tip7": "條件時，繼續往下執行",
  "datahelper.output.error.tip8": "否則，提示下麵錯誤資訊並直接返回，不繼續往下執行",
  "datahelper.output.error.tip9": "否則，直接返回，不繼續往下執行",
  "datahelper.output.error.tip10": "符合以下",
  "datahelper.inputdata.error.tip": "輸入數據沒有找到欄位，請先保存表單欄位",
  "datahelper.import.dataExt": "擴展操作",
  "datahelper.import.dataExt.open": "啟用數據助手",
  "datahelper.import.dataExt.tip": "可在資料管理編輯數據助手",
  "datahelper.node.output.title": "輸出錶",
  "datahelper.guide.1": "1/5 選擇並設定輸入數據->設定資料處理管道->調整輸出錶->添加執行動作",
  "datahelper.guide.2": "2/5 選擇並設定輸入數據【可新增類比數據】",
  "datahelper.guide.3": "3/5 設定資料處理管道【根據自己需求進行設定】",
  "datahelper.guide.4": "4/5 調整輸出錶【可設定主錶模式和子表單模式】",
  "datahelper.guide.5": "5/5 添加執行動作【可設定多個並可調整執行順序】",
  "datahelper.module.current.name": "[數據助手-輸出錶]",
  "datahelper.op.log": "數據助手日誌",
  "datahelper.op.log.tip": "日誌只記錄最新100條，運行時長超過閾值和系統錯誤的會進行記錄。",
  "datahelper.help.header.tip1": "表格背景色：",
  "datahelper.help.header.tip2": "文字顏色：",
  "datahelper.help.header.tip3": "新增的數據",
  "datahelper.help.header.tip4": "根據查詢準則查找到的數據",
  "datahelper.help.header.tip5": "條件欄位",
  "datahelper.help.header.tip6": "內部過程（不可見）",
  "datahelper.help.header.tip7": "後臺資料處理過程",
  "datahelper.help.header.tip8": "被修改或聯動顯示的欄位",
  "datahelper.trigger.addaction": "新增數據",
  "datahelper.trigger.deleteaction": "删除數據",
  "datahelper.trigger.editaction": "修改數據",
  "datahelper.trigger.relyction": "數據聯動",
  "adv.set": "高級設置",
  "show.title": "顯示標題",
  "border.radius": "圓角",
  "show.title.background": "填充背景",
  "funnel.chart": "漏鬥圖",
  "transformation.ratio": "轉化率",
  "border.width": "描邊線寬",
  "border.color": "描邊顏色",
  "width": "寬度",
  "gap.between.each.trapezoid": "數據圖形間距",
  "show.tip.tool": "顯示提示框控件",
  "tooltip": "提示框",
  "opacity": "透明度",
  "mouse.click": "鼠標點擊時",
  "mouse.moves": "鼠標經過時",
  "conditions.trigger.tooltip": "提示框觸發條件",
  "follow.the.position.of.mouse": "跟隨鼠標位置",
  "tooltip.prefix": "自定義系列名稱",
  "tip.alert.reset": "是否重置{{ name }}屬性？",
  "tip.reset": "重置{{ name }}屬性",
  "Label": "标签",
  "inside": "內部",
  "outside": "外部",
  "dash.pie.common": "基礎餅圖",
  "dash.pie.rose": "玫瑰圖",
  "dash.pie.doughnut": "環形圖",
  "dash.interval.y": "Y軸間隔大小",
  "dash.interval.y.warning.tip": "Y軸間隔必須大於0",
  "dash.interval.y.warning.tip1": "Y軸間隔最大值必須大於最小值",
  "dash.interval.y.warning.tip2": "Y軸間隔最小值必須小於最大值",
  "dash.interval.y.tip": "Y軸間隔必須大於0，Y軸間隔過小會影響y軸刻度的顯示，請適當調整間隔值的大小",
  "dash.radiusAxis.y": "極坐標系",
  "dash.Axis.y": "直角坐標系",
  "dash.gauge": "儀表盤",
  "dash.gaugeChart": "儀表盤",
  "dash.gaugeChart.tip": "1個指標",
  "dash.gaugeChart.range": "範圍",
  "dash.gaugeChart.pointer.color": "指針顏色",
  "dash.gantt": "甘特圖",
  'dash.gantt.starttime': "開始時間",
  'dash.gantt.enttime': "結束時間",
  'dash.gantt.progress': '進度',
  'dash.gantt.starttime.tip': '僅支持時間字段',
  'dash.gantt.progress.tip': '僅支持數字字段',
  'dash.gantt.starttime.tip1': "添加失敗，僅可添加1個開始時間",
  'dash.gantt.enttime.tip1': "添加失敗，僅可添加1個結束時間",
  'dash.gantt.progress.tip1': '添加失敗，僅可添加1個進度字段',
  'dash.gantt.time.tip1': '添加失敗，開始時間與結束時間不能相同',
  'dash.gantt.dimension.tip1': '「開始時間」、「結束時間」、「進度」以及「維度」中子表單字段必須同屬於一個子表單',
  'dash.gantt.time.precision': '精度',
  'dash.gantt.zoomLevel.tip': '縮放等級',
  'dash.gantt.zoomLevel.title': '{{ level }}級',
  'dash.gantt.dependencies': '任務依賴關系',
  'dash.gantt.dependencies.tip1': '任務標識字段',
  'dash.gantt.dependencies.tip2': '任務依賴字段',
  'dash.gantt.dependencies.tooltip2': '任務標識字段用來唯一標識一個任務節點, 任務依賴字段：用來記錄這個節點依賴哪個任務節點的完成,會產生連線效果',
  'dash.gantt.bar.start': '開始：',
  'dash.gantt.bar.end': '結束：',
  'dash.gantt.bar.progress': '進度：',
  'dash.gantt.field.add.guide': '拖拽左側字段到上方「維度」、「開始時間」、「結束時間」來創建甘特圖',
  'Year': '年',
  'Quarterly': '季度',
  'Month': '月',
  'Quarterly Month': '季度/月',
  'Week': '周',
  'Day': '天',
  'Half Day': '上午/下午',
  'Hour': '小時',
  'hourTime': '時',
  "schedule.update.start.tip": "當前計劃任務處於停止狀態，是否立即啟動",
  "no.operation.authority": "無操作權限",
  "preview.view.data": "預覽時不支持查看數據",
  "preview.create.data": "預覽時不支持新增數據",
  "preview.triggerEvent": "預覽時不支援功能擴展的觸發",
  "preview.buttom.triggerEvent": "預覽時不支援按鈕操作",
  "data.manager.create.data": "數據管理不支持新增數據",
  "data.manager.view.data": "數據管理不支持查看數據",
  "data.manager.not.permission": "无权操作",
  "data.manager.have.permission.data": "仅执行有权限的数据",
  "data.manager.have.permission.data.tip": "已勾选{{total}}条，{{select}}条有权限。无权限的数据已取消勾选。",
  "link.form.op": "關聯表操作",
  "linkdata.show.data.count": "顯示數據條數",
  "link.form.addData": "允許新增關聯表數據",
  "link.form.oneData": "一條",
  "link.form.manyData": "多條",
  "dingding.phone.placeholder": "請輸入釘釘註冊使用的手機號",
  "dingding.empty.team.tip": "您還沒有加入任何釘釘團隊！<br />還未開通釘釘 <a style='color:var(--bsy-base-color);' href='/dingding/login_guide' target='_blank'>如何開通？</a>",
  "dingding.have.teams.tip": "系統檢測到您有多個團隊，請選擇一個團隊進行下一步掃碼登錄",
  "dingding.auto.syn.switch": "允許自動同步通訊錄",
  "dingding.user.login": "釘釘成員登錄",
  "form.flow.dingding": "接入釘釘審批套件",
  "form.flow.dingding.tip": "開啟此功能的流程，發生流程流轉時，將推送給對應的負責人，負責人可以在釘釘工作臺審批應用的「OA審批」、「待處理」任務分組下查看並處理該流程。",
  "form.dingding.SSO.Obtain": "獲取",
  "SSOsecret.dingding.tip1": "註意：SSOsecret主要用於釘釘後臺進入應用操作，如無此需求可不修改",
  "SSOsecret.dingding.tip2": "修改SSOsecret",
  "SSOsecret.dingding.tip3": "（請根據下方步驟進行操作）",
  "SSOsecret.dingding.tip4": "操作步驟：",
  "SSOsecret.dingding.tip5": "1.打開鏈接：",
  "SSOsecret.dingding.tip6": "2.【點擊查看】SSOsecret",
  "SSOsecret.dingding.tip7": "（需管理員點擊查看）",
  "SSOsecret.dingding.tip8": "*SSOsecret僅用於從釘釘後臺進入應用",
  "dingding.auto.syn.log": "通訊錄日誌",
  "dingding.auto.syn.log.edit.after": "修改前",
  "dingding.auto.syn.log.edit.before": "修改後",
  "print.guide.1": "<span style='color: var(--bsy-base-color);font-weight: bold;'>1</span>/6 點擊【編輯】> 進入打印模板設計頁面",
  "print.guide.2": "<span style='color: var(--bsy-base-color);font-weight: bold;'>2</span>/6 【紙張設置】確定實際打印範圍 > 自行繪製打印樣式",
  "print.guide.3": "<span style='color: var(--bsy-base-color);font-weight: bold;'>3</span>/6 雙擊【單元格】> 拖動【表單字段】自定義【編輯單元格內容】",
  "print.guide.4": "<span style='color: var(--bsy-base-color);font-weight: bold;'>4</span>/6 點擊【批量打印】> 設置【分頁打印】或【連續打印】",
  "print.guide.5": "<span style='color: var(--bsy-base-color);font-weight: bold;'>5</span>/6 點擊【自定義水印】> 自定義設置【無水印】、【圖片】水印或【文字水印】",
  "print.guide.6": "<span style='color: var(--bsy-base-color);font-weight: bold;'>6</span>/6 點擊【背景設置】> 選擇上傳【背景圖】> 按字段值的位置【繪製單元格】> 拖動字段至對應單元格內 > 【保存並配置模板使用範圍】> 打開單條數據，點擊【打印】按鈕可按該模板打印",
  "edit.content.filed": "修改內容",
  "check.template": "選擇模板",
  "check.template.tip1": "（必填）",
  "check.template.tip2": "<i style='color:#f5222d;font-size: 20px;vertical-align: middle;margin-right: 6px;'>*</i>",
  "check.template.table1": "消息表單內容",
  "color.black": "黑色",
  "color.gray": "灰色",
  "color.highlight": "高亮",
  "refresh.template": "刷新模板列表",
  "template.test": "測試",
  "template.test.user": "請選擇測試用戶",
  "template.sms.reminder": "短信提醒",
  "template.sms.set": "短信設置",
  "template.voice.reminder": "語音提醒",
  "template.voice.set": "語音設置",
  "template.email.set": "郵件設置",
  "template.dd.set": "釘釘設置",
  "template.wx.set": "微信設置",
  "template.qywx.set": "企業微信設置",
  "template.reminder.content": "提醒內容",
  "template.send.fail": "發送失敗，請檢查內容",
  "template.voice.sms.id": "模板ID",
  "template.voice.sms.btn": "獲取消息內容",
  "template.we.refresh.tip": "請點擊上方刷新按鈕重新獲取消息內容！",
  "template.url": "消息推送入口",
  "template.check.url": "表單鏈接設置",
  "template.check.url.detail": "數據詳情",
  "template.add.cont": "添加內容",
  "template.create.title": "請在這裏配置{{type}}模板",
  "template.create.title2": "請在這裏製作{{type}}模板",
  "template.create.title3": "如何配置",
  mail: "郵件",
  "template.style.title": "填寫樣式預覽",
  "template.select": "選擇",
  "sms": "短信",
  "voice": "語音",
  "qywechat": "企業微信",
  "voice.title.tip": "（模板內容要和阿裏雲模板內容一致,否則無效！）",
  "flow.action.urge": "催辦",
  "flow.action.cc": "抄送",
  "template.mail.tip": "成員用戶必須先綁定郵箱，才能收到提醒。",
  "template.wx.tip": "成員用戶必須先關註微信服務號，才能收到提醒。",
  "template.phone.tip": "成員用戶必須手機號有效，才能收到提醒。",
  "template.phone.tip1": "成員用戶必須手機號有效或文本控件有效，才能收到提醒。",
  "template.urge.tip": "使用流程催辦模板進行提醒",
  "template.error.tip": "該功能需要私有雲支持，配置後開啟",
  "template.error.tip1": "該功能需要私有雲支持，配置後開啟",
  "check.template.waterMark": "請輸入語音模板ID",
  "check.template.sms.waterMark": "請輸入短信模板ID",
  "check.template.waterMark1": "請選擇模板",
  "title.trigger": "觸發條件",
  "sms.num": "短信條數",
  "voice.num": "語音條數",
  "empty.template.tip": "請先設置{{name}}模板",
  "error.template.tip1": "請檢查模板內容是否填寫完整",
  "error.template.tip3": "請至少選擇一種提醒方式",
  "datahelper.subform.tip": "當前沒有可用子表單",
  "datahelper.subform.tip1": "請選擇消息推送入口",
  "template.id.empty.tip": "模板ID不能為空",
  "template.id.empty.tip1": "請先完成{{name}}設置",
  "template.id.empty.tip2": "請添加被提醒人",
  "edit.etl.stage.title": "修改節點名稱：",
  "template.restore": "恢復默認",
  "template.length.tip": "消息表單內容最多不能超過{{len}}個",
  "api.add.data.batch": "批量新增數據",
  "api.create.batch": "新建多條數據接口",
  "api.create.desc.batch": "在指定表單中添加多條數據。",
  "api.res.create.batch.success": "成功的數據結果",
  "api.res.create.batch.failed": "失敗的原數據",
  "api.res.create.batch.failedCode": "失敗對應的錯誤碼code",
  "api.res.create.batch.data": "響應內容：",
  "api.create.batch.data.desc": "限製100條 超出報錯",
  "qyweixin.set.manage": "點擊配置",
  "qyweixin.set.manage.title": "企業微信通訊錄授權",
  "corp.qyweixin.Step.url": "URL",
  "corp.qyweixin.Step.Token": "Token",
  "corp.qyweixin.Step.EncodingAESKey": "EncodingAESKey",
  "corp.qyweixin.Step.title": "配置通訊錄自動同步參數",
  "corp.qyweixin.Step.title.tip": "（請將以下參數復製粘貼到<a href='https://work.weixin.qq.com/wework_admin/frame#apps/contactsApi' style='color:var(--bsy-base-color);font-weight: bold;margin: 0 5px;padding-bottom: 1px;border-bottom: 1px solid var(--bsy-base-color);' target='_blank'>通訊錄同步</a>的相應位置，詳見參數配置操作引導）",
  "manage.qyweixin.explain": "配置說明",
  "set.password.new": "設置新密碼",
  "set.name.new": "設置您的姓名",
  "set.name.new.p": "請設置您的姓名",
  "set.name.new.t": "建議您使用真實姓名,方便團隊裏面快速識別",
  "wxbind.tip": "該手機號<a style='color: var(--bsy-base-color);text-decoration: underline;'>{{value}}</a>已經存在",
  "wxbind.tip1": "請直接綁定此賬號並登錄",
  "wxbind.login": "綁定並登錄",
  "entry.code.tip": "請輸入{{len}}位驗證碼",
  "dingding.code.team.login": "手機釘釘掃碼直接登錄",
  "set.password.tip": '密碼不符合規範，請重新設置',
  'feishu.login': '飛書登錄',
  'mobile.login.empty.tip': '移動端沒有合適的登錄方式，請聯系管理員或前往電腦端登錄',
  'reg.login.empty.tip': '當前不能進行註冊，請聯系管理員',
  'switch.to.resignation': '轉為已刪除',
  'addressbook.joined.tip': '有<span style="color: #F5222D;margin:0 2px">{{num}}</span>名成員未加入，<span class="inv" style="color: var(--bsy-base-color);cursor: pointer;">再次全部邀請</span>',
  'batch.error.tip': '批量導入數據結果：成功{{success}}條，已存在{{exist}}條，失敗{{error}}條',
  'batch.error.btn': '下載錯誤的數據',
  'dismission': '刪除',
  'dismission.error.tip': '只能對普通成員進行刪除操作',
  'dismission.error.tip2': '請選擇需要刪除的成員',
  'dismission.alert.tip': '您確定將所選成員轉為已刪除成員？',
  'dismission.alert.tip1': '轉為已刪除成員後，使用相同成員編號再次加入時，可恢復相關配置',
  'handover.work': '交接工作',
  'handover.work.loading': '正在將{{user}}的以下工作轉交給{{to}}，請稍等......',
  'handover.auth.group': '表單權限組成員',
  'handover.notify': '推送提醒被提醒人',
  'handover.datahelper': '數據助手被提醒人',
  'handover.dash.auth': '報表權限組成員',
  'handover.name.tip': '有以下工作，可根據需要轉交給其他成員',
  'handover.finish.tip': '轉交完成，可繼續轉交其他工作',
  'handover.empty.tip': '該分類下暫無工作',
  'handover.empty.tip1': '當前未選中任何工作，請確認是否選擇了需要轉交的工作',
  'handover.error.tip': '不能將工作轉交給自己',
  'handover.error.tip1': '請選擇一名需要被轉交工作的成員',
  "handover.finish": "成功{{success}}條",
  "handover.forward": "失敗{{fail}}條",
  "handover.load.forward": "轉交完成，但是存在失敗的工作轉交，可嘗試再次轉交",
  'todo.data': '待辦數據',
  'todo.data.tip': '轉交內容：當前用戶審批中的流程',
  'todo.data.empty.tip': '無進行中流程',
  "todo.dataCount": "{{count}}條",
  'todo.data.tip1': '流程進行中',
  'creator.data': '當前用戶提交的數據',
  'creator.data.empty.tip': '沒有當前用戶提交的數據',
  'creator.data.tip': '轉交內容：當前用戶提交的數據',
  'flow.user': '流程負責人',
  'flow.user.tip': '轉交內容：節點負責人、節點抄送人、限時處理被提醒人、轉交候選人',
  'flow.creator.data.tip': '轉交內容：當前用戶發起的流程數據',
  'flow.creator.data.empty.tip': '沒有當前用戶發起的流程數據',
  'form.dash.config': '表單、報表配置',
  'form.dash.config.tip': '轉交內容：權限組、推送提醒、定時提醒',
  'role.tip': '支持轉交【創建的角色】，通訊錄其他配置請到通訊錄中調整',
  'set.name.empty.tip': '姓名不能為空',
  'outsider.custom.group': "自定義分組",
  'outsider.custom.all': "全部聯系人",
  'outsider.view.custom.all': "查看全部聯系人",
  "outsider.add": "添加外部聯系人分組",
  "outsider.name.required": "請填寫分組名稱",
  "outsider.name.empty": "分組名稱不能為空",
  "outsider.group.delete.tip": "刪除外部聯系人分組會將所關聯的權限一並刪除，此操作不可逆",
  "outsider.member.delete.tip": "刪除外部聯系人會將所關聯的權限一並刪除，此操作不可逆",
  "outsider.group.edit": "修改分組名稱",
  "outsider.miniapp.seting.tip": '分組成員分享微信小程序自動加入該組',
  "outsider.member.batch.recover": "批量恢復",
  "outsider.member.recover.groupempty.tip": "選擇恢復到的分組",
  "outsider.member.remove.empty": "請選擇需要刪除的外部聯系人",
  "outsider.member.remove.tip": "您確定刪除所選外部聯系人？",
  "outsider.member.recover.empty": "請選擇需要恢復的外部聯系人",
  "outsider.member.recover.tip": "您確定恢復所選外部聯系人？",
  "outsider.member.add": "添加外部聯系人",
  "outsider.member.singleAdd": "手動添加外部聯系人",
  "outsider.member.batchAdd": "批量導入外部聯系人",
  "outsider.member.in.group": "所在分組",
  "outsider.member.import.Download01": "1.導入賬號直接生效",
  "outsider.member.import.Download11": "1.下載表樣，不能增加、刪除或修改本Excel表的成員信息類別，不填的留空即可。",
  "outsider.member.import.Download12": "2.手機、姓名、分組為必填，手機區號、用戶ID、郵箱為選填。",
  "outsider.member.import.Download13": "3.分組不存在會自動創建",
  "outsider.member.import.Download14": "4.批量導入最大數據200條。手機號和用戶ID已經在外部聯系人內或信息有誤的成員不導入，如有超出，請分為多個文件導入",
  "outsider.member.import.Download15": "5.免激活模式的密碼規則：6位到18位，不填寫則默認為：123456",
  "outsider.member.to.dept": '轉部門成員',
  "outsider.member.from.dept": '轉外部聯系人', //部門成員轉外部聯系人
  "outsider.miniapp.seting": "微信小程序設置",
  "outsider.miniapp.seting.share.autojoin": "分享微信小程序自動加入",
  "outsider.miniapp.seting.share.autojoin.tip1": '開啟以後,通訊錄成員或外部聯繫人成員分享微信小程序,會自動註冊並加入默認分組',
  "outsider.miniapp.seting.share.autojoin.tip2": '開啟以後,本組外部聯繫人成員分享微信小程序,會自動註冊並加入該外部聯繫人自定義分組,自定義分組的優先級要高於默認分組的設置',
  "outsider.miniapp.seting.share.qr": "二維碼入口",
  "outsider.miniapp.seting.share.qr.tip": "開啟以後,允許外部人員掃二維碼訪問特定的頁面,並自動加入該外部聯繫人分組",
  "outsider.miniapp.seting.share.home": "設置入口頁面",
  "outsider.miniapp.seting.share.expiretime": "分享鏈接和分享二維碼有效截止時間設置",
  "outsider.miniapp.seting.share.regenerate": "重新生成",
  "outsider.miniapp.seting.share.qrsize": "分享二維碼尺寸",
  "outsider.miniapp.seting.share.qrsize.8": "8cm*8cm",
  "outsider.miniapp.seting.share.qrsize.12": "12cm*12cm",
  "outsider.miniapp.seting.share.qrsize.15": "15cm*15cm",
  "outsider.miniapp.seting.share.qrsize.30": "30cm*30cm",
  "outsider.miniapp.seting.share.qrsize.50": "50cm*50cm",
  "outsider.miniapp.seting.share.Invalidation": " 二維碼已失效，請重新生成",
  "outsider.miniapp.seting.share.EffectiveTimeire": "二維碼有效時間",
  "outsider.miniapp.seting.share.permanentTime": "永久有效",
  "outsider.miniapp.seting.share.limitTime.tip1": "二維碼有效時間必須大於當前時間30分鐘",
  "outsider.miniapp.seting.share.limitTime.tip2": "二維碼有效時間不能大於當前時間30天",
  "outsider.miniapp.seting.launcher": "設置入口頁面",
  "outsider.miniapp.seting.launcher.clear": "清空入口頁面",
  "approve.list.header.1": '申請人',
  "approve.list.header.2": '手機或郵箱',
  "approve.list.header.3": '申請時間',
  "approve.list.header.4": '申請理由',
  "handover.create.role": "創建角色分組",
  "resign.user": "已刪除成員",
  "resign.user.1": "已不在通讯录成员",
  "resign.time": "刪除時間",
  "resign.user.tip": "請選擇需要恢復在職的成員",
  "resign.alert.tip": "確定恢復選中的已刪除成員為在職嗎？",
  "reinstatement": "恢復在職",
  "outsider.miniapp.seting.launcher.home": "應用主頁",
  "resigned.user": "已刪除",
  "off.on.use": "是否{{ dos }}該{{ type }}？",
  "scan.qr.signature": "掃描二維碼，添加手寫簽名",
  "scan.qr.image": "手機掃描二維碼，即可上傳圖片",
  "corp.feishu.authorization": "飛書應用授權",
  "corp.feishu.explain": "飛書應用綁定說明",
  "corp.feishu.href": "需要聯系【團隊管理員】登錄飛書開放平臺 <a href='{{url}}' target='_blank' style='color: #00FFD2;'>{{url}}</a> 進行綁定配置 ",
  "corp.feishu.text1": "飛書應用綁定采用了飛書【企業內部開發】的模式對接",
  "corp.feishu.text2": "為什麽采用【企業內部開發】的模式",
  "corp.feishu.text3": "采用【企業內部開發】的模式可以獲取更多的能力：比如，通訊錄自動同步等，節約大量時間",
  "corp.feishu.help": "請根據 <a href='/feishu/guide' target='_blank' style='color: #FFB200;'><i class='icon-bsy-guide'></i>參數配置操作引導</a> 完成操作 ",
  "corp.feishu.Step.unbin.btn": "解除飛書授權",
  "corp.feishu.Step.unbind": "是否解除飛書授權？",
  "corp.feishu.Step.unbind.tip": "解除飛書綁定以後，賬號將還原到本賬號原來的通訊錄信息，應用和數據信息將保留，重新綁定原飛書應用可以恢復。",
  feishu: "飛書",
  "dash.thresholds.msg.feishu": "飛書提醒",
  "template.feishu.set": "飛書設置",
  "corp.feishu.h5.url": "H5可信域名",
  "corp.feishu.redirect.url": "重定向URL",
  "corp.feishu.redirect2.url": "請求網址",
  "corp.feishu.ip.url": "IP白名單",
  "corp.feishu.pc.url": "桌面端主頁",
  "corp.feishu.mobile.url": "移動端主頁",
  "corp.feishu.omp.url": "管理後臺主頁",
  "corp.feishu.app.url": "2.配置應用權限並發布應用",
  "sign.out.team": "退出當前團隊",
  "sign.out.team.waterMark": "請輸入當前團隊名",
  "sign.out.team.tip1": "請輸入正確的團隊名",
  "sign.out.team.tip": "成功退出{{teamName}}",
  "outsider.miniapp.seting.share.qrsize.tip": "點擊下方圖標選擇相應的二維碼尺寸進行下載",
  "role.empty.tip": "當前沒有角色，請創建",
  "role.empty.tip1": "當前第三方團隊沒有角色",
  "create.role": "創建角色",
  "node_has_loop": "多分支流程存在迴圈，無法正常流轉。 請聯系管理員檢查流程設計",
  "flow-exception": "流程异常",
  "manager.delete.warning1": "刪除普通管理組則相關管理員及權限也將一並刪除，且無法還原。",
  'handover.work.empty': '當前沒有可交接的工作',
  'app.store.search': '搜索應用系統',
  'app.store.search.tip': '該應用所在系統',
  'app.store.search.title': '以下為當前搜索結果',
  'app.store.list.empty': '當前類別暫無應用',
  'app.store.search.empty': '請輸入需要搜索的內容',
  "form.select": "表單選擇",
  "push.event": "推送事件",
  "activated.setting": "已啟用設置",
  "stoped.setting": "已停用設置",
  "deactivate": "停用",
  "push.log.type": "推送日誌類型",
  "push.logging": "推送日誌記錄",
  "pending.log": "待發送日誌",
  "abandon.log": "放棄推送日誌",
  "data.api.logTip.day": "僅保留{{day}}天的推送日誌",
  "push.content": "推送內容",
  "push.event.tip": "請至少勾選一個推送事件",
  "secret.tip": "請填寫secret",
  "activated.webhook.tip": "是否啟用該推送？",
  "deactivated.webhook.tip": "是否停用該推送？",
  "delete.webhook.tip": "是否刪除該推送？",
  "retry.webhook.tip": "是否重新推送？",
  "abandon.webhook.tip": "是否放棄推送？",
  "retry.webhook.tip1": "已重新請求該推送",
  "pending.status": "待發送",
  "open.platform": "開放平臺",
  "server.url.tip": "該服務器地址不是以http://https://開頭，或者不是網址",
  "server.url.tip1": "例如：http://www.xxxxx.com或者https://www.xxxxx.com",
  "open.platform.empty.tip": "當前沒有數據推送，去新建一個吧~",
  "member.change": "成員變更",
  "dept.change": "部門變更",
  "role.change": "角色變更",
  "external.contact.change": "外部聯系人變更",
  "member.contact.add": "通訊錄成員增加",
  "member.contact.edit": "通訊錄成員更改",
  "member.contact.del": "通訊錄成員離職",
  "member.contact.recover": "通訊錄成員刪除恢復",
  "member.to.external": "通訊錄成員轉外部聯系人",
  "member.to.dept": "通訊錄成員移動部門",
  "dept.create": "通訊錄企業部門創建",
  "dept.edit": "通訊錄企業部門修改",
  "dept.del": "通訊錄企業部門刪除",
  "add.role": "增加角色組",
  "edit.role": "修改角色組",
  "edit.add.user": "增加角色組成員",
  "edit.del": "刪除角色組",
  "edit.del.user": "刪除角色組成員",
  "external.add.group": "增加外部聯系人分組",
  "external.edit.group": "刪除外部聯系人分組",
  "external.del.group": "修改外部聯系人分組",
  "external.add": "增加外部聯系人",
  "external.del": "刪除外部聯系人",
  "external.edit": "修改外部聯系人",
  "external.to.dept": "外部聯系人轉部門成員",
  "url.server.tip1": "該服務器地址連接正常",
  "url.server.tip2": "該服務器地址連接異常，錯誤碼為{{code}}",
  "delete.webhook.tip1": "刪除通訊錄webhook回調設置，不再觸發接口？",
  "deactivated.webhook.tip1": "停止通訊錄webhook接口回調，啟動後恢復",
  "activated.webhook.tip1": "啟動通訊錄webhook回調",
  "purview.webhook.tip1": "暫未獲取開放平臺權限",
  "push.event.flow": "流程事件",
  "outsider.to.user.tip": '外部聯系人轉成員為特殊操作，請核對身份，以免轉換後導致部分設置和數據異常',
  "user.to.outsider.tip": '成員轉外部聯系人為特殊操作，請核對身份，以免轉換後導致部分設置和數據異常',
  "outdiser.subadmin.tip1": '當子管理員為外部聯系人的時候，此屬性無效',
  "deactivated.form.tip1": "停止表單webhook接口回調，啟動後恢復",
  "activated.form.tip1": "啟動表單webhook回調",
  "searchApp": "請輸入應用或表單名稱",
  "searchAppForm": "搜索應用或表單名稱",
  "recycle.bin": "回收站",
  "delete.webhook.form.tip1": "刪除表單webhook回調設置，不再觸發接口？",
  "edit.form": "編輯表單",
  "move.app.toGroup": "移動應用到下面分組",
  "name.form.report": "請輸入表單/報表名稱",
  "input.app.name": "請輸入應用名稱",
  "input.form.name": "請輸入表單或報表名稱",
  "corpid.Enter.title": "請先綁定團隊的corpid",
  "corpid.Enter.inputTip": "請填寫企業corpid",
  "corpid.edit": "修改企業ID",
  "form.dash.empty": "表單或報表不存在",
  "app.dash.form.empty": "當前應用沒有可使用的表單或報表",
  "dash.not.select": "當前未選中任何報表",
  "dash.form.empty": "當前未搜索到相匹配的表單或報表",
  "app.all.empty": "當前未搜索到相匹配的應用",
  "add.already.num": "已添加{{num}}個",
  'Block.invalid': '報表已被刪除',
  'Block.invalid.1': '報表無權限訪問',
  "app.empty.tip1": '暫時還沒有應用，去創建一個應用開啟你的工作之旅吧',
  "platform.system": "平臺體系",
  "address.book.system": "通訊錄體系",
  "application.system": "應用體系",
  "key.management": "api密鑰",
  "api.res.params": "返回參數：",
  "api.res.noParams": "返回參數：無",
  "webhook.key": "密鑰：",
  "webhook.key.name": "密鑰名稱：",
  "webhook.key.name1": "密鑰名稱",
  "webhook.key.all.placeholder": "請輸入密鑰名稱",
  "webhook.key.all.error": "請輸入正確的密鑰名稱",
  "webhook.key.all.detail.tip": "擁有通訊錄和應用的全部接口權限",
  "webhook.key.all": "全部接口",
  "webhook.key.all.msg": "*該密鑰擁有通訊錄接口和所有應用的接口權限",
  "webhook.key.detail": "密鑰詳情",
  "webhook.key.create": "創建密鑰",
  "webhook.key.customize": "自定義密鑰",
  "webhook.key.app.select.title": "應用選擇",
  "webhook.key.del.title": "請確認是否刪除「{{name}}」該權限？",
  "webhook.key.customize.del.title": "請確認是否刪除該自定義權限？",
  "webhook.key.customize.menu": "自定義體系",
  "webhook.key.customize.empty": "當前沒有自定義應用體系，去新建一個吧~",
  "webhook.key.customize.create": "新建自定義體系",
  "webhook.key.customize.edit": "編輯自定義體系",
  "webhook.key.customize.title": "表單自定義權限組",
  "webhook.key.app.empty.title": "當前沒有應用體系，去新建一個吧~",
  "webhook.key.auth.empty.title": "當前沒有平臺體系權限，請聯系管理員",
  "webhook.key.create.first.app": "開始新建你的第一個應用",
  "webhook.key.create.app": "新建應用",
  "webhook.create.app.blank.application": "新建空白應用",
  "webhook.create.app.office.apps": "自己動手搭建辦公應用",
  "webhook.create.app.select.application.template": "選擇應用模版",
  "webhook.create.applications.from.template.center": "從模版中心安裝已有應用",
  "webhook.create.app.importing.installation.package": "導入安裝包",
  "webhook.create.app.import.application.installation.package.system": "導入應用安裝包到系統",
  "webhook.key.create.tip": "創建密鑰（自定義密鑰）",
  "webhook.re.key": "請確認是否重置「{{name}}」該密鑰的Api Key？",
  "webhook.re.key.placeholder": "請輸入密鑰名稱",
  "webhook.re.key.tip": "輸入的密鑰名稱不正確，請確認後重新輸入",
  "flow.ding.max.len": "最多只能钉{{num}}个表单",
  "flow.min.len": "当前菜单最少需要保留{{num}}个表单",
  "no.set.page": "当前没有设置入口页面",
  "form.backflowidName": "来自{{name}}的回退",
  "form.backflowidName.title": "来自{{name}}",
  "form.backflowidName.end": "的回退",
  "dash.agree": '符合',
  "dash.agree1": '筛选条件的数据',
  "dash.full.autoRefresh.tip": "全屏模式下会自动刷新数据",
  "webhook.key.empty.tip": "当前没有密钥，去新建一个吧~",
  "login.mirror.access": "訪問鏡像",
  "login.mirror.access.quit": "退出鏡像訪問模式",
  "login.mirror.access.title": "鏡像訪問",
  "login.mirror.access.title.mobile": "鏡像訪問模式",
  "login.mirror.access.tip.title": "鏡像模式",
  "login.mirror.system.tip.title": "{{time}}系統鏡像",
  "login.mirror.access.msg": "只讀模式，可下載，不能進行編輯，用於找回誤操作的數據。",
  "login.mirror.access.tip": "訪問{{time}}的系統鏡像，只讀模式，可下載，用於找回誤操作的數據。",
  "login.mirror.header.msg": "{{time}}的鏡像數據，僅管理員登錄",
  "login.mirror.access.msg1": "只讀模式,可下載,不能進行編輯,用於找回誤操作的數據，只有團隊的系統管理員可以訪問。",
  "login.mirror.title.msg": "僅管理員登錄",
  "login.mirror.signin": "管理員登錄",
  "dashboard.flow.todo.set": "拖動以下組件到右側來設置工作臺",
  "dashboard.page.components": "頁面組件",
  "latest.to.do": "最新待辦",
  "all.to.do": "全部待辦",
  "latest.to.do.urge": "最新催辦",
  "about.to.time.out": "即將超時",
  "todo.from": "來自",
  "todo.empty.msg": "暫無待辦消息",
  "dashboard.all.app.tip": "配置過程僅展示部分應用，訪問工作台時顯示全部的應用",
  "dashboard.all.entry.tip": "配置過程僅展示部分表單，訪問工作臺時顯示全部的表單",
  "self.build": "自建",
  "close.custom.dash": "關閉自定義工作臺",
  "login.qywechat.self": "企業微信自建登錄",
  "design.close.msg": "您常用的應用、表單、報表可以自由布局添加到工作臺了！更快提升您的工作效率！",
  "design.custom.open": "開啟自定義工作臺",
  "design.close.alert.title": "您確定要關閉自定義工作臺嗎？",
  "dash.map.window.title": "信息列表",
  "dash.map.marker.empty.tip": "请在地图报表上添加需要设置的坐标点（点击地图或者通过搜索地址添加坐标点）",
  "design.close.alert.msg": "这会使您的工作台回到默认样式，此操作无法撤销。",
  "address.book.dept.set.title": "設置職稱",
  'jobtitle.set': "設置成員所在部門的職稱",
  'address.book.dept.set.title.select': "請選擇職稱",
  'address.book.dept.jobtitle.add': "添加職稱",
  'address.book.dept.jobtitle.addnew': "添加新職稱",
  'address.book.dept.jobtitle.addnew.tip': "每行代表一個職稱，且不超過16個字符",
  'address.book.dept.jobtitle.addnew.no-permission': "用戶不在當前部門",
  "qywechat.bind.activation.tip": "企業微信體驗時間還剩餘{{ day }}天，為了不影響您的正常體驗，請馬上激活",
  "qywechat.bind.select.user": "請選擇需要登錄的團隊",
  "install.app.title": "安裝【{{appName}}】應用",
  "install.app.tip": "獲取後可以進行個性化改造",
  "install.app.wechat.title": "在線聯繫客服",
  "install.app.ok": "確認安裝",
  "install.app.cancel": "取消安裝",
  "package.base.title": "基礎功能購買",
  "package.buy.title": "自定義套餐購買",
  "package.base.dataview.grouptable.begin": "{{num}}個起步升配",
  "package.base.member.begin": "{{num}}人起步升配",
  "package.base.flow.begin": "{{num}}G起步升配",
  "package.base.data.begin": "{{num}}萬數據起步升配",
  "package.base.flow.num": "{{num}}G",
  "package.base.data": "數據量",
  "package.base.member": "用戶數",
  "package.base.dataview.grouptable.unit": "{{num}}元/個/年",
  "package.base.member.unit": "{{num}}元/人/年",
  "package.base.flow.unit": "{{num}}元/G",
  "package.base.data.unit": "{{num}}元/萬數據/年",
  "package.base.purchased": "已購：",
  "package.base.not.purchased": "未購：",
  "package.base.check.order": "查看訂單",
  "package.base.update": "升配",
  "package.details": "套餐詳情",
  "package.details.base": "基礎配置：",
  "package.app.install.num": "應用安裝個數",
  "package.site.webapi": "開放平台-平台級接口",
  "num.ge": "{{num}}個",
  "appstore.guide.step1.title": "創建您的<span>第一個應用</span>",
  "appstore.guide.step1.desc": "您可以<span>創建空白應用</span>，自行搭建",
  "appstore.guide.step2.desc": "或者，您也可以<span>安裝應用中心的應用</span>，直接使用或自行進行個性化改造",
  "sso.empty.config.tip": "暫未配置單點登錄，配置後可以更方便您登錄操作",
  "purview.sso.tip": "暫未獲取單點登錄權限",
  "sso.config.content.title": "單點登錄配置內容",
  "sso.other.team.tip": "第三方團隊不支持單點登錄",
  "qiyewechat.custom": "企業微信通訊錄激活",
  "qiyewechat.custom.tip": "企業微信通訊錄激活，激活後，才可以正常獲取企業微信的通訊錄信息",
  "qiyewechat.custom.active": "去激活",
  "qiyewechat.custom.active.code": "打開企業微信掃描下方二維碼，授權待開發自建應用，激活通訊錄",
  "qiyewechat.custom.active.code2": "授權完成後，請等待官方審核，審核通過後即可激活通訊錄",
  "qiyewechat.phone.entry.tip": "請填寫企業微信綁定的手機號",
  'clean.select.item': '清空所選項',
  'outlink.tip.user': '表單外鏈不支持成員控件',
  'outlink.tip.usergroup': '表單外鏈不支持成員多選控件',
  'outlink.tip.dept': '表單外鏈不支持部門控件',
  'outlink.tip.deptgroup': '表單外鏈不支持部門多選控件',
  'data.manager.alldata.edit': '全部数据',
  'data.manager.filterdata.edit': '筛选后的数据',
  'data.manager.alldata.exportfile': '全部数据的附件',
  'data.manager.filterdata.exportfile': '筛选后数据的附件',
  'data.manager.alldata.qrcode': '全部数据的二维码',
  'data.manager.filterdata.qrcode': '筛选后数据的二维码',
  'field.widget.name': '字段原始别名',
  'deleted.outdiser': '已刪除的外部聯系人',
  'default.group': '默認分組',
  'waiting.new': '已等待',
  'wps.xlsx.name1': '外部聯系人批量導入模板.xlsx',
  'wps.xlsx.name2': '連接企業批量導入模板.xlsx',
  'wps.xlsx.file.name': '通訊錄批量導入模板.xlsx',
  'invite.phone.required': '必須填寫正確的手機號',
  'invite.email.required': '必須填寫正確的郵箱',
  "email.entry.tip": "請填寫正確的郵箱",
  'member.invitation.import': '成員邀請導入',
  'consolidate.departments.groups': '部門/角色組處理方式',
  'consolidate.departments.groups.tip': '當導入已存在的成員時，部門/角色組是覆蓋模式還是合並模式，其他不需要驗證的信息覆蓋',
  'before.del': '刪除前',
  'consolidate.departments.groups.title': '用戶已存在，是否合並部門和角色？',
  merge: '合並',
  "dept.entry.tip": "請填寫需要加入的部門",
  'url.join.dept.tip': '訪問鏈接直接加入部門',
  'dept.entry.tip1': '最少需要選擇一個部門',
  'personnel.invitation': '人員邀請',
  'personnel.invitation.tip': '具備對所有人員邀請權限',
  'member.invitation': '成員邀請',
  'external.contact.invitation': '外部聯系人邀請',
  'personnel.deletion': '人員刪除',
  'personnel.deletion.tip': '具備對所有人員刪除權限',
  'member.deletion': '成員刪除',
  'external.contact.deletion': '外部聯系人刪除',
  'department.external.group.deletion': '部門/外部聯系人分組刪除',
  'department.external.group.deletion.tip': '具備對所有部門/外部聯系人分組刪除權限',
  'department.deletion': '部門刪除',
  'job.select.tip': '點擊選擇職位',
  'group.deletion': '外部聯系人分組刪除',
  "member.not.verify.tip1": '有<span style="color: #F5222D;margin:0 2px">{{num}}</span>個手機/郵箱未驗證，<span class="inv" style="color: var(--bsy-base-color);cursor: pointer;">再次全部驗證</span>',
  "click.ver": "點擊驗證",
  "contact.note.title": "備註",
  manager1: "管理員",
  'join.time': '加入時間',
  'department.ownership': '部門歸屬',
  'verified.phone.tip': '手機已驗證，您無法修改。如需修改請聯系成員在個人設置頁面重新綁定。',
  'verified.email.tip': '郵箱已驗證，您無法修改。如需修改請聯系成員在個人設置頁面重新綁定。',
  "verify.all.tip": "是否再次驗證全部未驗證的手機郵箱？",
  "corp.management": "企業管理",
  "select.loginer.placeholder": "請選擇登錄人",
  "applications.object.placeholder": "請選擇應用/對象",
  "enter.old.password": "請輸入舊密碼",
  "enter.new.password": "請輸入新密碼",
  "enter.again.new.password": "請重新輸入新密碼",
  "app.belong": "所屬應用",
  "corp.log.tip": "保存最近{{num}}個月的操作日誌",
  "remind.setting": "提醒設置",
  "operate.detail": "操作詳情",
  "corp.login.time": "登錄時間",
  "corp.login.member": "登錄人",
  "corp.login.city": "登錄地",
  "corp.login.platform": "登錄平台",
  "corp.login.info.tip": "保存最近{{num}}個月的登錄日誌",
  "corp.login.statistics.info": "統計最近30天的登錄情況",
  "corp.op.statistics.info": "統計最近30天的操作情況",
  "corp.op.statistics": "操作統計",
  "corp.login.statistics": "登錄統計",
  "corp.usage.range": "統計範圍",
  "corp.usage.counts": "人數",
  "corp.usage.loginStats": "每日登錄人數",
  "corp.usage.times": "次數",
  "corp.usage.dataCreateStats": "每日數據創建人數&次數",
  "corp.usage.dataDownStats": "每日文件下載人數&次數",
  "corp.usage.dataExportStats": "每日數據導出人數&次數",
  "corp.usage.dataUpdateStats": "每日數據修改人數&次數",
  "corp.usage.stats": "每日使用人數",
  "operate.object": "操作對象",
  "applications.object": "應用/對象",
  "corp.log.app.filter": "篩選此應用",
  "corp.log.object.filter": "篩選此物件",
  "member.deleted": "已刪除成員",
  "outsider.deleted": "已刪除外部聯系人",
  "login.log": "登錄日誌",
  "enterprise.log": "企業日誌",
  "platform.log": "平臺日誌",
  "application.log": "應用日誌",
  "export.logs": "導出日誌",
  "log.range": "日誌範圍",
  "log.type": "日誌類型",
  "all.data.print": "拼接打印",
  "one.data.print": "逐條打印",
  "all.data.print.tip": "（所有數據合成一個打印文件）",
  "one.data.print.tip": "（每條數據合成一個打印文件）",
  "data.printTemplate1": "打印模板",
  "data.printTemplate1.tip": "請選擇打印模板",
  "print.method": "打印方式",
  "data.word": "Word預覽",
  "corp.coop": "互聯組織",
  "corp.coop.authorization": "互聯組織授權",
  "corp.coop.authorization.subtitle": "輸入並驗證手機即可授權，授權後可與合作夥伴基於本平臺實現線上業務協作。",
  "corp.coop.contact.request.already": "對方已接管您的通訊錄許可權，無需重複操作。",
  "corp.coop.contact.request.already.title": "已移交通訊錄許可權",
  "corp.coop.contact.request.fail": "連結失效，無法移交通訊錄許可權，請聯繫對方企業負責人重新發送。",
  "corp.coop.contact.request.success": "對方可以説明您管理成員，您也可以在「通訊錄」重新接管許可權。",
  "corp.coop.contact.request.success.title": "通訊錄許可權移交成功",
  "corp.coop.manage.prev.tip": "可預設代管對方通訊錄，代管狀態下可以自主給對方通訊錄添加成員",
  "contact.corp.all": "全部企業",
  "contact.corp.connect.establish": "建立連接關係",
  "contact.corp.connect.established": "已建立連接關係",
  "contact.corp.connect.expired.tip": "連結失效，無法建立協作關係，請聯繫對方企業負責人重新發送連結。",
  "contact.corp.connect.expired.title": "連結已失效",
  "contact.corp.connect.fail": "連接建立失敗",
  "contact.corp.connect.fail.creator": "您的手機號不是企業建立者身份，不能通過此連結建立連接關係，請聯繫對方確認。",
  "contact.corp.connect.fail.detail": "連接關係建立失敗",
  "contact.corp.connect.fail.permission": "對方企業已不具備連接許可權，請聯繫對方處理",
  "contact.corp.connect.fail.phone": "未匹配到手機號，請聯繫對方確認。",
  "contact.corp.connect.fail.tip": "對方企業連接剩餘連接額度不足，請聯繫對方處理。",
  "external.dept": "外部企業",
  "contact.handover": "外部對接人",
  "contact.handover.add": "添加對接人",
  "contact.handover.add.again": "再次添加",
  "contact.handover.add.again.fail": "此企業的建立者尚未授權，暫時無法添加此成員，請先邀請建立者建立連接后再添加",
  "corp.coop.empty.tip1": "通過「互聯組織」功能可以連接經銷商、供應商、母子公司等外部合作夥伴",
  "corp.coop.empty.tip2": "連接後可以將你的表單/流程權限分配給對方，線上完成企業間數據填報、流程審批等",
  "corp.coop.empty.tip3": "快來連接合作夥伴，提升企業間協作效率吧",
  "contact.connection.new": "新建連接",
  "contact.connection.new.link": "公開連結邀請",
  "contact.connection.new.multi": "批量導入邀請",
  "contact.connection.remove": "解除連接",
  "contact.connection.remove.confirm.tip": "解除連接后，不能和該企業進行業務協作，此操作不可還原。",
  "contact.connection.remove.confirm.title": "確定要解除連接？",
  "contact.connection.remove.empty": "請選擇要解除連接的企業",
  "contact.connection.selected.remove": "確定和選擇的企業解除連接？",
  "contact.connection.selected.remove.tip": "解除連接后，不能和對應企業進行業務協作，此操作不可還原。",
  "contact.connection.tip.url.msg": "連接對方企業時需要發送邀請連結，您當前暫無可用的連結，請配置后重試。",
  "contact.connection.tip.url.title": "沒有可用的邀請連結",
  "contact.connection.upgrade.tip.manager": "連接企業數量已達上限，您可以聯繫企業創建者升級版本，或移除無用連接后再新建。",
  "contact.connection.upgrade.tip.owner": "系統用量受到限制，您是否要立即升級？",
  "contact.connection.vip.upgrade": "您當前使用的版本不包含互聯組織功能，您可以至「企業管理-版本資訊」查看版本使用詳情和升級版本。",
  "contact.connection.vip.upgrade.manager": "您當前使用的版本不包含互聯組織功能，請聯繫企業創建者升級版本。",
  "dept.label.add": "添加企業標籤",
  "contact.handover.all": "全部對接人",
  "contact.handover.click.select": "點擊選擇對接人",
  "contact.handover.corp": "歸屬企業",
  "contact.handover.corp.empty": "請選擇對接人所屬企業",
  "contact.handover.corp.placeholder": "必填，請選擇對接人所屬企業",
  "contact.handover.current": "我方對接人",
  "contact.handover.current.add.tip": "設置我方對接人可以讓不同的員工和不同的連接企業對接，便捷的開展業務協作。",
  "contact.handover.empty": "此分類下暫無工作",
  "contact.handover.export.all": "匯出全部",
  "contact.handover.guest": "可管理的外部對接人",
  "contact.handover.guest.empty": "對接人一般負責企業間的業務協作。 您可以給連接企業的對接人分配本企業的應用/表單許可權，開展相關協作事宜。 請聯繫對方企業負責人設置對接人。",
  "contact.handover.host": "僅查看的外部對接人",
  "contact.handover.host.empty": "對方企業管理者沒有設置對接人",
  "contact.handover.invite.tip": "代管通訊錄企業中有 {{count}} 名對接人未加入",
  "contact.handover.list": "對接人清單",
  "contact.handover.name": "對接人姓名",
  "contact.handover.name.required": "請輸入對接人姓名",
  "contact.handover.name.too.lang": "對接人姓名最長80個字元",
  "contact.handover.not.join.tip": "有 {{count}} 名對接人未授權加入企業",
  "contact.handover.other": "對方對接人",
  "contact.handover.phone.required": "請輸入手機號",
  "contact.handover.role": "對接人角色",
  "contact.handover.role.empty": "當前沒有角色，請創建",
  "contact.handover.title": "有以下工作，可根據需要轉交給其他成員",
  "contact.is.owner": "是否為建立者",
  "label.list": "標籤清單",
  "label.name": "標籤名稱",
  "label.name.input": "請輸入標籤名稱",
  "label.name.notEmpty": "標籤名稱不能為空",
  "label.name.notSame": "標籤名稱不能重複",
  "label.name.tooLong": "標籤名稱不能超過{{length}}個字元",
  "label.select1": "點擊選擇企業",
  "label.target.add.max": "最多添加{{count}}個企業標籤",
  enterprise: "企業",
  "contact.docker.empty": "暫無對接人",
  "contact.docker.empty.tip": "暫無相關對接人",
  "contact.docker.invite.success.tip": "添加邀請發送成功",
  "contact.docker.our.edit.tip": "我方對接人可以直接參與互聯企業協作，修改後不可還原。",
  "contact.docker.our.edit.title": "確定修改我方對接人？",
  "contact.docker.remove.tip": "移除后，此對接人無法再參與和此連接企業的業務協作，此操作不可還原。",
  "contact.docker.remove.title": "確定移除此對接人？",
  "contact.docking.corp": "對接企業",
  "contact.docking.corp.tip": "對接已經建立和未來建立連接關係的所有企業",
  "contact.docking.people": "對接人",
  "contact.docking.people.require": "請選擇對接人",
  "member.invite.phoneOrEmail.placeholder": "輸入手機號或郵箱來邀請成員，多個成員之間使用逗號、分號或換行隔開每個手機號或郵箱每天最多邀請3次",
  "member.invite.public.link": "公開連結邀請",
  "member.invite.public.setLink": "設置連結",
  "member.invite.public.setLink.text": "將下方鏈接分享給合作夥伴，對方點擊即可建立連接關係；建議預設企業標籤、角色等屬性后分享。",
  "member.invite.public.tip.title": "公開連結邀請適用場景",
  "member.invite.public.tip1": "當合作夥伴「已有{{productName}}帳號」時，只能用公開連結邀請。 推薦通過微信發送邀請連結。",
  "member.invite.public.tip2": "當合作夥伴「想在釘釘/企業微信/飛書上使用{{productName}}」時，需先在對應平臺上完成對接後，再用公開連結邀請。",
  "member.invite.public.tip3": "當合作夥伴「沒有{{productName}}帳號」時，可以用公開連結邀請對方註冊。",
  "member.invite.qrcode.brief": "尊敬的合作夥伴，誠摯邀請您掃碼與我建立協作關係，基於「{{productName}}」實現企業間數據填報、流程審批等。",
  "member.invite.report": "你可以發佈報表給他/她查看。",
  "member.invite.role": "你可以將他/她設置為不同角色，參與業務管理。",
  "member.invite.send": "發送邀請",
  "member.invite.sms.send": "發送邀請簡訊",
  "member.invite.success": "邀請成功！",
  "member.invite.tip": "邀請成員加入一起管理企業的業務",
  "member.invite.title": "企業中沒有成員，是否邀請？",
  "contact.connection.link.tip": "通過此連結邀請的企業/對接人預設設置如下",
  "persona.corp.dept.label": "企業標籤",
  "manager.contactAuth": "通訊錄許可權",
  "link.add": "添加連結",
  "link.address": "連結位址",
  "link.copy.success": "連結已複製",
  "link.edit": "編輯連結",
  "link.edit.fail": "不能同時編輯多條連結，請保存後重試",
  "link.failure": "鏈接已失效",
  "link.qrcode": "連結二維碼",
  "link.share": "分享連結",
  "openLink.auth.name.enterprise": "企業名稱",
  "corp.search": "搜索企業",
  "corp.team.name": "企業/團隊名稱",
  "corp.coop.delete.tip": "刪除企業標簽不會刪除此企業標簽中包含的對接企業。",
  "corp.role.delete.tip": "刪除角色會同時刪除該角色的權限，但不會刪除此角色中包含的對接人。",
  "contact.corp.panel.tip": "此頁面展示你主動邀請的企業，邀請成功后給他們分配表單/流程許可權即可協作",
  "contact.handover.panel.tip": "此頁面展示你主動邀請的企業的成員，邀請成功后給他們分配表單/流程許可權即可協作",
  "function.intro.detail": "功能詳細介紹",
  "label.dept.new": "添加企業",
  "label.set": "設置標籤",
  "role.set": "設置角色",
  "remove.out": "拿掉",
  "invite.link": "連結邀請",
  "qrCode.download": "下載二維碼",
  "contact.escrow.setting.tip": "可設置代管對方通訊錄，代管狀態可以自主給對方通訊錄添加成員",
  "label.setting": "設置企業標籤",
  "contact.corp.handover.set": "設置對接人",
  "link.state": "鏈接狀態",
  "links.at.least.one": "至少保留 1 條連結",
  "corp.coop.manage.apply.tip": "沒有對方通訊錄操作許可權，無法添加對接人。請線下聯繫對方添加或申請對方通訊錄管理許可權",
  "corp.coop.dept.manage.apply.tip": "沒有對方通訊錄操作許可權，無法添加對接部門。請線下聯繫對方添加或申請對方通訊錄管理許可權",
  "wechat.official.account.follow.instruction": "搜索或掃碼關注「{{productName}}」官方公眾號，手機即時查看資訊&處理待辦",
  "wechat.qrcode.instruction": "請使用微信掃碼或在微信中長按識別",
  "wechat.rebind.tip": "當前登錄帳號已綁定其他微信帳號，是否換綁到當前微信帳號?",
  "contact.corp.connect.fail.title": "業務協作關係建立失敗",
  "contact.corp.connect.fail.wrong.phone": "您的手機號不是企業建立者身份或已通過其他方式註冊帳號，不能通過此連結建立連接關係，請聯繫對方確認。",
  "contact.corp.connect.member.tip1": "您不是當前登陸企業的建立者、系統管理員或無互聯組織許可權，無法建立連接",
  "contact.corp.connect.member.tip2": "如果您需要繼續操作，請切換至您是建立者、系統管理員或有互聯組織許可權的企業",
  "contact.corp.connect.no.corp": "當前帳號下沒有任何企業，請創建新企業或加入其他企業后重試",
  "contact.corp.connect.query.tip": "連接關係建立后，我方成員可以訪問對方開放許可權的應用/表單，實現企業間數據填報、流程審批等。",
  "contact.corp.connect.query.title": "企業「{{name}}」想和您建立企業連接，開展業務協作，是否接受？",
  "contact.corp.connect.self.tip1": "當前登錄企業是發送連結的企業，無法和自己建立連接",
  "contact.corp.connect.self.tip2": "如果要繼續操作，請切換其他企業",
  "contact.corp.connect.success": "連接關係建立成功",
  "contact.corp.connect.success.register": "已成功註冊並建立連接關係",
  "contact.corp.connect.success.tip": "您的合作夥伴已經用{{productName}}實現企業內部業務管理，後續雙方可以基於【{{productName}}】開展企業間業務協作，預祝協作順利！",
  "contact.corp.connect.success.tip1": "需要設置雙方業務協作人，在{{productName}}中我們將協作人稱為「對接人」",
  "contact.corp.connect.success.tip2": "你可以現在設置對接人，也可以後續在「通訊錄-互聯組織」中調整",
  "contact.corp.connect.success.title": "業務協作關係建立成功",
  "contact.corp.docker.set.success": "對接人設置完成",
  "contact.corp.empty": "沒有對接此類的企業",
  "contact.corp.empty.tab": "暫無此類企業",
  "contact.corp.link.query.tip": "連接關係建立後，您可以使用對方製作的應用程式/表單等內容，實現企業間資料填寫、流程核准等。如果已有{{productName}}帳號請 直接登入建立連接，沒有帳號請先註冊。",
  "contact.corp.link.query.title": "企業「{{name}}」想基於{{productName}}和您建立企業連接，開展業務協作。 ",
  "contact.corp.list": "企業列表",
  "contact.corp.not.connection.single": "此企業創建者尚未授權建立連線關係",
  "contact.corp.owner.info": "創建者：{{name}}",
  "contact.corp.link.query.login": "已有帳號，直接登錄",
  "contact.corp.link.query.register": "註冊新帳號",
  "contact.corp.handover.set.not": "暫不設置",
  "contact.corp.has.connect.tip1": "已經和企業「{name}」建立連接",
  "contact.corp.has.connect.tip2": "請聯繫對方企業管理員給您分享應用/表單許可權，實現企業間數據填報、流程審批等。",
  "contact.learn.bs": "瞭解{{productName}}",
  "receiver.enter.homepage": "進入{{productName}}",
  "corp.joined1": "已加入「{{corp}}」",
  "contact.corp.not.connection.tip": "有 <b style=\"color:#FF634E;font-weight: normal; \">{{count}}</b> 個導入的企業未同意建立連接關係",
  "member.invite.link.change": "修改邀請連結",
  "member.invite.link.copy": "複製邀請連結",
  "contact.docker.email.verify.tip": "郵箱未驗證，不能接收消息，請聯繫該成員登錄{{productName}}驗證。",
  "contact.docker.phone.verify.tip": "手機未驗證，不能接收消息，請聯繫該成員登錄{{productName}}驗證。",
  "label.select": "點擊選擇企業標籤",
  "member.invite.copy.link": "尊敬的合作夥伴，誠摯邀請您與我建立連接關係，基於「{{productName}}」實現企業間數據填報、流程審批等。 期待與您的合作！\n邀請人：{{name}}\n邀請鏈接：{{link}}",
  "member.invite.copy.link.brief": "尊敬的合作夥伴，誠摯邀請您與我建立連接關係，基於「{{productName}}」實現企業間數據填報、流程審批等。",
  "contact.corp.host": "邀請我協作的企業",
  "contact.corp.some": "部分企業",
  "contact.escrow": "代管通訊錄",
  "escrow.disabled": "不代管",
  "docker.role.setting": "設置對接人角色",
  "member.invite.public.link.success.tip": "推薦您連接關鍵決策者，以便合理安排協作工作的內容與許可權",
  "configuration.success": "配置成功！",
  "link.not.yet": "暫不連接",
  "label.dept.empty.corp.tip": "可以用企業標籤給邀請的合作夥伴分類，如供應商、轉銷商等。 當前標籤下沒有對接企業，請添加。",
  "label.dept.empty.tip": "可以用企業標籤給邀請的合作夥伴分類，如供應商、經銷商等。當前你還沒有企業標籤，請先添加",
  "role.current.member.empty.add": "當前角色下沒有成員，請添加",
  "contact.external.role.list": "外部角色清單",
  "organization.internal": "內部組織",
  "organization.external": "外部組織",
  "organization.interconnected": "互聯組織",
  "contact.template.corp.cooperation.tip.1": "當「合作夥伴沒有{{productName}}帳號且不想自己註冊」可以使用批量導入的方式。",
  "contact.template.corp.cooperation.title": "批量導入邀請適用場景",
  "contact.template.corp.import.tip": "每次最多導入{{corpCount}}家企業，每家企業最多導入{{memberCount}}名成員",
  "contact.template.download": "下載導入範本",
  "contact.template.download.tip": "請下載{{link}}，按格式修改後導入",
  "contact.template.import.after": "導入成功後會自動發送邀請簡訊，合作夥伴點擊簡訊即可連接",
  "contact.template.import.link": "您也可以通過微信，直接分享下方鏈接給合作企業創建者，綁定官方公眾號並建立連接",
  "file.select.detail": "選擇或拖拽上傳文件,單個{{num}}MB以內",
  "create.after.excel.import": "成功導入Excel後生成",
  "error.19004": "與目標企業不存在關聯關係",
  "error.19008": "該名稱已存在，請調整后重試",
  "error.19013": "最多添加 20 個對接人",
  "error.19014": "檔內沒有可導入的企業，請調整后重新上傳",
  "error.19017": "此使用者已經是該企業的對接人，請勿重複添加",
  "error.19019": "角色名稱不能重複",
  "error.19020": "最多添加200個角色",
  "error.19021": "每天僅可發送 1 次邀請，請明天重試",
  "corp.import.complete": "成功導入{{count}}家企業",
  "corp.import.complete.docker.fail": "成功導入{{count}}家企業，部分成員未導入",
  "corp.import.not.complete": "成功導入{{successCount}}家企業，失敗<i style=\"color: var(--bsy-base-error-color)\">{{failCount}}</i>家",
  "app.dock": "外部應用",
  "corp.label.empty.tip": "企業標簽名稱不能為空",
  "corp.role.empty.tip": "對接人名稱不能為空",
  "corp.label.max.tip": "企業標簽名稱最長不能超過{{length}}個字符",
  "corp.role.max.tip": "對接人名稱最長不能超過{{length}}個字符",
  "contact.role.notEmpty": "對接人角色名稱不能為空",
  "contact.manage.auth.request": "申請代管通訊錄",
  "contact.manage.auth.request.success": "代管申請已發送",
  "contact.manage.auth.transfer": "移交代管許可權",
  "contact.manage.auth.transfer.msg": "移交后將失去添加對方對接人的許可權，將由連接的企業自主添加對接人，此操作不可還原。",
  "contact.manage.auth.transfer.title": "確定要移交代管許可權？",
  "contact.member.join.success.tip": "可以和同事一起在【{{productName}}】填報數據、審批流程等，在線協同辦公，提高工作效率。",
  "contact.member.join.success.title": "成功加入企業",
  "message.sended": "添加信息已發送",
  "contact.handover.add.all.again": "全部再次添加",
  "contact.connect.host.corp": "連接對方企業",
  "label.dept.remove.empty": "請選擇要移出的對接企業",
  "label.dept.selected.remove": "確定從此企業標籤中移出所選對接企業？",
  "label.dept.selected.remove.tip": "從此標籤中移出所選對接企業不會解除與其建立的連接。",
  "contact.our.docker.remove.empty": "請選擇要移除的對接人",
  "contact.our.docker.remove.out.empty": "請選擇要移出的對接人",
  "contact.our.docker.remove.tip": "移除后，對接人無法再參與互聯企業協作，此操作不可還原。",
  "contact.our.docker.remove.title": "確定移除所選對接人？",
  "contact.role.docker.remove.tip": "移出后，對接人無法再參與此角色相關的外部企業協作，此操作不可還原。",
  "contact.role.docker.remove.title": "確定從此角色中移出所選對接人？",
  "contact.handover.role.add": "添加對接人角色",
  "contact.take.over": "自主管理通訊錄",
  "contact.take.over.msg": "自主管理后，協作企業將失去相關許可權，與對方的業務協作對接人需要你自主維護。 此操作不可還原。",
  "contact.take.over.tip1": "你的通訊錄暫時由協作企業「{{corp}}」代為管理，你沒有操作許可權",
  "contact.take.over.tip2": "點擊下方按鈕獲取許可權，之後你可以進行邀請成員、添加部門等操作",
  "contact.take.over.title": "確定要自主管理通訊錄嗎？",
  "contact.dailog.over.title": "你確定要離開當前頁面嗎？",
  "contact.dailog.over.tip": "離開當頁面後，你所做的修改不會被保存",
  "external.member.invite.tip1": "開啟后，只需訪問此連結，即可加入企業並自動成為對接人",
  "external.member.invite.tip2": "可將此連結分享給對方企業創建者，讓其在企業內分發給相關員工",
  "organization.external.user": "外部組織成員",
  "organization.internal.user": "內部組織成員",
  "organization.external.flow": "外部流程",
  "organization.internal.flow": "內部流程",
  "contact.search.name": "搜索姓名",
  "corp.coop.manage.integrated.tip": "對方將{{productName}}集成在企業微信/釘釘/飛書等平臺，無法直接添加對接人，請線下聯繫對方添加。",
  "dock.flow.todo": "外部待辦",
  "signin.qrcode": "掃碼登錄",
  "mobile.num.login": "手機號登錄",
  "crm.authority": "許可權",
  "app.edit.child.group.create": "新建子分組",
  "app.edit.move.tip": "此分組內有子分組，不能通過「移動」的方式排序，請直接拖拽排序。",
  "main.department": "主部门",
  "max.two.level.group": "當前最多只能支持兩級分組",
  "system": "系统",
  "trigger.create.app": "新建应用时推送",
  "trigger.create.form": "新建表单时推送",

  "page.error.tip": '系統出小差了，请联系管理员处理',
  "flow.time.start": "流程發起時間",
  "flow.my.transactors.time": "我最近處理的節點時間",
  "flow.my.cc.time": "節點抄送時間",
  "custom.dashboard.subtitle.layout": "佈局元件",
  "custom.dashboard.subtitle.left.bar": "左側邊欄",
  "custom.dashboard.subtitle.middle.bar": "單欄",
  "custom.dashboard.subtitle.page": "頁面元件",
  "custom.dashboard.subtitle.right.bar": "右側邊欄",
  "custom.dashboard.toast.empty": "儲存失敗，請新增「頁面元件」",
  "custom.dashboard.subtitle.tab.bar": "標籤容器",
  "manage.dashboard.design": "管理工作台",
  "set.worker.dashboard.design": "設定企業工作台",
  "create.dashboard.design": "新建工作台",
  "create.dashboard.design.tip": "請輸入工作台名稱",
  "select.dashboard.design": "選擇工作台",
  "set.dashboard.design.auth": "設定權限",
  "set.dashboard.design.auth.msg": "新增成員，授權他們查看並使用該工作台",
  "set.dashboard.design": "設定工作台",
  "dashboard.design.delete.title": "您確定要刪除工作台「{{name}}」嗎？",
  "dashboard.design.delete.tip": "刪除工作台則佈局、表單、報表以及資料也都會一併刪除，此操作不可逆！",
  "dashboard.design.auth.title": "設定檢視使用權限",
  "dashboard.design.auth.msg": "在此分組內的成員可以檢視並使用該工作台",
  "close.custom.design": "關閉我的工作台",
  "design.custom.close.alert.title": "您確定要關閉我的工作台嗎？",
  "design.custom.close.alert.msg": "這會使我的工作台回到預設樣式，此操作無法撤銷。",
  "design.custom.create.alert.title": "如需進行此操作，請先儲存目前工作台",
  "speedy.entry.settings": "設定快速入口",
  "speedy.entry.tab.component": "元件屬性",
  "speedy.entry.tab.entryItem": "入口屬性",
  "speedy.entry.tab.entryItem.emptyTip": "在左側點選選擇入口來設定屬性",
  "speedy.entry.title.overLength": "標題不能超過{{count}}個字元",
  "speedy.entry.unnamed": "未命名快速入口",
  "speedy.entry.displayStyle": "入口樣式",
  "speedy.entry.entryList": "入口清單",
  "speedy.entry.add.entry": "新增入口",
  "speedy.entry.add.title": "添加表單應用",
  "speedy.entry.add.max": "最多新增{count}個",
  "app.form": "表單應用",
  "print.file.name.custom": "自訂名稱",
  "speedy.entry.entryItem.customIcon": "自訂圖示",
  "speedy.entry.entryItem.openType": "開啟方式",
  "speedy.entry.entryItem.openType.current": "當前頁面",
  "speedy.entry.entryItem.openType.newPage": "新頁面",
  "speedy.entry.entryItem.openType.tips": "僅在電腦端生效，行動端為目前頁面開啟",
  "speedy.entry.entryItem.source": "入口來源",
  "dash.report": "分析報表",
  "change.icon": "修改圖示",
  "modify.system.icon": "系統圖示",
  "modify.upload.maxLimit": "請選擇5MB以內的jpg、jpeg、gif 或 png圖片",
  "image.upload.size.tip": "建議尺寸{{width}}*{{height}}像素",
  "modify.upload.icon": "選擇上傳新圖片",
  "avatar.image.change": "更換圖片",
  "change.switch.design": "切換工作台",
  "dashboard.design.error.tip": "工作台名稱不能為空白",
  "my.dash": "我的報表",
  "add.my.dash": "新增我的報表",
  "my.chart.view.desc": "無須統一配置，由成員自行新增常用的圖表",
  "my.chart.favorites.desc": "無須統一配置，由成員自行收藏常用的應用/表單/報表",
  "icon.replacement.failed": "自訂圖示更換失敗！",
  "icon.replacement.successful": "自訂圖示更換成功！",
  "speedyEntry.empty.tip": "請在右側元件屬性中新增入口",
  "speedyEntry.card.style.horizontal": "卡片樣式橫排",
  "speedyEntry.card.style.row": "卡片樣式豎排",
  "speedyEntry.card.list.style": "列表樣式",
  "design.warning.msg": "自訂工作台名稱不能為空白",
  "design.warning.msg1": "自訂工作台名稱長度不能超過26位元",
  "user.relation": "成員關係",
  "add.user.relation": "點擊新增成員",
  "add.relation.user": "新增成員關係",
  "add.relation": "新建成員關係名稱",
  "new.relation": "新關係",
  "relation.duplicate.name": "關係名稱不能重複",
  "relation.empty.name": "關係名稱不能為空",
  "join.all.tip": "是否再次邀請全部未加入的成員？",
  "relation.save.user.tip": "有未填入完整的成員關係，請檢查後再進行儲存",
  "relation.name": "關係名稱",
  "user.relation.list": "成員關係清單",
  "contact.handover.other.dept": "對方對接部門",
  "contact.handover.current.dept": "我方對接部門",
  "contact.docker.dept.empty": "暫無對接部門",
  "removal1": "移除",
  "close.detail": "關閉詳情",
  "contact.docker.dept.user.empty": "目前對接部門暫無成員",
  "contact.handover.dept.add": "添加对接部门",
  "contact.dock.dept.empty": "暂无对接部门",
  "contact.dock.dept.empty.tip": "暂无相关对接部门",
  "contact.dock.dept.our.edit.tip": "我方对接部门可以直接参与互联企业协作，修改后不可还原。",
  "contact.dock.dept.our.edit.title": "确定修改我方对接部门？",
  "contact.dock.dept.remove.tip": "移除后，此对接部门无法再参与和此连接企业的业务协作，此操作不可还原。",
  "contact.dock.dept.remove.title": "确定移除此对接部门？",
  "contact.docking.dept": "对接部门",
  "contact.docking.dept.require": "请选择对接部门",
  "escrow": "代管",
  "my.contacts": "我的通讯录",
  "my.corp.contacts": "自己企业的通讯录",
  "escrow.contacts": "代管的通讯录",
  "open.contact.manage.transfer": "打开代管通讯录",
  "contact.dept.current.add.tip": "设置我方对接部门可以让不同的员工和不同的连接企业对接，便捷的开展业务协作。",
  "contact.our.dept.remove.empty": "请选择要移除的对接部门",
  "contact.our.dept.remove.out.empty": "请选择要移出的对接部门",
  "contact.our.dept.remove.tip": "移除后，对接部门无法再参与互联企业协作，此操作不可还原。",
  "contact.our.dept.remove.title": "确定移除所选对接部门？",
  "contact.search.dept": "搜索部门",
  "widget.dept.clickToSelect1": "選擇部門",
  "widget.user.clickToSelect1": "選擇成員",
  "change.flow.node.tip": "更換流程的目前節點，以及節點的負責人。",
  "flow.transfer.tip": "調整流程目前節點的負責人。",
  "reference.relationship.query": "引用關係查詢",
  "referenceByFormList.label": "被引用物件",
  "referenceExtend.label": "外掛",
  "referenceFormList.label": "引用物件",
  "referenceMode.label": "位置",
  "referenceType.label": "關係",
  "byReference.label": "引用方式：",
  "byReference.item1": "本表引用其他物件",
  "byReference.item2": "其他地方引用本表",
  "byFormInfo.label": "被引用物件",
  "extendInfo.label": "外掛程式資訊",
  "formInfo.label": "引用物件",
  "modeInfo.label": "引用位置",
  "typeInfo.label": "引用關係",
  "detailsInfo.label": "詳細資料",
  "form.filter": "查詢此表單",
  "reference.filter": "查詢此外掛程式",
  "view.reference.detail": "查看引用詳情",
  "reference.relationship": "引用關係",
  "reference.empty.text": "在一些複雜業務中，一張表單通常會與其他表單、資料視圖、聚合表、資料助理、外掛程式等關聯使用，進行資料協作和引用，透過「引用關係」即 可查看表單的關聯關係，以便於管理員進行管理與維護。 ",
  "reference.open.text": "開啟引用物件查詢",
  "reference.opening.text": "引用物件查詢正在開啟中，請稍等一下...",
  "byReference.form.item1": "目前表單引用其他物件",
  "byReference.form.item2": "其他物件引用目前表單",
  "byReference.dash.item1": "目前報表引用其他物件",
  "byReference.dash.item2": "其他物件引用目前報表",
  "byReference.scenes.item1": "当前报表引用其他对象",
  "byReference.scenes.item2": "其他对象引用当前报表",
  "byReference.report.item1": "当前报表引用其他对象",
  "byReference.report.item2": "其他对象引用当前报表",
  "byReference.etl.item1": "目前視圖引用其他物件",
  "byReference.etl.item2": "其他物件引用目前視圖",
  "byReference.aggregate.item1": "目前聚合表引用其他物件",
  "byReference.aggregate.item2": "其他物件引用目前聚合表",
  "reference.relationship.view": "視圖模式",
  "relationship.detail": "引用詳情",
  "reference.relationship.view.tip": "該「視圖模式」所顯示的為目前「查詢模式」本頁面的所有結果，如需查看更多，請配合「查詢模式」翻頁功能進行檢視",
  "position.management": "職位管理",
  "position.name": "職位名稱",
  "position.duplicate.name": "職位名稱不能重複",
  "position.empty.name": "職位名稱不能為空",
  "position.length.max.name": "職位名稱不能超過16個字元",
  "position.placeholder.name": " 請輸入職位名稱",
  "relation.placeholder.name": " 請輸入關係名稱",
  "position.add.batch": " 大量新增職位",
  "position.del.tip.title": "是否確認刪除目前職位？",
  "position.del.tip.msg": "如果確認刪除，會將成員的對應職位也刪除",
  "position.add.tip1": "職缺[{{name}}]字元超過 {{max}} 位元",
  "position.add.tip2": "職位[{{name}}]已存在",
  "position.select.tip": "請選擇一個職位",
  "relation.tip1": "同步的成员关系不支持编辑",
  "config.info": "設定資訊",
  "push.method": "推播方式：",
  "encryption.aes_key": "加密 aes_key：",
  "signature.token": "簽名 token：",
  "request.URL": "請求網址：",
  "event.subscription": "事件訂閱：",
  "create.role.group": "建立角色群組",
  "role.group.name": "角色群組名稱",
  "role.group.name.placeholder": "請輸入角色群組名稱",
  "role.group.name.notEmpty": "角色群組名稱不能為空",
  "role.group.name.tooLong": "角色群組名稱不能超過{{length}}個字元",
  "target.group": "目標分組",
  "role.group.remove.tip": "非空角色分組不能刪除",
  "and.sub.group": "及子分組的角色",
  "role.edit.group.moveTo": "移到「{{- groupName}}」分組",
  "Role.group.ID": "角色组ID",
  "gzt": "贛政通",
  "user.in.dept": "成員所在部門",
  "all.dept": "所有部門",
  "deactivated": "已停用",
  'deactivate.error.tip': '建立者/管理者/邀請中成員 不能進行停用操作',
  'deactivate.error.tip2': '沒有停用的成員',
  'deactivate.alert.tip': '您確定停用所選成員？ ',
  'deactivate.alert.tip1': '停用成員後，該成員無法存取本企業（已選取：{{length1}}個成員，可停用：{{length2}}個成員）',
  'enable.error.tip': '建立者/管理者/邀請中成員 不能進行啟用操作',
  'enable.error.tip2': '沒有啟用的成員',
  'enable.alert.tip': '您確定啟用所選成員？ ',
  'enable.alert.tip1': '啟用成員後，該成員可以存取本企業並恢復所有權限（已選取：{{length1}}個成員，可啟用：{{length2}}個成員）',
  'frozen.switch.tip': '同步的新成員帳號授權狀態預設為',
  'enable.success.tip': '成功啟用了{{length}}個成員({{users}}),將恢復成員的存取權限',
  'deactivate.success.tip': '成功停用了{{length}}個成員({{users}}),將限制停用成員的存取權限',
  'select.approval.dept': '選擇審核部門',
  'select.approval.dept.tip': '你同時為多個部門的成員，請選擇需要審核流程的部門',
  'select.approval.dept.tip1': '請選擇需要審核流程的部門',
  'select.approval.dept.tip2': '請選擇部門',
  'group.id': "分組ID",
  'dashboard.see.more': '查看更多',
  'dashboard.link.type': '链接类型',
  'dashboard.open.internal.page': '打开内部页面',
  'dashboard.open.external.link': '打开外部链接',
  'dashboard.dynamic.data.source': '动态数据来源',
  'dashboard.static.data.source': '静态数据来源',
  "dataload.tree.tip1": "展開資料夾查看更多數據內容",
  "dataload.tree.tip2": "搜索結果展示：",
  "installation.package.update": "安装包更新应用",
  "installation.package.update.title": "请点击上传安装包更新此应用",
  "installation.package.update.re": "更换安装包",
  "installation.package.update.tip": "请重新上传安装包对此应用进行更新操作",
  "virtual.address.book": "虚拟通讯录",
  "virtual.address.book.msg": "*虚拟通讯录用于标准应用的设计,需要发布更新设置虚拟通讯录的映射关系以后才能使用。",
  "name.correspondence.settings": "名称对应关系设置",
  "outsider.member": "外部联系人成员",
  "virtual.add": "新增{{name}}",
  "virtual.add.title": "新增{{name}}信息",
  "virtual.add.name.placeholder": "请输入{{name}}名称",
  "virtual.add.describe.placeholder": "请输入描述内容",
  "virtual.add.name.tip": "名称只能输入中文、英文、数字和下划线，最长为128个字符",
  "virtual.edit.title": "编辑{{name}}信息",
  "virtual.delete.title": "确认删除「{{name}}」{{type}}？",
  "virtual.name.correspondence.settings": "虚拟通讯录名称对应关系设置",
  "corresponding.address.book.dept": "对应通讯录部门",
  "select.role": "选择角色",
  "select.outsiderGroup": "选择外部联系人分组",
  "select.outsider.member": "选择外部联系人成员",
  "corresponding.member": "对应通讯录成员",
  "corresponding.role": "对应通讯录角色",
  "corresponding.outsiderGroup": "对应通讯录外部联系人分组",
  "corresponding.outsider.member": "对应通讯录外部联系人成员",
  "test.version": "测试版",
  "test.app.edit": "标准应用编辑",
  "release.management": "发布管理",
  "release.set": "发布设置",
  "release.install.update.log": "安装更新记录",
  "release.user.management": "安装用户管理",
  "install.package.mode": "安装包模式",
  "download.install.package": "下载安装包",
  "custom.user.install": "自定义用户安装",
  "custom.user.install.msg": "*只允许哪些站点的哪些用户使用安装包",
  "install.package.mode.msg": "*导出安装包随意安装",
  "project.release.management": "发布项目管理",
  "project.release.management.list": "发布项目列表",
  "add.project.release.management": "发布新项目",
  "add.project.release.management.type": "添加分类",
  "project.name": "项目名称",
  "project.remark": "项目描述",
  "Project.name": "项目名称：",
  "Project.remark": "项目描述：",
  "Select.release.standard.app": "当前版本打包的应用：",
  "project.name.placeholder": "请输入项目名称",
  "project.remark.placeholder": "请输入项目描述",
  "project.group.name": "项目分类名称",
  "project.info.enter": "项目信息填写",
  "project.info": "项目信息",
  "project.management": "项目管理",
  "project.create": "应用搭建",
  "unbind.key": "生成解绑key",
  "unbind.key.not.empty": "key不能为空",
  "unbind.key.hint": "请输入解绑key",
  "unbind.key.error": "解绑key错误，请重新输入",
  "unbind.validate.hit": "请输入[确定解绑]来完成最后的操作",
  "unbind.validate.text": "确定解绑",
  "select.release.standard.app": "选择要发布的标准应用",
  "select.release.standard.app.waterMark": "请选择要发布的标准应用",
  "project.set": "项目设置",
  "project.init.version": "项目初始化版本号：",
  "init.set": "初始设置",
  "select.user.install": "选择可安装用户：",
  "allow.anyone.install": "允许任何人安装",
  "only.allow.user.install": "只允许指定用户安装",
  "user.management": "用户管理",
  "trial.time.after.first.installation": "首次安装后的试用时间：",
  "installation.notes": "安装说明",
  "installation.notes.placeholder": "请输入安装说明",
  "not.limited": "不限制",
  "release.new.version": "发布新版本",
  "install.log": "安装日志",
  "history.version": "历史版本",
  "project.version": "当前版本 ",
  "project.site": "站点",
  "project.user.account": "用户账号",
  "project.user.name": "用户昵称",
  "current.version": "当前版本",
  "add.user": "添加用户",
  postpone: "延期",
  "disable.restore": "禁用/恢复",
  "unbind.management": "解除绑定管理",
  "project.user.detail": "用户详情",
  "user.site": "用户站点",
  "user.account": "用户账户",
  "user.name": "用户昵称",
  "begin.install.time": "开始安装时间",
  "end.update.time": "最后更新时间",
  "project.note": "备注",
  "project.state": "状态",
  "project.unbind.key": "解绑key",
  "project.unbind.key.clear": "清空解绑key",
  "project.debug": "调试",
  "project.debug.token.title": "调试权限",
  "project.debug.token": "token：{{token}}",
  "project.debug.token.time": "有效时间：{{time}}小时",
  "project.debug.token.permanent": "有效时间：永久",
  "project.debug.token.clear": "清空调试token",
  "project.debug.token.generate": "生成调试token",
  "project.debug.token.effective.time.error": "有效时间不能为0",
  "project.debug.token.empty": "调试token不能为空",
  "project.debug.token.error": "调试token错误，请重新输入",
  "project.debug.token.tip": "请输入token，开启调试功能",
  "effective.time": "有效时间",
  "project.update.state": "是否允许更新",
  "project.update.state.ing": "允许",
  "project.update.stop.ing": "允许",
  "project.update.stop": "停止",
  "project.update.restart": "允许",
  "project.update.stop.tip": "是否停止应用的更新？",
  "project.update.restart.tip": "是否恢复应用的更新？",
  "edit.note": "修改备注",
  "Operating.time": "操作时间：",
  "Operating.type": "操作类型：",
  "operating.cont": "操作内容",
  "please.enter.keyword": "请输入关键词",
  "edit.project.release.management": "编辑名称",
  "placeholder.project.site": "请输入站点名称",
  "placeholder.project.user.account": "请输入用户账号",
  "placeholder.project.user.name": "请输入用户昵称",
  "placeholder.maturity.time": "请选择到期时间",
  "search.data.operation.record": "搜索操作记录",
  "placeholder.contact.note": "请输入备注",
  "user.postpone": "用户延期",
  "postpone.note": "延期说明",
  "postpone.time": "延期时间",
  "placeholder.postpone.note": "请输入延期说明",
  "placeholder.postpone.time": "请选择延期时间",
  "placeholder.operating.time": "请选择操作时间",
  "restore": "恢复",
  "query.restore.title": "确认恢复「{{name}}」用户？",
  "query.disable.title": "确认禁用「{{name}}」用户？",
  "query.disable.msg": "用户被禁用以后不是立即生效，会在24小时内停止用户使用。",
  "unbind.management.msg": "注意：此模式会解绑用户标准应用管理，允许用户自己搭建，用户能进入编辑界面进行应用设计和编辑，无法进行更新操作。",
  "install.version": "安装版本",
  "release.time": "发布时间",
  "update.cont": "更新内容",
  "doc.link": "文档链接",
  "version.download": "版本下载",
  "Latest.version.number": "目前最新版本号：",
  "Applications.packaged.latest.version": "最新版本打包的应用：",
  "Update.cont": "更新内容：",
  "Doc.link": "文档链接：",
  "placeholder.update.cont": "请输入更新内容",
  "placeholder.doc.link": "请输入文档链接",
  "maturity.time.msg": "*选择空值代表永久",
  "only.allow.user.install.msg": "*切换至【用户管理】页添加用户",
  "create.new.standard": "新建空白标准应用",
  "create.new.standard1": "选择现有应用转为标准应用",
  "copy.standard.msg": "*复制普通应用模式，不影响原普通应用使用",
  "standard.search.placeholder": "输入关键字快速搜索应用",
  "has.standard.app.update": "有应用可更新",
  "go.update": "去更新",
  "app.package.import.export": "应用包导入导出",
  "update.app": "更新应用",
  "update.project.app": "更新项目应用",
  "Apps.need.update": "需要更新的应用：",
  "batch.export.app": "批量导出应用",
  "batch.import.app": "批量导入应用安装包",
  "app.batch.import-export": "应用包导入导出",
  "app.batch.import": "导入应用包安装包",
  "app.batch.import.tip": "应用包导入中",
  "app.batch.import.set": '导入设置',
  "app.batch.import.subtitle": "导入应用包安装文件",
  "app.batch.export": "导出应用包",
  "app.batch.export1": "导出应用",
  "app.batch.export.title": "批量导出应用",
  "app.batch.export.set": "导出设置",
  "app.batch.export.title.tip": "批量导入导出多个应用，视图，聚合表以及跨应用的设置",
  "update.cont.tip": "更新内容不能为空",
  "trial.time.after.first.tip": "首次安装后的试用时间只能在0 - 99999之间",
  "all.standard.application": "全部标准应用",
  "select.user.relation": "选择成员关系",
  "corresponding.user.relation": "对应通讯录成员关系",
  "select.release.app": "选择要发布的应用",
  "select.release.app.waterMark": "请选择要发布的应用",
  "batch.export.app.msg": "*批量导出应用不包含标准应用",
  "new.export.app": "新导入",
  "del.project.group.title": "是否删除该项目分类？",
  "del.project.group.tip": "只能删除空项目分类",
  "amap.sdk.load.fail": "高德SDK加载失败，请联系管理员处理",
  "workbench.img.link": "跳轉指定鏈接",
  "workbench.noticeBoard.no": "暫未設置公告欄",
  "workbench.noticeBoard.thare.style": "其他樣式",
  "workbench.noticeBoard.title": "標題欄",
  "workbench.noticeBoard.dataSource": "公告内容",
  "workbench.noticeBoard.setting": "配置公告",
  "workbench.noticeBoard.add": "添加公告",
  "workbench.noticeBoard.add.img": "公告配圖",
  "workbench.noticeBoard.add.outlin": "内容来源",
  "workbench.noticeBoard.add.number": "數據條數",
  "workbench.noticeBoard.add.title": "公告欄標題",
  "workbench.carouselMap.bg.title": "圖片填充方式",
  "workbench.myApp.title": "我管理的",
  "app.group.repeat": "分組名稱不能重複",
  "not.create.report": "你還沒有創建任何報表",
  "not.create.app.form.dash": "你還沒有創建任何應用/表單/報表",
  "setting.app.group": "設置應用分組",
  "Graffiti": "塗鴉",
};

export default langTW
